/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@hookform/resolvers/dist/resolvers.js":
/*!************************************************************!*\
  !*** ./node_modules/@hookform/resolvers/dist/resolvers.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var r=__webpack_require__(/*! react-hook-form */ "./node_modules/react-hook-form/dist/index.cjs.js"),e=function(e,i,t){if(e&&"reportValidity"in e){var a=r.get(t,i);e.setCustomValidity(a&&a.message||""),e.reportValidity()}},i=function(r,i){var t=function(t){var a=i.fields[t];a&&a.ref&&"reportValidity"in a.ref?e(a.ref,t,r):a.refs&&a.refs.forEach(function(i){return e(i,t,r)})};for(var a in i.fields)t(a)};exports.toNestError=function(e,t){t.shouldUseNativeValidation&&i(e,t);var a={};for(var o in e){var f=r.get(t.fields,o);r.set(a,o,Object.assign(e[o]||{},{ref:f&&f.ref}))}return a},exports.validateFieldsNatively=i;
//# sourceMappingURL=resolvers.js.map


/***/ }),

/***/ "./node_modules/@hookform/resolvers/yup/dist/yup.js":
/*!**********************************************************!*\
  !*** ./node_modules/@hookform/resolvers/yup/dist/yup.js ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var e=__webpack_require__(/*! @hookform/resolvers */ "./node_modules/@hookform/resolvers/dist/resolvers.js"),t=__webpack_require__(/*! react-hook-form */ "./node_modules/react-hook-form/dist/index.cjs.js");exports.yupResolver=function(r,o,n){return void 0===o&&(o={}),void 0===n&&(n={}),function(a,s,i){try{return Promise.resolve(function(t,u){try{var c=(o.context&&"development"==="development"&&console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead"),Promise.resolve(r["sync"===n.mode?"validateSync":"validate"](a,Object.assign({abortEarly:!1},o,{context:s}))).then(function(t){return i.shouldUseNativeValidation&&e.validateFieldsNatively({},i),{values:n.raw?a:t,errors:{}}}))}catch(e){return u(e)}return c&&c.then?c.then(void 0,u):c}(0,function(r){if(!r.inner)throw r;return{values:{},errors:e.toNestError((o=r,n=!i.shouldUseNativeValidation&&"all"===i.criteriaMode,(o.inner||[]).reduce(function(e,r){if(e[r.path]||(e[r.path]={message:r.message,type:r.type}),n){var o=e[r.path].types,a=o&&o[r.type];e[r.path]=t.appendErrors(r.path,n,e,r.type,a?[].concat(a,r.message):r.message)}return e},{})),i)};var o,n}))}catch(e){return Promise.reject(e)}}};
//# sourceMappingURL=yup.js.map


/***/ }),

/***/ "./node_modules/dompurify/dist/purify.js":
/*!***********************************************!*\
  !*** ./node_modules/dompurify/dist/purify.js ***!
  \***********************************************/
/***/ (function(module) {

/*! @license DOMPurify 2.4.4 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.4/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  0;
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create; // eslint-disable-line import/no-mutable-exports

  var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;

  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }

  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }

  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }

  if (!construct) {
    construct = function construct(Func, args) {
      return _construct(Func, _toConsumableArray(args));
    };
  }

  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringToString = unapply(String.prototype.toString);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);
  var regExpTest = unapply(RegExp.prototype.test);
  var typeErrorCreate = unconstruct(TypeError);
  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return apply(func, thisArg, args);
    };
  }
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return construct(func, args);
    };
  }
  /* Add properties to a lookup table */

  function addToSet(set, array, transformCaseFunc) {
    transformCaseFunc = transformCaseFunc ? transformCaseFunc : stringToLowerCase;

    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }

    var l = array.length;

    while (l--) {
      var element = array[l];

      if (typeof element === 'string') {
        var lcElement = transformCaseFunc(element);

        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }

          element = lcElement;
        }
      }

      set[element] = true;
    }

    return set;
  }
  /* Shallow clone an object */

  function clone(object) {
    var newObject = create(null);
    var property;

    for (property in object) {
      if (apply(hasOwnProperty, object, [property]) === true) {
        newObject[property] = object[property];
      }
    }

    return newObject;
  }
  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */

  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);

      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }

        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }

      object = getPrototypeOf(object);
    }

    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }

    return fallbackValue;
  }

  var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']); // SVG

  var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']); // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.

  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']); // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.

  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  var text = freeze(['#text']);

  var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
  var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode

  var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape

  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape

  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  var DOCTYPE_NAME = seal(/^html$/i);

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };
  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */


  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    } // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.


    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';

    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }

    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html) {
          return html;
        },
        createScriptURL: function createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };

  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };
    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */


    DOMPurify.version = '2.4.4';
    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */

    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }

    var originalDocument = window.document;
    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        HTMLFormElement = window.HTMLFormElement,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;
    var ElementPrototype = Element.prototype;
    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode'); // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.

    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');

      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }

    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);

    var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
    var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;
    var documentMode = {};

    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}

    var hooks = {};
    /**
     * Expose whether this browser supports running the full DOMPurify.
     */

    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && typeof implementation.createHTMLDocument !== 'undefined' && documentMode !== 9;
    var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
        ERB_EXPR$1 = ERB_EXPR,
        TMPLIT_EXPR$1 = TMPLIT_EXPR,
        DATA_ATTR$1 = DATA_ATTR,
        ARIA_ATTR$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
    var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */

    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
    /* Allowed attribute names */

    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */

    var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */

    var FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */

    var FORBID_ATTR = null;
    /* Decide if ARIA attributes are okay */

    var ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */

    var ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */

    var ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */

    var ALLOW_SELF_CLOSE_IN_ATTR = true;
    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */

    var SAFE_FOR_TEMPLATES = false;
    /* Decide if document with <html>... should be returned */

    var WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */

    var SET_CONFIG = false;
    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */

    var FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */

    var RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */

    var RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */

    var RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */

    var SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */

    var SANITIZE_NAMED_PROPS = false;
    var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */

    var KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */

    var IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */

    var USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */

    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
    /* Tags that are safe for data: URIs */

    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
    /* Attributes safe for values like "javascript:" */

    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */

    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */

    var ALLOWED_NAMESPACES = null;
    var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
    /* Parsing of strict XHTML documents */

    var PARSER_MEDIA_TYPE;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc;
    /* Keep a reference to config to pass to hooks */

    var CONFIG = null;
    /* Ideally, do not touch anything below this line */

    /* ______________________________________________ */

    var formElement = document.createElement('form');

    var isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity


    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }
      /* Shield configuration object from tampering */


      if (!cfg || _typeof(cfg) !== 'object') {
        cfg = {};
      }
      /* Shield configuration object from prototype pollution */


      cfg = clone(cfg);
      PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.

      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
      /* Set configuration parameters */

      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true

      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true

      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false

      ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true

      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false

      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false

      RETURN_DOM = cfg.RETURN_DOM || false; // Default false

      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false

      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false

      FORCE_BODY = cfg.FORCE_BODY || false; // Default false

      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true

      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false

      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

      IN_PLACE = cfg.IN_PLACE || false; // Default false

      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }

      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }

      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }
      /* Parse profile info */


      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
        ALLOWED_ATTR = [];

        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }

        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }
      /* Merge configuration parameters */


      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }

        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }

      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }

        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }

      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }

      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }

        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }
      /* Add #text in case KEEP_CONTENT is set to true */


      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }
      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */


      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }
      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */


      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      } // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.


      if (freeze) {
        freeze(cfg);
      }

      CONFIG = cfg;
    };

    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']); // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.

    var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */

    var ALL_SVG_TAGS = addToSet({}, svg$1);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);
    var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */

    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.

      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: NAMESPACE,
          tagName: 'template'
        };
      }

      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);

      if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
        return false;
      }

      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        } // The only way to switch from MathML to SVG is via`
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.


        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        } // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.


        return Boolean(ALL_SVG_TAGS[tagName]);
      }

      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        } // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points


        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        } // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.


        return Boolean(ALL_MATHML_TAGS[tagName]);
      }

      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        } // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace


        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      } // For XHTML and XML documents that support custom namespaces


      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
        return true;
      } // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
      // Return false just in case.


      return false;
    };
    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */


    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });

      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };
    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */


    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }

      node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes

      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };
    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */


    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc;
      var leadingWhitespace;

      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }

      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }

      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */

      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }
      /* Use createHTMLDocument in case DOMParser is not available */


      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);

        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
        } catch (_) {// Syntax error if dirtyPayload is invalid xml
        }
      }

      var body = doc.body || doc.documentElement;

      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }
      /* Work on whole document or just its body */


      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }

      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */


    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
    };
    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */


    var _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
    };
    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */


    var _isNode = function _isNode(object) {
      return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };
    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */


    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }

      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };
    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */


    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeElements', currentNode, null);
      /* Check if element is clobbered or can clobber */


      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Check if tagname contains Unicode */


      if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Now let's check the element's type and name */


      var tagName = transformCaseFunc(currentNode.nodeName);
      /* Execute a hook if present */

      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });
      /* Detect mXSS attempts abusing namespace confusion */


      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Mitigate a problem with templates inside select */


      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Remove element if anything forbids its presence */


      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }
        /* Keep content except for bad-listed elements */


        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;

          if (childNodes && parentNode) {
            var childCount = childNodes.length;

            for (var i = childCount - 1; i >= 0; --i) {
              parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
            }
          }
        }

        _forceRemove(currentNode);

        return true;
      }
      /* Check whether element has a valid namespace */


      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }

      if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Sanitize element content to be template-safe */


      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
        content = stringReplace(content, ERB_EXPR$1, ' ');
        content = stringReplace(content, TMPLIT_EXPR$1, ' ');

        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeElements', currentNode, null);

      return false;
    };
    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity


    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }
      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */


      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if ( // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */

      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if (!value) ; else {
        return false;
      }

      return true;
    };
    /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */


    var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
      return tagName.indexOf('-') > 0;
    };
    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */


    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr;
      var value;
      var lcName;
      var l;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeAttributes', currentNode, null);

      var attributes = currentNode.attributes;
      /* Check if we have attributes; if not we might have a text node */

      if (!attributes) {
        return;
      }

      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;
      /* Go backwards over all attributes; safely remove bad ones */

      while (l--) {
        attr = attributes[l];
        var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;
        value = name === 'value' ? attr.value : stringTrim(attr.value);
        lcName = transformCaseFunc(name);
        /* Execute a hook if present */

        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set

        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);

        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */

        if (hookEvent.forceKeepAttr) {
          continue;
        }
        /* Remove attribute */


        _removeAttribute(name, currentNode);
        /* Did the hooks approve of the attribute? */


        if (!hookEvent.keepAttr) {
          continue;
        }
        /* Work around a security issue in jQuery 3.0 */


        if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);

          continue;
        }
        /* Sanitize attribute content to be template-safe */


        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
          value = stringReplace(value, ERB_EXPR$1, ' ');
          value = stringReplace(value, TMPLIT_EXPR$1, ' ');
        }
        /* Is `value` valid for this attribute? */


        var lcTag = transformCaseFunc(currentNode.nodeName);

        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }
        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */


        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value


          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }
        /* Handle attributes that require Trusted Types */


        if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ; else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                value = trustedTypesPolicy.createHTML(value);
                break;

              case 'TrustedScriptURL':
                value = trustedTypesPolicy.createScriptURL(value);
                break;
            }
          }
        }
        /* Handle invalid data-* attribute set by try-catching it */


        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeAttributes', currentNode, null);
    };
    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */


    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode;

      var shadowIterator = _createIterator(fragment);
      /* Execute a hook if present */


      _executeHook('beforeSanitizeShadowDOM', fragment, null);

      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);
        /* Sanitize tags and elements */


        if (_sanitizeElements(shadowNode)) {
          continue;
        }
        /* Deep shadow DOM detected */


        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(shadowNode);
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };
    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity


    DOMPurify.sanitize = function (dirty) {
      var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body;
      var importedNode;
      var currentNode;
      var oldNode;
      var returnNode;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */

      IS_EMPTY_INPUT = !dirty;

      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }
      /* Stringify, in case dirty is an object */


      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        // eslint-disable-next-line no-negated-condition
        if (typeof dirty.toString !== 'function') {
          throw typeErrorCreate('toString is not a function');
        } else {
          dirty = dirty.toString();

          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        }
      }
      /* Check we can run. Otherwise fall back or ignore */


      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }

          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }

        return dirty;
      }
      /* Assign config vars */


      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }
      /* Clean up removed elements */


      DOMPurify.removed = [];
      /* Check if dirty is correctly typed for IN_PLACE */

      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }

      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          var tagName = transformCaseFunc(dirty.nodeName);

          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);

        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }
        /* Initialize the document to work on */


        body = _initDocument(dirty);
        /* Check we have a DOM node from the data */

        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }
      /* Remove first element node (ours) if FORCE_BODY is set */


      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }
      /* Get node iterator */


      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
      /* Now start iterating over the created document */


      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }
        /* Sanitize tags and elements */


        if (_sanitizeElements(currentNode)) {
          continue;
        }
        /* Shadow DOM detected, sanitize it */


        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(currentNode);

        oldNode = currentNode;
      }

      oldNode = null;
      /* If we sanitized `dirty` in-place, return it. */

      if (IN_PLACE) {
        return dirty;
      }
      /* Return sanitized string or DOM */


      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);

          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }

        if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }

        return returnNode;
      }

      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
      /* Serialize doctype if allowed */

      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }
      /* Sanitize final string template-safe */


      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
      }

      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };
    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */


    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);

      SET_CONFIG = true;
    };
    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */


    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };
    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */


    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }

      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };
    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */


    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }

      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };
    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */


    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        return arrayPop(hooks[entryPoint]);
      }
    };
    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */


    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };
    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */


    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };

    return DOMPurify;
  }

  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),

/***/ "./node_modules/lodash/lodash.js":
/*!***************************************!*\
  !*** ./node_modules/lodash/lodash.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ "./node_modules/react-hook-form/dist/index.cjs.js":
/*!********************************************************!*\
  !*** ./node_modules/react-hook-form/dist/index.cjs.js ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}Object.defineProperty(exports, "__esModule", ({value:!0}));var t=e(__webpack_require__(/*! react */ "react")),r=e=>"checkbox"===e.type,s=e=>e instanceof Date,a=e=>null==e;const n=e=>"object"==typeof e;var i=e=>!a(e)&&!Array.isArray(e)&&n(e)&&!s(e),u=e=>i(e)&&e.target?r(e.target)?e.target.checked:e.target.value:e,o=(e,t)=>e.has((e=>e.substring(0,e.search(/\.\d+(\.|$)/))||e)(t)),l=e=>{const t=e.constructor&&e.constructor.prototype;return i(t)&&t.hasOwnProperty("isPrototypeOf")},c="undefined"!=typeof window&&void 0!==window.HTMLElement&&"undefined"!=typeof document;function d(e){let t;const r=Array.isArray(e);if(e instanceof Date)t=new Date(e);else if(e instanceof Set)t=new Set(e);else{if(c&&(e instanceof Blob||e instanceof FileList)||!r&&!i(e))return e;if(t=r?[]:{},Array.isArray(e)||l(e))for(const r in e)t[r]=d(e[r]);else t=e}return t}var f=e=>Array.isArray(e)?e.filter(Boolean):[],m=e=>void 0===e,y=(e,t,r)=>{if(!t||!i(e))return r;const s=f(t.split(/[,[\].]+?/)).reduce(((e,t)=>a(e)?e:e[t]),e);return m(s)||s===e?m(e[t])?r:e[t]:s};const p={BLUR:"blur",FOCUS_OUT:"focusout",CHANGE:"change"},g={onBlur:"onBlur",onChange:"onChange",onSubmit:"onSubmit",onTouched:"onTouched",all:"all"},_="max",h="min",v="maxLength",b="minLength",x="pattern",A="required",V="validate",F=t.default.createContext(null),S=()=>t.default.useContext(F);var w=(e,t,r,s=!0)=>{const a={defaultValues:t._defaultValues};for(const n in e)Object.defineProperty(a,n,{get:()=>{const a=n;return t._proxyFormState[a]!==g.all&&(t._proxyFormState[a]=!s||g.all),r&&(r[a]=!0),e[a]}});return a},k=e=>i(e)&&!Object.keys(e).length,D=(e,t,r,s)=>{r(e);const{name:a,...n}=e;return k(n)||Object.keys(n).length>=Object.keys(t).length||Object.keys(n).find((e=>t[e]===(!s||g.all)))},C=e=>Array.isArray(e)?e:[e],O=(e,t,r)=>r&&t?e===t:!e||!t||e===t||C(e).some((e=>e&&(e.startsWith(t)||t.startsWith(e))));function j(e){const r=t.default.useRef(e);r.current=e,t.default.useEffect((()=>{const t=!e.disabled&&r.current.subject&&r.current.subject.subscribe({next:r.current.next});return()=>{t&&t.unsubscribe()}}),[e.disabled])}function E(e){const r=S(),{control:s=r.control,disabled:a,name:n,exact:i}=e||{},[u,o]=t.default.useState(s._formState),l=t.default.useRef(!0),c=t.default.useRef({isDirty:!1,isLoading:!1,dirtyFields:!1,touchedFields:!1,isValidating:!1,isValid:!1,errors:!1}),d=t.default.useRef(n);return d.current=n,j({disabled:a,next:e=>l.current&&O(d.current,e.name,i)&&D(e,c.current,s._updateFormState)&&o({...s._formState,...e}),subject:s._subjects.state}),t.default.useEffect((()=>(l.current=!0,c.current.isValid&&s._updateValid(!0),()=>{l.current=!1})),[s]),w(u,s,c.current,!1)}var U=e=>"string"==typeof e,B=(e,t,r,s,a)=>U(e)?(s&&t.watch.add(e),y(r,e,a)):Array.isArray(e)?e.map((e=>(s&&t.watch.add(e),y(r,e)))):(s&&(t.watchAll=!0),r);function T(e){const r=S(),{control:s=r.control,name:a,defaultValue:n,disabled:i,exact:u}=e||{},o=t.default.useRef(a);o.current=a,j({disabled:i,subject:s._subjects.values,next:e=>{O(o.current,e.name,u)&&c(d(B(o.current,s._names,e.values||s._formValues,!1,n)))}});const[l,c]=t.default.useState(s._getWatch(a,n));return t.default.useEffect((()=>s._removeUnmounted())),l}var L=e=>/^\w*$/.test(e),N=e=>f(e.replace(/["|']|\]/g,"").split(/\.|\[/));function M(e,t,r){let s=-1;const a=L(t)?[t]:N(t),n=a.length,u=n-1;for(;++s<n;){const t=a[s];let n=r;if(s!==u){const r=e[t];n=i(r)||Array.isArray(r)?r:isNaN(+a[s+1])?{}:[]}e[t]=n,e=e[t]}return e}function R(e){const r=S(),{name:s,control:a=r.control,shouldUnregister:n}=e,i=o(a._names.array,s),l=T({control:a,name:s,defaultValue:y(a._formValues,s,y(a._defaultValues,s,e.defaultValue)),exact:!0}),c=E({control:a,name:s}),f=t.default.useRef(a.register(s,{...e.rules,value:l}));return t.default.useEffect((()=>{const e=a._options.shouldUnregister||n,t=(e,t)=>{const r=y(a._fields,e);r&&(r._f.mount=t)};if(t(s,!0),e){const e=d(y(a._options.defaultValues,s));M(a._defaultValues,s,e),m(y(a._formValues,s))&&M(a._formValues,s,e)}return()=>{(i?e&&!a._state.action:e)?a.unregister(s):t(s,!1)}}),[s,a,i,n]),{field:{name:s,value:l,onChange:t.default.useCallback((e=>f.current.onChange({target:{value:u(e),name:s},type:p.CHANGE})),[s]),onBlur:t.default.useCallback((()=>f.current.onBlur({target:{value:y(a._formValues,s),name:s},type:p.BLUR})),[s,a]),ref:e=>{const t=y(a._fields,s);t&&e&&(t._f.ref={focus:()=>e.focus(),select:()=>e.select(),setCustomValidity:t=>e.setCustomValidity(t),reportValidity:()=>e.reportValidity()})}},formState:c,fieldState:Object.defineProperties({},{invalid:{enumerable:!0,get:()=>!!y(c.errors,s)},isDirty:{enumerable:!0,get:()=>!!y(c.dirtyFields,s)},isTouched:{enumerable:!0,get:()=>!!y(c.touchedFields,s)},error:{enumerable:!0,get:()=>y(c.errors,s)}})}}var q=(e,t,r,s,a)=>t?{...r[e],types:{...r[e]&&r[e].types?r[e].types:{},[s]:a||!0}}:{};const P=(e,t,r)=>{for(const s of r||Object.keys(e)){const r=y(e,s);if(r){const{_f:e,...s}=r;if(e&&t(e.name)){if(e.ref.focus){e.ref.focus();break}if(e.refs&&e.refs[0].focus){e.refs[0].focus();break}}else i(s)&&P(s,t)}}};var W=()=>{const e="undefined"==typeof performance?Date.now():1e3*performance.now();return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,(t=>{const r=(16*Math.random()+e)%16|0;return("x"==t?r:3&r|8).toString(16)}))},$=(e,t,r={})=>r.shouldFocus||m(r.shouldFocus)?r.focusName||`${e}.${m(r.focusIndex)?t:r.focusIndex}.`:"",H=e=>({isOnSubmit:!e||e===g.onSubmit,isOnBlur:e===g.onBlur,isOnChange:e===g.onChange,isOnAll:e===g.all,isOnTouch:e===g.onTouched}),I=(e,t,r)=>!r&&(t.watchAll||t.watch.has(e)||[...t.watch].some((t=>e.startsWith(t)&&/^\.\w+/.test(e.slice(t.length))))),G=(e,t,r)=>{const s=f(y(e,r));return M(s,"root",t[r]),M(e,r,s),e},z=e=>"boolean"==typeof e,J=e=>"file"===e.type,K=e=>"function"==typeof e,Q=e=>{if(!c)return!1;const t=e?e.ownerDocument:0;return e instanceof(t&&t.defaultView?t.defaultView.HTMLElement:HTMLElement)},X=e=>U(e),Y=e=>"radio"===e.type,Z=e=>e instanceof RegExp;const ee={value:!1,isValid:!1},te={value:!0,isValid:!0};var re=e=>{if(Array.isArray(e)){if(e.length>1){const t=e.filter((e=>e&&e.checked&&!e.disabled)).map((e=>e.value));return{value:t,isValid:!!t.length}}return e[0].checked&&!e[0].disabled?e[0].attributes&&!m(e[0].attributes.value)?m(e[0].value)||""===e[0].value?te:{value:e[0].value,isValid:!0}:te:ee}return ee};const se={isValid:!1,value:null};var ae=e=>Array.isArray(e)?e.reduce(((e,t)=>t&&t.checked&&!t.disabled?{isValid:!0,value:t.value}:e),se):se;function ne(e,t,r="validate"){if(X(e)||Array.isArray(e)&&e.every(X)||z(e)&&!e)return{type:r,message:X(e)?e:"",ref:t}}var ie=e=>i(e)&&!Z(e)?e:{value:e,message:""},ue=async(e,t,s,n,u)=>{const{ref:o,refs:l,required:c,maxLength:d,minLength:f,min:p,max:g,pattern:F,validate:S,name:w,valueAsNumber:D,mount:C,disabled:O}=e._f,j=y(t,w);if(!C||O)return{};const E=l?l[0]:o,B=e=>{n&&E.reportValidity&&(E.setCustomValidity(z(e)?"":e||""),E.reportValidity())},T={},L=Y(o),N=r(o),M=L||N,R=(D||J(o))&&m(o.value)&&m(j)||Q(o)&&""===o.value||""===j||Array.isArray(j)&&!j.length,P=q.bind(null,w,s,T),W=(e,t,r,s=v,a=b)=>{const n=e?t:r;T[w]={type:e?s:a,message:n,ref:o,...P(e?s:a,n)}};if(u?!Array.isArray(j)||!j.length:c&&(!M&&(R||a(j))||z(j)&&!j||N&&!re(l).isValid||L&&!ae(l).isValid)){const{value:e,message:t}=X(c)?{value:!!c,message:c}:ie(c);if(e&&(T[w]={type:A,message:t,ref:E,...P(A,t)},!s))return B(t),T}if(!(R||a(p)&&a(g))){let e,t;const r=ie(g),n=ie(p);if(a(j)||isNaN(j)){const s=o.valueAsDate||new Date(j),a=e=>new Date((new Date).toDateString()+" "+e),i="time"==o.type,u="week"==o.type;U(r.value)&&j&&(e=i?a(j)>a(r.value):u?j>r.value:s>new Date(r.value)),U(n.value)&&j&&(t=i?a(j)<a(n.value):u?j<n.value:s<new Date(n.value))}else{const s=o.valueAsNumber||(j?+j:j);a(r.value)||(e=s>r.value),a(n.value)||(t=s<n.value)}if((e||t)&&(W(!!e,r.message,n.message,_,h),!s))return B(T[w].message),T}if((d||f)&&!R&&(U(j)||u&&Array.isArray(j))){const e=ie(d),t=ie(f),r=!a(e.value)&&j.length>+e.value,n=!a(t.value)&&j.length<+t.value;if((r||n)&&(W(r,e.message,t.message),!s))return B(T[w].message),T}if(F&&!R&&U(j)){const{value:e,message:t}=ie(F);if(Z(e)&&!j.match(e)&&(T[w]={type:x,message:t,ref:o,...P(x,t)},!s))return B(t),T}if(S)if(K(S)){const e=ne(await S(j,t),E);if(e&&(T[w]={...e,...P(V,e.message)},!s))return B(e.message),T}else if(i(S)){let e={};for(const r in S){if(!k(e)&&!s)break;const a=ne(await S[r](j,t),E,r);a&&(e={...a,...P(r,a.message)},B(a.message),s&&(T[w]=e))}if(!k(e)&&(T[w]={ref:E,...e},!s))return T}return B(!0),T};function oe(e,t){return[...e,...C(t)]}var le=e=>Array.isArray(e)?e.map((()=>{})):void 0;function ce(e,t,r){return[...e.slice(0,t),...C(r),...e.slice(t)]}var de=(e,t,r)=>Array.isArray(e)?(m(e[r])&&(e[r]=void 0),e.splice(r,0,e.splice(t,1)[0]),e):[];function fe(e,t){return[...C(t),...C(e)]}var me=(e,t)=>m(t)?[]:function(e,t){let r=0;const s=[...e];for(const e of t)s.splice(e-r,1),r++;return f(s).length?s:[]}(e,C(t).sort(((e,t)=>e-t))),ye=(e,t,r)=>{e[t]=[e[r],e[r]=e[t]][0]};function pe(e,t){const r=Array.isArray(t)?t:L(t)?[t]:N(t),s=1===r.length?e:function(e,t){const r=t.slice(0,-1).length;let s=0;for(;s<r;)e=m(e)?s++:e[t[s++]];return e}(e,r),a=r.length-1,n=r[a];return s&&delete s[n],0!==a&&(i(s)&&k(s)||Array.isArray(s)&&function(e){for(const t in e)if(!m(e[t]))return!1;return!0}(s))&&pe(e,r.slice(0,-1)),e}var ge=(e,t,r)=>(e[t]=r,e);function _e(){let e=[];return{get observers(){return e},next:t=>{for(const r of e)r.next&&r.next(t)},subscribe:t=>(e.push(t),{unsubscribe:()=>{e=e.filter((e=>e!==t))}}),unsubscribe:()=>{e=[]}}}var he=e=>a(e)||!n(e);function ve(e,t){if(he(e)||he(t))return e===t;if(s(e)&&s(t))return e.getTime()===t.getTime();const r=Object.keys(e),a=Object.keys(t);if(r.length!==a.length)return!1;for(const n of r){const r=e[n];if(!a.includes(n))return!1;if("ref"!==n){const e=t[n];if(s(r)&&s(e)||i(r)&&i(e)||Array.isArray(r)&&Array.isArray(e)?!ve(r,e):r!==e)return!1}}return!0}var be=e=>"select-multiple"===e.type,xe=e=>Y(e)||r(e),Ae=e=>Q(e)&&e.isConnected,Ve=e=>{for(const t in e)if(K(e[t]))return!0;return!1};function Fe(e,t={}){const r=Array.isArray(e);if(i(e)||r)for(const r in e)Array.isArray(e[r])||i(e[r])&&!Ve(e[r])?(t[r]=Array.isArray(e[r])?[]:{},Fe(e[r],t[r])):a(e[r])||(t[r]=!0);return t}function Se(e,t,r){const s=Array.isArray(e);if(i(e)||s)for(const s in e)Array.isArray(e[s])||i(e[s])&&!Ve(e[s])?m(t)||he(r[s])?r[s]=Array.isArray(e[s])?Fe(e[s],[]):{...Fe(e[s])}:Se(e[s],a(t)?{}:t[s],r[s]):r[s]=!ve(e[s],t[s]);return r}var we=(e,t)=>Se(e,t,Fe(t)),ke=(e,{valueAsNumber:t,valueAsDate:r,setValueAs:s})=>m(e)?e:t?""===e?NaN:e?+e:e:r&&U(e)?new Date(e):s?s(e):e;function De(e){const t=e.ref;if(!(e.refs?e.refs.every((e=>e.disabled)):t.disabled))return J(t)?t.files:Y(t)?ae(e.refs).value:be(t)?[...t.selectedOptions].map((({value:e})=>e)):r(t)?re(e.refs).value:ke(m(t.value)?e.ref.value:t.value,e)}var Ce=(e,t,r,s)=>{const a={};for(const r of e){const e=y(t,r);e&&M(a,r,e._f)}return{criteriaMode:r,names:[...e],fields:a,shouldUseNativeValidation:s}},Oe=e=>m(e)?e:Z(e)?e.source:i(e)?Z(e.value)?e.value.source:e.value:e,je=e=>e.mount&&(e.required||e.min||e.max||e.maxLength||e.minLength||e.pattern||e.validate);function Ee(e,t,r){const s=y(e,r);if(s||L(r))return{error:s,name:r};const a=r.split(".");for(;a.length;){const s=a.join("."),n=y(t,s),i=y(e,s);if(n&&!Array.isArray(n)&&r!==s)return{name:r};if(i&&i.type)return{name:s,error:i};a.pop()}return{name:r}}var Ue=(e,t,r,s,a)=>!a.isOnAll&&(!r&&a.isOnTouch?!(t||e):(r?s.isOnBlur:a.isOnBlur)?!e:!(r?s.isOnChange:a.isOnChange)||e),Be=(e,t)=>!f(y(e,t)).length&&pe(e,t);const Te={mode:g.onSubmit,reValidateMode:g.onChange,shouldFocusError:!0};function Le(e={},t){let n,l={...Te,...e},_={submitCount:0,isDirty:!1,isLoading:K(l.defaultValues),isValidating:!1,isSubmitted:!1,isSubmitting:!1,isSubmitSuccessful:!1,isValid:!1,touchedFields:{},dirtyFields:{},errors:{}},h={},v=(i(l.defaultValues)||i(l.values))&&d(l.defaultValues||l.values)||{},b=l.shouldUnregister?{}:d(v),x={action:!1,mount:!1,watch:!1},A={mount:new Set,unMount:new Set,array:new Set,watch:new Set},V=0;const F={isDirty:!1,dirtyFields:!1,touchedFields:!1,isValidating:!1,isValid:!1,errors:!1},S={values:_e(),array:_e(),state:_e()},w=e.resetOptions&&e.resetOptions.keepDirtyValues,D=H(l.mode),O=H(l.reValidateMode),j=l.criteriaMode===g.all,E=async e=>{if(F.isValid||e){const e=l.resolver?k((await q()).errors):await W(h,!0);e!==_.isValid&&S.state.next({isValid:e})}},T=e=>F.isValidating&&S.state.next({isValidating:e}),L=(e,t,r,s)=>{const a=y(h,e);if(a){const n=y(b,e,m(r)?y(v,e):r);m(n)||s&&s.defaultChecked||t?M(b,e,t?n:De(a._f)):Y(e,n),x.mount&&E()}},N=(e,t,r,s,a)=>{let n=!1,i=!1;const u={name:e};if(!r||s){F.isDirty&&(i=_.isDirty,_.isDirty=u.isDirty=$(),n=i!==u.isDirty);const r=ve(y(v,e),t);i=y(_.dirtyFields,e),r?pe(_.dirtyFields,e):M(_.dirtyFields,e,!0),u.dirtyFields=_.dirtyFields,n=n||F.dirtyFields&&i!==!r}if(r){const t=y(_.touchedFields,e);t||(M(_.touchedFields,e,r),u.touchedFields=_.touchedFields,n=n||F.touchedFields&&t!==r)}return n&&a&&S.state.next(u),n?u:{}},R=(t,r,s,a)=>{const i=y(_.errors,t),u=F.isValid&&z(r)&&_.isValid!==r;var o;if(e.delayError&&s?(o=()=>((e,t)=>{M(_.errors,e,t),S.state.next({errors:_.errors})})(t,s),n=e=>{clearTimeout(V),V=setTimeout(o,e)},n(e.delayError)):(clearTimeout(V),n=null,s?M(_.errors,t,s):pe(_.errors,t)),(s?!ve(i,s):i)||!k(a)||u){const e={...a,...u&&z(r)?{isValid:r}:{},errors:_.errors,name:t};_={..._,...e},S.state.next(e)}T(!1)},q=async e=>l.resolver(b,l.context,Ce(e||A.mount,h,l.criteriaMode,l.shouldUseNativeValidation)),W=async(e,t,r={valid:!0})=>{for(const s in e){const a=e[s];if(a){const{_f:e,...s}=a;if(e){const s=A.array.has(e.name),n=await ue(a,b,j,l.shouldUseNativeValidation&&!t,s);if(n[e.name]&&(r.valid=!1,t))break;!t&&(y(n,e.name)?s?G(_.errors,n,e.name):M(_.errors,e.name,n[e.name]):pe(_.errors,e.name))}s&&await W(s,t,r)}}return r.valid},$=(e,t)=>(e&&t&&M(b,e,t),!ve(se(),v)),X=(e,t,r)=>B(e,A,{...x.mount?b:m(t)?v:U(e)?{[e]:t}:t},r,t),Y=(e,t,s={})=>{const n=y(h,e);let i=t;if(n){const s=n._f;s&&(!s.disabled&&M(b,e,ke(t,s)),i=Q(s.ref)&&a(t)?"":t,be(s.ref)?[...s.ref.options].forEach((e=>e.selected=i.includes(e.value))):s.refs?r(s.ref)?s.refs.length>1?s.refs.forEach((e=>(!e.defaultChecked||!e.disabled)&&(e.checked=Array.isArray(i)?!!i.find((t=>t===e.value)):i===e.value))):s.refs[0]&&(s.refs[0].checked=!!i):s.refs.forEach((e=>e.checked=e.value===i)):J(s.ref)?s.ref.value="":(s.ref.value=i,s.ref.type||S.values.next({name:e,values:{...b}})))}(s.shouldDirty||s.shouldTouch)&&N(e,i,s.shouldTouch,s.shouldDirty,!0),s.shouldValidate&&re(e)},Z=(e,t,r)=>{for(const a in t){const n=t[a],i=`${e}.${a}`,u=y(h,i);!A.array.has(e)&&he(n)&&(!u||u._f)||s(n)?Y(i,n,r):Z(i,n,r)}},ee=(e,r,s={})=>{const n=y(h,e),i=A.array.has(e),u=d(r);M(b,e,u),i?(S.array.next({name:e,values:{...b}}),(F.isDirty||F.dirtyFields)&&s.shouldDirty&&S.state.next({name:e,dirtyFields:we(v,b),isDirty:$(e,u)})):!n||n._f||a(u)?Y(e,u,s):Z(e,u,s),I(e,A)&&S.state.next({..._}),S.values.next({name:e,values:{...b}}),!x.mount&&t()},te=async e=>{const t=e.target;let r=t.name,s=!0;const a=y(h,r);if(a){let i,o;const c=t.type?De(a._f):u(e),d=e.type===p.BLUR||e.type===p.FOCUS_OUT,f=!je(a._f)&&!l.resolver&&!y(_.errors,r)&&!a._f.deps||Ue(d,y(_.touchedFields,r),_.isSubmitted,O,D),m=I(r,A,d);M(b,r,c),d?(a._f.onBlur&&a._f.onBlur(e),n&&n(0)):a._f.onChange&&a._f.onChange(e);const g=N(r,c,d,!1),v=!k(g)||m;if(!d&&S.values.next({name:r,type:e.type,values:{...b}}),f)return F.isValid&&E(),v&&S.state.next({name:r,...m?{}:g});if(!d&&m&&S.state.next({..._}),T(!0),l.resolver){const{errors:e}=await q([r]),t=Ee(_.errors,h,r),s=Ee(e,h,t.name||r);i=s.error,r=s.name,o=k(e)}else i=(await ue(a,b,j,l.shouldUseNativeValidation))[r],s=isNaN(c)||c===y(b,r,c),s&&(i?o=!1:F.isValid&&(o=await W(h,!0)));s&&(a._f.deps&&re(a._f.deps),R(r,o,i,g))}},re=async(e,t={})=>{let r,s;const a=C(e);if(T(!0),l.resolver){const t=await(async e=>{const{errors:t}=await q();if(e)for(const r of e){const e=y(t,r);e?M(_.errors,r,e):pe(_.errors,r)}else _.errors=t;return t})(m(e)?e:a);r=k(t),s=e?!a.some((e=>y(t,e))):r}else e?(s=(await Promise.all(a.map((async e=>{const t=y(h,e);return await W(t&&t._f?{[e]:t}:t)})))).every(Boolean),(s||_.isValid)&&E()):s=r=await W(h);return S.state.next({...!U(e)||F.isValid&&r!==_.isValid?{}:{name:e},...l.resolver||!e?{isValid:r}:{},errors:_.errors,isValidating:!1}),t.shouldFocus&&!s&&P(h,(e=>e&&y(_.errors,e)),e?a:A.mount),s},se=e=>{const t={...v,...x.mount?b:{}};return m(e)?t:U(e)?y(t,e):e.map((e=>y(t,e)))},ae=(e,t)=>({invalid:!!y((t||_).errors,e),isDirty:!!y((t||_).dirtyFields,e),isTouched:!!y((t||_).touchedFields,e),error:y((t||_).errors,e)}),ne=(e,t={})=>{for(const r of e?C(e):A.mount)A.mount.delete(r),A.array.delete(r),t.keepValue||(pe(h,r),pe(b,r)),!t.keepError&&pe(_.errors,r),!t.keepDirty&&pe(_.dirtyFields,r),!t.keepTouched&&pe(_.touchedFields,r),!l.shouldUnregister&&!t.keepDefaultValue&&pe(v,r);S.values.next({values:{...b}}),S.state.next({..._,...t.keepDirty?{isDirty:$()}:{}}),!t.keepIsValid&&E()},ie=(e,t={})=>{let r=y(h,e);const s=z(t.disabled);return M(h,e,{...r||{},_f:{...r&&r._f?r._f:{ref:{name:e}},name:e,mount:!0,...t}}),A.mount.add(e),r?s&&M(b,e,t.disabled?void 0:y(b,e,De(r._f))):L(e,!0,t.value),{...s?{disabled:t.disabled}:{},...l.shouldUseNativeValidation?{required:!!t.required,min:Oe(t.min),max:Oe(t.max),minLength:Oe(t.minLength),maxLength:Oe(t.maxLength),pattern:Oe(t.pattern)}:{},name:e,onChange:te,onBlur:te,ref:s=>{if(s){ie(e,t),r=y(h,e);const a=m(s.value)&&s.querySelectorAll&&s.querySelectorAll("input,select,textarea")[0]||s,n=xe(a),i=r._f.refs||[];if(n?i.find((e=>e===a)):a===r._f.ref)return;M(h,e,{_f:{...r._f,...n?{refs:[...i.filter(Ae),a,...Array.isArray(y(v,e))?[{}]:[]],ref:{type:a.type,name:e}}:{ref:a}}}),L(e,!1,void 0,a)}else r=y(h,e,{}),r._f&&(r._f.mount=!1),(l.shouldUnregister||t.shouldUnregister)&&(!o(A.array,e)||!x.action)&&A.unMount.add(e)}}},oe=()=>l.shouldFocusError&&P(h,(e=>e&&y(_.errors,e)),A.mount),le=(r,s={})=>{const a=r||v,n=d(a),i=r&&!k(r)?n:v;if(s.keepDefaultValues||(v=a),!s.keepValues){if(s.keepDirtyValues||w)for(const e of A.mount)y(_.dirtyFields,e)?M(i,e,y(b,e)):ee(e,y(i,e));else{if(c&&m(r))for(const e of A.mount){const t=y(h,e);if(t&&t._f){const e=Array.isArray(t._f.refs)?t._f.refs[0]:t._f.ref;if(Q(e)){const t=e.closest("form");if(t){t.reset();break}}}}h={}}b=e.shouldUnregister?s.keepDefaultValues?d(v):{}:n,S.array.next({values:{...i}}),S.values.next({values:{...i}})}A={mount:new Set,unMount:new Set,array:new Set,watch:new Set,watchAll:!1,focus:""},!x.mount&&t(),x.mount=!F.isValid||!!s.keepIsValid,x.watch=!!e.shouldUnregister,S.state.next({submitCount:s.keepSubmitCount?_.submitCount:0,isDirty:s.keepDirty?_.isDirty:!(!s.keepDefaultValues||ve(r,v)),isSubmitted:!!s.keepIsSubmitted&&_.isSubmitted,dirtyFields:s.keepDirtyValues?_.dirtyFields:s.keepDefaultValues&&r?we(v,r):{},touchedFields:s.keepTouched?_.touchedFields:{},errors:s.keepErrors?_.errors:{},isSubmitting:!1,isSubmitSuccessful:!1})},ce=(e,t)=>le(K(e)?e(b):e,t);return{control:{register:ie,unregister:ne,getFieldState:ae,_executeSchema:q,_getWatch:X,_getDirty:$,_updateValid:E,_removeUnmounted:()=>{for(const e of A.unMount){const t=y(h,e);t&&(t._f.refs?t._f.refs.every((e=>!Ae(e))):!Ae(t._f.ref))&&ne(e)}A.unMount=new Set},_updateFieldArray:(e,t=[],r,s,a=!0,n=!0)=>{if(s&&r){if(x.action=!0,n&&Array.isArray(y(h,e))){const t=r(y(h,e),s.argA,s.argB);a&&M(h,e,t)}if(n&&Array.isArray(y(_.errors,e))){const t=r(y(_.errors,e),s.argA,s.argB);a&&M(_.errors,e,t),Be(_.errors,e)}if(F.touchedFields&&n&&Array.isArray(y(_.touchedFields,e))){const t=r(y(_.touchedFields,e),s.argA,s.argB);a&&M(_.touchedFields,e,t)}F.dirtyFields&&(_.dirtyFields=we(v,b)),S.state.next({name:e,isDirty:$(e,t),dirtyFields:_.dirtyFields,errors:_.errors,isValid:_.isValid})}else M(b,e,t)},_getFieldArray:t=>f(y(x.mount?b:v,t,e.shouldUnregister?y(v,t,[]):[])),_reset:le,_resetDefaultValues:()=>K(l.defaultValues)&&l.defaultValues().then((e=>{ce(e,l.resetOptions),S.state.next({isLoading:!1})})),_updateFormState:e=>{_={..._,...e}},_subjects:S,_proxyFormState:F,get _fields(){return h},get _formValues(){return b},get _state(){return x},set _state(e){x=e},get _defaultValues(){return v},get _names(){return A},set _names(e){A=e},get _formState(){return _},set _formState(e){_=e},get _options(){return l},set _options(e){l={...l,...e}}},trigger:re,register:ie,handleSubmit:(e,t)=>async r=>{r&&(r.preventDefault&&r.preventDefault(),r.persist&&r.persist());let s=d(b);if(S.state.next({isSubmitting:!0}),l.resolver){const{errors:e,values:t}=await q();_.errors=e,s=t}else await W(h);pe(_.errors,"root"),k(_.errors)?(S.state.next({errors:{}}),await e(s,r)):(t&&await t({..._.errors},r),oe(),setTimeout(oe)),S.state.next({isSubmitted:!0,isSubmitting:!1,isSubmitSuccessful:k(_.errors),submitCount:_.submitCount+1,errors:_.errors})},watch:(e,t)=>K(e)?S.values.subscribe({next:r=>e(X(void 0,t),r)}):X(e,t,!0),setValue:ee,getValues:se,reset:ce,resetField:(e,t={})=>{y(h,e)&&(m(t.defaultValue)?ee(e,y(v,e)):(ee(e,t.defaultValue),M(v,e,t.defaultValue)),t.keepTouched||pe(_.touchedFields,e),t.keepDirty||(pe(_.dirtyFields,e),_.isDirty=t.defaultValue?$(e,y(v,e)):$()),t.keepError||(pe(_.errors,e),F.isValid&&E()),S.state.next({..._}))},clearErrors:e=>{e&&C(e).forEach((e=>pe(_.errors,e))),S.state.next({errors:e?_.errors:{}})},unregister:ne,setError:(e,t,r)=>{const s=(y(h,e,{_f:{}})._f||{}).ref;M(_.errors,e,{...t,ref:s}),S.state.next({name:e,errors:_.errors,isValid:!1}),r&&r.shouldFocus&&s&&s.focus&&s.focus()},setFocus:(e,t={})=>{const r=y(h,e),s=r&&r._f;if(s){const e=s.refs?s.refs[0]:s.ref;e.focus&&(e.focus(),t.shouldSelect&&e.select())}},getFieldState:ae}}exports.Controller=e=>e.render(R(e)),exports.FormProvider=e=>{const{children:r,...s}=e;return t.default.createElement(F.Provider,{value:s},r)},exports.appendErrors=q,exports.get=y,exports.set=M,exports.useController=R,exports.useFieldArray=function(e){const r=S(),{control:s=r.control,name:a,keyName:n="id",shouldUnregister:i}=e,[u,o]=t.default.useState(s._getFieldArray(a)),l=t.default.useRef(s._getFieldArray(a).map(W)),c=t.default.useRef(u),f=t.default.useRef(a),m=t.default.useRef(!1);f.current=a,c.current=u,s._names.array.add(a),e.rules&&s.register(a,e.rules),j({next:({values:e,name:t})=>{if(t===f.current||!t){const t=y(e,f.current);Array.isArray(t)&&(o(t),l.current=t.map(W))}},subject:s._subjects.array});const p=t.default.useCallback((e=>{m.current=!0,s._updateFieldArray(a,e)}),[s,a]);return t.default.useEffect((()=>{if(s._state.action=!1,I(a,s._names)&&s._subjects.state.next({...s._formState}),m.current&&(!H(s._options.mode).isOnSubmit||s._formState.isSubmitted))if(s._options.resolver)s._executeSchema([a]).then((e=>{const t=y(e.errors,a),r=y(s._formState.errors,a);(r?!t&&r.type:t&&t.type)&&(t?M(s._formState.errors,a,t):pe(s._formState.errors,a),s._subjects.state.next({errors:s._formState.errors}))}));else{const e=y(s._fields,a);e&&e._f&&ue(e,s._formValues,s._options.criteriaMode===g.all,s._options.shouldUseNativeValidation,!0).then((e=>!k(e)&&s._subjects.state.next({errors:G(s._formState.errors,e,a)})))}s._subjects.values.next({name:a,values:{...s._formValues}}),s._names.focus&&P(s._fields,(e=>!!e&&e.startsWith(s._names.focus||""))),s._names.focus="",s._updateValid()}),[u,a,s]),t.default.useEffect((()=>(!y(s._formValues,a)&&s._updateFieldArray(a),()=>{(s._options.shouldUnregister||i)&&s.unregister(a)})),[a,s,n,i]),{swap:t.default.useCallback(((e,t)=>{const r=s._getFieldArray(a);ye(r,e,t),ye(l.current,e,t),p(r),o(r),s._updateFieldArray(a,r,ye,{argA:e,argB:t},!1)}),[p,a,s]),move:t.default.useCallback(((e,t)=>{const r=s._getFieldArray(a);de(r,e,t),de(l.current,e,t),p(r),o(r),s._updateFieldArray(a,r,de,{argA:e,argB:t},!1)}),[p,a,s]),prepend:t.default.useCallback(((e,t)=>{const r=C(d(e)),n=fe(s._getFieldArray(a),r);s._names.focus=$(a,0,t),l.current=fe(l.current,r.map(W)),p(n),o(n),s._updateFieldArray(a,n,fe,{argA:le(e)})}),[p,a,s]),append:t.default.useCallback(((e,t)=>{const r=C(d(e)),n=oe(s._getFieldArray(a),r);s._names.focus=$(a,n.length-1,t),l.current=oe(l.current,r.map(W)),p(n),o(n),s._updateFieldArray(a,n,oe,{argA:le(e)})}),[p,a,s]),remove:t.default.useCallback((e=>{const t=me(s._getFieldArray(a),e);l.current=me(l.current,e),p(t),o(t),s._updateFieldArray(a,t,me,{argA:e})}),[p,a,s]),insert:t.default.useCallback(((e,t,r)=>{const n=C(d(t)),i=ce(s._getFieldArray(a),e,n);s._names.focus=$(a,e,r),l.current=ce(l.current,e,n.map(W)),p(i),o(i),s._updateFieldArray(a,i,ce,{argA:e,argB:le(t)})}),[p,a,s]),update:t.default.useCallback(((e,t)=>{const r=d(t),n=ge(s._getFieldArray(a),e,r);l.current=[...n].map(((t,r)=>t&&r!==e?l.current[r]:W())),p(n),o([...n]),s._updateFieldArray(a,n,ge,{argA:e,argB:r},!0,!1)}),[p,a,s]),replace:t.default.useCallback((e=>{const t=C(d(e));l.current=t.map(W),p([...t]),o([...t]),s._updateFieldArray(a,[...t],(e=>e),{},!0,!1)}),[p,a,s]),fields:t.default.useMemo((()=>u.map(((e,t)=>({...e,[n]:l.current[t]||W()})))),[u,n])}},exports.useForm=function(e={}){const r=t.default.useRef(),[s,a]=t.default.useState({isDirty:!1,isValidating:!1,isLoading:K(e.defaultValues),isSubmitted:!1,isSubmitting:!1,isSubmitSuccessful:!1,isValid:!1,submitCount:0,dirtyFields:{},touchedFields:{},errors:{},defaultValues:K(e.defaultValues)?void 0:e.defaultValues});r.current||(r.current={...Le(e,(()=>a((e=>({...e}))))),formState:s});const n=r.current.control;return n._options=e,j({subject:n._subjects.state,next:e=>{D(e,n._proxyFormState,n._updateFormState,!0)&&a({...n._formState})}}),t.default.useEffect((()=>{e.values&&!ve(e.values,n._defaultValues)?n._reset(e.values,n._options.resetOptions):n._resetDefaultValues()}),[e.values,n]),t.default.useEffect((()=>{n._state.mount||(n._updateValid(),n._state.mount=!0),n._state.watch&&(n._state.watch=!1,n._subjects.state.next({...n._formState})),n._removeUnmounted()})),r.current.formState=w(s,n),r.current},exports.useFormContext=S,exports.useFormState=E,exports.useWatch=T;
//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ "./src/bot/cards/chat-search-refiners/chat-search-refiners.component.tsx":
/*!*******************************************************************************!*\
  !*** ./src/bot/cards/chat-search-refiners/chat-search-refiners.component.tsx ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatSearchRefiners = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const { Bubble } = botframework_webchat_1.Components;
//TODO align styles once themes are available
const useSearchStyles = react_jss_1.createUseStyles(({ palette, spacing, sizes, fonts }) => ({
    bubble: {
        marginBottom: spacing.medium
    },
    content: Object.assign(Object.assign({}, fonts.normalPlus), { padding: `${spacing.smallPlus} ${spacing.smallPlus} ${spacing.smallPlus} ${spacing.medium}`, color: palette.neutralEmptyOn, lineHeight: sizes.small, display: "flex", justifyContent: "space-between", alignItems: "center" })
}));
const ChatSearchRefiners = ({ refiners, activity, sortOrder, children }) => {
    const searchStyles = useSearchStyles();
    const gridStyles = smarthub_common_1.useGridStyles();
    const localize = smarthub_common_1.useLocalizeConfig();
    const [expanded, setExpanded] = react_1.useState(false);
    const handleRefineOrder = () => {
        setExpanded(!expanded);
    };
    return react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.sm12, expanded ? gridStyles.lg4 : "", gridStyles.padL].join(" ") },
        react_1.default.createElement(Bubble, { className: searchStyles.bubble, fromUser: false, nub: false },
            children({ activity, attachment: sortOrder }),
            react_1.default.createElement("div", { className: searchStyles.content },
                react_1.default.createElement("span", null, expanded ? localize.refinerTitle : localize.refinerExpandTitle),
                react_1.default.createElement(react_2.IconButton, { title: expanded ? localize.hideRefiners : localize.showRefiners, ariaLabel: expanded ? localize.hideRefiners : localize.showRefiners, onClick: handleRefineOrder },
                    react_1.default.createElement(react_2.Icon, { iconName: expanded ? "ChevronUp" : "ChevronDown" }))),
            expanded && children({ activity, attachment: refiners })));
};
exports.ChatSearchRefiners = ChatSearchRefiners;


/***/ }),

/***/ "./src/bot/cards/chat-search-refiners/index.ts":
/*!*****************************************************!*\
  !*** ./src/bot/cards/chat-search-refiners/index.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-search-refiners.component */ "./src/bot/cards/chat-search-refiners/chat-search-refiners.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/cards/chat-search-results/chat-search-results.component.tsx":
/*!*****************************************************************************!*\
  !*** ./src/bot/cards/chat-search-results/chat-search-results.component.tsx ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatSearchResults = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const models_1 = __webpack_require__(/*! ../../../models */ "./src/models/index.ts");
const chat_search_refiners_1 = __webpack_require__(/*! ../chat-search-refiners */ "./src/bot/cards/chat-search-refiners/index.ts");
const { useActivities } = botframework_webchat_1.hooks;
const { Bubble } = botframework_webchat_1.Components;
//TODO align styles once themes are available
const useSearchStyles = react_jss_1.createUseStyles(({ palette, fonts, sizes, spacing }) => ({
    bubble: {
        marginBottom: spacing.medium
    },
    card: {
        marginBottom: spacing.medium,
        display: "flex"
    },
    content: Object.assign(Object.assign({}, fonts.normalPlus), { padding: spacing.medium, color: palette.emptyOn, lineHeight: sizes.small })
}));
const ChatSearchResults = ({ activity, children }) => {
    var _a, _b;
    const searchStyles = useSearchStyles();
    const gridStyles = smarthub_common_1.useGridStyles();
    const [state, setState] = react_1.useState(null);
    const [activities] = useActivities();
    const lastActivity = activities[activities.length - 1];
    const lastActivityId = ((_a = lastActivity.channelData) === null || _a === void 0 ? void 0 : _a.resultType) == "refined"
        && ((_b = lastActivity.channelData) === null || _b === void 0 ? void 0 : _b.resultId) === activity.channelData.resultId
        && lastActivity.attachments.length
        ? lastActivity.id
        : activity.id;
    react_1.useEffect(() => {
        var _a, _b;
        const resultSet = activities.filter(({ channelData }) => (channelData === null || channelData === void 0 ? void 0 : channelData.resultId) == activity.channelData.resultId);
        const carousels = resultSet.filter(({ channelData, attachments }) => (channelData === null || channelData === void 0 ? void 0 : channelData.resultType) == "refined"
            && attachments.length);
        const messages = resultSet.filter(({ channelData, attachments }) => (channelData === null || channelData === void 0 ? void 0 : channelData.resultType) == "refined"
            && !attachments.length);
        if (carousels[0].id != activity.id)
            return;
        let newState = {
            sortOrder: null,
            refiners: null,
            results: null,
            paging: null,
            promoted: null,
            stats: {
                start: 0,
                end: 0,
                total: 0
            }
        };
        let lastRefinementId = null;
        carousels.forEach((a, i) => {
            newState.sortOrder = a.attachments.find(t => t.name == "ICS.Flex.Results.SortOrder");
            newState.refiners = a.attachments.find(t => t.name == "ICS.Flex.Results.Refiners");
            newState.paging = a.attachments.find(t => t.name == "Results Navigator");
            if (lastRefinementId != a.channelData.refinementId) {
                newState.results = a.attachments.filter(t => t.name == "Result Card Attachment").map(t => (Object.assign(Object.assign({}, t), { $schema: models_1.SearchResultCardSchema })));
                newState.promoted = a.attachments.filter(t => t.name == "ICS.Flex.Results.Promoted").map(t => (Object.assign(Object.assign({}, t), { $schema: models_1.SearchResultCardSchema })));
            }
            else
                newState.results.push(...a.attachments.filter(t => t.name == "Result Card Attachment").map(t => (Object.assign(Object.assign({}, t), { $schema: models_1.SearchResultCardSchema }))));
            lastRefinementId = a.channelData.refinementId;
        });
        const lastMessage = messages.length
            ? messages[messages.length - 1]
            : null;
        if (lastMessage && lastMessage.channelData.refinementId == lastRefinementId) {
            const matches = lastMessage.text.match(/Here are suggestions (?<start>[1-9]|[1-9][0-9]|[1-9][0-9][0-9]) to (?<end>[1-9]|[1-9][0-9]|[1-9][0-9][0-9]) out of the (?<total>[1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9]) that I found./);
            if (matches === null || matches === void 0 ? void 0 : matches.groups) {
                newState.stats.start = 1;
                newState.stats.end = +matches.groups.end;
                newState.stats.total = +matches.groups.total;
            }
        }
        else if (newState.results.length > 0)
            newState.stats.start = newState.stats.end = newState.stats.total = 1;
        const pagingActions = (_b = (_a = newState.paging) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.actions;
        if (pagingActions === null || pagingActions === void 0 ? void 0 : pagingActions.length) {
            const prevActionIdx = pagingActions.findIndex(a => a.data.action == "previous");
            if (~prevActionIdx)
                pagingActions.splice(prevActionIdx, 1);
            const nextAction = pagingActions.find(a => a.data.action == "more");
            if (nextAction)
                nextAction.title = "View more";
        }
        setState(newState);
    }, [lastActivityId]);
    return react_1.useMemo(() => {
        var _a;
        return react_1.default.createElement("div", { className: [gridStyles.grid, gridStyles.padR].join(" ") }, state && react_1.default.createElement("div", { className: gridStyles.row },
            react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.sm12, gridStyles.padL].join(" ") },
                react_1.default.createElement(Bubble, { className: searchStyles.bubble, fromUser: false, nub: false },
                    react_1.default.createElement("div", { className: searchStyles.content }, state.stats.total > 1 ?
                        `Here are suggestions ${state.stats.start} to ${state.stats.end} out of the ${state.stats.total} that I found` :
                        state.stats.total == 1 ?
                            "Here is a suggestion that I found" :
                            "I couldn't find any suggestions for your query or refinement"))),
            (state.refiners || state.sortOrder) && react_1.default.createElement(chat_search_refiners_1.ChatSearchRefiners, { activity: activity, sortOrder: state.sortOrder, refiners: state.refiners }, children),
            ((_a = state.results) === null || _a === void 0 ? void 0 : _a.length) > 0 && react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.sm12, state.refiners ? gridStyles.lg8 : "", gridStyles.padL].join(" ") },
                react_1.default.createElement("div", null, state.promoted.map((promo, index) => react_1.default.createElement("div", { key: index, className: searchStyles.card }, children({ activity: activity, attachment: promo })))),
                react_1.default.createElement("div", null, state.results.map((r, i) => react_1.default.createElement("div", { key: i, className: searchStyles.card }, children({ activity: activity, attachment: r })))),
                state.paging && react_1.default.createElement("div", null, children({ activity: activity, attachment: state.paging })))));
    }, [state, gridStyles, searchStyles]);
};
exports.ChatSearchResults = ChatSearchResults;


/***/ }),

/***/ "./src/bot/cards/chat-search-results/index.ts":
/*!****************************************************!*\
  !*** ./src/bot/cards/chat-search-results/index.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-search-results.component */ "./src/bot/cards/chat-search-results/chat-search-results.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/cards/handle-carousel/handle-carousel.fn.tsx":
/*!**************************************************************!*\
  !*** ./src/bot/cards/handle-carousel/handle-carousel.fn.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.handleCarousel = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const __1 = __webpack_require__(/*! .. */ "./src/bot/cards/index.ts");
const handleCarousel = (props, activityInfo) => {
    const { activity, activity: { channelData: { resultType } = { resultType: null } } } = activityInfo;
    return resultType == "refined"
        ? children => react_1.default.createElement(__1.ChatSearchResults, { activity: activity }, children)
        : null;
};
exports.handleCarousel = handleCarousel;


/***/ }),

/***/ "./src/bot/cards/handle-carousel/index.ts":
/*!************************************************!*\
  !*** ./src/bot/cards/handle-carousel/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./handle-carousel.fn */ "./src/bot/cards/handle-carousel/handle-carousel.fn.tsx"), exports);


/***/ }),

/***/ "./src/bot/cards/handle-oauth/handle-oauth.fn.ts":
/*!*******************************************************!*\
  !*** ./src/bot/cards/handle-oauth/handle-oauth.fn.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.handleOAuth = void 0;
const handleOAuth = ({ store }, activityInfo) => {
    const { activity } = activityInfo;
    const { activities } = store.getState();
    const timestamp = new Date(activity.timestamp);
    const cutoff = new Date();
    const [lastMessage] = activities
        .filter(a => a.type === 'message')
        .slice(-1);
    cutoff.setMinutes(cutoff.getMinutes() - 5);
    return timestamp < cutoff || activity.id !== lastMessage.id
        ? false
        : null;
};
exports.handleOAuth = handleOAuth;


/***/ }),

/***/ "./src/bot/cards/handle-oauth/index.ts":
/*!*********************************************!*\
  !*** ./src/bot/cards/handle-oauth/index.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./handle-oauth.fn */ "./src/bot/cards/handle-oauth/handle-oauth.fn.ts"), exports);


/***/ }),

/***/ "./src/bot/cards/index.ts":
/*!********************************!*\
  !*** ./src/bot/cards/index.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-search-refiners */ "./src/bot/cards/chat-search-refiners/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-search-results */ "./src/bot/cards/chat-search-results/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./handle-carousel */ "./src/bot/cards/handle-carousel/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./handle-oauth */ "./src/bot/cards/handle-oauth/index.ts"), exports);


/***/ }),

/***/ "./src/bot/controls/bot-skill/bot-skill.component.tsx":
/*!************************************************************!*\
  !*** ./src/bot/controls/bot-skill/bot-skill.component.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BotSkill = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_3 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (({ theme: { palette, spacing, sizes, fonts } }) => ({
    card: {
        root: {
            borderRadius: spacing.small,
            border: `${spacing.tiny} solid ${palette.neutralMinus4}`,
            height: sizes.xxLarge,
            "& .card-description.ms-DocumentCardTitle": fonts.smallPlus,
            "& .ms-DocumentCardTitle": fonts.large
        },
    },
    preview: {
        root: {
            backgroundColor: palette.neutralMinus4,
            "div": {
                height: "100%"
            }
        },
        fileList: {},
        fileListIcon: {},
        fileListLink: {},
        fileListOverflowText: {},
        icon: {},
        previewIcon: {}
    }
}));
const BotSkill = ({ skill, onClick }) => {
    const { title, image, description } = skill;
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const preview = {
        previewImages: [
            {
                name: title,
                previewImageSrc: image,
                width: 64,
                imageFit: react_3.ImageFit.centerContain
            }
        ],
        styles: styles.preview
    };
    return (react_1.default.createElement(react_2.DocumentCard, { styles: styles.card, title: description, "aria-label": description, type: react_2.DocumentCardType.compact, onClick: () => onClick(skill) },
        react_1.default.createElement(react_2.DocumentCardPreview, Object.assign({}, preview)),
        react_1.default.createElement(react_2.DocumentCardDetails, null,
            react_1.default.createElement(react_2.DocumentCardTitle, { title: title, shouldTruncate: true }),
            react_1.default.createElement(react_2.DocumentCardTitle, { className: 'card-description', title: description, shouldTruncate: true }))));
};
exports.BotSkill = BotSkill;


/***/ }),

/***/ "./src/bot/controls/bot-skill/index.ts":
/*!*********************************************!*\
  !*** ./src/bot/controls/bot-skill/index.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./bot-skill.component */ "./src/bot/controls/bot-skill/bot-skill.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/chat-buttons/chat-buttons.component.tsx":
/*!******************************************************************!*\
  !*** ./src/bot/controls/chat-buttons/chat-buttons.component.tsx ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatButtons = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const send_button_1 = __webpack_require__(/*! ../send-button */ "./src/bot/controls/send-button/index.ts");
const clear_button_1 = __webpack_require__(/*! ../clear-button */ "./src/bot/controls/clear-button/index.ts");
const upload_button_1 = __webpack_require__(/*! ../upload-button */ "./src/bot/controls/upload-button/index.ts");
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const { useStyleOptions } = botframework_webchat_1.hooks;
const ChatButtons = ({ scope }) => {
    const [{ hideUploadButton }] = useStyleOptions();
    return react_1.useMemo(() => (react_1.default.createElement(react_1.default.Fragment, null,
        (scope === null || scope === void 0 ? void 0 : scope.target) == 'panel' &&
            react_1.default.createElement(clear_button_1.ClearButton, null),
        (scope === null || scope === void 0 ? void 0 : scope.target) != 'panel' && !hideUploadButton &&
            react_1.default.createElement(upload_button_1.UploadButton, null),
        react_1.default.createElement(send_button_1.SendButton, { scope: scope }))), [scope]);
};
exports.ChatButtons = ChatButtons;


/***/ }),

/***/ "./src/bot/controls/chat-buttons/index.ts":
/*!************************************************!*\
  !*** ./src/bot/controls/chat-buttons/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-buttons.component */ "./src/bot/controls/chat-buttons/chat-buttons.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/chat-context/chat-context.component.tsx":
/*!******************************************************************!*\
  !*** ./src/bot/controls/chat-context/chat-context.component.tsx ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = ({ theme: { palette, fonts, sizes, spacing }, }) => ({
    root: {
        backgroundColor: palette.primaryMinus2,
        transition: "background-color 300ms ease-in",
        padding: 0,
        border: "0",
        minHeight: sizes.large,
        borderRadius: spacing.small,
    },
    flexContainer: {
        padding: `0 ${spacing.medium}`,
        alignItems: "center",
    },
    rootHovered: {
        backgroundColor: palette.primary,
    },
    description: Object.assign(Object.assign({}, fonts.normalPlus), { textTransform: "uppercase", letterSpacing: spacing.tiny, lineHeight: "100%", color: palette.primaryMinus2On }),
    label: Object.assign(Object.assign({}, fonts.tiny), { fontWeight: "100", textTransform: "uppercase", letterSpacing: spacing.tiny, lineHeight: "100%", marginBottom: spacing.smallPlus, color: palette.primaryMinus2On }),
    icon: {
        color: palette.primaryMinus2On,
    },
    descriptionHovered: {
        color: palette.primaryOn,
    },
    labelHovered: {
        color: palette.primaryOn,
    },
    iconHovered: {
        color: palette.primaryOn,
    },
});
const ChatContext = ({ context, onClick }) => {
    const { description, title, subTitle, icon } = context;
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const iconProps = (icon === null || icon === void 0 ? void 0 : icon.length) ? {
        iconName: icon,
    }
        : null;
    return (react_1.default.createElement(react_2.CompoundButton, { onClick: () => onClick(context), styles: styles, secondaryText: title, text: subTitle, iconProps: iconProps, title: description, ariaLabel: title }));
};
exports.ChatContext = ChatContext;


/***/ }),

/***/ "./src/bot/controls/chat-context/index.ts":
/*!************************************************!*\
  !*** ./src/bot/controls/chat-context/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-context.component */ "./src/bot/controls/chat-context/chat-context.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/chat-controls/chat-controls-int.component.tsx":
/*!************************************************************************!*\
  !*** ./src/bot/controls/chat-controls/chat-controls-int.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatControlsInternal = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const chat_scope_menu_1 = __webpack_require__(/*! ../chat-scope-menu */ "./src/bot/controls/chat-scope-menu/index.ts");
const chat_text_box_1 = __webpack_require__(/*! ../chat-text-box */ "./src/bot/controls/chat-text-box/index.ts");
const search_text_box_1 = __webpack_require__(/*! ../search-text-box */ "./src/bot/controls/search-text-box/index.ts");
const chat_buttons_1 = __webpack_require__(/*! ../chat-buttons */ "./src/bot/controls/chat-buttons/index.ts");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const { SuggestedActions, DictationInterims } = botframework_webchat_1.Components;
const { useSendBoxSpeechInterimsVisible, useDirection } = botframework_webchat_1.hooks;
const useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b;
    const { palette, spacing, styles } = theme;
    const controls = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.chat) === null || _a === void 0 ? void 0 : _a.controls) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    return {
        root: ({ responsive }) => (Object.assign(Object.assign({ display: "flex", position: "relative", flexDirection: "row", height: "auto", backgroundColor: palette.neutralMinus3, boxSizing: "border-box", padding: spacing.medium, width: "100%" }, smarthub_common_1.themeStyle(controls.root, props)), { "&:focus-within $line": Object.assign({ opacity: 1 }, smarthub_common_1.themeStyle(controls.lineActive, props)) })),
        active: {},
        line: Object.assign({ position: "absolute", left: 0, right: 0, bottom: 0, height: spacing.xSmall, backgroundColor: palette.primaryMinus2, transition: "opacity 200ms ease-in", opacity: 0 }, smarthub_common_1.themeStyle(controls.line, props)),
        buttons: Object.assign({ alignItems: "center", display: "flex" }, smarthub_common_1.themeStyle(controls.buttons, props)),
        inputBar: Object.assign({ flex: "1 1", display: "flex", flexDirection: "row", boxSizing: "border-box", borderRadius: spacing.small, position: "relative", backgroundColor: palette.neutralEmpty, overflow: "hidden", height: "auto" }, smarthub_common_1.themeStyle(controls.inputBar, props)),
    };
});
const ChatControlsInternal = ({ coachmark, hideOnVisible = false, }) => {
    const view = smarthub_common_1.useViewConfig();
    const { visible } = smarthub_common_1.usePanelView("chat");
    const styleProps = smarthub_common_1.useStyleProps(null, view.chat.dockSizes);
    const styles = useStyles(styleProps);
    const textBoxRef = react_1.useRef();
    const localize = smarthub_common_1.useLocalizeConfig();
    const [speechInterimsVisible] = useSendBoxSpeechInterimsVisible();
    const [direction] = useDirection();
    const scope = smarthub_common_1.useChatScope();
    const register = smarthub_common_1.useRegisterFocus();
    const focus = react_1.useCallback(() => textBoxRef.current.focus(), []);
    const handleMenuClose = react_1.useCallback((selection) => {
        const { scope: nextScope } = selection || {};
        if ((nextScope === null || nextScope === void 0 ? void 0 : nextScope.target) == (scope === null || scope === void 0 ? void 0 : scope.target))
            focus();
    }, [scope]);
    react_1.useEffect(() => {
        if (visible != hideOnVisible)
            register("chat-controls", focus);
    }, [visible, hideOnVisible]);
    const changesRef = react_1.useRef({
        scope,
        hidden: hideOnVisible == visible,
    });
    react_1.useEffect(() => {
        const { current: { scope: currentScope, hidden: isHidden }, } = changesRef;
        const hidden = hideOnVisible == visible;
        const changed = hidden != isHidden || scope != currentScope;
        const { target } = scope || {};
        if (!hidden && (visible || (target == "panel" && changed)))
            focus();
        changesRef.current = {
            scope,
            hidden,
        };
    });
    return react_1.useMemo(() => {
        const { chatControlsLabel } = localize;
        const content = visible != hideOnVisible ? (react_1.default.createElement("div", { className: styles.root },
            react_1.default.createElement("div", { dir: direction, "aria-label": chatControlsLabel, role: "form", className: styles.inputBar },
                react_1.default.createElement(SuggestedActions, null),
                scope && react_1.default.createElement(chat_scope_menu_1.ChatScopeMenu, { onClose: handleMenuClose }),
                (scope === null || scope === void 0 ? void 0 : scope.target) == "panel" ? (react_1.default.createElement(search_text_box_1.SearchTextBox, { scope: scope, componentRef: textBoxRef })) : speechInterimsVisible ? (react_1.default.createElement(DictationInterims, null)) : (react_1.default.createElement(chat_text_box_1.ChatTextBox, { scope: scope, componentRef: textBoxRef })),
                react_1.default.createElement("div", { className: styles.buttons },
                    react_1.default.createElement(chat_buttons_1.ChatButtons, { scope: scope })),
                react_1.default.createElement("div", { className: styles.line })))) : null;
        return content && coachmark != null ? (react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, coachmark), content)) : (content);
    }, [visible == hideOnVisible, coachmark, styles, scope, localize]);
};
exports.ChatControlsInternal = ChatControlsInternal;


/***/ }),

/***/ "./src/bot/controls/chat-controls/chat-controls.component.tsx":
/*!********************************************************************!*\
  !*** ./src/bot/controls/chat-controls/chat-controls.component.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatControls = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const chat_controls_int_component_1 = __webpack_require__(/*! ./chat-controls-int.component */ "./src/bot/controls/chat-controls/chat-controls-int.component.tsx");
const ChatControls = ({ config: { coachmarks } }) => {
    const chromeCoachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(coachmark => coachmark.target === 'component-chrome');
    return react_1.default.createElement(chat_controls_int_component_1.ChatControlsInternal, { coachmark: chromeCoachmark });
};
exports.ChatControls = ChatControls;


/***/ }),

/***/ "./src/bot/controls/chat-controls/index.ts":
/*!*************************************************!*\
  !*** ./src/bot/controls/chat-controls/index.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-controls.component */ "./src/bot/controls/chat-controls/chat-controls.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-controls-int.component */ "./src/bot/controls/chat-controls/chat-controls-int.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/chat-hint/chat-hint.component.tsx":
/*!************************************************************!*\
  !*** ./src/bot/controls/chat-hint/chat-hint.component.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatHint = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (({ theme: { palette } }) => ({
    root: {
        transition: "background-color 300ms ease-in",
        backgroundColor: palette.neutralMinus1,
        borderRadius: "100px",
        border: 0
    },
    label: {
        transition: "color 150ms ease-in",
        color: palette.neutralMinus1On
    },
    rootHovered: {
        backgroundColor: palette.primaryMinus2
    },
    labelHovered: {
        color: palette.primaryMinus2On
    }
}));
const ChatHint = ({ hint, onClick }) => {
    var _a;
    const styleProps = smarthub_common_1.useThemeStyleProps();
    const styles = smarthub_common_1.useFluentStyles(fluentStyles, styleProps);
    const buttonText = ((_a = hint.text) === null || _a === void 0 ? void 0 : _a.length) ? hint.text : hint.value;
    return (react_1.default.createElement(react_2.DefaultButton, { styles: styles, text: buttonText, title: buttonText, ariaLabel: buttonText, onClick: () => onClick(hint) }));
};
exports.ChatHint = ChatHint;


/***/ }),

/***/ "./src/bot/controls/chat-hint/index.ts":
/*!*********************************************!*\
  !*** ./src/bot/controls/chat-hint/index.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-hint.component */ "./src/bot/controls/chat-hint/chat-hint.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/chat-scope-menu/chat-scope-compact-menu.component.tsx":
/*!********************************************************************************!*\
  !*** ./src/bot/controls/chat-scope-menu/chat-scope-compact-menu.component.tsx ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatScopeCompactMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_2 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const chat_hint_1 = __webpack_require__(/*! ../chat-hint */ "./src/bot/controls/chat-hint/index.ts");
const chat_context_1 = __webpack_require__(/*! ../chat-context */ "./src/bot/controls/chat-context/index.ts");
const bot_skill_1 = __webpack_require__(/*! ../bot-skill */ "./src/bot/controls/bot-skill/index.ts");
const useStyles = react_jss_1.createUseStyles(({ palette, spacing, sizes, fonts }) => ({
    menu: ({ width }) => ({
        backgroundColor: palette.neutralEmpty,
        color: palette.neutralEmptyOn,
        position: "relative",
        display: "flex",
        flexDirection: "column",
        width
    }),
    section: {
        boxSizing: "border-box",
        padding: spacing.medium,
    },
    header: {
        padding: `0 ${spacing.medium}`,
        lineHeight: sizes.normal,
        boxSizing: "border-box",
        backgroundColor: palette.neutralEmpty,
        color: palette.neutralEmptyOn,
        borderBottom: `${spacing.tiny} solid ${palette.neutralMinus1}`
    },
    rightButton: {
        position: "absolute",
        right: "0",
        color: "#444"
    },
    subTitle: Object.assign({ fontWeight: "100" }, fonts.large),
    title: Object.assign({ marginLeft: spacing.smallPlus, fontWeight: "500" }, fonts.large),
    description: Object.assign(Object.assign({}, fonts.small), { marginLeft: spacing.smallPlus, fontStyle: "italic" })
}));
const fluentStyles = (({ responsive: { colSize }, theme: { spacing } }) => ({
    root: {
        width: colSize
            ? colSize == 12
                ? '100%'
                : `calc(${smarthub_common_1.responsiveColumnWidths[colSize]} - ${spacing.medium})`
            : undefined
    }
}));
const stackTokens = {
    childrenGap: 12
};
const stackProps = {
    horizontal: true,
    tokens: stackTokens,
    wrap: true
};
const ChatScopeCompactMenu = (props) => {
    var _a, _b;
    const { scope, state, close } = props;
    const responsiveProps = react_2.useMemo(() => ({
        sm: {
            colSize: 12
        },
        md: {
            colSize: 12
        },
        lgx: {
            colSize: state.size != 'full' ? 12 : 6
        }
    }), [state]);
    const styleProps = smarthub_common_1.useThemeStyleProps(null, responsiveProps);
    const stackStyles = smarthub_common_1.useFluentStyles(fluentStyles, styleProps);
    const styles = useStyles(props);
    const scopes = smarthub_common_1.useChatScopes();
    const entity = smarthub_common_1.usePanelEntity();
    const invokeSkill = smarthub_common_1.useHandleSkill();
    const setScope = smarthub_common_1.useSetChatScope();
    const sendMessage = smarthub_common_1.useSendMessage();
    const handleHint = (hint) => {
        sendMessage(hint.value);
        close({ hint });
    };
    const handleSkill = (skill) => {
        invokeSkill({
            $id: "",
            $schema: smarthub_common_1.SkillActionSchema,
            ref: skill.$id,
            invokeText: skill.invokeText
        });
        close({ skill });
    };
    const handleContext = react_2.useCallback((scope) => {
        setScope(scope, { entity });
        close({ scope });
    }, [entity]);
    return (react_2.default.createElement("div", { className: styles.menu, role: "menu", "aria-label": "Select a hint or task,  or choose another topic." },
        react_2.default.createElement("header", { className: styles.header },
            react_2.default.createElement("span", { className: styles.subTitle }, scope.subTitle),
            react_2.default.createElement("span", { className: styles.title },
                scope.title,
                ":"),
            react_2.default.createElement("span", { className: styles.description }, scope.description),
            react_2.default.createElement(react_1.IconButton, { title: "Close the topic menu", className: styles.rightButton, onClick: () => { close(); } },
                react_2.default.createElement(react_1.Icon, { iconName: "ChromeClose" }))),
        ((_a = scope.hints) === null || _a === void 0 ? void 0 : _a.length) && react_2.default.createElement("section", { className: styles.section },
            react_2.default.createElement(react_1.Separator, null, "Suggestions and Hints"),
            react_2.default.createElement(react_1.Stack, Object.assign({}, stackProps), scope.hints.map((hint, i) => react_2.default.createElement(chat_hint_1.ChatHint, { key: i, hint: hint, onClick: handleHint })))),
        ((_b = scope.skills) === null || _b === void 0 ? void 0 : _b.length) && react_2.default.createElement("section", { className: styles.section },
            react_2.default.createElement(react_1.Separator, null, "Popular Tasks"),
            react_2.default.createElement(react_1.Stack, Object.assign({}, stackProps), scope.skills.map((skill, i) => react_2.default.createElement(react_1.StackItem, { key: i, styles: stackStyles },
                react_2.default.createElement(bot_skill_1.BotSkill, { skill: skill, onClick: handleSkill }))))),
        (scopes === null || scopes === void 0 ? void 0 : scopes.length) > 1 && react_2.default.createElement("section", { className: styles.section },
            react_2.default.createElement(react_1.Separator, null, "Other Topics"),
            react_2.default.createElement(react_1.Stack, Object.assign({}, stackProps), scopes.map((otherScope, i) => scope != otherScope && react_2.default.createElement(chat_context_1.ChatContext, { key: i, context: otherScope, onClick: handleContext }))))));
};
exports.ChatScopeCompactMenu = ChatScopeCompactMenu;


/***/ }),

/***/ "./src/bot/controls/chat-scope-menu/chat-scope-menu.component.tsx":
/*!************************************************************************!*\
  !*** ./src/bot/controls/chat-scope-menu/chat-scope-menu.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatScopeMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const chat_scope_compact_menu_component_1 = __webpack_require__(/*! ./chat-scope-compact-menu.component */ "./src/bot/controls/chat-scope-menu/chat-scope-compact-menu.component.tsx");
const useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing }) => ({
    scope: {
        position: "relative",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        background: palette.primaryMinus2,
        paddingLeft: spacing.medium,
        color: palette.primaryMinus2On,
        transition: "background-color 300ms ease-in",
        textTransform: "uppercase",
        letterSpacing: spacing.tiny,
        "&:hover": {
            background: palette.primary
        },
        height: "100%"
    },
    text: {
        flex: "1 1",
        whiteSpace: "nowrap"
    },
    title: Object.assign(Object.assign({}, fonts.mediumPlus), { lineHeight: fonts.mediumPlus.fontSize }),
    subTitle: Object.assign(Object.assign({}, fonts.tiny), { lineHeight: fonts.tiny.fontSize, marginBottom: spacing.small }),
    moreIcon: {
        fontSize: fonts.superLarge.fontSize,
        right: spacing.smallPlus,
        width: spacing.xLarge,
        color: palette.primaryMinus2On,
    },
    icon: {
        fontSize: fonts.superLarge.fontSize,
        marginRight: spacing.normal,
        color: palette.primaryMinus2On,
    }
}));
const onRenderPlainCard = (_a) => {
    var { buttonRef } = _a, rest = tslib_1.__rest(_a, ["buttonRef"]);
    const width = `${buttonRef.current.offsetParent.clientWidth}px`;
    return (react_1.default.createElement(chat_scope_compact_menu_component_1.ChatScopeCompactMenu, Object.assign({}, Object.assign(Object.assign({}, rest), { width }))));
};
//TODO localise
const ChatScopeMenu = ({ onClose }) => {
    var _a, _b, _c;
    const buttonRef = react_1.useRef(null);
    const hoverCard = react_1.useRef(null);
    const [sticky, setSticky] = react_1.useState(false);
    const scope = smarthub_common_1.useChatScope();
    const state = smarthub_common_1.usePanelView('chat');
    const styles = useStyles();
    const close = (selection) => {
        hoverCard.current.dismiss();
        if (onClose)
            onClose(selection);
    };
    const cardProps = {
        onRenderPlainCard,
        directionalHint: react_2.DirectionalHint.topLeftEdge,
        renderData: { scope, state, close, buttonRef },
        gapSpace: 6,
        calloutProps: {
            isBeakVisible: false,
            minPagePadding: 0
        },
    };
    return (react_1.default.createElement(react_2.HoverCard, { componentRef: hoverCard, "aria-label": "Select a chat topic.", plainCardProps: cardProps, trapFocus: true, sticky: sticky, type: react_2.HoverCardType.plain, cardDismissDelay: 500, instantOpenOnClick: true, openHotKey: react_2.KeyCodes.enter, onCardHide: () => setSticky(false) },
        react_1.default.createElement("div", { ref: buttonRef, className: styles.scope, role: "button", "aria-label": "Select a chat topic.", tabIndex: 0, onClick: () => setSticky(true) },
            ((_a = scope.icon) === null || _a === void 0 ? void 0 : _a.length) > 0 && react_1.default.createElement(react_2.Icon, { className: styles.icon, iconName: scope.icon, title: scope.description }),
            ((_b = scope.title) === null || _b === void 0 ? void 0 : _b.length) > 0 && react_1.default.createElement("div", { className: styles.text },
                ((_c = scope.subTitle) === null || _c === void 0 ? void 0 : _c.length) > 0 && react_1.default.createElement("div", { className: styles.subTitle }, scope.subTitle),
                react_1.default.createElement("div", { className: styles.title }, scope.title)),
            react_1.default.createElement(react_2.Icon, { className: styles.moreIcon, iconName: "MoreVertical", title: scope === null || scope === void 0 ? void 0 : scope.description }))));
};
exports.ChatScopeMenu = ChatScopeMenu;


/***/ }),

/***/ "./src/bot/controls/chat-scope-menu/index.ts":
/*!***************************************************!*\
  !*** ./src/bot/controls/chat-scope-menu/index.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-scope-menu.component */ "./src/bot/controls/chat-scope-menu/chat-scope-menu.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-scope-compact-menu.component */ "./src/bot/controls/chat-scope-menu/chat-scope-compact-menu.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/chat-text-box/chat-text-box.component.tsx":
/*!********************************************************************!*\
  !*** ./src/bot/controls/chat-text-box/chat-text-box.component.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatTextBox = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_component_1 = __webpack_require__(/*! botframework-webchat-component */ "botframework-webchat-component");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const chat_styles_1 = __webpack_require__(/*! ../chat.styles */ "./src/bot/controls/chat.styles.ts");
//const {useDisabled, useSubmitSendBox, useTextBoxValue, useScrollToEnd, useScrollUp, useScrollDown} = hooks;
const { useDisabled, useSubmitSendBox, useTextBoxValue, useScrollToEnd } = botframework_webchat_component_1.hooks;
const PREVENT_DEFAULT_HANDLER = (event) => event.preventDefault();
const ChatTextBox = ({ scope, componentRef }) => {
    var _a;
    const [disabled] = useDisabled();
    const ref = react_1.useRef();
    const chatPanelState = smarthub_common_1.usePanelView("chat");
    const setChatPanelState = smarthub_common_1.useSetPanelView("chat");
    const scrollToEnd = useScrollToEnd();
    //const scrollUp = useScrollUp();
    //const scrollDown = useScrollDown();
    const [textBoxValue, setTextBoxValue] = useTextBoxValue();
    const localize = smarthub_common_1.useLocalizeConfig();
    const submitSendBox = useSubmitSendBox();
    const styles = chat_styles_1.useInputStyles();
    const inputLabel = ((_a = scope === null || scope === void 0 ? void 0 : scope.placeholder) === null || _a === void 0 ? void 0 : _a.length) ? scope.placeholder
        : localize.chatPlaceholder;
    const placeholderText = inputLabel;
    const focus = react_1.useCallback(() => { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus(); }, []);
    const handleChange = react_1.useCallback(({ target: { value } }) => {
        setTextBoxValue(value, { selectionEnd: 0, selectionStart: 0 });
    }, [setTextBoxValue]);
    const handleKeyPress = react_1.useCallback((event) => {
        const { key, shiftKey } = event;
        if (key === "Enter" && !shiftKey) {
            event.preventDefault();
            submitSendBox();
            scrollToEnd();
        }
    }, [submitSendBox, scrollToEnd]);
    const handleSubmit = react_1.useCallback((event) => {
        event.preventDefault();
        submitSendBox();
        scrollToEnd();
    }, [submitSendBox, scrollToEnd]);
    const handleFocus = react_1.useCallback((e) => {
        if (!chatPanelState.visible && (!scope || (scope === null || scope === void 0 ? void 0 : scope.target) == "bot"))
            setChatPanelState(Object.assign(Object.assign({}, chatPanelState), { visible: true }));
    }, [chatPanelState, scope]);
    react_1.useEffect(() => {
        if (componentRef)
            componentRef.current = {
                focus,
                target: "bot",
                input: ref === null || ref === void 0 ? void 0 : ref.current,
            };
    }, []);
    return (react_1.default.createElement("form", { className: styles.form, "aria-disabled": disabled, onSubmit: disabled ? PREVENT_DEFAULT_HANDLER : handleSubmit },
        react_1.default.createElement("input", { id: "chatTextBox", name: "chatTextBox", type: "text", ref: ref, className: styles.text, placeholder: placeholderText, disabled: disabled, 
            //onKeyDown={disabled ? undefined : handleKeyDown}
            onChange: disabled ? undefined : handleChange, onKeyPress: disabled ? undefined : handleKeyPress, onFocus: disabled ? undefined : handleFocus, readOnly: disabled, "aria-label": inputLabel, value: textBoxValue })));
};
exports.ChatTextBox = ChatTextBox;


/***/ }),

/***/ "./src/bot/controls/chat-text-box/index.ts":
/*!*************************************************!*\
  !*** ./src/bot/controls/chat-text-box/index.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-text-box.component */ "./src/bot/controls/chat-text-box/chat-text-box.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/chat.styles.ts":
/*!*****************************************!*\
  !*** ./src/bot/controls/chat.styles.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.buttonStyles = exports.useInputStyles = void 0;
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
exports.useInputStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b;
    const { palette, fonts, spacing, styles } = theme;
    const controls = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.chat) === null || _a === void 0 ? void 0 : _a.controls) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    return {
        form: Object.assign({ width: "100%", display: "block", margin: 0 }, smarthub_common_1.themeStyle(controls.form, props)),
        text: Object.assign(Object.assign(Object.assign({}, fonts.normal), { border: ["none", "!important"], background: "transparent", padding: `0 ${spacing.medium}`, height: "100%", width: "100%", boxSizing: "border-box", color: palette.neutralEmptyOn, ["&::placeholder"]: Object.assign(Object.assign(Object.assign({}, fonts.normal), { color: palette.neutralPlus2 }), smarthub_common_1.themeStyle(controls.inputPlaceholder, props)), "&:focus-visible": Object.assign({ outline: "none" }, smarthub_common_1.themeStyle(controls.inputFocus, props)) }), smarthub_common_1.themeStyle(controls.input, props)),
    };
});
const buttonStyles = ({ theme }) => {
    var _a, _b;
    const { sizes, fonts, styles } = theme;
    const controls = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.chat) === null || _a === void 0 ? void 0 : _a.controls) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    return {
        root: Object.assign({ width: sizes.large, height: sizes.large }, smarthub_common_1.themeStyle(controls.button, props)),
        icon: Object.assign(Object.assign({}, fonts.superLarge), smarthub_common_1.themeStyle(controls.buttonIcon, props)),
    };
};
exports.buttonStyles = buttonStyles;


/***/ }),

/***/ "./src/bot/controls/clear-button/clear-button.component.tsx":
/*!******************************************************************!*\
  !*** ./src/bot/controls/clear-button/clear-button.component.tsx ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ClearButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_hooks_1 = __webpack_require__(/*! @fluentui/react-hooks */ "@fluentui/react-hooks");
const chat_styles_1 = __webpack_require__(/*! ../chat.styles */ "./src/bot/controls/chat.styles.ts");
const { useDisabled } = botframework_webchat_1.hooks;
const ClearButton = () => {
    const id = react_hooks_1.useId();
    const styles = smarthub_common_1.useFluentStylesWithProps(chat_styles_1.buttonStyles);
    const [keywords, setKeywords] = smarthub_common_1.useKeywords();
    const [disabled] = useDisabled();
    const focus = smarthub_common_1.useFocus();
    const localize = smarthub_common_1.useLocalizeConfig();
    const handleCancel = react_1.useCallback(() => {
        setKeywords("");
        focus('chat-controls');
    }, [focus, setKeywords]);
    return (react_1.default.createElement(react_1.default.Fragment, null, (keywords === null || keywords === void 0 ? void 0 : keywords.length) > 0 && react_1.default.createElement(react_2.TooltipHost, { id: id, directionalHint: react_2.DirectionalHint.topCenter, content: localize.chatClearTitle },
        react_1.default.createElement(react_2.IconButton, { name: localize.chatClearText, iconProps: {
                iconName: "Cancel"
            }, ariaLabel: localize.chatClearLabel, styles: styles, disabled: disabled, onClick: handleCancel }))));
};
exports.ClearButton = ClearButton;


/***/ }),

/***/ "./src/bot/controls/clear-button/index.ts":
/*!************************************************!*\
  !*** ./src/bot/controls/clear-button/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./clear-button.component */ "./src/bot/controls/clear-button/clear-button.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/index.ts":
/*!***********************************!*\
  !*** ./src/bot/controls/index.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./bot-skill */ "./src/bot/controls/bot-skill/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-buttons */ "./src/bot/controls/chat-buttons/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-context */ "./src/bot/controls/chat-context/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-controls */ "./src/bot/controls/chat-controls/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-hint */ "./src/bot/controls/chat-hint/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-scope-menu */ "./src/bot/controls/chat-scope-menu/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-text-box */ "./src/bot/controls/chat-text-box/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./clear-button */ "./src/bot/controls/clear-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./search-text-box */ "./src/bot/controls/search-text-box/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./send-button */ "./src/bot/controls/send-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./upload-button */ "./src/bot/controls/upload-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat.styles */ "./src/bot/controls/chat.styles.ts"), exports);


/***/ }),

/***/ "./src/bot/controls/search-text-box/index.ts":
/*!***************************************************!*\
  !*** ./src/bot/controls/search-text-box/index.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./search-text-box.component */ "./src/bot/controls/search-text-box/search-text-box.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/search-text-box/search-text-box.component.tsx":
/*!************************************************************************!*\
  !*** ./src/bot/controls/search-text-box/search-text-box.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SearchTextBox = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_component_1 = __webpack_require__(/*! botframework-webchat-component */ "botframework-webchat-component");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const chat_styles_1 = __webpack_require__(/*! ../chat.styles */ "./src/bot/controls/chat.styles.ts");
const { useTextBoxValue } = botframework_webchat_component_1.hooks;
//TODO move keywords into central state
const SearchTextBox = ({ scope, componentRef }) => {
    var _a;
    const localiseConfig = smarthub_common_1.useLocalizeConfig();
    const ref = react_1.useRef();
    const [textBoxValue, setTextBoxValue] = useTextBoxValue();
    const [keywords, setKeywords] = smarthub_common_1.useKeywords();
    const styles = chat_styles_1.useInputStyles();
    const inputLabel = ((_a = scope === null || scope === void 0 ? void 0 : scope.placeholder) === null || _a === void 0 ? void 0 : _a.length) ? scope.placeholder
        : localiseConfig.searchPlaceholder;
    const placeholderText = inputLabel;
    const focus = react_1.useCallback(() => { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus(); }, []);
    react_1.useEffect(() => {
        if (componentRef)
            componentRef.current = {
                focus,
                target: 'panel',
                input: ref === null || ref === void 0 ? void 0 : ref.current
            };
    }, []);
    react_1.useEffect(() => {
        setTextBoxValue(keywords !== null && keywords !== void 0 ? keywords : "", { selectionEnd: 0, selectionStart: 0 });
    }, [keywords]);
    const handleChange = react_1.useCallback(({ target: { value } }) => {
        setTextBoxValue(value, { selectionEnd: 0, selectionStart: 0 });
    }, [setTextBoxValue]);
    const handleSubmit = react_1.useCallback(event => {
        event.preventDefault();
        setKeywords(textBoxValue);
    }, [setKeywords, textBoxValue]);
    const handleKeyPress = react_1.useCallback(event => {
        const { key, shiftKey } = event;
        if (key === 'Enter' && !shiftKey) {
            event.preventDefault();
            setKeywords(textBoxValue);
        }
    }, [setKeywords, textBoxValue]);
    return (react_1.default.createElement("form", { className: styles.form, onSubmit: handleSubmit },
        react_1.default.createElement("input", { type: "text", ref: ref, className: styles.text, placeholder: placeholderText, onChange: handleChange, onKeyPress: handleKeyPress, "aria-label": inputLabel, value: textBoxValue })));
};
exports.SearchTextBox = SearchTextBox;


/***/ }),

/***/ "./src/bot/controls/send-button/index.ts":
/*!***********************************************!*\
  !*** ./src/bot/controls/send-button/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./send-button.component */ "./src/bot/controls/send-button/send-button.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/send-button/send-button.component.tsx":
/*!****************************************************************!*\
  !*** ./src/bot/controls/send-button/send-button.component.tsx ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SendButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_hooks_1 = __webpack_require__(/*! @fluentui/react-hooks */ "@fluentui/react-hooks");
const chat_styles_1 = __webpack_require__(/*! ../chat.styles */ "./src/bot/controls/chat.styles.ts");
const { MicrophoneButton } = botframework_webchat_1.Components;
const { useDisabled, useScrollToEnd, useSubmitSendBox, useTextBoxValue, useWebSpeechPonyfill, } = botframework_webchat_1.hooks;
const SendButton = ({ scope }) => {
    var _a;
    const id = react_hooks_1.useId();
    const styles = smarthub_common_1.useFluentStylesWithProps(chat_styles_1.buttonStyles);
    const [, setKeywords] = smarthub_common_1.useKeywords();
    const [disabled] = useDisabled();
    const focus = smarthub_common_1.useFocus();
    const scrollToEnd = useScrollToEnd();
    const submitSendBox = useSubmitSendBox();
    const [textBoxValue] = useTextBoxValue();
    const { chatQueryTitle, chatQueryLabel, chatSendTitle, chatSendLabel, chatSendText, chatQueryText, } = smarthub_common_1.useLocalizeConfig();
    const [{ SpeechRecognition }] = useWebSpeechPonyfill();
    const supportSpeechRecognition = !!SpeechRecognition;
    const handleSend = react_1.useCallback(() => {
        if ((scope === null || scope === void 0 ? void 0 : scope.target) == "panel")
            setKeywords(textBoxValue);
        else {
            scrollToEnd();
            submitSendBox();
        }
        focus("chat-controls");
    }, [focus, scrollToEnd, textBoxValue, submitSendBox, scope, setKeywords]);
    return supportSpeechRecognition ? (react_1.default.createElement(MicrophoneButton, null)) : (react_1.default.createElement(react_2.TooltipHost, { id: id, directionalHint: react_2.DirectionalHint.topCenter, content: (scope === null || scope === void 0 ? void 0 : scope.target) == "panel" ? chatQueryTitle : chatSendTitle },
        react_1.default.createElement(react_2.IconButton, { name: (scope === null || scope === void 0 ? void 0 : scope.target) == "panel" ? chatQueryText : chatSendText, iconProps: {
                iconName: (_a = scope === null || scope === void 0 ? void 0 : scope.buttonIcon) !== null && _a !== void 0 ? _a : "Send",
            }, ariaLabel: (scope === null || scope === void 0 ? void 0 : scope.target) == "panel" ? chatQueryLabel : chatSendLabel, styles: styles, disabled: disabled, onClick: handleSend })));
};
exports.SendButton = SendButton;


/***/ }),

/***/ "./src/bot/controls/upload-button/index.ts":
/*!*************************************************!*\
  !*** ./src/bot/controls/upload-button/index.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./upload-button.component */ "./src/bot/controls/upload-button/upload-button.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/controls/upload-button/upload-button.component.tsx":
/*!********************************************************************!*\
  !*** ./src/bot/controls/upload-button/upload-button.component.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UploadButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_hooks_1 = __webpack_require__(/*! @fluentui/react-hooks */ "@fluentui/react-hooks");
const chat_styles_1 = __webpack_require__(/*! ../chat.styles */ "./src/bot/controls/chat.styles.ts");
const { useDisabled, useSendFiles } = botframework_webchat_1.hooks;
const UploadButton = () => {
    const id = react_hooks_1.useId();
    const styles = smarthub_common_1.useFluentStylesWithProps(chat_styles_1.buttonStyles);
    const [disabled] = useDisabled();
    const localize = smarthub_common_1.useLocalizeConfig();
    const focus = smarthub_common_1.useFocus();
    const inputRef = react_1.useRef(null);
    const sendFiles = useSendFiles();
    const handleSend = react_1.useCallback(() => {
        inputRef.current && inputRef.current.click();
    }, [inputRef.current]);
    const handleFileChange = react_1.useCallback(({ target: { files } }) => {
        sendFiles(files);
        focus("chat-controls");
        if (inputRef.current) {
            inputRef.current.value = null;
        }
    }, [inputRef.current, sendFiles, focus]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", { style: { display: "none" }, "aria-disabled": disabled, multiple: true, onChange: handleFileChange, readOnly: disabled, ref: (elementRef) => (inputRef.current = elementRef), tabIndex: -1, type: "file" }),
        react_1.default.createElement(react_2.TooltipHost, { id: id, directionalHint: react_2.DirectionalHint.topCenter, content: localize.chatUploadTitle },
            react_1.default.createElement(react_2.IconButton, { name: localize.chatUploadText, iconProps: {
                    iconName: "Attach",
                }, ariaLabel: localize.chatUploadLabel, styles: styles, disabled: disabled, onClick: handleSend }))));
};
exports.UploadButton = UploadButton;


/***/ }),

/***/ "./src/bot/index.ts":
/*!**************************!*\
  !*** ./src/bot/index.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./cards */ "./src/bot/cards/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./controls */ "./src/bot/controls/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel */ "./src/bot/panel/index.ts"), exports);


/***/ }),

/***/ "./src/bot/panel/chat-footer/chat-footer.component.tsx":
/*!*************************************************************!*\
  !*** ./src/bot/panel/chat-footer/chat-footer.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatFooter = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_hooks_1 = __webpack_require__(/*! @fluentui/react-hooks */ "@fluentui/react-hooks");
const react_2 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const fluentStyles = (props) => {
    var _a, _b, _c;
    return ({
        root: Object.assign({ marginLeft: "auto" }, smarthub_common_1.themeStyle((_c = (_b = (_a = props.theme.styles) === null || _a === void 0 ? void 0 : _a.chat) === null || _b === void 0 ? void 0 : _b.footer) === null || _c === void 0 ? void 0 : _c.poweredBy, props)),
    });
};
const useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b;
    const { palette, spacing, styles, sizes, fonts } = theme;
    const footer = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.chat) === null || _a === void 0 ? void 0 : _a.footer) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    return {
        root: Object.assign({ display: "flex", backgroundColor: palette.neutralMinus3 }, smarthub_common_1.themeStyle(footer.root, props)),
        inner: {
            width: "100%",
        },
        nav: Object.assign({ display: "flex", width: "100%", height: sizes.large, alignItems: "center", boxSizing: "border-box", padding: `0 ${spacing.medium}` }, smarthub_common_1.themeStyle(footer.nav, props)),
        poweredByImage: Object.assign({ maxHeight: sizes.large }, smarthub_common_1.themeStyle(footer.poweredByImage, props)),
        poweredByLink: Object.assign({ display: "flex" }, smarthub_common_1.themeStyle(footer.poweredByLink, props)),
        link: Object.assign(Object.assign(Object.assign(Object.assign({}, fonts.normal), { boxSizing: "border-box", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }), smarthub_common_1.themeStyle(footer.link, props)), { fontWeight: (palette === null || palette === void 0 ? void 0 : palette.bold) == "true" ? "bold" : "normal" }),
    };
});
const getValue = (value, locale) => {
    return typeof value == "object" ? value[locale] : value;
};
const ChatFooter = ({ config: { props: { actions } = { actions: [] } }, }) => {
    const { chatFooterLabel, focusZoneHorizontalLabel, chatPoweredByAlt, chatPoweredByLabel, chatPoweredByTitle, } = smarthub_common_1.useLocalizeConfig();
    const styles = useStyles();
    const toolTipStyles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const id = react_hooks_1.useId();
    const locale = smarthub_common_1.useLocale();
    const { poweredByUri } = smarthub_common_1.useSourceInfo();
    const footer = react_2.useRef();
    const register = smarthub_common_1.useRegisterFocus();
    const imageUri = smarthub_common_1.useThemeImageURI(smarthub_common_1.ImageKeys.chatPoweredBy);
    react_2.useEffect(() => {
        register("chat-footer", () => {
            footer.current.focus();
        });
    }, []);
    return (react_2.default.createElement("div", { className: styles.root },
        react_2.default.createElement(react_1.FocusZone, { componentRef: footer, direction: react_1.FocusZoneDirection.horizontal, className: [styles.inner].join(" ") },
            react_2.default.createElement("nav", { className: styles.nav, "aria-label": `${chatFooterLabel} ${focusZoneHorizontalLabel}` }, actions === null || actions === void 0 ? void 0 :
                actions.map(({ name, action, title, description, shortTitle }) => {
                    return (react_2.default.createElement(utilities_1.ActionLink, { key: name, action: action, title: getValue(title, locale), label: getValue(description, locale), className: styles.link, headerLevel: false }, getValue(shortTitle, locale)));
                }),
                (poweredByUri === null || poweredByUri === void 0 ? void 0 : poweredByUri.length) > 0 && (react_2.default.createElement(react_1.TooltipHost, { styles: toolTipStyles, id: id, directionalHint: react_1.DirectionalHint.topCenter, content: chatPoweredByTitle },
                    react_2.default.createElement("a", { target: "_blank", "aria-label": chatPoweredByLabel, className: styles.poweredByLink, href: poweredByUri },
                        react_2.default.createElement("img", { className: styles.poweredByImage, alt: chatPoweredByAlt, src: imageUri }))))))));
};
exports.ChatFooter = ChatFooter;


/***/ }),

/***/ "./src/bot/panel/chat-footer/index.ts":
/*!********************************************!*\
  !*** ./src/bot/panel/chat-footer/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-footer.component */ "./src/bot/panel/chat-footer/chat-footer.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/panel/chat-header/chat-header.component.tsx":
/*!*************************************************************!*\
  !*** ./src/bot/panel/chat-header/chat-header.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatHeader = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b, _c;
    const { palette, spacing, styles, sizes, fonts } = theme;
    const header = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.chat) === null || _a === void 0 ? void 0 : _a.header) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    return {
        root: Object.assign({ display: "flex", backgroundColor: palette.primary }, smarthub_common_1.themeStyle(header.root, props)),
        imageSection: Object.assign({ padding: spacing.normal, display: "flex" }, smarthub_common_1.themeStyle(header.imageSection, props)),
        image: Object.assign(Object.assign({}, (_c = styles === null || styles === void 0 ? void 0 : styles.chatHeader) === null || _c === void 0 ? void 0 : _c.image), { display: "block !important" }),
        titleSection: Object.assign(Object.assign({ marginLeft: spacing.normal, boxSizing: "border-box", display: "flex", flexDirection: "column", justifyContent: "space-evenly" }, smarthub_common_1.themeStyle(header.titleSection, props)), { "& h1$title": Object.assign(Object.assign(Object.assign({}, fonts.superLarge), { margin: "0px !important", border: "0px !important", padding: "0px !important", boxSizing: "border-box", lineHeight: sizes.normal, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textTransform: "none !important", color: `${palette.primaryOn} !important` }), smarthub_common_1.themeStyle(header.title, props)), "& h2$subTitle": Object.assign(Object.assign(Object.assign({}, fonts.normal), { margin: "0px !important", border: "0px !important", padding: "0px !important", boxSizing: "border-box", lineHeight: sizes.small, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textTransform: "none !important", color: `${palette.primaryOn} !important` }), smarthub_common_1.themeStyle(header.subTitle, props)) }),
        title: {},
        subTitle: {},
    };
});
const ChatHeader = () => {
    const localize = smarthub_common_1.useLocalizeConfig();
    const styles = useStyles();
    const imageUri = smarthub_common_1.useThemeImageURI(smarthub_common_1.ImageKeys.chatHead);
    return (react_1.default.createElement("div", { className: styles.root },
        react_1.default.createElement("div", { className: styles.imageSection },
            react_1.default.createElement("img", { className: styles.image, alt: localize.chatHeadImageAlt, src: imageUri })),
        react_1.default.createElement("div", { className: styles.titleSection },
            react_1.default.createElement("h1", { className: styles.title, "aria-label": localize.chatHeadTitleLabel }, localize.chatHeadTitle),
            react_1.default.createElement("h2", { className: styles.subTitle, "aria-label": localize.chatHeadSubTitleLabel }, localize.chatHeadSubTitle))));
};
exports.ChatHeader = ChatHeader;


/***/ }),

/***/ "./src/bot/panel/chat-header/index.ts":
/*!********************************************!*\
  !*** ./src/bot/panel/chat-header/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-header.component */ "./src/bot/panel/chat-header/chat-header.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/panel/chat-launcher/chat-launcher.component.tsx":
/*!*****************************************************************!*\
  !*** ./src/bot/panel/chat-launcher/chat-launcher.component.tsx ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatLauncher = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_2 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const useStyles = react_jss_1.createUseStyles(({ palette, spacing }) => ({
    fullRight: () => ({
        width: "33.3333% !important",
        zIndex: 9999,
        top: "45px !important",
        left: "0 !important",
        right: "auto !important",
    }),
    fullLeft: () => ({
        width: "33.3333% !important",
        zIndex: 9999,
        top: "45px !important",
        right: "0 !important",
        left: "auto !important",
    }),
    root: (props) => {
        var _a;
        return ({
            position: "absolute",
            background: ((_a = props === null || props === void 0 ? void 0 : props.body) === null || _a === void 0 ? void 0 : _a.background) || "rgba(255,255,255)",
            color: "#333",
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            "& *::-webkit-scrollbar": {
                width: spacing.medium,
                height: spacing.medium,
                border: "0",
            },
            "& *:hover::-webkit-scrollbar": {
                width: spacing.medium,
                height: spacing.medium,
            },
        });
    },
    inner: () => ({
        overflow: "auto",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
    }),
    toggleBtn: (props) => {
        var _a, _b;
        return ({
            width: "30px",
            height: "30px",
            padding: "10px",
            zIndex: 9999,
            background: ((_a = props === null || props === void 0 ? void 0 : props.toggleButton) === null || _a === void 0 ? void 0 : _a.background) || palette.primary,
            color: ((_b = props === null || props === void 0 ? void 0 : props.toggleButton) === null || _b === void 0 ? void 0 : _b.color) || "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            borderRadius: "50%",
            top: "calc(50% - 15px)",
            cursor: "pointer",
        });
    },
    toggleBtnRight: () => ({
        left: "-15px",
    }),
    toggleBtnLeft: () => ({
        right: "-15px",
    }),
    right: () => ({
        right: "0",
        borderRight: "1px solid #ddd",
        transition: "right 0.3s ease",
    }),
    visibleRight: () => ({
        right: "100%",
        boxShadow: "rgb(0 0 0 / 12%) -4px 0px 8px",
    }),
    selected: () => ({
        boxShadow: "0 0 0 4px #333",
    }),
    left: () => ({
        left: "0",
        borderLeft: "1px solid #ddd",
        transition: "left 0.3s ease",
    }),
    visibleLeft: () => ({
        left: "100%",
        boxShadow: "rgb(0 0 0 / 12%) 4px 0px 8px",
    }),
    topBar: (props) => ({
        height: "44px",
        minHeight: "44px",
        borderBottom: "1px solid #ddd",
        padding: "0 0px",
        position: "relative",
        display: "flex",
        alignItems: "center",
    }),
    title: (props) => {
        var _a, _b, _c, _d, _e;
        return ({
            color: ((_a = props === null || props === void 0 ? void 0 : props.title) === null || _a === void 0 ? void 0 : _a.color) || "#333",
            fontSize: ((_b = props === null || props === void 0 ? void 0 : props.title) === null || _b === void 0 ? void 0 : _b.fontSize) || "22px",
            fontWeight: ((_c = props === null || props === void 0 ? void 0 : props.title) === null || _c === void 0 ? void 0 : _c.fontWeight) || "600",
            lineHeight: ((_d = props === null || props === void 0 ? void 0 : props.title) === null || _d === void 0 ? void 0 : _d.lineHeight) || "1.2em",
            margin: ((_e = props === null || props === void 0 ? void 0 : props.title) === null || _e === void 0 ? void 0 : _e.margin) || "0px 35px 10px 0px",
            display: "flex",
        });
    },
    subtitle: (props) => {
        var _a, _b, _c, _d, _e;
        return ({
            color: ((_a = props === null || props === void 0 ? void 0 : props.subtitle) === null || _a === void 0 ? void 0 : _a.color) || "#333",
            fontSize: ((_b = props === null || props === void 0 ? void 0 : props.subtitle) === null || _b === void 0 ? void 0 : _b.fontSize) || "13px",
            fontWeight: ((_c = props === null || props === void 0 ? void 0 : props.subtitle) === null || _c === void 0 ? void 0 : _c.fontWeight) || "400",
            lineHeight: ((_d = props === null || props === void 0 ? void 0 : props.subtitle) === null || _d === void 0 ? void 0 : _d.lineHeight) || "1.2em",
            margin: ((_e = props === null || props === void 0 ? void 0 : props.subtitle) === null || _e === void 0 ? void 0 : _e.margin) || "0px",
        });
    },
    sectionWrapper: () => ({
        display: "flex",
        flexDirection: "column",
        gap: "10px",
    }),
    sectionHeader: (props) => {
        var _a, _b, _c, _d, _e;
        return ({
            color: ((_a = props === null || props === void 0 ? void 0 : props.sectionTitle) === null || _a === void 0 ? void 0 : _a.color) || "#333",
            fontSize: ((_b = props === null || props === void 0 ? void 0 : props.sectionTitle) === null || _b === void 0 ? void 0 : _b.fontSize) || "17px",
            fontWeight: ((_c = props === null || props === void 0 ? void 0 : props.sectionTitle) === null || _c === void 0 ? void 0 : _c.fontWeight) || "600",
            lineHeight: ((_d = props === null || props === void 0 ? void 0 : props.sectionTitle) === null || _d === void 0 ? void 0 : _d.lineHeight) || "1.2em",
            margin: ((_e = props === null || props === void 0 ? void 0 : props.sectionTitle) === null || _e === void 0 ? void 0 : _e.margin) || "0px 0px 10px 0px",
            display: "flex",
        });
    },
    sectionText: (props) => {
        var _a, _b, _c, _d, _e;
        return ({
            color: ((_a = props === null || props === void 0 ? void 0 : props.sectionSubtitle) === null || _a === void 0 ? void 0 : _a.color) || "#333",
            fontSize: ((_b = props === null || props === void 0 ? void 0 : props.sectionSubtitle) === null || _b === void 0 ? void 0 : _b.fontSize) || "13px",
            fontWeight: ((_c = props === null || props === void 0 ? void 0 : props.sectionSubtitle) === null || _c === void 0 ? void 0 : _c.fontWeight) || "400",
            lineHeight: ((_d = props === null || props === void 0 ? void 0 : props.sectionSubtitle) === null || _d === void 0 ? void 0 : _d.lineHeight) || "1.2em",
            margin: ((_e = props === null || props === void 0 ? void 0 : props.sectionSubtitle) === null || _e === void 0 ? void 0 : _e.margin) || "0px",
        });
    },
    buttonWrapper: () => ({
        display: "flex",
        flexDirection: "column",
        gap: "10px",
    }),
    button: (props) => {
        var _a, _b, _c, _d, _e;
        return ({
            padding: ((_a = props === null || props === void 0 ? void 0 : props.button) === null || _a === void 0 ? void 0 : _a.padding) || "15px 10px",
            background: ((_b = props === null || props === void 0 ? void 0 : props.button) === null || _b === void 0 ? void 0 : _b.background) || palette.primary,
            border: ((_c = props === null || props === void 0 ? void 0 : props.button) === null || _c === void 0 ? void 0 : _c.border) || "none !important",
            textAlign: ((_d = props === null || props === void 0 ? void 0 : props.button) === null || _d === void 0 ? void 0 : _d.textAlign) || "center",
            borderRadius: ((_e = props === null || props === void 0 ? void 0 : props.button) === null || _e === void 0 ? void 0 : _e.borderRadius) || "5px",
            display: "flex",
            cursor: "pointer",
            position: "relative",
            gap: "10px",
        });
    },
    buttonIcon: (props) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return ({
            margin: ((_b = (_a = props === null || props === void 0 ? void 0 : props.button) === null || _a === void 0 ? void 0 : _a.icon) === null || _b === void 0 ? void 0 : _b.margin) || "0px",
            fontSize: ((_d = (_c = props === null || props === void 0 ? void 0 : props.button) === null || _c === void 0 ? void 0 : _c.icon) === null || _d === void 0 ? void 0 : _d.fontSize) || "30px",
            display: "flex",
            alignSelf: "center",
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
            "& img": {
                height: ((_f = (_e = props === null || props === void 0 ? void 0 : props.button) === null || _e === void 0 ? void 0 : _e.icon) === null || _f === void 0 ? void 0 : _f.height) || "30px",
                width: ((_h = (_g = props === null || props === void 0 ? void 0 : props.button) === null || _g === void 0 ? void 0 : _g.icon) === null || _h === void 0 ? void 0 : _h.width) || "auto",
            },
        });
    },
    buttonText: (props) => {
        var _a, _b, _c, _d;
        return ({
            padding: ((_b = (_a = props === null || props === void 0 ? void 0 : props.button) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.padding) || "0px",
            color: ((_d = (_c = props === null || props === void 0 ? void 0 : props.button) === null || _c === void 0 ? void 0 : _c.text) === null || _d === void 0 ? void 0 : _d.color) || "white",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            flex: 1,
        });
    },
    buttonTitle: (props) => {
        var _a;
        return ({
            fontSize: ((_a = props === null || props === void 0 ? void 0 : props.button) === null || _a === void 0 ? void 0 : _a.titleFontSize) || "18px",
            fontWeight: "600",
        });
    },
    buttonSubtitle: (props) => {
        var _a;
        return ({
            fontSize: ((_a = props === null || props === void 0 ? void 0 : props.button) === null || _a === void 0 ? void 0 : _a.subtitleFontSize) || "12px",
            lineHeight: "1.2em",
        });
    },
    page: () => ({
        background: "white",
        position: "absolute",
        height: "100%",
        width: "100%",
        zIndex: -1,
        right: "0",
        transition: "right 0.3s ease",
    }),
    pageVisible: () => ({
        right: "100%",
        boxShadow: "rgb(0 0 0 / 12%) -4px 0px 8px",
    }),
    header: () => ({
        display: "flex",
        gap: "10px",
        position: "relative",
    }),
    titleSection: () => ({
        display: "flex",
        flexDirection: "column",
        flex: 1,
    }),
    closeButton: () => ({
        position: "absolute",
        right: "0px",
        padding: "10px",
        top: "0",
        height: "100%",
    }),
    breadcrumb: () => ({
        height: "100%",
        padding: "0px",
        display: "flex",
        alignItems: "center",
    }),
    breadcrumbButton: () => ({
        height: "100%",
        padding: "0px 10px",
    }),
    homeButton: () => ({
        height: "100%",
        padding: "10px",
        borderRight: "1px solid #ddd",
    }),
    backButton: () => ({
        height: "100%",
        padding: "10px",
        borderRight: "1px solid #ddd",
    }),
    "@media (max-width: 640px)": () => ({
        root: {
            zIndex: 99,
        },
        right: {
            right: "-100%",
        },
        visibleRight: {
            right: "0",
        },
        left: {
            left: "-100%",
        },
        visibleLeft: {
            left: "0",
        },
        toggleBtn: {
            display: "none",
        },
    }),
}));
const ChatLauncher = ({ config: { props: { enabled, config, configUri }, }, }) => {
    const invokeSkill = smarthub_common_1.useHandleSkill();
    const locale = smarthub_common_1.useLocale();
    const sendMessage = smarthub_common_1.useSendMessage();
    const sendBackChannel = smarthub_common_1.useSendBackChannel();
    const [, setSelectedPage] = smarthub_common_1.usePage();
    const [personality, setPersonality] = smarthub_common_1.usePersonality();
    const chatPanelState = smarthub_common_1.usePanelView("chat");
    const [activeSections, setActiveSections] = react_2.useState([]);
    const setLauncherState = smarthub_common_1.useSetPreference(smarthub_common_1.preferenceKeys.chatLauncherState);
    // load JSON from configUri
    const [configParams, setConfigParams] = react_2.useState();
    const launcherConfig = react_2.useMemo(() => {
        return configParams || config;
    }, [configParams, config]);
    react_2.useEffect(() => {
        if (configUri) {
            fetch(configUri)
                .then((response) => response.json())
                .then((data) => {
                setConfigParams(data);
            })
                .catch((error) => {
                console.log("Failed to load config from " + configUri);
            });
        }
    }, [configUri]);
    const styles = useStyles(launcherConfig.styles);
    const [dockPostion] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys.chatDockPosition, false);
    const [launcherState] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys.chatLauncherState, false);
    const { chat: { dockPositions: { preferred: position }, }, } = smarthub_common_1.useViewConfig();
    const preferredPosition = react_2.useMemo(() => {
        if (dockPostion) {
            return dockPostion;
        }
        return position;
    }, [dockPostion, position]);
    const isVisible = react_2.useMemo(() => {
        if (launcherState == "open") {
            return true;
        }
        return false;
    }, [launcherState]);
    const toggleLauncher = react_2.useCallback(() => {
        if (launcherState == "open") {
            setLauncherState("closed");
        }
        else {
            setLauncherState("open");
        }
    }, [launcherState]);
    const processButtonTitle = react_2.useCallback((data) => {
        let suffix = "";
        let hasLinkAction = data.actions.find((action) => action.action === "Link");
        if (hasLinkAction) {
            if (hasLinkAction.target === "_blank") {
                suffix = " (Opens in new window)";
            }
        }
        return data.title[locale] + suffix;
    }, [locale]);
    const processButtonAction = (data) => {
        data.actions.forEach((data) => {
            switch (data.action) {
                case "Skill": {
                    invokeSkill({
                        $id: "",
                        $schema: smarthub_common_1.SkillActionSchema,
                        ref: data.dllReference,
                        invokeText: data.involkeText[locale],
                    });
                    break;
                }
                case "Nav": {
                    let newActiveSections = JSON.parse(JSON.stringify(activeSections));
                    if (data.sectionId === "back") {
                        // remove the last section
                        newActiveSections.pop();
                    }
                    else {
                        newActiveSections.push({
                            id: data.sectionId,
                            name: data.sectionName[locale],
                        });
                    }
                    setActiveSections(newActiveSections);
                    break;
                }
                case "Link": {
                    window.open(data.url, data.target);
                    break;
                }
                case "Message": {
                    sendMessage(data.message[locale], data.involkeText[locale]);
                    break;
                }
                case "Page": {
                    setSelectedPage({
                        id: data.pageId,
                    });
                    break;
                }
                case "UserBackChannel": {
                    sendBackChannel({
                        type: "context.user",
                        version: "1.0",
                        payload: data.payload,
                    });
                }
                case "Personality": {
                    setPersonality(data.personality);
                    sendBackChannel({
                        type: "context.user",
                        version: "1.0",
                        payload: {
                            personality: data.personality,
                            showHintsCard: true,
                        },
                    });
                    break;
                }
            }
        });
    };
    const isSelected = react_2.useCallback((data) => {
        // if there is a personality defined in data.actions array
        if (data.actions) {
            let personalityAction = data.actions.find((action) => action.action == "Personality");
            if (personalityAction) {
                if (personalityAction.personality == personality) {
                    return styles.selected;
                }
                return null;
            }
        }
        return null;
    }, [personality]);
    const renderChild = react_2.useCallback((child, index) => {
        switch (child.type) {
            case "Button":
                let data = child.config;
                return (react_2.default.createElement(VisibilityManager, { key: index, config: child.visibility },
                    react_2.default.createElement("button", { tabIndex: 0, className: [styles.button, isSelected(data)].join(" "), role: "button", style: Object.assign(data.styles || {}), "aria-label": processButtonTitle(data), title: processButtonTitle(data), onKeyPress: (e) => {
                            if (e.key == "Enter")
                                processButtonAction(data);
                        }, onClick: () => {
                            processButtonAction(data);
                        } },
                        data.imageUrl && (react_2.default.createElement("div", { className: styles.buttonIcon },
                            react_2.default.createElement("img", { src: data.imageUrl }))),
                        react_2.default.createElement("div", { className: styles.buttonText },
                            react_2.default.createElement("div", { className: styles.buttonTitle }, data.title[locale]),
                            react_2.default.createElement("div", { className: styles.buttonSubtitle }, data.subtitle[locale])))));
            default:
                return null;
        }
    }, [personality, locale, activeSections]);
    if (!launcherConfig || !enabled)
        return null;
    let { subsections } = launcherConfig;
    let activeSection = react_2.default.useMemo(() => {
        if (!activeSections)
            return null;
        if (activeSections.length == 0)
            return null;
        return subsections.find((section) => {
            let as = activeSections[activeSections.length - 1];
            return section.id === as.id;
        });
    }, [activeSections, subsections]);
    const renderNav = react_2.useCallback(() => {
        if (!launcherConfig)
            return null;
        let nav = activeSection || launcherConfig;
        return (react_2.default.createElement("div", { className: styles.inner },
            react_2.default.createElement("div", { className: styles.header }, (nav.title[locale] || nav.subtitle[locale]) && (react_2.default.createElement("div", { className: styles.titleSection },
                nav.title[locale] && (react_2.default.createElement("div", { className: styles.title }, nav.title[locale])),
                nav.subtitle[locale] && (react_2.default.createElement("div", { className: styles.subtitle }, nav.subtitle[locale]))))),
            nav.sections && (react_2.default.createElement(react_2.default.Fragment, null, nav.sections.map((section, index) => {
                return (react_2.default.createElement("div", { key: index, className: styles.sectionWrapper },
                    react_2.default.createElement("div", null,
                        react_2.default.createElement("div", { className: styles.sectionHeader }, section.title[locale]),
                        react_2.default.createElement("div", { className: styles.sectionText }, section.subtitle[locale])),
                    react_2.default.createElement("div", null, section.children && (react_2.default.createElement("div", { className: styles.buttonWrapper }, section.children.map((child, index) => renderChild(child, index)))))));
            })))));
    }, [launcherConfig, activeSection, locale]);
    let menu_section = react_2.useMemo(() => {
        // get the last section in the array
        if (!activeSections)
            return null;
        if (activeSections.length == 0)
            return null;
        let section = activeSections[activeSections.length - 1];
        return section;
    }, [activeSections]);
    let submenu_sections = react_2.useMemo(() => {
        // get the last section in the array
        if (!activeSections)
            return null;
        if (activeSections.length == 0)
            return null;
        let section = activeSections[activeSections.length - 1];
        return activeSections.filter((s) => s.id !== section.id);
    }, [activeSections]);
    return (react_2.default.createElement("div", { "aria-label": "Chat Launcher", className: [
            styles.root,
            preferredPosition === "right" ? styles.right : styles.left,
            chatPanelState.size === "full"
                ? preferredPosition === "right"
                    ? styles.fullRight
                    : styles.fullLeft
                : isVisible &&
                    (preferredPosition === "right"
                        ? styles.visibleRight
                        : styles.visibleLeft),
        ].join(" ") },
        chatPanelState.size !== "full" && (react_2.default.createElement(react_1.IconButton, { styles: {
                rootHovered: { color: "#333" },
            }, title: "Toggle the Action Panel", className: [
                styles.toggleBtn,
                preferredPosition === "right"
                    ? styles.toggleBtnRight
                    : styles.toggleBtnLeft,
            ].join(" "), style: {
                visibility: isVisible ? "hidden" : "visible",
                transform: preferredPosition === "right"
                    ? isVisible
                        ? "rotate(180deg)"
                        : "rotate(0deg)"
                    : isVisible
                        ? "rotate(0deg)"
                        : "rotate(180deg)",
            }, onClick: () => {
                toggleLauncher();
            } },
            react_2.default.createElement("svg", { style: { width: "10px" }, fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512" },
                react_2.default.createElement("path", { d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" })))),
        react_2.default.createElement("div", { className: styles.topBar },
            react_2.default.createElement(react_1.CommandBarButton, { iconProps: { iconName: "Home" }, "aria-label": "Go to the actions panel home page", title: "Go to the actions panel home page", className: styles.homeButton, onClick: () => {
                    setActiveSections([]);
                } }),
            activeSection && (react_2.default.createElement(react_2.default.Fragment, null,
                react_2.default.createElement(react_1.CommandBarButton, { iconProps: { iconName: "ChevronLeft" }, className: styles.backButton, "aria-label": "Go back one level", title: "Go back one level", onClick: () => {
                        //deep clone activeSections
                        let newActiveSections = JSON.parse(JSON.stringify(activeSections));
                        newActiveSections.pop();
                        setActiveSections(newActiveSections);
                    } }),
                react_2.default.createElement("span", { className: styles.breadcrumb }, menu_section && (react_2.default.createElement(react_1.CommandBarButton, { text: `${menu_section.name}`, className: styles.breadcrumbButton, "aria-label": "View the breadcrumb menu", title: "View the breadcrumb menu", menuProps: {
                        items: submenu_sections.reverse().map((section, index) => {
                            return {
                                key: section.id,
                                text: section.name,
                                onClick: () => {
                                    //deep clone activeSections
                                    let newActiveSections = JSON.parse(JSON.stringify(activeSections));
                                    //remove all sections after this one (the subsections array is reversed)
                                    newActiveSections.splice(newActiveSections.findIndex((s) => s.id === section.id) + 1);
                                    setActiveSections(newActiveSections);
                                },
                            };
                        }),
                    } }))))),
            chatPanelState.size !== "full" && (react_2.default.createElement(react_1.CommandBarButton, { iconProps: { iconName: "ChromeClose" }, className: styles.closeButton, title: "Close the actions panel menu", "aria-label": "Close the actions panel menu", onClick: () => {
                    toggleLauncher();
                } }))),
        renderNav()));
};
exports.ChatLauncher = ChatLauncher;
const VisibilityManager = ({ children, config }) => {
    if (!config)
        return react_2.default.createElement(react_2.default.Fragment, null, children);
    if (config.startDateTime) {
        let startDate = new Date(config.startDateTime);
        if (startDate > new Date()) {
            return null;
        }
    }
    if (config.endDateTime) {
        let endDate = new Date(config.endDateTime);
        if (endDate < new Date()) {
            return null;
        }
    }
    // if config.personalities contains the active personality
    if (config.personalities && config.personalities.length > 0) {
        let activePersonality = "Generic"; //getActivePersonality();
        if (activePersonality) {
            // make sure each personality is lowercase and compare
            let activePersonalityLower = activePersonality.toLowerCase();
            let found = config.personalities.find((p) => p.toLowerCase().includes(activePersonalityLower));
            if (!found) {
                return null;
            }
        }
    }
    // if config.urlRegex has a value and the current URL doesn't match then return null
    if (config.urlRegex) {
        let url = window.location.href;
        if (!url.match(config.urlRegex)) {
            return null;
        }
    }
    return react_2.default.createElement(react_2.default.Fragment, null, children);
};


/***/ }),

/***/ "./src/bot/panel/chat-launcher/index.ts":
/*!**********************************************!*\
  !*** ./src/bot/panel/chat-launcher/index.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-launcher.component */ "./src/bot/panel/chat-launcher/chat-launcher.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/panel/chat-menu/chat-menu.component.tsx":
/*!*********************************************************!*\
  !*** ./src/bot/panel/chat-menu/chat-menu.component.tsx ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const ChatMenu = ({ config: { props: { showLauncher = false }, }, }) => {
    var _a;
    const viewConfig = smarthub_common_1.useViewConfig();
    const setChatPosition = smarthub_common_1.useSetPreference(smarthub_common_1.preferenceKeys.chatDockPosition);
    const setLauncherState = smarthub_common_1.useSetPreference(smarthub_common_1.preferenceKeys.chatLauncherState);
    const setChatSize = smarthub_common_1.useSetPreference(smarthub_common_1.preferenceKeys.chatDockSize);
    const [launcherState] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys.chatLauncherState, false);
    const { chatMenuTitle, chatMenuLabel, chatMenuResetDesc, chatMenuResetTitle, chatMenuResetText, chatMenuLauncherTitle, chatMenuLauncherText, chatMenuCloseTitle, chatMenuCloseDesc, chatMenuCloseText, } = smarthub_common_1.useLocalizeConfig();
    const chatPanelState = smarthub_common_1.usePanelView("chat");
    const setChatPanelState = smarthub_common_1.useSetPanelView("chat");
    const [, setChromeState] = smarthub_common_1.useChromeState();
    const resetDirectline = smarthub_common_1.useResetDirectline();
    const focus = smarthub_common_1.useFocus();
    const locale = smarthub_common_1.useLocale();
    const dockConfig = smarthub_common_1.useResponsiveProps((_a = viewConfig.chat) === null || _a === void 0 ? void 0 : _a.dockSizes);
    const close = react_1.useCallback(() => {
        if (viewConfig.mode == "full")
            setChatPanelState(Object.assign(Object.assign({}, chatPanelState), { visible: false }));
        else
            setChromeState("closed");
    }, [chatPanelState]);
    const changeChatSize = react_1.useCallback((dock) => {
        setChatSize(dock);
    }, []);
    const changeChatPosition = react_1.useCallback((dockPosition) => {
        setChatPosition(dockPosition);
    }, []);
    const changeLauncherState = react_1.useCallback((state) => {
        setLauncherState(state);
    }, []);
    const reset = react_1.useCallback(() => {
        resetDirectline();
        focus("chat-controls");
    }, [resetDirectline]);
    return react_1.useMemo(() => {
        var _a;
        let buttons = [];
        if (showLauncher) {
            buttons.push({
                key: "Launcher",
                text: chatMenuLauncherText,
                name: chatMenuLauncherText,
                title: chatMenuLauncherTitle,
                iconProps: {
                    iconName: launcherState == "open"
                        ? "OpenPaneMirrored"
                        : "OpenPane",
                },
                ariaDescription: chatMenuResetDesc,
                ariaLabel: chatMenuResetTitle,
                onClick: () => {
                    if (launcherState == "open") {
                        changeLauncherState("closed");
                    }
                    else {
                        changeLauncherState("open");
                    }
                },
            });
        }
        buttons.push({
            key: "reset",
            text: chatMenuResetText,
            name: chatMenuResetText,
            title: chatMenuResetTitle,
            iconProps: { iconName: "Refresh" },
            ariaDescription: chatMenuResetDesc,
            ariaLabel: chatMenuResetTitle,
            onClick: () => reset(),
        });
        return (react_1.default.createElement(core_1.ViewMenu, { title: chatMenuTitle, label: chatMenuLabel, changeDockSize: changeChatSize, changeDockPosition: changeChatPosition, dockSize: chatPanelState.size, dockPosition: chatPanelState.position, focusName: "chat-menu", dockConfig: dockConfig, dockPositionConfig: (_a = viewConfig === null || viewConfig === void 0 ? void 0 : viewConfig.chat) === null || _a === void 0 ? void 0 : _a.dockPositions, buttons: {
                afterItems: buttons,
            }, closeProps: {
                onClick: close,
                text: chatMenuCloseText,
                title: chatMenuCloseTitle,
                description: chatMenuCloseDesc,
            } }));
    }, [
        reset,
        close,
        changeChatSize,
        showLauncher,
        launcherState,
        chatPanelState,
        viewConfig,
        locale,
    ]);
};
exports.ChatMenu = ChatMenu;


/***/ }),

/***/ "./src/bot/panel/chat-menu/index.ts":
/*!******************************************!*\
  !*** ./src/bot/panel/chat-menu/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-menu.component */ "./src/bot/panel/chat-menu/chat-menu.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/panel/chat-pages/chat-pages.component.tsx":
/*!***********************************************************!*\
  !*** ./src/bot/panel/chat-pages/chat-pages.component.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatPages = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_2 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const content_1 = __webpack_require__(/*! ../../../content */ "./src/content/index.ts");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const useStyles = react_jss_1.createUseStyles((theme) => {
    const { palette, spacing } = theme;
    return {
        root: {
            position: "absolute",
            background: "rgba(255,255,255)",
            color: "#333",
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            "& *::-webkit-scrollbar": {
                width: spacing.medium,
                height: spacing.medium,
                border: "0",
            },
            "& *:hover::-webkit-scrollbar": {
                width: spacing.medium,
                height: spacing.medium,
            },
        },
        inner: {
            overflow: "auto",
            padding: "20px",
            display: "flex",
            flex: "1",
            flexDirection: "column",
        },
        toggleBtn: {
            width: "30px",
            height: "30px",
            padding: "10px",
            zIndex: 9999,
            background: palette.primary,
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            borderRadius: "50%",
            top: "calc(50% - 15px)",
            cursor: "pointer",
        },
        toggleBtnRight: {
            left: "-15px",
        },
        toggleBtnLeft: {
            right: "-15px",
        },
        right: {
            right: "0",
            borderRight: "1px solid #ddd",
            transition: "right 0.3s ease",
        },
        visibleRightFull: {
            right: "66.66% !important",
            left: "auto !important",
        },
        visibleLeftFull: {
            left: "66.66% !important",
            right: "auto !important",
        },
        leftFull: {
            borderLeft: "1px solid #ddd",
            transition: "left 0.3s ease",
            left: "100%",
            top: "45px",
            width: "33.333%",
            zIndex: "99999",
        },
        rightFull: {
            borderRight: "1px solid #ddd",
            transition: "right 0.3s ease",
            right: "100%",
            top: "45px",
            zIndex: "99999",
            width: "33.333%",
        },
        visibleRight: {
            right: "100%",
            boxShadow: "rgb(0 0 0 / 12%) -4px 0px 8px",
        },
        fullWidth: {
            width: "calc(100vw - 100% - 18px)",
        },
        left: {
            left: "0",
            borderLeft: "1px solid #ddd",
            transition: "left 0.3s ease",
        },
        visibleLeft: {
            left: "100%",
            boxShadow: "rgb(0 0 0 / 12%) 4px 0px 8px",
        },
        title: {
            fontSize: "22px",
            fontWeight: "600",
            lineHeight: "1.2em",
            marginBottom: "10px",
            marginRight: "35px",
            display: "flex",
        },
        sectionWrapper: {
            display: "flex",
            flexDirection: "column",
            gap: "10px",
        },
        sectionHeader: {
            fontSize: "17px",
            fontWeight: "600",
        },
        sectionText: {
            fontSize: "13px",
        },
        button: {
            background: palette.primary,
            padding: "10px",
            color: "white",
            textAlign: "center",
            borderRadius: "10px",
            display: "flex",
            cursor: "pointer",
            gap: "10px",
            marginBottom: "10px",
        },
        buttonIcon: {
            fontSize: "30px",
            width: "50px",
            padding: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "& img": {
                maxHeight: "30px",
                maxWidth: "50px",
            },
        },
        pageContent: {
            "& p": {
                marginBottom: "10px",
            },
        },
        buttonText: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            flex: 1,
        },
        buttonTitle: {
            fontSize: "18px",
            fontWeight: "600",
        },
        buttonSubtitle: {
            fontSize: "12px",
            lineHeight: "1.2em",
        },
        image: {
            width: "100%",
            height: "auto",
            marginBottom: "10px",
        },
        page: {
            background: "white",
            position: "absolute",
            height: "100%",
            width: "100%",
            zIndex: -1,
            right: "0",
            transition: "right 0.3s ease",
        },
        h1: {
            fontSize: "2em",
            fontWeight: "600",
            lineHeight: "1.2em",
            marginBottom: "0.67em",
        },
        h2: {
            fontSize: "1.5em",
            fontWeight: "600",
            lineHeight: "1.2em",
            marginBottom: "0.83em",
        },
        h3: {
            fontSize: "1.17em",
            fontWeight: "600",
            lineHeight: "1.2em",
            marginBottom: "1em",
        },
        h4: {
            fontSize: "1em",
            fontWeight: "600",
            lineHeight: "1.2em",
            marginBottom: "1.33em",
        },
        h5: {
            fontSize: "0.83em",
            fontWeight: "600",
            lineHeight: "1.2em",
            marginBottom: "1.67em",
        },
        h6: {
            fontSize: "0.67em",
            fontWeight: "600",
            lineHeight: "1.2em",
            marginBottom: "2.33em",
        },
        pageVisible: {
            right: "100%",
            boxShadow: "rgb(0 0 0 / 12%) -4px 0px 8px",
        },
        header: {
            display: "flex",
            position: "relative",
            background: "#f5f5f5",
            padding: "20px",
            borderBottom: "1px solid #ddd",
        },
        titleSection: {
            display: "flex",
            flexDirection: "column",
            flex: 1,
        },
        closeButton: {
            position: "absolute",
            right: "20px",
        },
        "@media (max-width: 640px)": {
            root: {
                zIndex: 99,
            },
            right: {
                right: "-100%",
            },
            visibleRight: {
                right: "0",
            },
            left: {
                left: "-100%",
            },
            visibleLeft: {
                left: "0",
            },
            toggleBtn: {
                display: "none",
            },
        },
    };
});
const ChatPages = ({ config: { props: { config, configUri }, }, }) => {
    var _a;
    const invokeSkill = smarthub_common_1.useHandleSkill();
    const sendMessage = smarthub_common_1.useSendMessage();
    const sendBackChannel = smarthub_common_1.useSendBackChannel();
    const { directline } = (_a = smarthub_common_1.useDirectline()) !== null && _a !== void 0 ? _a : {};
    const [selectedPage, setSelectedPage] = smarthub_common_1.usePage();
    // load JSON from configUri
    const [configParams, setConfigParams] = react_2.useState();
    const chatPanelState = smarthub_common_1.usePanelView("chat");
    const pagesConfig = react_2.useMemo(() => {
        return configParams || config;
    }, [configParams, config]);
    const activePage = react_2.useMemo(() => {
        if (pagesConfig && selectedPage) {
            return pagesConfig.pages.find((p) => p.id == (selectedPage === null || selectedPage === void 0 ? void 0 : selectedPage.id));
        }
        return null;
    }, [selectedPage, pagesConfig]);
    react_2.useEffect(() => {
        if (configUri) {
            fetch(configUri)
                .then((response) => response.json())
                .then((data) => {
                setConfigParams(data);
            })
                .catch((error) => {
                console.log("Failed to load config from " + configUri);
            });
        }
    }, [configUri]);
    const styles = useStyles();
    const [dockPostion] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys.chatDockPosition, false);
    const { chat: { dockPositions: { preferred: position }, }, } = smarthub_common_1.useViewConfig();
    const preferredPosition = react_2.useMemo(() => {
        if (dockPostion) {
            return dockPostion;
        }
        return position;
    }, [dockPostion, position]);
    const isVisible = react_2.useMemo(() => {
        if (selectedPage) {
            return true;
        }
        return false;
    }, [selectedPage]);
    const processButtonAction = react_2.useCallback((actions) => {
        actions.forEach((data) => {
            switch (data.action) {
                case "Skill": {
                    invokeSkill({
                        $id: "",
                        $schema: smarthub_common_1.SkillActionSchema,
                        ref: data.dllReference,
                        invokeText: data.involkeText,
                    });
                    break;
                }
                case "Link": {
                    window.open(data.url, data.target);
                    break;
                }
                case "Message": {
                    sendMessage(data.message, data.involkeText);
                    break;
                }
                case "Page": {
                    setSelectedPage({
                        id: data.pageId,
                    });
                    break;
                }
                case "UserBackChannel": {
                    sendBackChannel({
                        type: "context.user",
                        version: "1.0",
                        payload: data.payload,
                    });
                }
                case "Personality": {
                    sendBackChannel({
                        type: "context.user",
                        version: "1.0",
                        payload: {
                            personality: data.personality,
                            showHintsCard: true,
                        },
                    });
                }
            }
        });
    }, []);
    const getIFrame = react_2.useCallback(() => {
        let url = new URL(activePage === null || activePage === void 0 ? void 0 : activePage.url);
        let conversationId = "";
        if (directline) {
            conversationId = directline.conversationId;
        }
        url.searchParams.append("conversationId", conversationId);
        return (react_2.default.createElement("iframe", { src: url.toString(), style: { width: "100%", height: "100%" } }));
    }, [activePage, directline]);
    const renderPageSections = react_2.useCallback(() => {
        if (selectedPage === null || selectedPage === void 0 ? void 0 : selectedPage.html) {
            return (react_2.default.createElement("div", { dangerouslySetInnerHTML: { __html: selectedPage === null || selectedPage === void 0 ? void 0 : selectedPage.html } }));
        }
        if (!activePage) {
            return null;
        }
        if (activePage.sections) {
            return activePage.sections.map((section, index) => {
                switch (section.type) {
                    case "button":
                        let buttonConfig = section.config;
                        return (react_2.default.createElement("button", { key: index, tabIndex: 0, className: [styles.button].join(" "), style: buttonConfig.style, role: "button", "aria-label": buttonConfig.title, title: buttonConfig.title, onKeyPress: (e) => {
                                if (e.key == "Enter")
                                    processButtonAction(buttonConfig.actions);
                            }, onClick: () => {
                                processButtonAction(buttonConfig.actions);
                            } },
                            buttonConfig.imageUrl && (react_2.default.createElement("div", { className: styles.buttonIcon },
                                react_2.default.createElement("img", { src: buttonConfig.imageUrl }))),
                            react_2.default.createElement("div", { className: styles.buttonText },
                                react_2.default.createElement("div", { className: styles.buttonTitle }, buttonConfig.title),
                                react_2.default.createElement("div", { className: styles.buttonSubtitle }, buttonConfig.subtitle))));
                    case "heading": {
                        let config = section.config;
                        switch (config.size) {
                            case "h1":
                                return (react_2.default.createElement("h1", { key: index, className: styles.h1 }, config.text));
                            case "h2":
                                return (react_2.default.createElement("h2", { key: index, className: styles.h2 }, config.text));
                            case "h3":
                                return (react_2.default.createElement("h3", { key: index, className: styles.h3 }, config.text));
                            case "h4":
                                return (react_2.default.createElement("h4", { key: index, className: styles.h4 }, config.text));
                            case "h5":
                                return (react_2.default.createElement("h5", { key: index, className: styles.h5 }, config.text));
                            case "h6":
                                return (react_2.default.createElement("h6", { key: index, className: styles.h6 }, config.text));
                            default:
                                return (react_2.default.createElement("h1", { key: index, className: styles.h1 }, config.text));
                        }
                    }
                    case "paragraph":
                        let config = section.config;
                        return react_2.default.createElement("p", { key: index }, config.text);
                    case "image":
                        let imageConfig = section.config;
                        return (react_2.default.createElement("div", { key: index, className: styles.image },
                            react_2.default.createElement("img", { src: imageConfig.imageUrl, alt: imageConfig.altText })));
                    case "iframe":
                        let iframeConfig = section.config;
                        let url = new URL(iframeConfig.url);
                        let conversationId = "";
                        if (directline) {
                            conversationId = directline.conversationId;
                        }
                        url.searchParams.append("conversationId", conversationId);
                        return (react_2.default.createElement("iframe", { key: index, src: url.toString(), style: { width: "100%", height: "100%" } }));
                    case "html":
                        let htmlConfig = section.config;
                        return (react_2.default.createElement("div", { key: index, dangerouslySetInnerHTML: { __html: htmlConfig.html } }));
                    case "form":
                        let formConfig = section.config;
                        return (react_2.default.createElement(content_1.FormBuilder, Object.assign({}, formConfig, { onSubmitted: (formResponse) => {
                                if (formConfig.postSubmitActions) {
                                    processButtonAction(formConfig.postSubmitActions);
                                }
                            } })));
                }
                return null;
            });
        }
        return null;
    }, [activePage, selectedPage, directline]);
    const getRootStyles = () => {
        let rootStyles = [];
        rootStyles.push(styles.root);
        if ((activePage === null || activePage === void 0 ? void 0 : activePage.fullWidth) === true && chatPanelState.size !== "full") {
            rootStyles.push(styles.fullWidth);
        }
        else {
        }
        if (chatPanelState.size === "full") {
            if (preferredPosition == "right") {
                rootStyles.push(styles.rightFull);
                if (isVisible) {
                    rootStyles.push(styles.visibleRightFull);
                }
            }
            else {
                rootStyles.push(styles.leftFull);
                if (isVisible) {
                    rootStyles.push(styles.visibleLeftFull);
                }
            }
        }
        else {
            if (preferredPosition == "right") {
                rootStyles.push(styles.right);
                if (isVisible) {
                    rootStyles.push(styles.visibleRight);
                }
            }
            else {
                rootStyles.push(styles.left);
                if (isVisible) {
                    rootStyles.push(styles.visibleLeft);
                }
            }
        }
        return rootStyles.join(" ");
    };
    if (!pagesConfig)
        return null;
    return (react_2.default.createElement("div", { className: getRootStyles() },
        ((selectedPage === null || selectedPage === void 0 ? void 0 : selectedPage.html) || activePage) && (react_2.default.createElement(react_2.default.Fragment, null,
            react_2.default.createElement("div", { className: styles.header },
                (activePage.title || selectedPage.name) && (react_2.default.createElement("div", { className: styles.titleSection },
                    react_2.default.createElement("div", { className: styles.title }, selectedPage.html ? selectedPage.name : activePage.title))),
                react_2.default.createElement(react_1.IconButton, { title: "Close the page menu", className: styles.closeButton, onClick: () => {
                        setSelectedPage(null);
                    } },
                    react_2.default.createElement(react_1.Icon, { iconName: "ChromeClose" }))))),
        react_2.default.createElement("div", { className: styles.inner }, (activePage === null || activePage === void 0 ? void 0 : activePage.url) ? (react_2.default.createElement(react_2.default.Fragment, null,
            " ",
            getIFrame())) : (react_2.default.createElement(react_2.default.Fragment, null, ((selectedPage === null || selectedPage === void 0 ? void 0 : selectedPage.html) || activePage) && (react_2.default.createElement(react_2.default.Fragment, null,
            react_2.default.createElement("div", { className: styles.pageContent, style: {
                    height: (activePage === null || activePage === void 0 ? void 0 : activePage.fullHeight) ? "100%" : "auto",
                } }, renderPageSections()))))))));
};
exports.ChatPages = ChatPages;


/***/ }),

/***/ "./src/bot/panel/chat-pages/index.ts":
/*!*******************************************!*\
  !*** ./src/bot/panel/chat-pages/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-pages.component */ "./src/bot/panel/chat-pages/chat-pages.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/panel/chat-splash/chat-splash.component.tsx":
/*!*************************************************************!*\
  !*** ./src/bot/panel/chat-splash/chat-splash.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatSplash = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const usehooks_ts_1 = __webpack_require__(/*! usehooks-ts */ "./node_modules/usehooks-ts/dist/esm/index.js");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const dompurify_1 = tslib_1.__importDefault(__webpack_require__(/*! dompurify */ "./node_modules/dompurify/dist/purify.js"));
const useStyles = react_jss_1.createUseStyles(({ palette, fonts }) => ({
    root: (props) => ({
        position: "absolute",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        zIndex: 1000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
    }),
    inner: (props) => {
        var _a, _b, _c, _d;
        return ({
            display: "flex",
            padding: ((_a = props === null || props === void 0 ? void 0 : props.container) === null || _a === void 0 ? void 0 : _a.padding) || "20px",
            margin: ((_b = props === null || props === void 0 ? void 0 : props.container) === null || _b === void 0 ? void 0 : _b.margin) || "25px",
            backgroundColor: ((_c = props === null || props === void 0 ? void 0 : props.container) === null || _c === void 0 ? void 0 : _c.backgroundColor) || "#fff",
            color: ((_d = props === null || props === void 0 ? void 0 : props.container) === null || _d === void 0 ? void 0 : _d.textColor) || "#333",
            flexDirection: "column",
            overflow: "auto",
            position: "absolute",
            inset: "0 0 0 0",
            boxShadow: "0 0 10px 0 rgba(0,0,0,0.3)",
        });
    },
    body: (props) => {
        var _a;
        return ({
            display: "flex",
            flexDirection: "column",
            flex: 1,
            "& p": Object.assign(Object.assign({}, fonts.normal), { fontSize: (_a = props === null || props === void 0 ? void 0 : props.container) === null || _a === void 0 ? void 0 : _a.fontSize, margin: 0, marginBottom: "10px" }),
        });
    },
    primaryButton: (props) => {
        var _a, _b, _c, _d, _e, _f, _g;
        return ({
            background: ((_a = props === null || props === void 0 ? void 0 : props.buttons) === null || _a === void 0 ? void 0 : _a.primaryButtonBackgroundColor) || palette.primary,
            borderRadius: ((_b = props === null || props === void 0 ? void 0 : props.buttons) === null || _b === void 0 ? void 0 : _b.primaryButtonBorderRadius) || "0px",
            color: (_c = props === null || props === void 0 ? void 0 : props.buttons) === null || _c === void 0 ? void 0 : _c.primaryButtonTextColor,
            fontSize: (_d = props === null || props === void 0 ? void 0 : props.buttons) === null || _d === void 0 ? void 0 : _d.primaryButtonFontSize,
            padding: (_e = props === null || props === void 0 ? void 0 : props.buttons) === null || _e === void 0 ? void 0 : _e.primaryButtonPadding,
            ["&:hover"]: {
                color: (_f = props === null || props === void 0 ? void 0 : props.buttons) === null || _f === void 0 ? void 0 : _f.primaryButtonHoverTextColor,
                background: ((_g = props === null || props === void 0 ? void 0 : props.buttons) === null || _g === void 0 ? void 0 : _g.primaryButtonHoverBackgroundColor) ||
                    palette.primaryMinus1,
            },
        });
    },
    cancelButton: (props) => {
        var _a, _b, _c, _d, _e, _f, _g;
        return ({
            background: ((_a = props === null || props === void 0 ? void 0 : props.buttons) === null || _a === void 0 ? void 0 : _a.secondaryButtonBackgroundColor) || palette.primary,
            color: (_b = props === null || props === void 0 ? void 0 : props.buttons) === null || _b === void 0 ? void 0 : _b.secondaryButtonTextColor,
            borderRadius: ((_c = props === null || props === void 0 ? void 0 : props.buttons) === null || _c === void 0 ? void 0 : _c.secondaryButtonBorderRadius) || "0px",
            fontSize: (_d = props === null || props === void 0 ? void 0 : props.buttons) === null || _d === void 0 ? void 0 : _d.secondaryButtonFontSize,
            padding: (_e = props === null || props === void 0 ? void 0 : props.buttons) === null || _e === void 0 ? void 0 : _e.secondaryButtonPadding,
            ["&:hover"]: {
                color: (_f = props === null || props === void 0 ? void 0 : props.buttons) === null || _f === void 0 ? void 0 : _f.secondaryButtonHoverTextColor,
                background: ((_g = props === null || props === void 0 ? void 0 : props.buttons) === null || _g === void 0 ? void 0 : _g.secondaryButtonHoverBackgroundColor) ||
                    palette.primaryMinus1,
            },
        });
    },
    footer: {},
}));
const getValue = (value, locale) => {
    return typeof value == "object" ? value[locale] : value;
};
const ChatSplash = ({ config: { props }, }) => {
    const { config, configUri, enabled, mode, version, sessionKey, cacheLocation, } = props;
    const localize = smarthub_common_1.useLocalizeConfig();
    const locale = smarthub_common_1.useLocale();
    const [isChecked, setIsChecked] = react_1.useState(true);
    const [splashVisibility_local, setSplashVisibility_local] = usehooks_ts_1.useLocalStorage(sessionKey, null);
    const [splashVisibility_session, setSplashVisibility_session] = usehooks_ts_1.useSessionStorage(sessionKey, null);
    const viewConfig = smarthub_common_1.useViewConfig();
    const chatPanelState = smarthub_common_1.usePanelView("chat");
    const setChatPanelState = smarthub_common_1.useSetPanelView("chat");
    const [, setChromeState] = smarthub_common_1.useChromeState();
    // load JSON from configUri
    const [configParams, setConfigParams] = react_1.useState();
    const splashConfig = react_1.useMemo(() => {
        return configParams || config;
    }, [configParams, config]);
    const styles = useStyles(splashConfig);
    react_1.useEffect(() => {
        if (configUri) {
            fetch(configUri)
                .then((response) => response.json())
                .then((data) => {
                setConfigParams(data);
            })
                .catch((error) => {
                console.log("Failed to load config from " + configUri);
            });
        }
    }, [configUri]);
    const getCache = react_1.useCallback(() => {
        let cacheStr = null;
        switch (cacheLocation) {
            case "local":
                cacheStr = splashVisibility_local;
                break;
            case "session":
                cacheStr = splashVisibility_session;
                break;
        }
        return cacheStr;
    }, [splashVisibility_local, splashVisibility_session, cacheLocation]);
    const setCache = react_1.useCallback(() => {
        let new_cache = {
            date: new Date().toISOString(),
            version: version,
            accepted: isChecked,
        };
        switch (cacheLocation) {
            case "local":
                if (splashVisibility_local === null) {
                    setSplashVisibility_local(new_cache);
                }
                break;
            case "session":
                if (splashVisibility_session === null) {
                    setSplashVisibility_session(new_cache);
                }
                break;
        }
    }, [splashVisibility_local, splashVisibility_session, cacheLocation]);
    const shouldShowSplash = react_1.useCallback(() => {
        let accepted = false;
        if (!enabled) {
            return false;
        }
        const cacheStr = getCache();
        if (cacheStr) {
            try {
                let tncs = cacheStr;
                accepted =
                    tncs.version != null &&
                        tncs.version == version &&
                        tncs.date != null &&
                        tncs.accepted == true;
                return !accepted;
            }
            catch (ex) {
                console.log("Failed to parse acceptance record. " + cacheStr);
                return false;
            }
        }
        // show splash if no cache found
        return true;
    }, [splashVisibility_local, splashVisibility_session, cacheLocation]);
    const close = react_1.useCallback(() => {
        if (viewConfig.mode == "full")
            setChatPanelState(Object.assign(Object.assign({}, chatPanelState), { visible: false }));
        else
            setChromeState("closed");
    }, [chatPanelState]);
    const onChange = react_1.useCallback((ev, checked) => {
        setIsChecked(!!checked);
    }, []);
    if (!shouldShowSplash()) {
        return null;
    }
    return (react_1.default.createElement("div", { className: styles.root },
        react_1.default.createElement("div", { className: styles.inner },
            react_1.default.createElement("div", { className: styles.body, dangerouslySetInnerHTML: {
                    __html: dompurify_1.default.sanitize(getValue(splashConfig === null || splashConfig === void 0 ? void 0 : splashConfig.html, locale), {
                        ADD_ATTR: ["target"],
                    }),
                } }),
            react_1.default.createElement("div", { className: styles.footer },
                mode === "explicit" && (react_1.default.createElement(react_2.Checkbox, { label: localize.chatSplashAcceptCbxLabel, title: localize.chatSplashAcceptCbxTitle, checked: isChecked, onChange: onChange })),
                react_1.default.createElement("div", { style: {
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                    } },
                    react_1.default.createElement(react_2.PrimaryButton, { text: localize.chatSplashConfirmBtnText, "aria-label": localize.chatSplashConfirmBtnLabel, title: localize.chatSplashConfirmBtnTitle, tabIndex: 0, width: "100%", className: styles.primaryButton, disabled: !isChecked, onClick: () => {
                            setCache();
                        } }),
                    react_1.default.createElement(react_2.PrimaryButton, { text: localize.chatSplashCancelBtnText, "aria-label": localize.chatSplashCancelBtnLabel, title: localize.chatSplashCancelBtnTitle, width: "100%", className: styles.cancelButton, onClick: () => {
                            close();
                        } }))))));
};
exports.ChatSplash = ChatSplash;


/***/ }),

/***/ "./src/bot/panel/chat-splash/index.ts":
/*!********************************************!*\
  !*** ./src/bot/panel/chat-splash/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-splash.component */ "./src/bot/panel/chat-splash/chat-splash.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/panel/chat-transcript/chat-transcript.component.tsx":
/*!*********************************************************************!*\
  !*** ./src/bot/panel/chat-transcript/chat-transcript.component.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatTranscript = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const { BasicWebChat } = botframework_webchat_1.Components;
const useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b;
    const { styles } = theme;
    const chat = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.chat) === null || _a === void 0 ? void 0 : _a.panel) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    return {
        transcript: Object.assign({ overflow: "hidden", "@global": {
                ".webchat__basic-transcript__scrollable": {
                    overflowY: "overlay",
                },
                ".webchat__basic-transcript__scrollable ul li:before": {
                    content: "none !important",
                },
            } }, smarthub_common_1.themeStyle(chat.transcript, props)),
    };
});
const ChatTranscript = () => {
    const styles = useStyles();
    return react_1.default.createElement(BasicWebChat, { className: styles.transcript });
};
exports.ChatTranscript = ChatTranscript;


/***/ }),

/***/ "./src/bot/panel/chat-transcript/index.ts":
/*!************************************************!*\
  !*** ./src/bot/panel/chat-transcript/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-transcript.component */ "./src/bot/panel/chat-transcript/chat-transcript.component.tsx"), exports);


/***/ }),

/***/ "./src/bot/panel/index.ts":
/*!********************************!*\
  !*** ./src/bot/panel/index.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-footer */ "./src/bot/panel/chat-footer/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-header */ "./src/bot/panel/chat-header/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-menu */ "./src/bot/panel/chat-menu/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-transcript */ "./src/bot/panel/chat-transcript/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-splash */ "./src/bot/panel/chat-splash/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-launcher */ "./src/bot/panel/chat-launcher/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-pages */ "./src/bot/panel/chat-pages/index.ts"), exports);


/***/ }),

/***/ "./src/content/about/about.component.tsx":
/*!***********************************************!*\
  !*** ./src/content/about/about.component.tsx ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.About = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_2 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing, sizes }) => ({
    root: {
        padding: spacing.medium
    },
    header: Object.assign(Object.assign({}, fonts.superLarge), { fontWeight: "100", padding: `${spacing.medium} 0`, color: palette.neutralEmptyOn }),
    detail: {
        flex: "1 1 100%",
        display: "flex",
        flexDirection: "row",
        marginBottom: spacing.xxLarge,
        color: palette.neutralEmptyOn
    },
    logo: {
        paddingTop: spacing.smallPlus,
    },
    image: {
        maxWidth: sizes.mega,
        maxHeight: "100%"
    },
    detailList: {
        display: "flex",
        flex: "1 1",
        paddingLeft: spacing.smallPlus,
        flexDirection: "column",
    },
    description: Object.assign(Object.assign({ paddingBottom: spacing.xxLarge }, fonts.large), { fontWeight: "100" }),
    info: Object.assign({}, fonts.small),
    label: Object.assign({}, fonts.smallPlus),
    linkList: {
        boxSizing: "border-box",
        padding: 0,
        display: "block",
        width: "100%",
    },
    linkListItem: {
        display: "block",
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
        listStyleType: "none",
        width: "100%",
    }
}));
const About = ({ config, config: { props: { links } = {} }, data }) => {
    var _a, _b, _c, _d;
    const handleCommand = smarthub_common_1.useHandleCommand();
    const source = smarthub_common_1.useSourceInfo();
    const { definition: theme } = smarthub_common_1.useTheme();
    const styles = useStyles();
    const localize = smarthub_common_1.useLocalizeConfig();
    const openAction = react_2.useCallback((action) => {
        handleCommand(action);
    }, []);
    return (react_2.default.createElement(core_1.ComponentChrome, { config: config, className: styles.root },
        react_2.default.createElement("div", { className: styles.header }, source.title),
        react_2.default.createElement("div", { className: styles.detail },
            react_2.default.createElement("div", { className: styles.logo },
                react_2.default.createElement("img", { alt: localize.logoImage, className: styles.image, src: theme.image.appLogoOnEmptyL })),
            react_2.default.createElement("div", { className: styles.detailList },
                react_2.default.createElement("div", { className: styles.description }, source.description),
                react_2.default.createElement("div", { className: styles.info },
                    react_2.default.createElement("span", { className: styles.label },
                        localize.aboutVersionPrefix,
                        ": "),
                    react_2.default.createElement("span", null, source.version)),
                react_2.default.createElement("div", { className: styles.info },
                    react_2.default.createElement("span", { className: styles.label },
                        localize.aboutPublishedPrefix,
                        ": "),
                    react_2.default.createElement("span", null, source.publisher)),
                ((_b = (_a = source.environment) === null || _a === void 0 ? void 0 : _a.label) === null || _b === void 0 ? void 0 : _b.length) > 0 && react_2.default.createElement("div", { className: styles.info },
                    react_2.default.createElement("span", { className: styles.label },
                        localize.aboutEnvironmentPrefix,
                        ": "),
                    react_2.default.createElement("span", null, source.environment.label)), (_d = (_c = source.environment) === null || _c === void 0 ? void 0 : _c.areas) === null || _d === void 0 ? void 0 :
                _d.map(({ label, name }) => react_2.default.createElement("div", { className: styles.info },
                    react_2.default.createElement("span", { className: styles.label },
                        name,
                        ": "),
                    react_2.default.createElement("span", null, label))))),
        react_2.default.createElement("ul", { className: styles.linkList }, links === null || links === void 0 ? void 0 : links.map((link, i) => react_2.default.createElement("li", { key: i, className: styles.linkListItem },
            react_2.default.createElement(react_1.Link, { onClick: () => openAction(link.action), "aria-label": link.name, title: link.name }, link.name))))));
};
exports.About = About;


/***/ }),

/***/ "./src/content/about/index.ts":
/*!************************************!*\
  !*** ./src/content/about/index.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./about.component */ "./src/content/about/about.component.tsx"), exports);


/***/ }),

/***/ "./src/content/adaptive-card/adaptive-card-embed.component.tsx":
/*!*********************************************************************!*\
  !*** ./src/content/adaptive-card/adaptive-card-embed.component.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AdaptiveCardEmbed = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const AdaptiveCards = tslib_1.__importStar(__webpack_require__(/*! adaptivecards */ "adaptivecards"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles({
    main: {
        width: "100%",
        height: "100%",
    }
});
const useACStyles = smarthub_common_1.createUseAdaptiveCardStyles();
const AdaptiveCardEmbed = ({ card, onSubmit, onFailure, onSuccess }) => {
    const hostConfig = smarthub_common_1.useHostConfig();
    const styles = useStyles();
    const acStyles = useACStyles();
    const errorMessage = smarthub_common_1.useLocalize(smarthub_common_1.LocalizeKeys.invalidSchema);
    const adaptiveCard = react_1.useRef(new AdaptiveCards.AdaptiveCard());
    const container = react_1.useRef(null);
    const [error, setError] = react_1.useState(null);
    const handleCommand = smarthub_common_1.useHandleCommand();
    const submit = react_1.useCallback((data) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            if (onSubmit)
                onSubmit(data);
            if (data.action) {
                const action = Object.assign(Object.assign({}, data.action), { body: data.action.$schema == smarthub_common_1.SubmitActionSchema
                        ? JSON.stringify(data, (k, v) => k == "action" ? undefined : v)
                        : undefined });
                yield handleCommand(action);
            }
            if (onSuccess)
                onSuccess(data);
        }
        catch (ex) {
            if (onFailure)
                onFailure(ex);
        }
    }), []);
    const openUrl = (url) => {
        handleCommand({
            $schema: smarthub_common_1.LinkActionSchema,
            $id: "",
            uri: url
        });
    };
    const onAction = react_1.useCallback((action) => {
        switch (action.getJsonTypeName()) {
            case AdaptiveCards.OpenUrlAction.JsonTypeName:
                return openUrl(action.url);
            case AdaptiveCards.SubmitAction.JsonTypeName:
                return submit(action.data);
        }
    }, []);
    react_1.useEffect(() => {
        if (card.$schema != models_1.IAdaptiveCardSchema) {
            setError("Invalid schema, cannot render data as an adaptive card");
            return;
        }
        const { current } = adaptiveCard;
        current.hostConfig = hostConfig;
        current.onExecuteAction = onAction;
        current.parse(card);
        const el = container.current;
        while (el.firstChild)
            el.removeChild(el.lastChild);
        const element = current.render();
        element.classList.add(acStyles.adaptiveCard);
        container.current.appendChild(element);
    }, [card, hostConfig, acStyles]);
    return react_1.useMemo(() => react_1.default.createElement(react_1.default.Fragment, null,
        error
            && react_1.default.createElement(utilities_1.ErrorBox, { error: { message: errorMessage } }),
        !error
            && react_1.default.createElement("div", { className: styles.main, ref: container })), [error, acStyles]);
};
exports.AdaptiveCardEmbed = AdaptiveCardEmbed;


/***/ }),

/***/ "./src/content/adaptive-card/adaptive-card.component.tsx":
/*!***************************************************************!*\
  !*** ./src/content/adaptive-card/adaptive-card.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AdaptiveCard = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const adaptive_card_embed_component_1 = __webpack_require__(/*! ./adaptive-card-embed.component */ "./src/content/adaptive-card/adaptive-card-embed.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const AdaptiveCard = ({ config, config: { consumes, props }, data }) => {
    const transform = smarthub_common_1.useTransform();
    const sharedCard = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'card'));
    const [card, setCard] = react_1.useState(null);
    react_1.useEffect(() => {
        var _a;
        const input = (_a = sharedCard !== null && sharedCard !== void 0 ? sharedCard : data) !== null && _a !== void 0 ? _a : props === null || props === void 0 ? void 0 : props.card;
        if (input) {
            if (input.$schema == models_1.IAdaptiveCardSchema)
                setCard(input);
            else {
                const result = transform(models_1.IAdaptiveCardSchema, input);
                setCard(result);
            }
        }
    }, [props, data, sharedCard]);
    return react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { config: config, hasContent: card }, card && react_1.default.createElement(adaptive_card_embed_component_1.AdaptiveCardEmbed, { card: card }))), [card]);
};
exports.AdaptiveCard = AdaptiveCard;


/***/ }),

/***/ "./src/content/adaptive-card/index.ts":
/*!********************************************!*\
  !*** ./src/content/adaptive-card/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./adaptive-card.component */ "./src/content/adaptive-card/adaptive-card.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./adaptive-card-embed.component */ "./src/content/adaptive-card/adaptive-card-embed.component.tsx"), exports);


/***/ }),

/***/ "./src/content/bookmark-list/bookmark-list.component.tsx":
/*!***************************************************************!*\
  !*** ./src/content/bookmark-list/bookmark-list.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BookmarkList = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const cards_1 = __webpack_require__(/*! ../cards */ "./src/content/cards/index.ts");
const BookmarkList = ({ config, config: { props: { refinerNames } = {} } }) => {
    const { provides, consumes, responsive, children = [] } = config;
    const render = smarthub_common_1.useRender();
    const refinersProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'refiners');
    const sortOptionsProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'sort-options');
    const setRefiners = smarthub_common_1.useSetSharedState(refinersProvider);
    const setSortOptions = smarthub_common_1.useSetSharedState(sortOptionsProvider);
    const [dataSet, setDataSet] = react_1.useState({ items: null });
    const sort = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'sort-option'));
    const refineBy = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'refine-by'));
    const group = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'group'));
    const [query] = smarthub_common_1.useBookmarks();
    const fetchData = (filters, items, next) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const { items: nextItems, refiners, sortOptions, continuation } = yield query(filters, refinerNames, next);
            setSortOptions(sortOptions);
            setRefiners(refiners);
            setDataSet({
                items: [...(items !== null && items !== void 0 ? items : []), ...(nextItems !== null && nextItems !== void 0 ? nextItems : [])],
                continuation
            });
        }
        catch (ex) {
            setDataSet({ error: ex, items: null });
        }
    });
    const loadMore = react_1.useCallback(() => {
        setDataSet(Object.assign(Object.assign({}, dataSet), { loading: true }));
        return fetchData({
            sort,
            filters: Object.assign(Object.assign({}, refineBy), { group })
        }, dataSet.items, dataSet.continuation);
    }, [sort, refineBy, group]);
    react_1.useEffect(() => {
        fetchData({
            sort,
            filters: Object.assign(Object.assign({}, refineBy), { group })
        });
    }, [sort, refineBy, group, config]);
    const renderCard = react_1.useCallback((data) => {
        const card = children.find(c => c.$id == 'card');
        return render(card, data, cards_1.ThumbCard)();
    }, [children]);
    return react_1.useMemo(() => {
        const { error, items, continuation } = dataSet;
        return (react_1.default.createElement(core_1.ComponentChrome, { config: config, hasContent: !items || items.length > 0, error: error },
            react_1.default.createElement(core_1.CardListBase, { items: items, renderCard: renderCard, paging: continuation != null, onLoadMore: loadMore, responsive: responsive })));
    }, [dataSet, config]);
};
exports.BookmarkList = BookmarkList;


/***/ }),

/***/ "./src/content/bookmark-list/index.ts":
/*!********************************************!*\
  !*** ./src/content/bookmark-list/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./bookmark-list.component */ "./src/content/bookmark-list/bookmark-list.component.tsx"), exports);


/***/ }),

/***/ "./src/content/button-grid/button-grid-item.component.tsx":
/*!****************************************************************!*\
  !*** ./src/content/button-grid/button-grid-item.component.tsx ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ButtonGridItem = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (({ theme: { spacing, sizes } }) => ({
    buttonStyles: {
        root: {
            minWidth: sizes.normal,
            padding: `0 ${spacing.small}`,
            border: "0",
            width: "100%"
        }
    }
}));
const ButtonGridItem = ({ buttonProps, selected, onButtonClick }) => {
    const { buttonStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const onClick = react_1.useCallback((ev) => {
        if (onButtonClick)
            onButtonClick(buttonProps.uniqueId, buttonProps.data);
        if (buttonProps.onClick)
            buttonProps.onClick(ev);
    }, [buttonProps, onButtonClick]);
    const styles = react_1.useMemo(() => (Object.assign(Object.assign({}, buttonProps.styles), buttonStyles)), [buttonProps]);
    return react_1.default.createElement(react_2.StackItem, { grow: 1, shrink: 1 }, selected
        ? react_1.default.createElement(react_2.PrimaryButton, Object.assign({}, buttonProps, { styles: styles, onClick: onClick }))
        : react_1.default.createElement(react_2.DefaultButton, Object.assign({}, buttonProps, { styles: styles, onClick: onClick })));
};
exports.ButtonGridItem = ButtonGridItem;


/***/ }),

/***/ "./src/content/button-grid/button-grid.component.tsx":
/*!***********************************************************!*\
  !*** ./src/content/button-grid/button-grid.component.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ButtonGrid = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const button_grid_item_component_1 = __webpack_require__(/*! ./button-grid-item.component */ "./src/content/button-grid/button-grid-item.component.tsx");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (({ theme: { spacing } }) => ({
    stackStyles: {
        inner: {
            gap: spacing.medium
        }
    }
}));
const ButtonGrid = ({ selectedId, buttons, ariaLabel, title, horizontal, horizontalAlign, verticalAlign, fill, wrap, onButtonClick }) => {
    const { stackStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    return (react_1.default.createElement(react_2.Stack, { styles: stackStyles, horizontal: horizontal == null ? true : horizontal, wrap: wrap == null ? true : wrap, horizontalAlign: horizontalAlign == null ? 'start' : horizontalAlign, verticalAlign: verticalAlign == null ? 'start' : verticalAlign, verticalFill: fill == null ? false : fill, title: title, "aria-label": ariaLabel }, buttons.map(props => react_1.default.createElement(button_grid_item_component_1.ButtonGridItem, { key: props.uniqueId, buttonProps: props, selected: props.uniqueId == selectedId, onButtonClick: onButtonClick }))));
};
exports.ButtonGrid = ButtonGrid;


/***/ }),

/***/ "./src/content/button-grid/index.ts":
/*!******************************************!*\
  !*** ./src/content/button-grid/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./button-grid-item.component */ "./src/content/button-grid/button-grid-item.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./button-grid.component */ "./src/content/button-grid/button-grid.component.tsx"), exports);


/***/ }),

/***/ "./src/content/calendar/calender-activity.component.tsx":
/*!**************************************************************!*\
  !*** ./src/content/calendar/calender-activity.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CalendarActivity = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const cards_1 = __webpack_require__(/*! ../cards */ "./src/content/cards/index.ts");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const duration_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/duration */ "dayjs/plugin/duration"));
dayjs_1.default.extend(duration_1.default);
const CalendarActivity = ({ config }) => {
    const { $id, query, consumes, responsive, props: { include } = { include: { allDay: true, events: true } } } = config;
    const fetch = smarthub_common_1.useFetch();
    const transform = smarthub_common_1.useTransform();
    const [dataSet, setDataSet] = react_1.useState({ items: null });
    const [meetingItems, setMeetingItems] = react_1.useState([]);
    const [filters, setFilters] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setFilters(consumes), [consumes]);
    const fetchData = (filters, { continuation: next } = {}) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const requiresParam = consumes === null || consumes === void 0 ? void 0 : consumes.some(({ required, name }) => required && (filters === null || filters === void 0 ? void 0 : filters[name]) == null);
            if (requiresParam)
                return;
            const { data, continuation } = yield fetch(query, filters, next);
            setDataSet({
                items: transform(models_1.ICalendarSchema, data),
                continuation
            });
        }
        catch (ex) {
            setDataSet({ error: ex, items: null });
        }
    });
    const setNextMeetingTime = react_1.useCallback(() => {
        var _a, _b;
        const finalItems = [];
        (_b = (_a = dataSet.items) === null || _a === void 0 ? void 0 : _a.meetings) === null || _b === void 0 ? void 0 : _b.map((item, i) => {
            var _a, _b, _c, _d;
            if ((_a = dataSet.items) === null || _a === void 0 ? void 0 : _a.meetings[i + 1]) {
                const durationDiff = dayjs_1.default((_b = dataSet.items) === null || _b === void 0 ? void 0 : _b.meetings[i + 1].start.dateTime).diff(dayjs_1.default((_c = dataSet.items) === null || _c === void 0 ? void 0 : _c.meetings[i].end.dateTime));
                item.nextMeetingTime = Math.sign(durationDiff) == 1 ? (_d = dataSet.items) === null || _d === void 0 ? void 0 : _d.meetings[i + 1].start.dateTime : null;
            }
            finalItems.push(item);
        });
        const allDayItems = finalItems === null || finalItems === void 0 ? void 0 : finalItems.filter(meeting => meeting.isAllDay);
        const eventsItems = finalItems === null || finalItems === void 0 ? void 0 : finalItems.filter(meeting => !meeting.isAllDay);
        const orderedMeetings = [...new Set([
                ...(include.allDay ? allDayItems : []),
                ...(include.events ? eventsItems : [])
            ])];
        setMeetingItems(orderedMeetings);
    }, [dataSet.items]);
    react_1.useEffect(() => {
        setNextMeetingTime();
    }, [dataSet]);
    react_1.useEffect(() => {
        fetchData(filters);
    }, [filters, fetch, config]);
    const renderCard = react_1.useCallback((data) => {
        return react_1.default.createElement(cards_1.EventCard, { config: config, data: data });
    }, [config]);
    return react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { config: config, hasContent: !meetingItems || meetingItems.length > 0 },
        react_1.default.createElement(core_1.CardListBase, { items: meetingItems, renderCard: renderCard, paging: dataSet.continuation != null, responsive: responsive }))), [dataSet, meetingItems]);
};
exports.CalendarActivity = CalendarActivity;


/***/ }),

/***/ "./src/content/calendar/index.ts":
/*!***************************************!*\
  !*** ./src/content/calendar/index.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./calender-activity.component */ "./src/content/calendar/calender-activity.component.tsx"), exports);


/***/ }),

/***/ "./src/content/card-list/card-list.component.tsx":
/*!*******************************************************!*\
  !*** ./src/content/card-list/card-list.component.tsx ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardList = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const cards_1 = __webpack_require__(/*! ../cards */ "./src/content/cards/index.ts");
const react_2 = __webpack_require__(/*! react */ "react");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const CardList = ({ config }) => {
    const { $id, query, provides, consumes, responsive, children = [], props: { noResults } = {}, coachmarks, chrome } = config;
    const refinersProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'refiners');
    const sortOptionsProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'sort-options');
    const fetch = smarthub_common_1.useFetch();
    const render = smarthub_common_1.useRender();
    const setRefiners = smarthub_common_1.useSetSharedState(refinersProvider);
    const setSortOptions = smarthub_common_1.useSetSharedState(sortOptionsProvider);
    const [dataSet, setDataSet] = react_2.useState({ items: null });
    const [filters, setFilters] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setFilters(consumes), [consumes]);
    const fetchData = (filters, { items, continuation: next } = {}) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const requiresParam = consumes === null || consumes === void 0 ? void 0 : consumes.some(({ required, name }) => required && (filters === null || filters === void 0 ? void 0 : filters[name]) == null);
            if (requiresParam)
                return;
            const { data, continuation, refiners, sortOptions } = yield fetch(query, filters, next);
            setDataSet({
                items: [
                    ...(items !== null && items !== void 0 ? items : []),
                    ...(data !== null && data !== void 0 ? data : [])
                ],
                continuation
            });
            if (sortOptionsProvider)
                setSortOptions(sortOptions);
            if (refinersProvider)
                setRefiners(refiners);
        }
        catch (ex) {
            setDataSet({ error: ex, items: null });
        }
    });
    const loadMore = react_1.useCallback(() => {
        return fetchData(filters, dataSet);
    }, [dataSet]);
    react_1.useEffect(() => {
        fetchData(filters);
    }, [filters, fetch, config]);
    const renderCard = react_1.useCallback((data) => {
        const card = children.find(c => c.$id == 'card');
        return render(card, data, cards_1.ThumbCard)();
    }, [children]);
    return react_1.useMemo(() => {
        const { error, items, continuation } = dataSet;
        return (react_1.default.createElement(core_1.ComponentChrome, { hasContent: !items || (items === null || items === void 0 ? void 0 : items.length) > 0, config: config, error: error }, (items === null || items === void 0 ? void 0 : items.length) > 0 && react_1.default.createElement(core_1.CardListBase, { items: items, renderCard: renderCard, coachmarks: coachmarks, paging: continuation != null, onLoadMore: loadMore, responsive: responsive, noResults: noResults, chrome: chrome })));
    }, [dataSet, config]);
};
exports.CardList = CardList;


/***/ }),

/***/ "./src/content/card-list/index.ts":
/*!****************************************!*\
  !*** ./src/content/card-list/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./card-list.component */ "./src/content/card-list/card-list.component.tsx"), exports);


/***/ }),

/***/ "./src/content/cards/card.style.ts":
/*!*****************************************!*\
  !*** ./src/content/cards/card.style.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCardStyle = void 0;
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
exports.useCardStyle = react_jss_1.createUseStyles(({ palette, spacing }) => ({
    card: ({ scale, offset, fill } = {}) => ({
        paddingTop: scale > 0
            ? (offset === null || offset === void 0 ? void 0 : offset.length) > 0
                ? `calc(${scale}% - ${spacing[offset]})`
                : `${scale}%`
            : undefined,
        boxShadow: "rgb(0 0 0 / 13%) 0px 1.6px 3.6px 0px, rgb(0 0 0 / 11%) 0px 0.3px 0.9px 0px",
        borderRadius: spacing.small,
        overflow: "hidden",
        position: "relative",
        minWidth: "0",
        maxWidth: "none",
        width: "100%",
        height: !fill || scale > 0
            ? "auto"
            : "100%",
        display: "flex",
        flexDirection: 'column',
        backgroundColor: palette.neutralEmpty,
        color: palette.neutralEmptyOn,
        transitionProperty: "box-shadow, transform",
        transitionDuration: "200ms",
        transitionTimingFunction: "ease-in",
        ["&:focus"]: {
            boxShadow: "rgb(0 0 0 / 23%) 0px 2.4px 4.8px 0px, rgb(0 0 0 / 21%) 0px 0.6px 1.8px 0px",
        },
        ["&:hover"]: {
            boxShadow: "rgb(0 0 0 / 23%) 0px 2.4px 4.8px 0px, rgb(0 0 0 / 21%) 0px 0.6px 1.8px 0px",
        }
    })
}));


/***/ }),

/***/ "./src/content/cards/comment-card/comment-card-styles.ts":
/*!***************************************************************!*\
  !*** ./src/content/cards/comment-card/comment-card-styles.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.activityStyles = void 0;
exports.activityStyles = (({ theme: { palette, spacing, fonts } }) => ({
    root: {
        marginBottom: spacing.medium
    },
    commentText: Object.assign(Object.assign({}, fonts.normal), { color: palette.neutralEmptyOn }),
    activityText: Object.assign(Object.assign({}, fonts.normal), { display: 'block', alignSelf: 'center', color: palette.neutralEmptyOn }),
    activityTypeIcon: {
        height: "100%",
    },
    timeStamp: {
        color: palette.neutralEmptyOn
    }
}));


/***/ }),

/***/ "./src/content/cards/comment-card/comment-card.component.tsx":
/*!*******************************************************************!*\
  !*** ./src/content/cards/comment-card/comment-card.component.tsx ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CommentCard = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const models_1 = __webpack_require__(/*! ../../../models */ "./src/models/index.ts");
const page_helper_1 = __webpack_require__(/*! ../../../content/page/page-metadata.component/page.helper */ "./src/content/page/page-metadata.component/page.helper.ts");
const page_comment_form_component_1 = __webpack_require__(/*! ../../../content/page/page-comment-form.component */ "./src/content/page/page-comment-form.component.tsx");
const comment_card_styles_1 = __webpack_require__(/*! ./comment-card-styles */ "./src/content/cards/comment-card/comment-card-styles.ts");
const CommentCard = ({ config, config: { consumes, provides, query, props: { localisedText, maxLength } = {} }, data: { data } }) => {
    const transform = smarthub_common_1.useTransform();
    const styles = smarthub_common_1.useFluentStylesWithProps(comment_card_styles_1.activityStyles);
    const profile = smarthub_common_1.useProfile();
    const handleCommand = smarthub_common_1.useHandleCommand();
    const [comment, setComment] = react_1.useState(null);
    const [mode, setMode] = react_1.useState(null);
    const setRefreshKey = smarthub_common_1.useSetSharedState(provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'refreshKey'));
    const page = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"));
    react_1.useEffect(() => {
        const card = transform(models_1.ICommentSchema, data);
        setComment(card);
    }, [data]);
    const handleOnSuccess = react_1.useCallback((data) => {
        setMode(null);
        setRefreshKey((new Date()).getTime());
    }, []);
    const renderDescription = (props, render) => {
        var _a;
        const { comment, profile } = props;
        const { $id, message, author: { id: authorId } = {} } = comment;
        const isOwner = authorId && (profile === null || profile === void 0 ? void 0 : profile.$id) === authorId;
        return react_1.default.createElement(react_2.Stack, { horizontal: true },
            isOwner && !((_a = page === null || page === void 0 ? void 0 : page.comments) === null || _a === void 0 ? void 0 : _a.closed) && react_1.default.createElement("div", null,
                react_1.default.createElement(react_2.IconButton, { ariaLabel: "edit the comment", onClick: () => setMode('update') },
                    react_1.default.createElement(react_2.Icon, { iconName: "Edit" })),
                react_1.default.createElement(react_2.IconButton, { ariaLabel: "delete the comment", onClick: () => setMode('delete') },
                    react_1.default.createElement(react_2.Icon, { iconName: "Delete" })),
                mode &&
                    react_1.default.createElement(page_comment_form_component_1.PageCommentForm, { id: $id, mode: mode, message: message, query: query, maxLength: maxLength, localizedText: localisedText, params: { page }, onSuccess: data => handleOnSuccess(data) })),
            render(props));
    };
    return react_1.useMemo(() => {
        if (!comment)
            return null;
        const { $id, message, author: { name, action, image } = {}, created } = comment;
        const profileLink = react_1.default.createElement(react_2.Link, { onClick: () => handleCommand(action), title: name, "aria-label": name }, name);
        const content = react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: decodeURIComponent(message) } });
        return react_1.default.createElement(core_1.ComponentChrome, { config: config },
            react_1.default.createElement(react_2.ActivityItem, { key: `${$id}`, styles: styles, onRenderActivityDescription: (props, render) => renderDescription(Object.assign(Object.assign({}, props), { profile, comment }), render), comments: profileLink, activityDescription: content, timeStamp: created, activityPersonas: [{
                        imageUrl: image,
                        text: name,
                        imageInitials: page_helper_1.getInitials(name),
                        onClick: () => handleCommand(action)
                    }] }));
    }, [comment, config, mode, data, styles, profile]);
};
exports.CommentCard = CommentCard;


/***/ }),

/***/ "./src/content/cards/comment-card/index.ts":
/*!*************************************************!*\
  !*** ./src/content/cards/comment-card/index.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./comment-card.component */ "./src/content/cards/comment-card/comment-card.component.tsx"), exports);


/***/ }),

/***/ "./src/content/cards/event-card/event-card.component.tsx":
/*!***************************************************************!*\
  !*** ./src/content/cards/event-card/event-card.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EventCard = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
//TODO Use event interface and transform
const useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing }) => ({
    card: Object.assign(Object.assign({}, fonts.normal), { borderLeft: `${spacing.smallPlus} solid ${palette.primary}`, padding: spacing.smallPlus, backgroundColor: palette.neutralFullOn, borderRadius: spacing.small, boxShadow: "rgb(0 0 0 / 13%) 0px 1.6px 3.6px 0px, rgb(0 0 0 / 11%) 0px 0.3px 0.9px 0px" }),
    meetingInfo: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: spacing.smallPlus,
    },
    freeTime: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: palette.neutral,
        margin: `${spacing.xLarge} auto ${spacing.medium}`,
        padding: `${spacing.smallPlus} ${spacing.xLarge}`,
        borderRadius: '100%',
    },
    meetingContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    meetingTitle: Object.assign(Object.assign({}, fonts.mediumPlus), { display: "flex", marginTop: spacing.medium })
}));
const fluentStyles = (({ theme: { fonts, spacing } }) => ({
    title: {
        root: Object.assign(Object.assign({}, fonts.normalPlus), { display: "flex" })
    },
    calendarIcon: {
        root: {
            position: "relative",
            top: spacing.small,
            marginRight: spacing.smallPlus,
        }
    }
}));
const EventCard = ({ config, data: { index = 0, data } = { data: null, index: 0 } }) => {
    const calendarStyles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const styles = useStyles();
    const { cardLabel, allDay, meetingAttendeeAria, join, joinMeeting, meetingFreeFor, meetingFreeFrom } = smarthub_common_1.useLocalizeConfig();
    const [persona, setPersona] = react_1.useState([]);
    react_1.useEffect(() => {
        const filterNames = (data === null || data === void 0 ? void 0 : data.attendees.map(e => e.emailAddress.name)) || [];
        const personaArr = [];
        filterNames === null || filterNames === void 0 ? void 0 : filterNames.forEach(person => {
            personaArr.push({ 'personaName': person });
        });
        setPersona(personaArr);
    }, [data === null || data === void 0 ? void 0 : data.attendees]);
    return react_1.useMemo(() => (data
        ? react_1.default.createElement(core_1.ComponentChrome, { config: config, "aria-label": `${data === null || data === void 0 ? void 0 : data.subject}, ${cardLabel}`, focusable: true, enableCoachmark: index === 0 },
            react_1.default.createElement("div", { className: styles.meetingContainer },
                react_1.default.createElement("div", { className: styles.card },
                    react_1.default.createElement("div", { className: styles.meetingTitle },
                        (data === null || data === void 0 ? void 0 : data.type) != "occurrence" ? react_1.default.createElement(react_2.Icon, { styles: calendarStyles.calendarIcon, iconName: "Calendar" })
                            : react_1.default.createElement(react_2.Icon, { styles: calendarStyles.calendarIcon, iconName: "RecurringEvent" }),
                        react_1.default.createElement(utilities_1.TextOverflow, { lines: 2, text: data === null || data === void 0 ? void 0 : data.subject },
                            react_1.default.createElement(react_2.Link, { href: data.webLink, target: "_blank" }, data === null || data === void 0 ? void 0 : data.subject))),
                    react_1.default.createElement(utilities_1.TextOverflow, { lines: 1, text: data.isAllDay
                            ? allDay
                            : `${smarthub_common_1.formatDateTime([data.start.dateTime, 'HH:mm'])} - ${smarthub_common_1.timeDifference(data.start.dateTime, data.end.dateTime)}` }),
                    react_1.default.createElement("div", { className: styles.meetingInfo },
                        react_1.default.createElement(react_2.Facepile, { personaSize: react_2.PersonaSize.size24, personas: persona, maxDisplayablePersonas: 6, ariaLabel: meetingAttendeeAria }),
                        data.isOnlineMeeting && react_1.default.createElement(react_2.DefaultButton, { title: joinMeeting, text: join, onClick: () => window.open(data.onlineMeeting.joinUrl, '_blank') }))),
                (data === null || data === void 0 ? void 0 : data.nextMeetingTime) && react_1.default.createElement("div", { className: styles.freeTime },
                    meetingFreeFor,
                    " ",
                    smarthub_common_1.timeDifference(data.end.dateTime, data.nextMeetingTime),
                    " ",
                    meetingFreeFrom,
                    " ",
                    smarthub_common_1.formatDateTime([data.end.dateTime, 'HH:mm']),
                    " ")))
        : null), [data, persona, calendarStyles]);
};
exports.EventCard = EventCard;


/***/ }),

/***/ "./src/content/cards/event-card/index.ts":
/*!***********************************************!*\
  !*** ./src/content/cards/event-card/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./event-card.component */ "./src/content/cards/event-card/event-card.component.tsx"), exports);


/***/ }),

/***/ "./src/content/cards/index.ts":
/*!************************************!*\
  !*** ./src/content/cards/index.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./thumb-card */ "./src/content/cards/thumb-card/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./tile */ "./src/content/cards/tile/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./slide */ "./src/content/cards/slide/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./person-card */ "./src/content/cards/person-card/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./link-tile */ "./src/content/cards/link-tile/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./event-card */ "./src/content/cards/event-card/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./comment-card */ "./src/content/cards/comment-card/index.ts"), exports);


/***/ }),

/***/ "./src/content/cards/link-tile/index.ts":
/*!**********************************************!*\
  !*** ./src/content/cards/link-tile/index.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./link-tile.component */ "./src/content/cards/link-tile/link-tile.component.tsx"), exports);


/***/ }),

/***/ "./src/content/cards/link-tile/link-tile.component.tsx":
/*!*************************************************************!*\
  !*** ./src/content/cards/link-tile/link-tile.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LinkTile = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const models_1 = __webpack_require__(/*! ../../../models */ "./src/models/index.ts");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const card_style_1 = __webpack_require__(/*! ../card.style */ "./src/content/cards/card.style.ts");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const fluentStyles = ({ config, theme: { palette, spacing, sizes }, }) => {
    var _a, _b, _c, _d;
    return ({
        stack: {
            root: {
                flexDirection: "column-reverse",
            },
        },
        tile: {
            root: {
                width: "100%",
                height: "100%",
                position: "absolute",
                overflow: "hidden",
            },
        },
        content: {
            root: {
                padding: spacing.medium,
                overflow: "hidden",
                position: "absolute",
                alignItems: "center",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: "100%",
                justifyContent: "center",
                backgroundColor: palette[config === null || config === void 0 ? void 0 : config.palette],
            },
        },
        title: {
            root: {
                maxHeight: "100%",
                color: palette[(_a = config === null || config === void 0 ? void 0 : config.textPalette) !== null && _a !== void 0 ? _a : `${config === null || config === void 0 ? void 0 : config.palette}On`],
                fontWeight: react_2.FontWeights.semibold,
                margin: "auto 0",
                display: "-webkit-box",
                lineClamp: "4",
                boxOrient: "vertical",
                textOverflow: "ellipsis",
                overflow: "hidden",
            },
        },
        description: {
            root: {
                color: palette[(_b = config === null || config === void 0 ? void 0 : config.textPalette) !== null && _b !== void 0 ? _b : `${config === null || config === void 0 ? void 0 : config.palette}On`],
                fontWeight: react_2.FontWeights.regular,
            },
        },
        promoStar: {
            root: {
                color: palette[(_c = config === null || config === void 0 ? void 0 : config.textPalette) !== null && _c !== void 0 ? _c : `${config === null || config === void 0 ? void 0 : config.palette}On`],
                textAlign: "center",
                position: "absolute",
                width: sizes.smallPlus,
                top: "0",
                left: "0",
                opacity: "0.6",
            },
        },
        bookmark: {
            root: {
                color: palette[(_d = config === null || config === void 0 ? void 0 : config.textPalette) !== null && _d !== void 0 ? _d : `${config === null || config === void 0 ? void 0 : config.palette}On`],
                position: "absolute",
                width: sizes.normal,
                bottom: "0",
                right: "0",
            },
        },
    });
};
const linkStyles = {
    root: {
        margin: "auto 0",
    },
};
const cardConfig = {
    scale: 60,
};
const LinkTile = ({ config, config: { props: { defaultTheme, themes, showDescription }, responsive, coachmarks, }, data: { data, index = 0 } = { data: null, index: 0 }, }) => {
    const { cardLabel, invalidSchema: message, linkTileTitle, linkTileAria, } = smarthub_common_1.useLocalizeConfig();
    const locale = smarthub_common_1.useLocale();
    const transform = smarthub_common_1.useTransform();
    const [{ card, theme }, setState] = react_1.useState({
        card: null,
        theme: null,
    });
    react_1.useEffect(() => {
        var _a;
        const card = transform(models_1.ILinkTileSchema, data);
        const theme = (_a = themes === null || themes === void 0 ? void 0 : themes.find((t) => t.name == (card === null || card === void 0 ? void 0 : card.theme))) !== null && _a !== void 0 ? _a : defaultTheme;
        setState({ card, theme });
    }, [data]);
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, theme, responsive);
    const cardStyle = card_style_1.useCardStyle(cardConfig);
    const focusStyle = smarthub_common_1.useFocusStyles();
    const bookmarkCoachmark = index === 0
        ? coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find((coachmark) => coachmark.target === "bookmark-button") : null;
    const error = card && card.$schema != models_1.ILinkTileSchema
        ? {
            message,
        }
        : null;
    return react_1.useMemo(() => {
        var _a;
        return card ? (react_1.default.createElement(core_1.ComponentChrome, { config: config, "aria-label": `${card === null || card === void 0 ? void 0 : card.title}, ${cardLabel}`, focusable: true, enableCoachmark: index === 0, error: error },
            react_1.default.createElement("div", { className: cardStyle.card },
                react_1.default.createElement(react_2.Stack, { styles: styles.stack },
                    react_1.default.createElement(react_2.StackItem, { styles: styles.content },
                        card.promoted === true && (react_1.default.createElement(react_2.Icon, { styles: styles.promoStar, iconName: "StarburstSolid" })),
                        react_1.default.createElement(utilities_1.ActionLink, { colour: `${theme === null || theme === void 0 ? void 0 : theme.palette}On`, styles: linkStyles, "aria-label": `${linkTileAria} ${card.title}`, title: `${linkTileTitle} ${card.title}`, action: card.action },
                            react_1.default.createElement(react_2.Text, { variant: "mediumPlus", styles: styles.title }, card === null || card === void 0 ? void 0 : card.title)),
                        showDescription && ((_a = card === null || card === void 0 ? void 0 : card.description) === null || _a === void 0 ? void 0 : _a.length) > 0 && (react_1.default.createElement(react_2.Text, { variant: "medium", styles: styles.description }, card.description)),
                        (card === null || card === void 0 ? void 0 : card.bookmark) && (react_1.default.createElement(react_2.Text, { styles: styles.bookmark }, bookmarkCoachmark != null ? (react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, bookmarkCoachmark),
                            react_1.default.createElement(utilities_1.Bookmark, { title: card.title, bookmarkInfo: card.bookmark }))) : (react_1.default.createElement(utilities_1.Bookmark, { title: card.title, bookmarkInfo: card.bookmark }))))))))) : (react_1.default.createElement(react_1.default.Fragment, null));
    }, [
        styles,
        card,
        locale,
        focusStyle.focus,
        cardStyle.card,
        bookmarkCoachmark,
    ]);
};
exports.LinkTile = LinkTile;


/***/ }),

/***/ "./src/content/cards/person-card/index.ts":
/*!************************************************!*\
  !*** ./src/content/cards/person-card/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./person-card */ "./src/content/cards/person-card/person-card.tsx"), exports);


/***/ }),

/***/ "./src/content/cards/person-card/person-card.tsx":
/*!*******************************************************!*\
  !*** ./src/content/cards/person-card/person-card.tsx ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PersonCard = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const card_style_1 = __webpack_require__(/*! ../card.style */ "./src/content/cards/card.style.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const fluentStyles = (({ theme: { spacing } }) => ({
    coin: {
        image: {
            marginRight: 0,
            cursor: 'pointer',
        }
    },
    persona: {
        root: {
            flexDirection: "column",
            height: 'auto',
            margin: spacing.medium
        },
        details: {
            marginTop: spacing.xxLarge,
            textAlign: "center",
            padding: 0
        },
    }
}));
const useBookMarkStyles = react_jss_1.createUseStyles({
    bookmark: {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "-25px"
    }
});
const getCustomPrimaryTextRenderer = (action) => {
    return (props) => {
        return (react_1.default.createElement(utilities_1.ActionLink, { "aria-label": props["aria-label"], title: props.title, action: action },
            react_1.default.createElement(utilities_1.TextOverflow, { lines: 2, text: props.text, font: smarthub_common_1.SizeKeys.mediumPlus, showTooltip: true })));
    };
};
const PersonCard = ({ config, data: { data, index = 0 } = { index: 0, data: null }, config: { $id, query, consumes, coachmarks } }) => {
    const transform = smarthub_common_1.useTransform();
    const fetch = smarthub_common_1.useFetch();
    const [card, setCard] = react_1.useState(null);
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const bookmarkStyles = useBookMarkStyles();
    const cardStyle = card_style_1.useCardStyle();
    const focusStyle = smarthub_common_1.useFocusStyles();
    const openAction = smarthub_common_1.useHandleCommand();
    const { invalidSchema: message, personaLinkAria, personaLinkTitle, cardLabel } = smarthub_common_1.useLocalizeConfig();
    const [filters, setFilters] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setFilters(consumes), [consumes]);
    const bookmarkCoachmark = index === 0
        ? coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(coachmark => coachmark.target === 'bookmark-button') : null;
    const onClick = react_1.useCallback(() => {
        openAction(card.action);
    }, [card]);
    const error = card && card.$schema != smarthub_common_1.IPersonSchema
        ? {
            message
        }
        : null;
    react_1.useEffect(() => {
        const fetchData = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            try {
                const result = yield fetch(query, filters);
                const data = transform(smarthub_common_1.IPersonSchema, result.data);
                setCard(data);
            }
            catch (ex) {
                smarthub_common_1.Logger.error("Failed to fetch person data", false, { ex });
            }
        });
        if (query)
            fetchData();
        else {
            const item = transform(smarthub_common_1.IPersonSchema, data);
            setCard(item);
        }
    }, [filters, config, data, fetch]);
    return react_1.useMemo(() => {
        const props = card
            ? {
                coinProps: {
                    styles: styles.coin,
                    onClick: onClick,
                },
                styles: styles.persona,
                size: react_2.PersonaSize.size100,
                text: card.name,
                secondaryText: card.jobTitle,
                tertiaryText: card.department,
                imageUrl: card.image,
                imageAlt: card.name,
                title: `${personaLinkTitle} ${card.name}`,
                "aria-label": `${personaLinkAria} ${card.name}`,
                onRenderPrimaryText: getCustomPrimaryTextRenderer(card.action)
            }
            : null;
        return card
            ? react_1.default.createElement(core_1.ComponentChrome, { config: config, "aria-label": `${card === null || card === void 0 ? void 0 : card.name}, ${cardLabel}`, focusable: true, enableCoachmark: index === 0, error: error },
                react_1.default.createElement("div", { className: cardStyle.card },
                    react_1.default.createElement(react_2.Stack, null,
                        react_1.default.createElement(react_2.StackItem, null,
                            react_1.default.createElement(react_2.Persona, Object.assign({}, props)),
                            card.bookmark && react_1.default.createElement("div", { className: bookmarkStyles.bookmark }, bookmarkCoachmark != null
                                ? react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, bookmarkCoachmark),
                                    react_1.default.createElement(utilities_1.Bookmark, { title: card === null || card === void 0 ? void 0 : card.name, bookmarkInfo: card.bookmark }))
                                : react_1.default.createElement(utilities_1.Bookmark, { title: card === null || card === void 0 ? void 0 : card.name, bookmarkInfo: card.bookmark }))))))
            : null;
    }, [styles, card, focusStyle.focus, cardStyle.card]);
};
exports.PersonCard = PersonCard;


/***/ }),

/***/ "./src/content/cards/slide/index.ts":
/*!******************************************!*\
  !*** ./src/content/cards/slide/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./slide.component */ "./src/content/cards/slide/slide.component.tsx"), exports);


/***/ }),

/***/ "./src/content/cards/slide/slide.component.tsx":
/*!*****************************************************!*\
  !*** ./src/content/cards/slide/slide.component.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Slide = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const models_1 = __webpack_require__(/*! ../../../models */ "./src/models/index.ts");
const ms_stream_1 = __webpack_require__(/*! ../../ms-stream */ "./src/content/ms-stream/index.ts");
const card_style_1 = __webpack_require__(/*! ../card.style */ "./src/content/cards/card.style.ts");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const fluentStyles = ({ theme: { palette, type, spacing }, }) => ({
    stack: {
        root: {
            flexDirection: "column-reverse",
        },
    },
    tile: {
        root: {
            width: "100%",
            height: "100%",
            position: "absolute",
            overflow: "hidden",
        },
    },
    content: {
        root: Object.assign(Object.assign({ padding: spacing.medium, overflow: "hidden", position: "absolute", width: "100%", boxSizing: "border-box", display: "flex", flexDirection: "column", justifyContent: "flex-end", backgroundColor: palette.filmPlus1, backdropFilter: `blur(${spacing.small})` }, react_2.AnimationStyles.fadeIn500), { animationDelay: "2s" }),
    },
    image: {
        root: {
            position: "relative",
            height: "100%",
        },
        image: {
            minWidth: "100%",
            minHeight: "100%",
            height: "100%",
            width: "auto",
            filter: type == "dark"
                ? "contrast(1.1) saturate(1.3) brightness(0.7)"
                : "contrast(1.1) saturate(1.3) brightness(0.9)",
        },
    },
});
const cardConfig = {
    scale: 60,
};
const Slide = ({ config, data: { data, index = 0 } = { index: 0, data: null }, }) => {
    const transform = smarthub_common_1.useTransform();
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const cardStyle = card_style_1.useCardStyle(cardConfig);
    const [card, setCard] = react_1.useState(null);
    const locale = smarthub_common_1.useLocale();
    const { cardLabel, invalidSchema: message, slideTitle } = smarthub_common_1.useLocalizeConfig();
    react_1.useEffect(() => {
        const card = transform(models_1.ISlideSchema, data);
        setCard(card);
    }, [data]);
    const error = card && card.$schema != models_1.ISlideSchema
        ? {
            message,
        }
        : null;
    return react_1.useMemo(() => {
        var _a, _b, _c;
        const linkTitle = (card === null || card === void 0 ? void 0 : card.title) ? `${slideTitle}, ${card.title}` : "";
        return card ? (react_1.default.createElement(core_1.ComponentChrome, { config: config, "aria-label": `${card === null || card === void 0 ? void 0 : card.title}, ${cardLabel}`, focusable: true, enableCoachmark: index === 0, error: error },
            react_1.default.createElement("div", { className: cardStyle.card }, ((_a = card.embed) === null || _a === void 0 ? void 0 : _a.type) == "video" ? (react_1.default.createElement(ms_stream_1.StreamEmbed, { uri: card.embed.uri })) : (react_1.default.createElement(react_2.Stack, { styles: styles.stack },
                react_1.default.createElement(react_2.StackItem, { styles: styles.tile },
                    react_1.default.createElement(react_2.Image, { src: card.image.uri, alt: card.description, styles: styles.image })),
                react_1.default.createElement(react_2.StackItem, { styles: styles.content },
                    card.action ? (react_1.default.createElement(utilities_1.ActionLink, { "aria-label": card.label, title: linkTitle, action: card.action, colour: smarthub_common_1.PaletteKeys.filmPlus1On },
                        react_1.default.createElement(utilities_1.TextOverflow, { lines: 2, text: card.title, font: smarthub_common_1.SizeKeys.mediumPlus, colour: smarthub_common_1.PaletteKeys.filmPlus1On, showTooltip: true, fixed: true }))) : (react_1.default.createElement(utilities_1.TextOverflow, { lines: 2, text: card.title, font: smarthub_common_1.SizeKeys.superLarge, colour: smarthub_common_1.PaletteKeys.filmPlus1On, showTooltip: true })),
                    ((_b = card.subTitle) === null || _b === void 0 ? void 0 : _b.length) > 0 && (react_1.default.createElement(utilities_1.TextOverflow, { lines: 1, text: card.subTitle, font: smarthub_common_1.SizeKeys.medium, colour: smarthub_common_1.PaletteKeys.filmPlus1On, showTooltip: true })),
                    ((_c = card.description) === null || _c === void 0 ? void 0 : _c.length) > 0 && (react_1.default.createElement(utilities_1.TextOverflow, { lines: 2, text: card.description, font: smarthub_common_1.SizeKeys.medium, colour: smarthub_common_1.PaletteKeys.filmPlus1On, showTooltip: true })))))))) : (react_1.default.createElement(react_1.default.Fragment, null));
    }, [styles, card, locale, cardStyle.card]);
};
exports.Slide = Slide;


/***/ }),

/***/ "./src/content/cards/thumb-card/card-body.component.tsx":
/*!**************************************************************!*\
  !*** ./src/content/cards/thumb-card/card-body.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardBody = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const card_line_component_1 = __webpack_require__(/*! ./card-line.component */ "./src/content/cards/thumb-card/card-line.component.tsx");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (({ theme: { spacing } }) => ({
    lineStyles: {
        root: {
            gap: spacing.normal
        }
    },
    bodyStyles: {
        root: {
            padding: spacing.smallPlus
        }
    }
}));
const CardBody = ({ card, horizontal, compact }) => {
    var _a, _b;
    const { lineStyles, bodyStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    return react_1.default.createElement(react_2.StackItem, { styles: bodyStyles, grow: 1 },
        react_1.default.createElement(react_2.Stack, { styles: lineStyles }, (_b = (_a = card.lines) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.map((line, index) => react_1.default.createElement(card_line_component_1.CardLine, { key: index, line: line, horizontal: horizontal, compact: compact }))));
};
exports.CardBody = CardBody;


/***/ }),

/***/ "./src/content/cards/thumb-card/card-footer.component.tsx":
/*!****************************************************************!*\
  !*** ./src/content/cards/thumb-card/card-footer.component.tsx ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardFooter = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const card_line_component_1 = __webpack_require__(/*! ./card-line.component */ "./src/content/cards/thumb-card/card-line.component.tsx");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (({ config: horizontal, theme: { palette, spacing } }) => ({
    footerStyles: {
        root: {
            gap: spacing.smallPlus,
            padding: spacing.smallPlus,
            borderTop: `${spacing.tiny} solid ${palette.neutralMinus4}`,
            alignItems: horizontal
                ? 'center'
                : undefined,
        }
    },
    lineStyles: {
        root: {
            alignItems: horizontal
                ? 'center'
                : undefined,
            gap: spacing.smallPlus
        }
    },
    mainStyles: {
        root: {
            flex: "1 1",
            gap: spacing.smallPlus,
            alignItems: horizontal
                ? "center"
                : "flex-end"
        }
    }
}));
const CardFooter = ({ card, horizontal, compact, index, coachmarks }) => {
    var _a, _b, _c;
    const { footerStyles, mainStyles, lineStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles, horizontal);
    const bookmarkCoachmark = (card === null || card === void 0 ? void 0 : card.bookmark) && index === 0
        ? coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(coachmark => coachmark.target === 'bookmark-button') : null;
    return react_1.default.createElement(react_2.Stack, { horizontal: horizontal, styles: footerStyles }, (_b = (_a = card.lines) === null || _a === void 0 ? void 0 : _a.footer) === null || _b === void 0 ? void 0 :
        _b.map((line, index) => react_1.default.createElement(card_line_component_1.CardLine, { key: index, line: line, horizontal: horizontal, compact: compact })),
        react_1.default.createElement(react_2.Stack, { horizontal: true, styles: mainStyles },
            react_1.default.createElement(react_2.StackItem, { grow: 1 },
                react_1.default.createElement(react_2.Stack, { horizontal: horizontal, styles: lineStyles }, (_c = card.tags) === null || _c === void 0 ? void 0 : _c.map((tag, index) => react_1.default.createElement(utilities_1.Tag, { key: index, tagInfo: tag, width: horizontal ? 'auto' : 'fill' })))),
            (card === null || card === void 0 ? void 0 : card.bookmark) && react_1.default.createElement(react_2.StackItem, null, bookmarkCoachmark != null
                ? react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, bookmarkCoachmark),
                    react_1.default.createElement(utilities_1.Bookmark, { title: card.title, bookmarkInfo: card === null || card === void 0 ? void 0 : card.bookmark }))
                : react_1.default.createElement(utilities_1.Bookmark, { title: card.title, bookmarkInfo: card === null || card === void 0 ? void 0 : card.bookmark }))));
};
exports.CardFooter = CardFooter;


/***/ }),

/***/ "./src/content/cards/thumb-card/card-header.component.tsx":
/*!****************************************************************!*\
  !*** ./src/content/cards/thumb-card/card-header.component.tsx ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardHeader = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const card_image_component_1 = __webpack_require__(/*! ./card-image.component */ "./src/content/cards/thumb-card/card-image.component.tsx");
const card_icon_component_1 = __webpack_require__(/*! ./card-icon.component */ "./src/content/cards/thumb-card/card-icon.component.tsx");
const card_overlay_component_1 = __webpack_require__(/*! ./card-overlay.component */ "./src/content/cards/thumb-card/card-overlay.component.tsx");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (({ config: horizontal }) => ({
    root: Object.assign({ position: "relative" }, (horizontal
        ? {
            width: "auto",
            maxWidth: "33%",
            height: "100%",
            flex: "0 1 0%"
        }
        : {
            width: "100%",
            maxWidth: "100%",
            height: "auto"
        }))
}));
const CardHeader = ({ header, horizontal }) => {
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, horizontal);
    return react_1.default.createElement(react_2.StackItem, { styles: styles },
        header.image && react_1.default.createElement(card_image_component_1.CardImage, { image: header.image, horizontal: horizontal }),
        header.icon && react_1.default.createElement(card_icon_component_1.CardIcon, { icon: header.icon, horizontal: horizontal, hasImage: header.image != null }),
        header.stack && react_1.default.createElement(card_overlay_component_1.CardOverlay, { stack: header.stack }));
};
exports.CardHeader = CardHeader;


/***/ }),

/***/ "./src/content/cards/thumb-card/card-icon.component.tsx":
/*!**************************************************************!*\
  !*** ./src/content/cards/thumb-card/card-icon.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardIcon = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_file_type_icons_1 = __webpack_require__(/*! @fluentui/react-file-type-icons */ "@fluentui/react-file-type-icons");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const useStyles = react_jss_1.createUseStyles(({ palette, spacing }) => ({
    icon: ({ icon, hasImage }) => {
        var _a, _b, _c, _d, _e;
        return ({
            color: (_a = palette[icon.colour]) !== null && _a !== void 0 ? _a : palette.neutralMinus3On,
            backgroundColor: hasImage
                ? undefined
                : (_b = palette[icon.backgroundColour]) !== null && _b !== void 0 ? _b : palette.neutralMinus3,
            width: "100%",
            height: "100%",
            top: 0,
            padding: spacing.medium,
            position: "absolute",
            display: "flex",
            justifyContent: !icon.position
                ? 'center'
                : ~icon.position.indexOf("left")
                    ? 'flex-start'
                    : ~((_c = icon.position) === null || _c === void 0 ? void 0 : _c.indexOf("right"))
                        ? 'flex-end'
                        : "center",
            alignItems: !icon.position
                ? 'center'
                : ~((_d = icon.position) === null || _d === void 0 ? void 0 : _d.indexOf("top"))
                    ? 'flex-start'
                    : ~((_e = icon.position) === null || _e === void 0 ? void 0 : _e.indexOf("bottom"))
                        ? 'flex-end'
                        : "center",
            boxSizing: "border-box"
        });
    },
    svg: ({ horizontal }) => {
        return horizontal ? {
            width: "auto",
            height: "100%",
            flex: "0 1 0%"
        } : {
            width: "100%",
            height: "auto"
        };
    }
}));
const CardIcon = (props) => {
    var _a;
    const { icon, horizontal, hasImage } = props;
    const styles = useStyles(props);
    const focusStyle = smarthub_common_1.useFocusStyles();
    const iconProps = ((_a = icon.extension) === null || _a === void 0 ? void 0 : _a.length) ? react_file_type_icons_1.getFileTypeIconProps({
        extension: icon.extension,
        size: icon.size
    })
        : {
            iconName: icon.name,
            title: icon.title
        };
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles.icon },
            react_1.default.createElement(react_2.Icon, Object.assign({}, iconProps, { "data-is-focusable": true, className: focusStyle.focus }))),
        !hasImage && react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: horizontal ? "10" : "6", width: "10", className: styles.svg }));
};
exports.CardIcon = CardIcon;


/***/ }),

/***/ "./src/content/cards/thumb-card/card-image.component.tsx":
/*!***************************************************************!*\
  !*** ./src/content/cards/thumb-card/card-image.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardImage = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles({
    svg: (horizontal) => {
        return horizontal ? {
            width: "auto",
            height: "100%",
            flex: "0 1 0%"
        } : {
            width: "100%",
            height: "auto"
        };
    }
});
const fluentStyles = (({ config: image, theme: { type, spacing, sizes } }) => ({
    root: Object.assign({ position: image.layout != 'portrait'
            ? 'absolute'
            : 'relative', top: '0', left: '0' }, (image.layout == 'avatar'
        ? {
            width: sizes.mega,
            height: sizes.mega,
            borderRadius: sizes.mega,
            margin: spacing.smallPlus
        }
        : {
            width: '100%',
            height: '100%'
        })),
    image: {
        width: "100%",
        filter: type == "dark"
            ? "contrast(1.1) saturate(1.3) brightness(0.7)"
            : "contrast(1.1) saturate(1.3) brightness(0.9)",
    }
}));
const focusConfig = {
    position: "absolute"
};
const CardImage = ({ image, horizontal }) => {
    const styles = useStyles(horizontal);
    const focusStyle = smarthub_common_1.useFocusStyles(image.layout != 'portrait'
        ? focusConfig
        : undefined);
    const imageStyles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, image);
    const imageWidth = (image.layout == 'avatar') ? "6" : "10";
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.Image, { "data-is-focusable": true, className: focusStyle.focus, src: image.uri, alt: image.title, imageFit: image.layout != 'portrait'
                ? react_2.ImageFit.cover
                : react_2.ImageFit.none, styles: imageStyles }),
        image.layout != 'portrait' &&
            react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "6", width: imageWidth, className: styles.svg }));
};
exports.CardImage = CardImage;


/***/ }),

/***/ "./src/content/cards/thumb-card/card-line-icons.component.tsx":
/*!********************************************************************!*\
  !*** ./src/content/cards/thumb-card/card-line-icons.component.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardLineIcons = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (({ theme: { palette } }) => ({
    icon: (colour) => ({
        root: {
            color: (colour === null || colour === void 0 ? void 0 : colour.length) ? palette[colour] : undefined
        }
    }),
}));
const CardLineIcons = ({ icons, colour }) => {
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    return (react_1.default.createElement(react_1.default.Fragment, null, icons.map((icon, idx) => { var _a; return react_1.default.createElement(react_2.Icon, { "aria-hidden": "true", key: idx, iconName: icon.name, styles: styles.icon(((_a = icon.colour) === null || _a === void 0 ? void 0 : _a.length) ? icon.colour : colour) }); })));
};
exports.CardLineIcons = CardLineIcons;


/***/ }),

/***/ "./src/content/cards/thumb-card/card-line.component.tsx":
/*!**************************************************************!*\
  !*** ./src/content/cards/thumb-card/card-line.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardLine = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_2 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const card_line_icons_component_1 = __webpack_require__(/*! ./card-line-icons.component */ "./src/content/cards/thumb-card/card-line-icons.component.tsx");
const fluentStyles = ({ theme: { spacing } }) => ({
    root: {
        gap: spacing.smallPlus,
    }
});
const CardLine = ({ line: { colour, font, icons, show, text, action, title, label }, horizontal, compact }) => {
    var _a, _b, _c, _d, _e;
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const { before, after } = icons !== null && icons !== void 0 ? icons : {};
    const { min, med, max, fixed } = show !== null && show !== void 0 ? show : {};
    const lines = horizontal
        ? (_b = (_a = min !== null && min !== void 0 ? min : med) !== null && _a !== void 0 ? _a : max) !== null && _b !== void 0 ? _b : 1 : compact
        ? (_c = med !== null && med !== void 0 ? med : min) !== null && _c !== void 0 ? _c : 1 : (_e = (_d = max !== null && max !== void 0 ? max : med) !== null && _d !== void 0 ? _d : min) !== null && _e !== void 0 ? _e : 1;
    return (react_2.default.createElement(react_1.Stack, { horizontal: true, wrap: false, styles: styles },
        before && react_2.default.createElement(card_line_icons_component_1.CardLineIcons, { icons: before, colour: colour }),
        react_2.default.createElement(react_1.StackItem, { grow: 1 }, action ?
            react_2.default.createElement(utilities_1.ActionLink, { "aria-label": label, title: title, action: action },
                react_2.default.createElement(utilities_1.TextOverflow, { showTooltip: true, lines: lines, text: text, fixed: fixed, font: font, colour: colour })) :
            react_2.default.createElement(utilities_1.TextOverflow, { label: label, showTooltip: true, lines: lines, text: text, fixed: fixed, font: font, colour: colour })),
        after && react_2.default.createElement(card_line_icons_component_1.CardLineIcons, { icons: after, colour: colour })));
};
exports.CardLine = CardLine;


/***/ }),

/***/ "./src/content/cards/thumb-card/card-main.component.tsx":
/*!**************************************************************!*\
  !*** ./src/content/cards/thumb-card/card-main.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardMain = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const card_footer_component_1 = __webpack_require__(/*! ./card-footer.component */ "./src/content/cards/thumb-card/card-footer.component.tsx");
const card_body_component_1 = __webpack_require__(/*! ./card-body.component */ "./src/content/cards/thumb-card/card-body.component.tsx");
const styles = {
    root: {
        height: "100%"
    }
};
const CardMain = ({ card, horizontal, compact, index, coachmarks }) => {
    return react_1.default.createElement(react_2.StackItem, { grow: 1 },
        react_1.default.createElement(react_2.Stack, { styles: styles },
            react_1.default.createElement(card_body_component_1.CardBody, { card: card, horizontal: horizontal, compact: compact }),
            react_1.default.createElement(card_footer_component_1.CardFooter, { card: card, horizontal: horizontal, compact: compact, index: index, coachmarks: coachmarks })));
};
exports.CardMain = CardMain;


/***/ }),

/***/ "./src/content/cards/thumb-card/card-overlay.component.tsx":
/*!*****************************************************************!*\
  !*** ./src/content/cards/thumb-card/card-overlay.component.tsx ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardOverlay = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (({ config: { position = "top-left", backgroundColour }, theme: { palette, spacing, fonts, sizes } }) => ({
    stack: {
        root: {
            position: "absolute",
            overflow: "hidden",
            top: (position === null || position === void 0 ? void 0 : position.indexOf("top")) >= 0
                ? 0
                : undefined,
            bottom: (position === null || position === void 0 ? void 0 : position.indexOf("bottom")) >= 0
                ? 0
                : undefined,
            right: (position === null || position === void 0 ? void 0 : position.indexOf("right")) >= 0
                ? 0
                : undefined,
            left: (position === null || position === void 0 ? void 0 : position.indexOf("left")) >= 0
                ? 0
                : undefined,
            width: sizes.large,
            height: sizes.large,
            backgroundColor: palette[backgroundColour] || palette.filmPlus1,
            borderTopLeftRadius: (position === null || position === void 0 ? void 0 : position.indexOf("bottom")) >= 0 && (position === null || position === void 0 ? void 0 : position.indexOf("right")) >= 0
                ? spacing.small
                : undefined,
            borderTopRightRadius: (position === null || position === void 0 ? void 0 : position.indexOf("bottom")) >= 0 && (position === null || position === void 0 ? void 0 : position.indexOf("left")) >= 0
                ? spacing.small
                : undefined,
            borderBottomLeftRadius: (position === null || position === void 0 ? void 0 : position.indexOf("top")) >= 0 && (position === null || position === void 0 ? void 0 : position.indexOf("right")) >= 0
                ? spacing.small
                : undefined,
            borderBottomRightRadius: (position === null || position === void 0 ? void 0 : position.indexOf("top")) >= 0 && (position === null || position === void 0 ? void 0 : position.indexOf("left")) >= 0
                ? spacing.small
                : undefined,
        }
    },
    stackItemText: (item, index) => ({
        root: {
            color: palette[item.colour] || palette.filmPlus1On,
            fontWeight: index ? "400" : "200",
            lineHeight: index ? sizes.small : sizes.normal,
            fontSize: index ? fonts.large.fontSize : fonts.xLarge.fontSize,
            textTransform: "uppercase"
        }
    }),
    stackItem: () => ({
        root: Object.assign(Object.assign({}, fonts.small), { textAlign: "center", height: sizes.smallPlus })
    }),
}));
const CardOverlay = ({ stack }) => {
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, stack);
    const focusStyle = smarthub_common_1.useFocusStyles();
    const renderItem = (item, index) => {
        return (react_1.default.createElement(react_2.StackItem, { styles: styles.stackItem(item, index), key: index },
            react_1.default.createElement(react_2.Text, { styles: styles.stackItemText(item, index), "data-is-focusable": true, className: focusStyle.focus }, item.text)));
    };
    const stackTokens = {
        childrenGap: 0
    };
    return (react_1.default.createElement(react_2.Stack, { tokens: stackTokens, styles: styles.stack, title: stack.title }, stack.items.map(renderItem)));
};
exports.CardOverlay = CardOverlay;


/***/ }),

/***/ "./src/content/cards/thumb-card/index.ts":
/*!***********************************************!*\
  !*** ./src/content/cards/thumb-card/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ThumbCard = void 0;
var thumb_card_component_1 = __webpack_require__(/*! ./thumb-card.component */ "./src/content/cards/thumb-card/thumb-card.component.tsx");
Object.defineProperty(exports, "ThumbCard", ({ enumerable: true, get: function () { return thumb_card_component_1.ThumbCard; } }));


/***/ }),

/***/ "./src/content/cards/thumb-card/thumb-card.component.tsx":
/*!***************************************************************!*\
  !*** ./src/content/cards/thumb-card/thumb-card.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ThumbCard = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const models_1 = __webpack_require__(/*! ../../../models */ "./src/models/index.ts");
const card_header_component_1 = __webpack_require__(/*! ./card-header.component */ "./src/content/cards/thumb-card/card-header.component.tsx");
const card_main_component_1 = __webpack_require__(/*! ./card-main.component */ "./src/content/cards/thumb-card/card-main.component.tsx");
const card_style_1 = __webpack_require__(/*! ../card.style */ "./src/content/cards/card.style.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const stackStyle = {
    root: {
        height: "100%"
    }
};
const ThumbCard = (props) => {
    const { config, config: { responsive = {}, coachmarks }, data: { data, index = 0 } = { index: 0 } } = props;
    const { horizontal, compact } = smarthub_common_1.useResponsiveProps(responsive);
    const styleProps = react_1.useMemo(() => ({ fill: !horizontal }), [horizontal]);
    const { cardLabel } = smarthub_common_1.useLocalizeConfig();
    const cardStyle = card_style_1.useCardStyle(styleProps);
    const transform = smarthub_common_1.useTransform();
    const message = smarthub_common_1.useLocalize(smarthub_common_1.LocalizeKeys.invalidSchema);
    const [card, setCard] = react_1.useState(null);
    react_1.useEffect(() => {
        const card = transform(models_1.IThumbCardSchema, data);
        setCard(card);
    }, [props, data]);
    const error = card && card.$schema != models_1.IThumbCardSchema
        ? {
            message
        }
        : null;
    return card
        ? react_1.default.createElement(core_1.ComponentChrome, { config: config, "aria-label": `${card.title}, ${cardLabel}`, className: cardStyle.card, focusable: true, enableCoachmark: index === 0, error: error },
            react_1.default.createElement(react_2.Stack, { horizontal: horizontal, styles: stackStyle },
                card.header && react_1.default.createElement(card_header_component_1.CardHeader, { header: card.header, horizontal: horizontal }),
                react_1.default.createElement(card_main_component_1.CardMain, { card: card, horizontal: horizontal, compact: compact, coachmarks: coachmarks, index: index })))
        : react_1.default.createElement(react_1.default.Fragment, null);
};
exports.ThumbCard = ThumbCard;


/***/ }),

/***/ "./src/content/cards/tile/index.ts":
/*!*****************************************!*\
  !*** ./src/content/cards/tile/index.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./tile.component */ "./src/content/cards/tile/tile.component.tsx"), exports);


/***/ }),

/***/ "./src/content/cards/tile/tile.component.tsx":
/*!***************************************************!*\
  !*** ./src/content/cards/tile/tile.component.tsx ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Tile = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const models_1 = __webpack_require__(/*! ../../../models */ "./src/models/index.ts");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const card_style_1 = __webpack_require__(/*! ../card.style */ "./src/content/cards/card.style.ts");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const fluentStyles = ({ theme: { palette, type, spacing }, }) => ({
    stack: {
        root: {
            flexDirection: "column-reverse",
        },
    },
    tile: {
        root: {
            width: "100%",
            height: "100%",
            position: "absolute",
            overflow: "hidden",
        },
    },
    content: {
        root: Object.assign(Object.assign({ padding: spacing.medium, overflow: "hidden", position: "absolute", width: "100%", boxSizing: "border-box", display: "flex", flexDirection: "column", justifyContent: "flex-end", backgroundColor: palette.filmPlus1, backdropFilter: `blur(${spacing.small})` }, react_2.AnimationStyles.fadeIn500), { animationDelay: "2s" }),
    },
    image: {
        root: {
            position: "relative",
            height: "100%",
        },
        image: {
            minWidth: "100%",
            objectFit: "cover",
            minHeight: "100%",
            height: "100%",
            width: "auto",
            filter: type == "dark"
                ? "contrast(1.1) saturate(1.3) brightness(0.7)"
                : "contrast(1.1) saturate(1.3) brightness(0.9)",
        },
    },
});
const cardConfig = {
    scale: 60,
    offset: smarthub_common_1.SizeKeys.small,
};
const Tile = ({ config, data: { data, index = 0 } = { index: 0, data: null } }) => {
    const transform = smarthub_common_1.useTransform();
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, null, config.responsive);
    const cardStyle = card_style_1.useCardStyle(cardConfig);
    const { cardLabel, invalidSchema: message, tileTitle } = smarthub_common_1.useLocalizeConfig();
    const [card, setCard] = react_1.useState(null);
    const locale = smarthub_common_1.useLocale();
    react_1.useEffect(() => {
        const card = transform(models_1.ITileSchema, data);
        setCard(card);
    }, [data]);
    const error = card && card.$schema != models_1.ITileSchema
        ? {
            message,
        }
        : null;
    return react_1.useMemo(() => {
        var _a, _b;
        const linkTitle = (card === null || card === void 0 ? void 0 : card.title) ? `${tileTitle} ${card.title}` : "";
        return card ? (react_1.default.createElement(core_1.ComponentChrome, { config: config, "aria-label": `${card === null || card === void 0 ? void 0 : card.title}, ${cardLabel}`, focusable: true, enableCoachmark: index === 0, error: error },
            react_1.default.createElement("div", { className: cardStyle.card },
                react_1.default.createElement(react_2.Stack, { styles: styles.stack },
                    react_1.default.createElement(react_2.StackItem, { styles: styles.tile },
                        react_1.default.createElement(react_2.Image, { src: card.image.uri, alt: card.description, styles: styles.image })),
                    react_1.default.createElement(react_2.StackItem, { styles: styles.content },
                        card.action ? (react_1.default.createElement(utilities_1.ActionLink, { "aria-label": card.label, title: linkTitle, action: card.action },
                            react_1.default.createElement(utilities_1.TextOverflow, { lines: 2, text: card.title, font: smarthub_common_1.SizeKeys.mediumPlus, colour: smarthub_common_1.PaletteKeys.filmPlus1On, showTooltip: true, fixed: true }))) : (react_1.default.createElement(utilities_1.TextOverflow, { lines: 2, text: card.title, font: smarthub_common_1.SizeKeys.mediumPlus, colour: smarthub_common_1.PaletteKeys.filmPlus1On, showTooltip: true, fixed: true })),
                        ((_a = card.subTitle) === null || _a === void 0 ? void 0 : _a.length) > 0 && (react_1.default.createElement(utilities_1.TextOverflow, { lines: 1, text: card.subTitle, font: smarthub_common_1.SizeKeys.medium, colour: smarthub_common_1.PaletteKeys.filmPlus1On, showTooltip: true })),
                        ((_b = card.description) === null || _b === void 0 ? void 0 : _b.length) > 0 && (react_1.default.createElement(utilities_1.TextOverflow, { lines: 2, text: card.description, font: smarthub_common_1.SizeKeys.medium, colour: smarthub_common_1.PaletteKeys.filmPlus1On, showTooltip: true, fixed: true }))))))) : (react_1.default.createElement(react_1.default.Fragment, null));
    }, [styles, card, cardStyle.card, locale]);
};
exports.Tile = Tile;


/***/ }),

/***/ "./src/content/carousel/arrow.component.tsx":
/*!**************************************************!*\
  !*** ./src/content/carousel/arrow.component.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Arrow = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const fluentStyles = (({ config: dir, theme: { spacing, palette } }) => ({
    stack: {
        root: {
            height: '100%',
            width: 'auto',
            position: 'absolute',
            top: 0,
            left: dir === 'prev' ? spacing.small : undefined,
            right: dir === 'next' ? spacing.small : undefined,
            zIndex: 10,
        }
    },
    button: {
        root: {
            borderRadius: '50%',
            transition: "background-color 300ms ease-in",
            backgroundColor: palette.neutalFilmMinus1,
        }
    }
}));
const Arrow = ({ dir, label, title, onClick }) => {
    //TODO use style props future
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, dir);
    const handleClick = react_1.useCallback(() => {
        onClick(dir);
    }, [onClick]);
    return (react_1.default.createElement(react_2.Stack, { styles: styles.stack, horizontal: false, verticalAlign: "center" },
        react_1.default.createElement(react_2.StackItem, null,
            react_1.default.createElement(react_2.IconButton, { "aria-label": label, title: title, styles: styles.button, onClick: handleClick, iconProps: {
                    iconName: dir == 'next' ? 'ChevronRight' : 'ChevronLeft'
                } }))));
};
exports.Arrow = Arrow;


/***/ }),

/***/ "./src/content/carousel/carousel.component.tsx":
/*!*****************************************************!*\
  !*** ./src/content/carousel/carousel.component.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Carousel = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const cards_1 = __webpack_require__(/*! ../cards */ "./src/content/cards/index.ts");
const arrow_component_1 = __webpack_require__(/*! ./arrow.component */ "./src/content/carousel/arrow.component.tsx");
const dots_component_1 = __webpack_require__(/*! ./dots.component */ "./src/content/carousel/dots.component.tsx");
const Carousel = ({ config }) => {
    const { $id, query, provides, consumes, children = [] } = config;
    const provider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'refiners');
    const fetch = smarthub_common_1.useFetch();
    const render = smarthub_common_1.useRender();
    const setRefiners = smarthub_common_1.useSetSharedState(provider);
    const [items, setItems] = react_1.useState(null);
    const [error, setError] = react_1.useState(null);
    const [filters, setFilters] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setFilters(consumes), [consumes]);
    const localize = smarthub_common_1.useLocalizeConfig();
    const [index, setIndex] = react_1.useState(0);
    react_1.useEffect(() => {
        const fetchData = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            try {
                const requiresParam = consumes === null || consumes === void 0 ? void 0 : consumes.some(({ required, name }) => required && (filters === null || filters === void 0 ? void 0 : filters[name]) == null);
                if (requiresParam)
                    return;
                const { data, refiners } = yield fetch(query, filters);
                setItems(data);
                if (refiners && provider)
                    setRefiners(refiners);
            }
            catch (ex) {
                setError(ex);
            }
        });
        fetchData();
    }, [filters, fetch]);
    const handleNav = react_1.useCallback((dir) => {
        const nextIndex = typeof dir == 'number'
            ? dir
            : dir == 'next'
                ? index == items.length - 1
                    ? 0
                    : index + 1
                : index == 0
                    ? items.length - 1
                    : index - 1;
        setIndex(nextIndex);
    }, [items, index, setIndex]);
    return react_1.useMemo(() => {
        const card = children.find(c => c.$id == 'card');
        return (items
            ? react_1.default.createElement(core_1.ComponentChrome, { config: config, hasContent: !items || (items === null || items === void 0 ? void 0 : items.length) > 0, error: error },
                (items === null || items === void 0 ? void 0 : items.length) > 1 && react_1.default.createElement(arrow_component_1.Arrow, { dir: "prev", label: localize.carousel.previousLabel, title: localize.carousel.previousTitle, onClick: handleNav }),
                (items === null || items === void 0 ? void 0 : items.length) > 0 && render(card, { data: items[index], index }, cards_1.Slide)(),
                (items === null || items === void 0 ? void 0 : items.length) > 1 && react_1.default.createElement(arrow_component_1.Arrow, { dir: "next", label: localize.carousel.nextLabel, title: localize.carousel.nextTitle, onClick: handleNav }),
                (items === null || items === void 0 ? void 0 : items.length) > 1 && react_1.default.createElement(dots_component_1.Dots, { currentIndex: index, count: items.length, onClick: handleNav }))
            : react_1.default.createElement(react_1.default.Fragment, null));
    }, [error, items, index, handleNav]);
};
exports.Carousel = Carousel;


/***/ }),

/***/ "./src/content/carousel/dot.component.tsx":
/*!************************************************!*\
  !*** ./src/content/carousel/dot.component.tsx ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Dot = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles(({ palette, spacing }) => ({
    root: ({ isActive, count }) => ({
        cursor: 'pointer',
        width: `calc(100% / ${count})`,
        maxWidth: spacing.xxLargePlus,
        height: spacing.smallPlus,
        backgroundColor: isActive
            ? palette.primary
            : palette.neutralPlus3,
        "&:hover": {
            backgroundColor: palette.primary
        }
    })
}));
const Dot = (props) => {
    const { index, label, title, onClick } = props;
    const styles = useStyles(props);
    const handleClick = react_1.useCallback(() => {
        onClick(index);
    }, [index, onClick]);
    return (react_1.default.createElement("div", { className: styles.root, onClick: handleClick, role: "button", "aria-label": label, title: title }));
};
exports.Dot = Dot;


/***/ }),

/***/ "./src/content/carousel/dots.component.tsx":
/*!*************************************************!*\
  !*** ./src/content/carousel/dots.component.tsx ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Dots = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const dot_component_1 = __webpack_require__(/*! ./dot.component */ "./src/content/carousel/dot.component.tsx");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const fluentStyles = (({ theme: { spacing } }) => ({
    stack: {
        root: {
            gap: spacing.small,
            position: 'absolute',
            top: "100%",
            zIndex: 11,
            width: '100%',
            opacity: '0.6',
            padding: spacing.small,
            transition: "opacity 300ms ease-in",
            "&:hover": {
                opacity: 1
            }
        }
    }
}));
const Dots = ({ count, currentIndex, onClick }) => {
    const localize = smarthub_common_1.useLocalizeConfig();
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    return react_1.useMemo(() => react_1.default.createElement(react_2.Stack, { styles: styles.stack, horizontal: true, horizontalAlign: 'center', verticalAlign: 'end' }, [...Array(count).keys()].map((i) => react_1.default.createElement(dot_component_1.Dot, { onClick: onClick, key: i, index: i, count: count, isActive: currentIndex == i, label: `${localize.carousel.dotLabel} ${i + 1}`, "aria-label": `${localize.carousel.dotTitle} ${i + 1}`, title: `${localize.carousel.dotTitle} ${i + 1}` }))), [styles, currentIndex, count, onClick]);
};
exports.Dots = Dots;


/***/ }),

/***/ "./src/content/carousel/index.ts":
/*!***************************************!*\
  !*** ./src/content/carousel/index.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./carousel.component */ "./src/content/carousel/carousel.component.tsx"), exports);


/***/ }),

/***/ "./src/content/category-menu/category-menu-buttons.component.tsx":
/*!***********************************************************************!*\
  !*** ./src/content/category-menu/category-menu-buttons.component.tsx ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CategoryMenuButtons = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const button_grid_1 = __webpack_require__(/*! ../button-grid */ "./src/content/button-grid/index.ts");
const CategoryMenuButtons = ({ title, categories, select, selectedId }) => {
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const [buttons, setButtons] = react_1.useState([]);
    react_1.useEffect(() => {
        const mapLinks = (links) => links.map(({ $id, title }) => ({
            uniqueId: $id,
            text: title,
            data: $id,
            title: `${localizeConfig.selectLabel} ${title}`,
            ariaLabel: `${localizeConfig.selectLabel} ${title}`,
        }));
        setButtons(mapLinks(categories));
    }, [categories, localizeConfig]);
    const onClick = react_1.useCallback((id, data) => {
        select(id);
    }, [select]);
    return react_1.useMemo(() => react_1.default.createElement(button_grid_1.ButtonGrid, { selectedId: selectedId, ariaLabel: title, onButtonClick: onClick, buttons: buttons, horizontalAlign: 'space-between' }), [onClick, selectedId, buttons]);
};
exports.CategoryMenuButtons = CategoryMenuButtons;


/***/ }),

/***/ "./src/content/category-menu/category-menu-nav.component.tsx":
/*!*******************************************************************!*\
  !*** ./src/content/category-menu/category-menu-nav.component.tsx ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CategoryMenuNav = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const navStyles = {
    root: {
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        overflowY: 'auto',
    },
};
const CategoryMenuNav = ({ title, categories, select, selectedId }) => {
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const [links, setLinks] = react_1.useState([]);
    react_1.useEffect(() => {
        const mapLinks = (links) => links.map(({ $id, title, children }) => ({
            key: `key-${$id !== null && $id !== void 0 ? $id : 'default'}`,
            categoryId: $id,
            name: title,
            url: "",
            target: "_blank",
            ariaLabel: `${localizeConfig.selectLabel} ${title}`,
            expandAriaLabel: `${localizeConfig.expandLabel} ${title}`,
            colapseAriaLabel: `${localizeConfig.collapseLabel} ${title}`,
            links: (children === null || children === void 0 ? void 0 : children.length) ? mapLinks(children)
                : null
        }));
        setLinks(mapLinks(categories));
    }, [categories, localizeConfig]);
    const onClick = react_1.useCallback((ev, { categoryId }) => {
        select(categoryId);
    }, [select]);
    return react_1.useMemo(() => react_1.default.createElement(react_2.Nav, { selectedKey: `key-${selectedId !== null && selectedId !== void 0 ? selectedId : 'default'}`, ariaLabel: title, styles: navStyles, onLinkClick: onClick, groups: [{
                links
            }] }), [selectedId, links]);
};
exports.CategoryMenuNav = CategoryMenuNav;


/***/ }),

/***/ "./src/content/category-menu/category-menu.component.tsx":
/*!***************************************************************!*\
  !*** ./src/content/category-menu/category-menu.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CategoryMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const category_menu_nav_component_1 = __webpack_require__(/*! ./category-menu-nav.component */ "./src/content/category-menu/category-menu-nav.component.tsx");
const category_menu_buttons_component_1 = __webpack_require__(/*! ./category-menu-buttons.component */ "./src/content/category-menu/category-menu-buttons.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const CategoryMenu = ({ config }) => {
    const { $id, query, provides, title, props: { options, defaultTo, type } = {}, consumes } = config;
    const provider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'category-id');
    const parentConsumer = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'parent-id');
    const [categories, setCategories] = react_1.useState([]);
    const fetch = smarthub_common_1.useFetch();
    const transform = smarthub_common_1.useTransform();
    const categoryId = smarthub_common_1.useReadSharedState(provider);
    const setCategoryId = smarthub_common_1.useSetSharedState(provider);
    const [filters, setFilters] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setFilters(consumes), [consumes]);
    react_1.useEffect(() => {
        const fetchData = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c;
            try {
                const { data } = yield fetch(query, filters);
                const navlinks = (_a = transform(models_1.ICategoryLinkSchema, data)) !== null && _a !== void 0 ? _a : [];
                const configLinks = [...options !== null && options !== void 0 ? options : []];
                if (defaultTo == 'first' && parentConsumer && configLinks.length > 0) {
                    const link = configLinks[0];
                    configLinks.splice(0, 1, Object.assign(Object.assign({}, link), { $id: ((_b = link.$id) === null || _b === void 0 ? void 0 : _b.length) ? link.$id
                            : (_c = filters === null || filters === void 0 ? void 0 : filters[parentConsumer.name]) !== null && _c !== void 0 ? _c : parentConsumer.value }));
                }
                const categories = [
                    ...configLinks,
                    ...navlinks !== null && navlinks !== void 0 ? navlinks : []
                ];
                setCategories(categories);
                if (defaultTo == 'first' && categories.length)
                    setCategoryId(categories[0].$id);
            }
            catch (ex) {
                smarthub_common_1.Logger.error("Failed to fetch category data", false, { ex });
            }
        });
        fetchData();
    }, [query, filters, fetch, parentConsumer]);
    const select = react_1.useCallback((id) => {
        setCategoryId(id);
    }, [setCategoryId]);
    return react_1.useMemo(() => react_1.default.createElement(core_1.ComponentChrome, { config: config, hasContent: !categories || categories.length > 0 }, type == 'buttons'
        ? react_1.default.createElement(category_menu_buttons_component_1.CategoryMenuButtons, { title: title, categories: categories, select: select, selectedId: categoryId })
        : react_1.default.createElement(category_menu_nav_component_1.CategoryMenuNav, { title: title, categories: categories, select: select, selectedId: categoryId })), [categoryId, categories, type]);
};
exports.CategoryMenu = CategoryMenu;


/***/ }),

/***/ "./src/content/category-menu/index.ts":
/*!********************************************!*\
  !*** ./src/content/category-menu/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./category-menu.component */ "./src/content/category-menu/category-menu.component.tsx"), exports);


/***/ }),

/***/ "./src/content/component-flow/component-flow.component.tsx":
/*!*****************************************************************!*\
  !*** ./src/content/component-flow/component-flow.component.tsx ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ComponentFlow = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const adaptive_card_1 = __webpack_require__(/*! ../adaptive-card */ "./src/content/adaptive-card/index.ts");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
//TODO for demo purposes only - refactor needed
const ComponentFlow = ({ config, config: { provides, props } }) => {
    var _a;
    const setComplete = smarthub_common_1.useSetSharedState(provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'complete'));
    const [card, setCard] = react_1.useState(((_a = props === null || props === void 0 ? void 0 : props.cards) === null || _a === void 0 ? void 0 : _a.length) ? props.cards[0].card : null);
    const onFailure = (data) => {
        _onSubmit({
            flowNext: data.action.flowError
        });
    };
    const onSuccess = (data) => {
        _onSubmit({
            flowNext: data.action.flowSuccess
        });
    };
    const onSubmit = (data) => {
        _onSubmit(data.action);
    };
    const _onSubmit = react_1.useCallback(({ flowNext }) => {
        if (flowNext) {
            const nextCard = props.cards.find(c => c.id == flowNext);
            if (nextCard) {
                setCard(nextCard.card);
                if (nextCard.end)
                    setComplete((new Date).getTime());
            }
        }
    }, [props]);
    return react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { config: config, hasContent: card }, card && react_1.default.createElement(adaptive_card_1.AdaptiveCardEmbed, { card: card, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure }))), [card]);
};
exports.ComponentFlow = ComponentFlow;


/***/ }),

/***/ "./src/content/component-flow/index.ts":
/*!*********************************************!*\
  !*** ./src/content/component-flow/index.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./component-flow.component */ "./src/content/component-flow/component-flow.component.tsx"), exports);


/***/ }),

/***/ "./src/content/data-table/data-table.component.tsx":
/*!*********************************************************!*\
  !*** ./src/content/data-table/data-table.component.tsx ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DataTable = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const react_visibility_sensor_1 = tslib_1.__importDefault(__webpack_require__(/*! react-visibility-sensor */ "react-visibility-sensor"));
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const set_groups_helper_1 = __webpack_require__(/*! ./set-groups.helper */ "./src/content/data-table/set-groups.helper.ts");
const render_group_header_helper_1 = __webpack_require__(/*! ./render-group-header.helper */ "./src/content/data-table/render-group-header.helper.tsx");
const render_item_column_helper_1 = __webpack_require__(/*! ./render-item-column.helper */ "./src/content/data-table/render-item-column.helper.ts");
const extend_columns_helper_1 = __webpack_require__(/*! ./extend-columns.helper */ "./src/content/data-table/extend-columns.helper.tsx");
const data_table_styles_1 = __webpack_require__(/*! ./data-table.styles */ "./src/content/data-table/data-table.styles.ts");
const DataTable = ({ config }) => {
    const { $id, query, coachmarks, provides, consumes, props: { columnDefinitions = [], estimate = 20, grouped = false, isCollapsed = true } = {}, title } = config;
    const { loadMoreStackItemStyles, loadMoreStyles, iconStyles, toggleButtonStyles } = smarthub_common_1.useFluentStylesWithProps(data_table_styles_1.fluentStyles);
    const refinersProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'refiners');
    const sortOptionsProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'sort-options');
    const fetch = smarthub_common_1.useFetch();
    const setRefiners = smarthub_common_1.useSetSharedState(refinersProvider);
    const setSortOptions = smarthub_common_1.useSetSharedState(sortOptionsProvider);
    const [data, setData] = react_1.useState({
        rows: null,
        loading: true
    });
    const [error, setError] = react_1.useState(null);
    const [filters, setFilters] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setFilters(consumes), [consumes]);
    const transform = smarthub_common_1.useTransform();
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const fetchData = (filters, rows, contineParam) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const requiresParam = consumes === null || consumes === void 0 ? void 0 : consumes.some(({ required, name }) => required && (filters === null || filters === void 0 ? void 0 : filters[name]) == null);
            if (requiresParam)
                return;
            const { data, continuation, refiners, sortOptions } = yield fetch(query, filters, contineParam);
            let newRows = transform(models_1.IDataTableRowSchema, data, config.props);
            newRows = Array.isArray(newRows) ? newRows : [newRows];
            setData({
                rows: [...(rows !== null && rows !== void 0 ? rows : []), ...newRows],
                loading: false,
                continuation
            });
            if (sortOptionsProvider)
                setSortOptions(sortOptions);
            if (refinersProvider)
                setRefiners(refiners);
        }
        catch (ex) {
            smarthub_common_1.Logger.error(`query and fetch failed for component ${$id} error: ${ex.description}`);
            setError(ex);
        }
    });
    react_1.useEffect(() => {
        fetchData(filters);
    }, [filters, query, fetch]);
    const loadMore = () => {
        setData(Object.assign(Object.assign({}, data), { loading: true }));
        fetchData(filters, data.rows, data.continuation);
    };
    const onVisibilityChange = (isVisible) => {
        if (isVisible && !data.loading)
            loadMore();
    };
    return react_1.useMemo(() => {
        var _a;
        const groups = grouped && (data === null || data === void 0 ? void 0 : data.rows)
            ? set_groups_helper_1.setGroups(data === null || data === void 0 ? void 0 : data.rows, isCollapsed, { toggleButtonStyles })
            : undefined;
        const items = (data === null || data === void 0 ? void 0 : data.rows) ? grouped
            ? [].concat(...data.rows.map(group => group.rows)).filter(item => item != null)
            : data.rows
            : [];
        const columns = extend_columns_helper_1.extendColumns(columnDefinitions, localizeConfig, grouped, coachmarks, { iconStyles });
        return react_1.default.createElement(core_1.ComponentChrome, { hasContent: !(data === null || data === void 0 ? void 0 : data.rows) || ((_a = data === null || data === void 0 ? void 0 : data.rows) === null || _a === void 0 ? void 0 : _a.length) > 0, config: config, error: error },
            react_1.default.createElement(react_2.Stack, null,
                react_1.default.createElement(react_2.ShimmeredDetailsList, { setKey: "items", items: items, groups: groups, layoutMode: react_2.DetailsListLayoutMode.justified, columns: columns, selectionMode: react_2.SelectionMode.none, onRenderItemColumn: render_item_column_helper_1.onRenderItemColumn, shimmerLines: estimate, enableShimmer: !(data === null || data === void 0 ? void 0 : data.rows), ariaLabelForShimmer: localizeConfig.fetchingItems, ariaLabelForGrid: `${title} ${localizeConfig.suffixItems}`, listProps: {
                        renderedWindowsAhead: 0,
                        renderedWindowsBehind: 0,
                    }, groupProps: {
                        showEmptyGroups: true,
                        isAllGroupsCollapsed: isCollapsed,
                        onRenderHeader: render_group_header_helper_1.renderGroupHeader
                    } }),
                (data === null || data === void 0 ? void 0 : data.continuation) && react_1.default.createElement(react_2.StackItem, { styles: loadMoreStackItemStyles },
                    react_1.default.createElement(react_visibility_sensor_1.default, { onChange: onVisibilityChange },
                        react_1.default.createElement(react_2.PrimaryButton, { disabled: data.loading, styles: loadMoreStyles, text: localizeConfig.loadMore, ariaLabel: localizeConfig.loadMore, title: localizeConfig.loadMore, ariaDescription: localizeConfig.loadMoreDesc, onClick: loadMore })))));
    }, [data, error, config]);
};
exports.DataTable = DataTable;


/***/ }),

/***/ "./src/content/data-table/data-table.styles.ts":
/*!*****************************************************!*\
  !*** ./src/content/data-table/data-table.styles.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fluentStyles = void 0;
exports.fluentStyles = (({ theme: { spacing, palette, fonts, sizes } }) => ({
    loadMoreStackItemStyles: {
        root: {
            display: "flex",
            justifyContent: "center",
            flexDirection: "row",
            height: "auto",
            width: "100%",
            marginTop: spacing.xxLarge,
            padding: spacing.xxLarge,
        }
    },
    loadMoreStyles: {
        root: {
            width: "25%",
        }
    },
    toggleButtonStyles: {
        root: {
            width: sizes.normalPlus,
            height: `calc(${sizes.medium} + ${spacing.xSmall})`
        },
        icon: Object.assign({}, fonts.small)
    },
    iconStyles: (colour) => ({
        root: {
            color: colour ? palette[colour] : undefined,
            verticalAlign: "bottom",
        }
    }),
}));


/***/ }),

/***/ "./src/content/data-table/extend-columns.helper.tsx":
/*!**********************************************************!*\
  !*** ./src/content/data-table/extend-columns.helper.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.extendColumns = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const advancedFormat_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/advancedFormat */ "dayjs/plugin/advancedFormat"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_file_type_icons_1 = __webpack_require__(/*! @fluentui/react-file-type-icons */ "@fluentui/react-file-type-icons");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
dayjs_1.default.extend(advancedFormat_1.default);
const extendColumns = (columnDefinitions, localizeConfig, grouped, coachmarks, styles) => columnDefinitions.map(column => {
    const { data: { type } = { type: '' } } = column;
    return Object.assign(Object.assign({}, column), (type == "date"
        ? {
            onRender: (item) => {
                return react_1.default.createElement("span", null, dayjs_1.default(item[column.key]).format(localizeConfig.commonDateFormat));
            }
        }
        : type == "link"
            ? {
                onRender: (item) => {
                    var _a;
                    const { isGroup } = item;
                    const { text, action } = (_a = item[column.key]) !== null && _a !== void 0 ? _a : {};
                    const font = isGroup && grouped
                        ? smarthub_common_1.SizeKeys.mediumPlus
                        : smarthub_common_1.SizeKeys.normal;
                    return react_1.default.createElement(utilities_1.ActionLink, { action: action, "aria-label": text, title: text },
                        react_1.default.createElement(utilities_1.TextOverflow, { showTooltip: true, lines: 1, text: text, fixed: true, font: font, colour: smarthub_common_1.PaletteKeys.primary }));
                }
            }
            : type == "file-icon"
                ? {
                    onRender: (item) => {
                        return react_1.default.createElement(react_2.Icon, Object.assign({}, react_file_type_icons_1.getFileTypeIconProps({ extension: item[column.key], size: 16 })));
                    }
                }
                : type == "bookmark"
                    ? {
                        onRender: (item, index) => {
                            var _a, _b;
                            const bookmarkCoachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(coachmark => coachmark.target === 'bookmark-button');
                            return (react_1.default.createElement("div", { style: { marginTop: "-8px" } }, bookmarkCoachmark && index === 0
                                ? react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, bookmarkCoachmark),
                                    react_1.default.createElement(utilities_1.Bookmark, { title: (_a = item === null || item === void 0 ? void 0 : item.title) === null || _a === void 0 ? void 0 : _a.text, bookmarkInfo: item === null || item === void 0 ? void 0 : item.bookmark }))
                                : react_1.default.createElement(utilities_1.Bookmark, { title: (_b = item === null || item === void 0 ? void 0 : item.title) === null || _b === void 0 ? void 0 : _b.text, bookmarkInfo: item === null || item === void 0 ? void 0 : item.bookmark })));
                        }
                    }
                    : type == "tag"
                        ? {
                            onRender: (item) => {
                                var _a;
                                const tags = (_a = item[column.key]) !== null && _a !== void 0 ? _a : [];
                                return (react_1.default.createElement("div", null, tags === null || tags === void 0 ? void 0 : tags.map((tag, index) => react_1.default.createElement(utilities_1.Tag, { key: index, tagInfo: tag }))));
                            }
                        }
                        : type == "icon"
                            ? {
                                onRender: (item) => {
                                    var _a;
                                    const { icon, text } = (_a = item[column.key]) !== null && _a !== void 0 ? _a : {};
                                    return (react_1.default.createElement("div", null,
                                        react_1.default.createElement(react_2.Icon, { iconName: icon === null || icon === void 0 ? void 0 : icon.name, styles: styles.iconStyles(icon === null || icon === void 0 ? void 0 : icon.colour) }),
                                        react_1.default.createElement("span", null,
                                            " ",
                                            text)));
                                }
                            }
                            : {}));
});
exports.extendColumns = extendColumns;


/***/ }),

/***/ "./src/content/data-table/index.ts":
/*!*****************************************!*\
  !*** ./src/content/data-table/index.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./data-table.component */ "./src/content/data-table/data-table.component.tsx"), exports);


/***/ }),

/***/ "./src/content/data-table/render-group-header.helper.tsx":
/*!***************************************************************!*\
  !*** ./src/content/data-table/render-group-header.helper.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.renderGroupHeader = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const renderGroupHeader = (props) => {
    if (props) {
        const { group, onToggleCollapse } = props;
        const _a = group.data, { styles: { toggleButtonStyles } } = _a, item = tslib_1.__rest(_a, ["styles"]), { isCollapsed, count } = group;
        const onRenderCheck = () => {
            return count
                ? react_1.default.createElement(react_2.IconButton, { styles: toggleButtonStyles, onClick: () => onToggleCollapse(group), iconProps: {
                        iconName: isCollapsed
                            ? 'ChevronRight'
                            : 'ChevronDown'
                    } })
                : react_1.default.createElement(react_2.GroupSpacer, { count: 1 });
        };
        return react_1.default.createElement(react_2.DetailsRow, Object.assign({}, props, { item: item, itemIndex: -1, indentWidth: 0, groupNestingDepth: 0, selectionMode: react_2.SelectionMode.single, onRenderCheck: onRenderCheck }));
    }
    return null;
};
exports.renderGroupHeader = renderGroupHeader;


/***/ }),

/***/ "./src/content/data-table/render-item-column.helper.ts":
/*!*************************************************************!*\
  !*** ./src/content/data-table/render-item-column.helper.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.onRenderItemColumn = void 0;
const onRenderItemColumn = (item, index, column) => {
    return item[column.key];
};
exports.onRenderItemColumn = onRenderItemColumn;


/***/ }),

/***/ "./src/content/data-table/set-groups.helper.ts":
/*!*****************************************************!*\
  !*** ./src/content/data-table/set-groups.helper.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setGroups = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
// logic to set the startIndex of each group
const setGroups = (rows, isCollapsed, styles) => {
    return rows.map((_a, i) => {
        var { count, name, key, level } = _a, rest = tslib_1.__rest(_a, ["count", "name", "key", "level"]);
        return (Object.assign(Object.assign({}, rest), { isCollapsed,
            key,
            name,
            count,
            level, data: Object.assign(Object.assign({ styles }, rest), { index: i, isGroup: true }), startIndex: i != 0
                ? rows
                    .slice(0, i)
                    .map(item => item === null || item === void 0 ? void 0 : item.count)
                    .reduce((prev, next) => prev + next)
                : 0 }));
    });
};
exports.setGroups = setGroups;


/***/ }),

/***/ "./src/content/form-builder/field-elements/checkbox/index.tsx":
/*!********************************************************************!*\
  !*** ./src/content/form-builder/field-elements/checkbox/index.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
// @ts-nocheck
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const lodash_1 = tslib_1.__importDefault(__webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js"));
const react_2 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_hook_form_1 = __webpack_require__(/*! react-hook-form */ "./node_modules/react-hook-form/dist/index.cjs.js");
const Checkbox = ({ config, disabled, control, value, onChange, }) => {
    const { id, label, description, values, defaultValue, validation, placeholder, } = config;
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement("div", { className: "flex flex-1 flex-col w-full" },
            label && (react_2.default.createElement("label", { htmlFor: id, className: "block text-sm uppercase font-medium text-black/40" },
                react_2.default.createElement("span", { dangerouslySetInnerHTML: { __html: label } }),
                react_2.default.createElement("span", { className: "text-red" }, (validation === null || validation === void 0 ? void 0 : validation.required) && "*"))),
            react_2.default.createElement("div", { className: "mt-1" }, control ? (react_2.default.createElement(react_hook_form_1.Controller, { name: id, control: control, defaultValue: defaultValue, rules: validation, render: ({ field: { onChange, onBlur, value, name, ref }, fieldState: { invalid, isTouched, isDirty, error }, formState, }) => (react_2.default.createElement(react_2.default.Fragment, null,
                    react_2.default.createElement(react_1.Checkbox, { style: { border: "none", padding: "0px", width: "100%" }, id: id, disabled: disabled, onChange: (_ev, data) => {
                            onChange(data);
                        }, placeholder: placeholder, defaultSelectedKey: value === undefined ? [] || 0 : value, options: values }),
                    error && react_2.default.createElement("span", { className: "text-red" }, error.message))) })) : (react_2.default.createElement(react_1.Checkbox, { style: { border: "none", padding: "0px", width: "100%" }, id: id, disabled: disabled, onChange: (e) => {
                    console.log(e);
                    onChange(e);
                }, placeholder: placeholder, defaultSelectedKey: value === undefined ? [] || 0 : value, options: values }))),
            description && (react_2.default.createElement("div", { className: "text-11 mt-1 text-black/60" }, description)))));
};
function valUpdated(prevProps, nextProps) {
    return lodash_1.default.isEqual(prevProps, nextProps);
}
exports["default"] = react_2.default.memo(Checkbox, valUpdated);


/***/ }),

/***/ "./src/content/form-builder/field-elements/choice/index.tsx":
/*!******************************************************************!*\
  !*** ./src/content/form-builder/field-elements/choice/index.tsx ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
// @ts-nocheck
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const lodash_1 = tslib_1.__importDefault(__webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js"));
const react_2 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_hook_form_1 = __webpack_require__(/*! react-hook-form */ "./node_modules/react-hook-form/dist/index.cjs.js");
const Choice = ({ config, disabled, control, value, onChange, }) => {
    const { id, label, description, values, defaultValue, validation, placeholder, } = config;
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement("div", { className: "flex flex-1 flex-col w-full" },
            label && (react_2.default.createElement("label", { htmlFor: id, className: "block text-sm uppercase font-medium text-black/40" },
                react_2.default.createElement("span", { dangerouslySetInnerHTML: { __html: label } }),
                react_2.default.createElement("span", { className: "text-red" }, (validation === null || validation === void 0 ? void 0 : validation.required) && "*"))),
            react_2.default.createElement("div", { className: "mt-1" }, control ? (react_2.default.createElement(react_hook_form_1.Controller, { name: id, control: control, defaultValue: defaultValue, rules: validation, render: ({ field: { onChange, onBlur, value, name, ref }, fieldState: { invalid, isTouched, isDirty, error }, formState, }) => (react_2.default.createElement(react_2.default.Fragment, null,
                    react_2.default.createElement(react_1.ComboBox, { style: { border: "none", padding: "0px", width: "100%" }, id: id, disabled: disabled, onChange: (e) => {
                            onChange(e.target.textContent);
                        }, placeholder: placeholder, defaultSelectedKey: value === undefined ? [] || 0 : value, options: values }),
                    error && react_2.default.createElement("span", { className: "text-red" }, error.message))) })) : (react_2.default.createElement(react_1.ComboBox, { style: { border: "none", padding: "0px", width: "100%" }, id: id, disabled: disabled, onChange: (e) => {
                    console.log(e);
                    onChange(e);
                }, placeholder: placeholder, defaultSelectedKey: value === undefined ? [] || 0 : value, options: values }))),
            description && (react_2.default.createElement("div", { className: "text-11 mt-1 text-black/60" }, description)))));
};
function valUpdated(prevProps, nextProps) {
    return lodash_1.default.isEqual(prevProps, nextProps);
}
exports["default"] = react_2.default.memo(Choice, valUpdated);


/***/ }),

/***/ "./src/content/form-builder/field-elements/index.ts":
/*!**********************************************************!*\
  !*** ./src/content/form-builder/field-elements/index.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TextArea = exports.Text = exports.Number = exports.Choice = exports.Checkbox = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const choice_1 = tslib_1.__importDefault(__webpack_require__(/*! ./choice */ "./src/content/form-builder/field-elements/choice/index.tsx"));
exports.Choice = choice_1.default;
const number_1 = tslib_1.__importDefault(__webpack_require__(/*! ./number */ "./src/content/form-builder/field-elements/number/index.tsx"));
exports.Number = number_1.default;
const text_1 = tslib_1.__importDefault(__webpack_require__(/*! ./text */ "./src/content/form-builder/field-elements/text/index.tsx"));
exports.Text = text_1.default;
const textarea_1 = tslib_1.__importDefault(__webpack_require__(/*! ./textarea */ "./src/content/form-builder/field-elements/textarea/index.tsx"));
exports.TextArea = textarea_1.default;
const checkbox_1 = tslib_1.__importDefault(__webpack_require__(/*! ./checkbox */ "./src/content/form-builder/field-elements/checkbox/index.tsx"));
exports.Checkbox = checkbox_1.default;


/***/ }),

/***/ "./src/content/form-builder/field-elements/number/index.tsx":
/*!******************************************************************!*\
  !*** ./src/content/form-builder/field-elements/number/index.tsx ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
// @ts-nocheck
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const lodash_1 = tslib_1.__importDefault(__webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js"));
const react_2 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_hook_form_1 = __webpack_require__(/*! react-hook-form */ "./node_modules/react-hook-form/dist/index.cjs.js");
const Number = ({ config, disabled: formDisabled, control, value, onChange, }) => {
    const { id, label, description, min = 0, disabled, defaultValue, placeholder, validation, } = config;
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement("div", { className: "flex flex-1 flex-col" },
            label && (react_2.default.createElement("label", { htmlFor: id, className: "block text-sm uppercase font-medium text-black/40" },
                label,
                react_2.default.createElement("span", { className: "text-red" }, (validation === null || validation === void 0 ? void 0 : validation.required) && "*"))),
            react_2.default.createElement("div", { className: "mt-1" }, control ? (react_2.default.createElement(react_hook_form_1.Controller, { name: id, control: control, defaultValue: defaultValue, rules: validation, render: ({ field: { onChange, onBlur, value, name, ref }, fieldState: { invalid, isTouched, isDirty, error }, formState, }) => {
                    return (react_2.default.createElement(react_2.default.Fragment, null,
                        react_2.default.createElement(react_1.SpinButton, { value: value, onChange: (_ev, data) => {
                                onChange(data);
                            }, ref: ref, placeholder: placeholder, id: id, disabled: disabled || formDisabled, style: {
                                marginBottom: description && "0px",
                                width: "100%",
                            } }),
                        error && react_2.default.createElement("span", { className: "text-red" }, error.message)));
                } })) : (react_2.default.createElement(react_1.SpinButton, { value: value, onChange: (e) => {
                    if (onChange)
                        onChange(e);
                }, min: min, placeholder: placeholder, id: id, disabled: disabled || formDisabled, style: {
                    marginBottom: description && "0px",
                    width: "100%",
                } }))),
            description && (react_2.default.createElement("div", { className: "text-11 mt-1 text-black/60" }, description)))));
};
function valUpdated(prevProps, nextProps) {
    return lodash_1.default.isEqual(prevProps, nextProps);
}
exports["default"] = react_2.default.memo(Number, valUpdated);


/***/ }),

/***/ "./src/content/form-builder/field-elements/text/index.tsx":
/*!****************************************************************!*\
  !*** ./src/content/form-builder/field-elements/text/index.tsx ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
// @ts-nocheck
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const lodash_1 = tslib_1.__importDefault(__webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js"));
const react_2 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_hook_form_1 = __webpack_require__(/*! react-hook-form */ "./node_modules/react-hook-form/dist/index.cjs.js");
const Text = ({ config, disabled: formDisabled, control, value, onChange, }) => {
    const { id, label, description, readOnly, validation, disabled, type, defaultValue, placeholder, } = config;
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement("div", { className: "flex flex-1 flex-col" },
            label && (react_2.default.createElement("label", { htmlFor: id, className: "block text-sm uppercase font-medium text-black/40" },
                label,
                react_2.default.createElement("span", { className: "text-red" }, (validation === null || validation === void 0 ? void 0 : validation.required) && "*"))),
            react_2.default.createElement("div", { className: "mt-1" }, control ? (react_2.default.createElement(react_hook_form_1.Controller, { name: id, control: control, defaultValue: defaultValue, rules: validation, render: ({ field: { onChange, onBlur, value, name, ref }, fieldState: { error }, }) => {
                    return (react_2.default.createElement(react_2.default.Fragment, null,
                        react_2.default.createElement(react_1.TextField, { value: value, name: name, ref: ref, autoFocus: false, onChange: onChange, onBlur: onBlur, placeholder: placeholder, id: id, disabled: disabled || formDisabled, type: type, className: "disabled:!text-black", readOnly: readOnly, style: { marginBottom: description && "0px" } }),
                        error && react_2.default.createElement("span", { className: "text-red" }, error.message)));
                } })) : (react_2.default.createElement(react_2.default.Fragment, null,
                react_2.default.createElement(react_1.TextField, { value: value, autoFocus: false, onChange: onChange, placeholder: placeholder, id: id, disabled: disabled || formDisabled, type: type, className: "disabled:!text-black", readOnly: readOnly, style: { marginBottom: description && "0px" } })))),
            description && (react_2.default.createElement("div", { className: "text-11 mt-1 text-black/60" }, description)))));
};
function valUpdated(prevProps, nextProps) {
    return lodash_1.default.isEqual(prevProps, nextProps);
}
exports["default"] = react_2.default.memo(Text, valUpdated);


/***/ }),

/***/ "./src/content/form-builder/field-elements/textarea/index.tsx":
/*!********************************************************************!*\
  !*** ./src/content/form-builder/field-elements/textarea/index.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
// @ts-nocheck
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const lodash_1 = tslib_1.__importDefault(__webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js"));
const react_2 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_hook_form_1 = __webpack_require__(/*! react-hook-form */ "./node_modules/react-hook-form/dist/index.cjs.js");
const TextArea = ({ config, disabled: formDisabled, control, value, onChange, }) => {
    const { id, label, description, readOnly, disabled, rows = 6, defaultValue, validation, placeholder, } = config;
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement("div", { className: "flex flex-1 flex-col" },
            label && (react_2.default.createElement("label", { htmlFor: id, className: "block text-sm uppercase font-medium text-black/40" },
                label,
                react_2.default.createElement("span", { className: "text-red" }, (validation === null || validation === void 0 ? void 0 : validation.required) && "*"))),
            react_2.default.createElement("div", { className: "mt-1" }, control ? (react_2.default.createElement(react_hook_form_1.Controller, { name: id, control: control, defaultValue: defaultValue, rules: validation, render: ({ field: { onChange, onBlur, value, name, ref }, fieldState: { error }, }) => {
                    return (react_2.default.createElement(react_2.default.Fragment, null,
                        react_2.default.createElement(react_1.TextField, { value: value || defaultValue, name: name, autoFocus: false, onChange: onChange, onBlur: onBlur, placeholder: placeholder, id: id, disabled: disabled || formDisabled, multiline: true, rows: rows, className: "disabled:!text-black", readOnly: readOnly, style: { marginBottom: description && "0px" } }),
                        error && react_2.default.createElement("span", { className: "text-red" }, error.message)));
                } })) : (react_2.default.createElement(react_2.default.Fragment, null,
                react_2.default.createElement(react_1.TextField, { value: value, autoFocus: false, onChange: onChange, placeholder: placeholder, id: id, disabled: disabled || formDisabled, multiline: true, rows: rows, className: "disabled:!text-black", readOnly: readOnly, style: { marginBottom: description && "0px" } })))),
            description && (react_2.default.createElement("div", { className: "text-11 mt-1 text-black/60" }, description)))));
};
function valUpdated(prevProps, nextProps) {
    return lodash_1.default.isEqual(prevProps, nextProps);
}
exports["default"] = react_2.default.memo(TextArea, valUpdated);


/***/ }),

/***/ "./src/content/form-builder/field-renderer/index.tsx":
/*!***********************************************************!*\
  !*** ./src/content/form-builder/field-renderer/index.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const React = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const field_elements_1 = __webpack_require__(/*! ../field-elements */ "./src/content/form-builder/field-elements/index.ts");
const FieldRenderer = ({ control, disabled, config }) => {
    const { type } = config;
    switch (type) {
        case "checkbox":
            return React.createElement(field_elements_1.Checkbox, { disabled: disabled, control: control, config: config });
        case "choice":
            return React.createElement(field_elements_1.Choice, { disabled: disabled, control: control, config: config });
        case "number":
            return React.createElement(field_elements_1.Number, { disabled: disabled, control: control, config: config });
        case "text":
            return React.createElement(field_elements_1.Text, { disabled: disabled, control: control, config: config });
        case "textarea":
            return React.createElement(field_elements_1.TextArea, { disabled: disabled, control: control, config: config });
    }
    return null;
};
exports["default"] = FieldRenderer;


/***/ }),

/***/ "./src/content/form-builder/form-builder.component.tsx":
/*!*************************************************************!*\
  !*** ./src/content/form-builder/form-builder.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FormBuilder = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_hook_form_1 = __webpack_require__(/*! react-hook-form */ "./node_modules/react-hook-form/dist/index.cjs.js");
const yup_1 = __webpack_require__(/*! @hookform/resolvers/yup */ "./node_modules/@hookform/resolvers/yup/dist/yup.js");
const field_renderer_1 = tslib_1.__importDefault(__webpack_require__(/*! ./field-renderer */ "./src/content/form-builder/field-renderer/index.tsx"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles((theme) => {
    const { palette, fonts } = theme;
    return {
        primaryButton: Object.assign(Object.assign({}, fonts.normal), { backgroundColor: palette.themePrimary, width: "100%" }),
        sectionName: {},
        sectionDescription: {},
    };
});
exports.FormBuilder = react_1.default.forwardRef(({ data, definition, autoSave, buttonText = "Save", buttonStyle, insertMode = true, validationSchema, action, onSubmitted, }, ref) => {
    const styles = useStyles();
    const { control, reset, watch, handleSubmit, formState: { isDirty, isValid }, } = react_hook_form_1.useForm({
        defaultValues: data,
        shouldFocusError: false,
        mode: insertMode ? "onChange" : "onTouched",
        resolver: validationSchema ? yup_1.yupResolver(validationSchema) : null,
    });
    const [initialDirty, setInitialDirty] = react_1.default.useState(false);
    const watchedData = watch();
    react_1.default.useEffect(() => {
        reset(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);
    react_1.default.useEffect(() => {
        if (!initialDirty) {
            setInitialDirty(isDirty);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDirty]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    {
        /* TEMP LETS DISABLE AUTOSAVE
      const debouncedSave = React.useCallback(
        debounce(() => {
          if (insertMode || !initialDirty) return;
          handleSubmit(onSubmit)();
        }, 500),
        [initialDirty]
      );
  
      React.useEffect(() => {
        if (autoSave) debouncedSave();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [watchedData]);
       */
    }
    react_1.default.useImperativeHandle(ref, () => {
        return {
            submit: () => {
                handleSubmit(onSubmit)();
            },
            reset: () => {
                reset();
            },
        };
    });
    const onSubmit = (submit_data) => {
        if (action) {
            // post the response to the action url
            fetch(action.url, {
                method: action.method,
                body: JSON.stringify(submit_data),
                headers: Object.assign(Object.assign({}, action.headers), { "Content-Type": "application/json" }),
            }).then((response) => {
                onSubmitted(submit_data);
            });
        }
        if (insertMode) {
            // delay 1 second to allow the form to reset
            setTimeout(() => {
                reset();
            }, 1000);
        }
    };
    return react_1.default.useMemo(() => {
        var _a, _b;
        return (react_1.default.createElement("div", { style: {
                display: "flex",
                flexDirection: "column",
                gap: "20px",
            } },
            react_1.default.createElement("form", { onSubmit: handleSubmit(onSubmit), style: {
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                } },
                ((_b = (_a = definition[0]) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.length) > 0 ? (react_1.default.createElement(react_1.default.Fragment, null, definition.map((c, cIndex) => {
                    let orientation = (c === null || c === void 0 ? void 0 : c.orientation) || "vertical";
                    // is last section
                    let isLastSection = cIndex === definition.length - 1;
                    return (react_1.default.createElement("div", { key: cIndex, className: `                       
                      ${orientation === "horizontal"
                            ? `flex-row bg-white ${!isLastSection && "border-b border-bordergrey1"} py-4`
                            : "flex-col bg-grey border border-bordergrey1 mb-4"} flex ` },
                        react_1.default.createElement("div", { className: `p-5 ${orientation === "horizontal" ? "w-72" : "pb-0"} ` },
                            react_1.default.createElement("h3", { className: styles.sectionName }, c.name),
                            react_1.default.createElement("p", { className: styles.sectionDescription }, c.description)),
                        react_1.default.createElement("div", { className: `w-full p-5 ${orientation === "horizontal" ? "" : "pt-0"}` },
                            react_1.default.createElement("div", { className: `${orientation === "horizontal"
                                    ? "gap-4 flex flex-col"
                                    : " px-4 py-5  shadow sm:rounded-md sm:overflow-hidden h-full bg-white space-y-6 sm:p-6 "}` }, c.fields.map((f, fIndex) => {
                                if (Array.isArray(f)) {
                                    return (react_1.default.createElement("div", { className: `grid w-full`, style: {
                                            gridTemplateColumns: `repeat(${f.length}, minmax(0, 1fr))`,
                                            gridGap: "16px",
                                        } }, f.map((sf, sfIndex) => {
                                        let showField = true;
                                        if (sf.visibleIf) {
                                            showField =
                                                Object.keys(sf.visibleIf)[0]
                                                    .split(".")
                                                    .reduce((o, i) => {
                                                    if (!o)
                                                        return true;
                                                    return o[i];
                                                }, watchedData) ===
                                                    Object.values(sf.visibleIf)[0];
                                        }
                                        let disableField = false;
                                        if (sf.disabledIf) {
                                            let disVal = Object.keys(sf.disabledIf)[0]
                                                .split(".")
                                                .reduce((o, i) => {
                                                if (!o)
                                                    return true;
                                                return o[i];
                                            }, watchedData);
                                            if (disVal === undefined) {
                                                disableField = true;
                                            }
                                            disableField =
                                                disVal ===
                                                    Object.values(sf.disabledIf)[0];
                                        }
                                        if (showField) {
                                            return (react_1.default.createElement("div", { key: sfIndex },
                                                react_1.default.createElement(field_renderer_1.default, { disabled: disableField, control: control, config: sf })));
                                        }
                                        return null;
                                    })));
                                }
                                else {
                                    let showField = true;
                                    if (f.visibleIf) {
                                        showField =
                                            Object.keys(f.visibleIf)[0]
                                                .split(".")
                                                .reduce((o, i) => {
                                                if (!o)
                                                    return true;
                                                return o[i];
                                            }, watchedData) ===
                                                Object.values(f.visibleIf)[0];
                                    }
                                    let disableField = false;
                                    if (f.disabledIf) {
                                        let disVal = Object.keys(f.disabledIf)[0]
                                            .split(".")
                                            .reduce((o, i) => {
                                            if (!o)
                                                return true;
                                            return o[i];
                                        }, watchedData);
                                        if (disVal === undefined) {
                                            disableField = true;
                                        }
                                        disableField =
                                            disVal === Object.values(f.disabledIf)[0];
                                    }
                                    if (showField) {
                                        return (react_1.default.createElement(field_renderer_1.default, { disabled: disableField, control: control, config: f }));
                                    }
                                }
                                return null;
                            })))));
                }))) : (react_1.default.createElement(react_1.default.Fragment, null, definition.map((f, fIndex) => {
                    if (Array.isArray(f)) {
                        return (react_1.default.createElement("div", { className: `mb-5 grid w-full`, style: {
                                gridTemplateColumns: `repeat(${f.length}, minmax(0, 1fr))`,
                                gridGap: "16px",
                            } }, f.map((sf, sfIndex) => {
                            return (react_1.default.createElement("div", { key: sfIndex },
                                react_1.default.createElement(field_renderer_1.default, { control: control, config: sf })));
                        })));
                    }
                    else {
                        // Render Wrapper
                        let showField = true;
                        if (f.visibleIf) {
                            try {
                                showField =
                                    Object.keys(f.visibleIf)[0]
                                        .split(".")
                                        .reduce((o, i) => {
                                        if (!o)
                                            return true;
                                        return o[i];
                                    }, watchedData) === Object.values(f.visibleIf)[0];
                            }
                            catch (e) {
                                showField = false;
                            }
                        }
                        let disableField = false;
                        if (f.disabledIf) {
                            let disVal = Object.keys(f.disabledIf)[0]
                                .split(".")
                                .reduce((o, i) => {
                                if (!o)
                                    return true;
                                return o[i];
                            }, watchedData);
                            if (disVal === undefined) {
                                disableField = true;
                            }
                            disableField = disVal === Object.values(f.disabledIf)[0];
                        }
                        if (showField) {
                            return (react_1.default.createElement("div", { className: "mb-5" },
                                react_1.default.createElement(field_renderer_1.default, { disabled: disableField, control: control, config: f })));
                        }
                    }
                    return null;
                }))),
                !autoSave && (react_1.default.createElement("div", { className: "flex flex-col", style: {
                        gap: "10px",
                    } },
                    react_1.default.createElement(react_2.PrimaryButton, { text: buttonText, "aria-label": buttonText, title: buttonText, tabIndex: 0, className: styles.primaryButton, width: "100%", style: buttonStyle, disabled: !isValid, onClick: () => {
                            handleSubmit(onSubmit)();
                        } }),
                    react_1.default.createElement(react_2.DefaultButton, { text: "Reset", "aria-label": "Reset", title: "Reset", tabIndex: 0, width: "100%", style: buttonStyle, disabled: !isValid, onClick: () => {
                            reset();
                        } }))))));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, isValid, watchedData]);
});


/***/ }),

/***/ "./src/content/form-builder/index.ts":
/*!*******************************************!*\
  !*** ./src/content/form-builder/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./form-builder.component */ "./src/content/form-builder/form-builder.component.tsx"), exports);


/***/ }),

/***/ "./src/content/html-screen/html-screen.component.tsx":
/*!***********************************************************!*\
  !*** ./src/content/html-screen/html-screen.component.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HTMLScreen = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const dompurify_1 = tslib_1.__importDefault(__webpack_require__(/*! dompurify */ "./node_modules/dompurify/dist/purify.js"));
const HTMLScreen = ({ config: { props: { html }, }, }) => {
    return (react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: dompurify_1.default.sanitize(html) } }));
};
exports.HTMLScreen = HTMLScreen;


/***/ }),

/***/ "./src/content/html-screen/index.ts":
/*!******************************************!*\
  !*** ./src/content/html-screen/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./html-screen.component */ "./src/content/html-screen/html-screen.component.tsx"), exports);


/***/ }),

/***/ "./src/content/image/image-embed.component.tsx":
/*!*****************************************************!*\
  !*** ./src/content/image/image-embed.component.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ImageEmbed = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_2 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_hooks_1 = __webpack_require__(/*! @fluentui/react-hooks */ "@fluentui/react-hooks");
const styles = {
    image: {
        width: "100%",
        maxWidth: "100%",
    }
};
const ImageEmbed = ({ uri, width, height, description, alt, fit, orientation }) => {
    const tooltipId = react_hooks_1.useId('tooltip');
    return (react_2.default.createElement(react_1.TooltipHost, { id: tooltipId, content: (description === null || description === void 0 ? void 0 : description.length) ? description : alt },
        react_2.default.createElement(react_1.Image, { styles: styles, "aria-describedby": tooltipId, coverStyle: react_1.ImageCoverStyle[(orientation === null || orientation === void 0 ? void 0 : orientation.length) ? orientation : 'landscape'], imageFit: react_1.ImageFit[(fit === null || fit === void 0 ? void 0 : fit.length) ? fit : 'cover'], src: uri, alt: alt, width: width, height: height })));
};
exports.ImageEmbed = ImageEmbed;


/***/ }),

/***/ "./src/content/image/image.component.tsx":
/*!***********************************************!*\
  !*** ./src/content/image/image.component.tsx ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Image = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const image_embed_component_1 = __webpack_require__(/*! ./image-embed.component */ "./src/content/image/image-embed.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles({
    wrapper: {
        display: 'flex',
        height: '100%',
    }
});
const Image = ({ config, config: { consumes, props } }) => {
    var _a;
    const image = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "image"));
    const styles = useStyles();
    const uri = ((_a = image === null || image === void 0 ? void 0 : image.uri) === null || _a === void 0 ? void 0 : _a.length) ? image.uri : props === null || props === void 0 ? void 0 : props.uri;
    const message = smarthub_common_1.useLocalize(smarthub_common_1.LocalizeKeys.imageError);
    const error = !(uri === null || uri === void 0 ? void 0 : uri.length)
        ? {
            message
        }
        : undefined;
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.wrapper, error: error }, (uri === null || uri === void 0 ? void 0 : uri.length) && react_1.default.createElement(image_embed_component_1.ImageEmbed, Object.assign({ uri: uri }, props))));
};
exports.Image = Image;


/***/ }),

/***/ "./src/content/image/index.ts":
/*!************************************!*\
  !*** ./src/content/image/index.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./image-embed.component */ "./src/content/image/image-embed.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./image.component */ "./src/content/image/image.component.tsx"), exports);


/***/ }),

/***/ "./src/content/index.ts":
/*!******************************!*\
  !*** ./src/content/index.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./about */ "./src/content/about/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./adaptive-card */ "./src/content/adaptive-card/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./bookmark-list */ "./src/content/bookmark-list/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./button-grid */ "./src/content/button-grid/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./calendar */ "./src/content/calendar/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./card-list */ "./src/content/card-list/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./cards */ "./src/content/cards/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./carousel */ "./src/content/carousel/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./category-menu */ "./src/content/category-menu/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./component-flow */ "./src/content/component-flow/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./data-table */ "./src/content/data-table/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./image */ "./src/content/image/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./launch-button */ "./src/content/launch-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./list-command-bar */ "./src/content/list-command-bar/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./map */ "./src/content/map/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./ms-form */ "./src/content/ms-form/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./ms-power-app */ "./src/content/ms-power-app/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./ms-stream */ "./src/content/ms-stream/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./notification */ "./src/content/notification/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page */ "./src/content/page/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./preferences */ "./src/content/preferences/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./profile */ "./src/content/profile/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./splash-screen */ "./src/content/splash-screen/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./summarizer */ "./src/content/summarizer/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./up-next */ "./src/content/up-next/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./view */ "./src/content/view/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./timeline */ "./src/content/timeline/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./html-screen */ "./src/content/html-screen/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./form-builder */ "./src/content/form-builder/index.ts"), exports);


/***/ }),

/***/ "./src/content/launch-button/index.ts":
/*!********************************************!*\
  !*** ./src/content/launch-button/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./launch-button.component */ "./src/content/launch-button/launch-button.component.tsx"), exports);


/***/ }),

/***/ "./src/content/launch-button/launch-button.component.tsx":
/*!***************************************************************!*\
  !*** ./src/content/launch-button/launch-button.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LaunchButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_2 = __webpack_require__(/*! react */ "react");
const react_3 = __webpack_require__(/*! react */ "react");
const useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b;
    const { styles, palette } = theme;
    const launch = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.main) === null || _a === void 0 ? void 0 : _a.launch) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    return {
        right: {
            right: 0,
        },
        left: {
            left: 0,
        },
        image: Object.assign({ display: "block !important", maxWidth: "none", "&.$right": smarthub_common_1.themeStyle(launch.imageRight, props), "&.$left": smarthub_common_1.themeStyle(launch.imageLeft, props) }, smarthub_common_1.themeStyle(launch.image, props)),
        root: Object.assign({ zIndex: 1000000, position: "fixed", display: "flex", top: 0, bottom: 0, "&.$right": smarthub_common_1.themeStyle(launch.rootRight, props), "&.$left": smarthub_common_1.themeStyle(launch.rootLeft, props) }, smarthub_common_1.themeStyle(launch.root, props)),
        button: Object.assign({ padding: 0, border: "none", backgroundColor: "transparent", position: "absolute", cursor: "pointer", alignSelf: "center", "&.$right": smarthub_common_1.themeStyle(launch.buttonRight, props), "&.$left": smarthub_common_1.themeStyle(launch.buttonLeft, props), "&:focus": Object.assign({ outline: `${palette.filmPlus1} auto` }, smarthub_common_1.themeStyle(launch.buttonFocus, props)) }, smarthub_common_1.themeStyle(launch.button, props)),
    };
});
const LaunchButton = () => {
    const ref = react_2.useRef();
    const localize = smarthub_common_1.useLocalizeConfig();
    const [dockPostion] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys.chatDockPosition, false);
    const styles = useStyles();
    const [, setChromeState] = smarthub_common_1.useChromeState();
    const { chat: { dockPositions: { preferred: position }, }, } = smarthub_common_1.useViewConfig();
    const focus = react_2.useRef(false);
    const onClick = react_1.useCallback(() => {
        setChromeState("open");
        focus.current = true;
    }, [setChromeState]);
    const onKeyPress = react_1.useCallback((e) => {
        if (e.key == "Enter")
            onClick();
    }, []);
    const preferredPosition = react_1.useMemo(() => {
        if (dockPostion) {
            return dockPostion;
        }
        return position;
    }, [dockPostion, position]);
    const imageUri = smarthub_common_1.useThemeImageURI(preferredPosition == "right"
        ? smarthub_common_1.ImageKeys.launchButtonRight
        : smarthub_common_1.ImageKeys.launchButtonLeft);
    react_3.useEffect(() => {
        if (focus.current)
            ref.current.focus();
    }, []);
    return react_1.useMemo(() => (react_1.default.createElement("div", { className: [
            styles.root,
            preferredPosition == "right" ? styles.right : styles.left,
        ].join(" ") },
        react_1.default.createElement("button", { tabIndex: 0, className: [
                styles.button,
                preferredPosition == "right" ? styles.right : styles.left,
            ].join(" "), role: "button", "aria-label": localize.launchButtonLabel, title: localize.launchButtonTitle, onKeyPress: onKeyPress, onClick: onClick },
            react_1.default.createElement("img", { alt: localize.launchButtonAlt, src: imageUri, style: { maxWidth: "inherit" }, className: [
                    styles.image,
                    preferredPosition == "right" ? styles.right : styles.left,
                ].join(" ") })))), [preferredPosition]);
};
exports.LaunchButton = LaunchButton;


/***/ }),

/***/ "./src/content/list-command-bar/a-z-filter-button.component.tsx":
/*!**********************************************************************!*\
  !*** ./src/content/list-command-bar/a-z-filter-button.component.tsx ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AZFilterButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const button_styles_1 = __webpack_require__(/*! ./button.styles */ "./src/content/list-command-bar/button.styles.tsx");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (props) => {
    const { spacing, sizes } = props.theme;
    return {
        azButtonStyles: Object.assign(Object.assign({}, button_styles_1.buttonStyles(props)), { icon: {
                margin: `0 ${spacing.normal} 0 ${spacing.xSmall}`,
                fontSize: spacing.medium
            } }),
        menuStyles: {
            list: {
                maxWidth: `calc(5 * ${sizes.mediumPlus})`
            },
            subComponentStyles: {
                menuItem: {
                    root: {
                        padding: 0,
                        textAlign: "center"
                    },
                    item: {
                        width: sizes.mediumPlus,
                        display: "inline-block",
                    }
                },
                callout: {}
            }
        }
    };
};
const AZFilterButton = (props) => {
    const { menuStyles, azButtonStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    props.subMenuProps.styles = menuStyles;
    return react_1.default.createElement(react_2.CompoundButton, Object.assign({}, props, { styles: azButtonStyles }));
};
exports.AZFilterButton = AZFilterButton;


/***/ }),

/***/ "./src/content/list-command-bar/button.styles.tsx":
/*!********************************************************!*\
  !*** ./src/content/list-command-bar/button.styles.tsx ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.buttonStyles = void 0;
const buttonStyles = ({ theme: { palette, fonts, sizes, spacing } }) => ({
    splitButtonContainer: {
        margin: `${spacing.xSmall} ${spacing.smallPlus} ${spacing.xSmall} 0`
    },
    root: {
        padding: 0,
        border: 0,
        minHeight: sizes.medium,
    },
    rootHovered: {
        border: 0,
    },
    menuIcon: {
        margin: `0 ${spacing.normal}`
    },
    splitButtonMenuButton: {
        border: 0,
        borderRadius: 0,
    },
    splitButtonMenuIcon: {
        margin: `${spacing.small} ${spacing.small} 0 ${spacing.small}`,
    },
    splitButtonDivider: {
        display: "none",
    },
    textContainer: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    flexContainer: {
        padding: `0 ${spacing.smallPlus}`,
        boxSizing: "border-box",
        alignItems: "center"
    },
    label: {
        lineHeight: "normal",
        marginBottom: "0",
        fontWeight: "400"
    },
    description: {
        lineHeight: fonts.large.fontSize,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }
});
exports.buttonStyles = buttonStyles;


/***/ }),

/***/ "./src/content/list-command-bar/index.ts":
/*!***********************************************!*\
  !*** ./src/content/list-command-bar/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ListCommandBar = void 0;
var list_command_bar_component_1 = __webpack_require__(/*! ./list-command-bar.component */ "./src/content/list-command-bar/list-command-bar.component.tsx");
Object.defineProperty(exports, "ListCommandBar", ({ enumerable: true, get: function () { return list_command_bar_component_1.ListCommandBar; } }));


/***/ }),

/***/ "./src/content/list-command-bar/list-command-bar.component.tsx":
/*!*********************************************************************!*\
  !*** ./src/content/list-command-bar/list-command-bar.component.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ListCommandBar = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const make_a_z_helper_1 = __webpack_require__(/*! ./make-a-z.helper */ "./src/content/list-command-bar/make-a-z.helper.tsx");
const make_button_helper_1 = __webpack_require__(/*! ./make-button.helper */ "./src/content/list-command-bar/make-button.helper.tsx");
const make_refiners_helper_1 = __webpack_require__(/*! ./make-refiners.helper */ "./src/content/list-command-bar/make-refiners.helper.tsx");
const make_sort_helper_1 = __webpack_require__(/*! ./make-sort.helper */ "./src/content/list-command-bar/make-sort.helper.tsx");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing }) => ({
    rootStyles: {
        display: "flex",
        width: "100%",
        backgroundColor: palette.neutralEmpty,
    },
    textStyles: Object.assign(Object.assign({}, fonts.mediumPlus), { paddingLeft: spacing.medium, color: palette.neutralEmptyOn, alignSelf: "center" }),
    commandStyles: {
        flex: "1 1"
    }
}));
const fluentStyles = ({ theme: { sizes } }) => ({
    image: {
        height: sizes.xSmall
    }
});
const ListCommandBar = ({ config }) => {
    const { description, title, consumes, provides, props: { actions = [], showTitle } = { buttons: [], showTitle: false } } = config;
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const refinerProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'refiners');
    const sortProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'sort-option');
    const letterProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'letter-filter');
    const letterFilter = smarthub_common_1.useReadSharedState(letterProvider);
    const setLetterFilter = smarthub_common_1.useSetSharedState(letterProvider);
    const sortOption = smarthub_common_1.useReadSharedState(sortProvider);
    const getThemeImageURI = smarthub_common_1.useGetThemeImageURI();
    const setSortOption = smarthub_common_1.useSetSharedState(sortProvider);
    const refinerValues = smarthub_common_1.useReadSharedState(refinerProvider);
    const setRefinerValues = smarthub_common_1.useSetSharedState(refinerProvider);
    const sortOptions = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "sort-options"));
    const refiners = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "refiners"));
    const openAction = smarthub_common_1.useHandleCommand();
    const { commandStyles, textStyles, rootStyles } = useStyles();
    const imageStyles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const refinerButtons = react_1.useMemo(() => make_refiners_helper_1.makeRefiners(refiners, refinerValues, localizeConfig, setRefinerValues), [refinerValues, refiners, setRefinerValues]);
    const azButton = react_1.useMemo(() => (letterProvider
        ? make_a_z_helper_1.makeAZ(letterFilter, localizeConfig, setLetterFilter)
        : []), [letterFilter, setLetterFilter]);
    const { leftBefore, leftAfter, more, rightAfter, rightBefore } = react_1.useMemo(() => ({
        leftBefore: make_button_helper_1.makeButton(actions, smarthub_common_1.AppActionPosition.nearBefore, openAction, getThemeImageURI, imageStyles),
        leftAfter: make_button_helper_1.makeButton(actions, smarthub_common_1.AppActionPosition.nearAfter, openAction, getThemeImageURI, imageStyles),
        more: make_button_helper_1.makeButton(actions, [smarthub_common_1.AppActionPosition.moreBefore, smarthub_common_1.AppActionPosition.moreAfter, undefined], openAction, getThemeImageURI, imageStyles),
        rightBefore: make_button_helper_1.makeButton(actions, smarthub_common_1.AppActionPosition.farBefore, openAction, getThemeImageURI, imageStyles),
        rightAfter: make_button_helper_1.makeButton(actions, smarthub_common_1.AppActionPosition.farAfter, openAction, getThemeImageURI, imageStyles)
    }), [actions, getThemeImageURI, imageStyles]);
    const items = react_1.useMemo(() => [
        ...leftBefore,
        ...azButton,
        ...refinerButtons,
        ...leftAfter,
    ], [refinerButtons, azButton, leftAfter, leftBefore]);
    const farItems = react_1.useMemo(() => [
        ...rightBefore,
        ...make_sort_helper_1.makeSort(sortOptions, sortOption, localizeConfig, setSortOption),
        ...rightAfter,
    ], [sortOptions, sortOption, rightAfter, rightBefore]);
    return (react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement("div", { className: rootStyles },
            showTitle && react_1.default.createElement("div", { className: textStyles }, title),
            react_1.default.createElement(react_2.CommandBar, { className: commandStyles, title: description, ariaLabel: description, items: items, overflowItems: more, farItems: farItems })))), [items, farItems, config, rootStyles, textStyles, commandStyles]));
};
exports.ListCommandBar = ListCommandBar;


/***/ }),

/***/ "./src/content/list-command-bar/make-a-z.helper.tsx":
/*!**********************************************************!*\
  !*** ./src/content/list-command-bar/make-a-z.helper.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeAZ = void 0;
const a_z_filter_button_component_1 = __webpack_require__(/*! ./a-z-filter-button.component */ "./src/content/list-command-bar/a-z-filter-button.component.tsx");
const makeAZ = (current, localizeConfig, onClick) => {
    const menuItems = [];
    for (let i = "A".charCodeAt(0); i <= "Z".charCodeAt(0); i++) {
        let char = String.fromCharCode(i);
        menuItems.push({
            key: char,
            text: char,
            ariaDescription: `${localizeConfig.azFilterValueDesc} ${char}`,
            ariaLabel: `${localizeConfig.azFilterValueTitle} ${char}`,
            title: `${localizeConfig.azFilterValueTitle} ${char}`,
            onClick: () => onClick(char)
        });
    }
    return [{
            key: "a-z",
            text: `${localizeConfig.azFilterText}`,
            commandBarButtonAs: a_z_filter_button_component_1.AZFilterButton,
            split: current != null,
            checked: current != null,
            iconProps: current
                ? { iconName: 'ChromeClose' }
                : null,
            secondaryText: current
                ? `${localizeConfig.azFilterSecondaryText} ${current}`
                : null,
            ariaDescription: `${localizeConfig.azFilterDesc} ${current}`,
            ariaLabel: `${localizeConfig.azFilterTitle} ${current}`,
            subMenuProps: {
                items: menuItems
            },
            onClick: () => current != null
                ? onClick(undefined)
                : null
        }];
};
exports.makeAZ = makeAZ;


/***/ }),

/***/ "./src/content/list-command-bar/make-button.helper.tsx":
/*!*************************************************************!*\
  !*** ./src/content/list-command-bar/make-button.helper.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeButton = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const getValue = (value, locale) => {
    return typeof value == "object" ? value[locale] : value;
};
const makeButton = (buttons, pos, onClick, getThemeImage, styles) => {
    const locale = smarthub_common_1.useLocale();
    return buttons
        .filter(({ position }) => Array.isArray(pos) ? ~pos.indexOf(position) : position == pos)
        .map(({ title, name, shortTitle, icon, action, description }, idx) => ({
        key: `${name}-${idx}`,
        text: getValue(shortTitle, locale),
        iconProps: {
            iconName: typeof icon == "string" ? icon : undefined,
            imageProps: icon && typeof icon == "object"
                ? {
                    styles: styles,
                    src: getThemeImage(icon.image),
                    alt: typeof icon.image == "object"
                        ? icon.image.text
                        : getValue(title, locale),
                }
                : undefined,
        },
        ariaDescription: getValue(description, locale),
        ariaLabel: getValue(title, locale),
        title: getValue(title, locale),
        onClick: () => onClick(action),
    }));
};
exports.makeButton = makeButton;


/***/ }),

/***/ "./src/content/list-command-bar/make-refiners.helper.tsx":
/*!***************************************************************!*\
  !*** ./src/content/list-command-bar/make-refiners.helper.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeRefiners = void 0;
const split_compound_button_component_1 = __webpack_require__(/*! ./split-compound-button.component */ "./src/content/list-command-bar/split-compound-button.component.tsx");
const makeRefiners = (refiners, selected, localizeConfig, onClick) => {
    if (!refiners)
        return [];
    const onRefinerChange = (name, value) => {
        const result = value == undefined
            ? Object.assign({}, selected) : Object.assign(Object.assign({}, selected), { [name]: value });
        if (value == undefined)
            delete result[name];
        onClick(Object.keys(result).length
            ? result
            : null);
    };
    const buttons = refiners.map(({ values, text, name }) => {
        const current = selected && selected[name]
            ? values.find(({ token }) => token == selected[name])
            : null;
        const currentText = current ? current.text : '';
        return {
            key: name,
            text: text,
            secondaryText: currentText,
            commandBarButtonAs: split_compound_button_component_1.SplitCompoundButton,
            split: current != null,
            checked: current != null,
            iconProps: current
                ? { iconName: 'ChromeClose' }
                : null,
            ariaDescription: `${localizeConfig.refineByDesc} ${text} ${currentText}`,
            ariaLabel: `${localizeConfig.refineByTitle} ${text} ${currentText}`,
            onClick: current != null ?
                () => onRefinerChange(name)
                : null,
            subMenuProps: {
                items: values
                    .map((value) => ({
                    key: value.token,
                    text: value.text,
                    ariaDescription: `${localizeConfig.refineByValueDesc} ${text} ${value.text}`,
                    ariaLabel: `${localizeConfig.refineByValueTitle} ${text} ${value.text}`,
                    title: `${localizeConfig.refineByValueTitle} ${text} ${value.text}`,
                    onClick: () => onRefinerChange(name, value.token)
                }))
            }
        };
    });
    if (selected)
        buttons.push({
            key: "clear-all",
            text: "Clear All",
            primary: true,
            iconProps: { iconName: 'ChromeClose' },
            ariaDescription: `${localizeConfig.refineByDesc}`,
            ariaLabel: `${localizeConfig.refineByTitle}`,
            title: `${localizeConfig.refineByTitle}`,
            onClick: () => onClick(null)
        });
    return buttons;
};
exports.makeRefiners = makeRefiners;


/***/ }),

/***/ "./src/content/list-command-bar/make-sort.helper.tsx":
/*!***********************************************************!*\
  !*** ./src/content/list-command-bar/make-sort.helper.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.makeSort = void 0;
const split_compound_button_component_1 = __webpack_require__(/*! ./split-compound-button.component */ "./src/content/list-command-bar/split-compound-button.component.tsx");
const makeSort = (options, option, localizeConfig, onClick) => {
    var _a;
    if (!options)
        return [];
    const sort = (_a = (option
        ? options.find(({ name, direction }) => name == option.name &&
            direction == option.direction)
        : options.find(({ preferred }) => preferred))) !== null && _a !== void 0 ? _a : options[0];
    const asc = !sort.direction || sort.direction == 'ascending' || sort.direction == 'asc';
    return [{
            key: "sort-options",
            text: `${localizeConfig.sortByText}`,
            commandBarButtonAs: split_compound_button_component_1.SplitCompoundButton,
            split: false,
            iconProps: {
                iconName: asc ? 'ascending' : 'descending'
            },
            secondaryText: sort.text,
            ariaDescription: `${localizeConfig.sortByDesc} ${sort.text}`,
            ariaLabel: `${localizeConfig.sortByTitle} ${sort.text}`,
            subMenuProps: {
                items: options.map(({ text, name, direction }, i) => {
                    const asc = !direction || direction == 'ascending' || direction == 'asc';
                    return {
                        key: `${name}-${direction}`,
                        text: text,
                        iconProps: {
                            iconName: asc ? 'ascending' : 'descending'
                        },
                        ariaDescription: `${localizeConfig.sortByValueDesc} ${text}`,
                        ariaLabel: `${localizeConfig.sortByValueTitle} ${text}`,
                        title: `${localizeConfig.sortByValueTitle} ${text}`,
                        onClick: () => onClick({ name, direction })
                    };
                })
            },
        }];
};
exports.makeSort = makeSort;


/***/ }),

/***/ "./src/content/list-command-bar/split-compound-button.component.tsx":
/*!**************************************************************************!*\
  !*** ./src/content/list-command-bar/split-compound-button.component.tsx ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SplitCompoundButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const button_styles_1 = __webpack_require__(/*! ./button.styles */ "./src/content/list-command-bar/button.styles.tsx");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fluentStyles = (props) => {
    var _a;
    const { theme, config } = props;
    const { spacing, fonts } = theme;
    return Object.assign(Object.assign({}, button_styles_1.buttonStyles(props)), { icon: {
            margin: `0 ${spacing.normal} 0 ${spacing.xSmall}`,
            fontSize: ((_a = config.iconProps) === null || _a === void 0 ? void 0 : _a.iconName) == 'ChromeClose'
                ? fonts.small.fontSize
                : fonts.superLarge.fontSize
        } });
};
const SplitCompoundButton = (props) => {
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, props);
    return react_1.default.createElement(react_2.CompoundButton, Object.assign({}, props, { styles: styles }));
};
exports.SplitCompoundButton = SplitCompoundButton;


/***/ }),

/***/ "./src/content/map/index.ts":
/*!**********************************!*\
  !*** ./src/content/map/index.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./map-embed.component */ "./src/content/map/map-embed.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./map.component */ "./src/content/map/map.component.tsx"), exports);


/***/ }),

/***/ "./src/content/map/map-embed.component.tsx":
/*!*************************************************!*\
  !*** ./src/content/map/map-embed.component.tsx ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MapEmbed = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const page_1 = __webpack_require__(/*! ../page */ "./src/content/page/index.ts");
const MapEmbed = ({ location: { address, coordinates }, width, height }) => {
    var _a, _b;
    const query = ((_a = coordinates === null || coordinates === void 0 ? void 0 : coordinates.lat) === null || _a === void 0 ? void 0 : _a.length) && ((_b = coordinates === null || coordinates === void 0 ? void 0 : coordinates.long) === null || _b === void 0 ? void 0 : _b.length)
        ? `${coordinates.lat},${coordinates.long}`
        : `${address.line1} ${address.postcode}`;
    const mapUri = `https://maps.google.com/maps?q=${encodeURIComponent(query)}&output=embed`;
    return (react_1.default.createElement(page_1.PageViewEmbed, { uri: mapUri, width: width, height: height }));
};
exports.MapEmbed = MapEmbed;


/***/ }),

/***/ "./src/content/map/map.component.tsx":
/*!*******************************************!*\
  !*** ./src/content/map/map.component.tsx ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Map = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const map_embed_component_1 = __webpack_require__(/*! ./map-embed.component */ "./src/content/map/map-embed.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles({
    wrapper: {
        display: 'flex',
        height: '100%',
    }
});
const Map = ({ config, config: { consumes, props } }) => {
    var _a;
    const location = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "location"))) !== null && _a !== void 0 ? _a : props === null || props === void 0 ? void 0 : props.location;
    const styles = useStyles();
    const message = smarthub_common_1.useLocalize(smarthub_common_1.LocalizeKeys.pageError);
    const error = !location
        ? {
            message
        }
        : undefined;
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.wrapper, error: error }, location && react_1.default.createElement(map_embed_component_1.MapEmbed, { location: location, width: props === null || props === void 0 ? void 0 : props.width, height: props === null || props === void 0 ? void 0 : props.height })));
};
exports.Map = Map;


/***/ }),

/***/ "./src/content/ms-form/index.ts":
/*!**************************************!*\
  !*** ./src/content/ms-form/index.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./ms-form-embed.component */ "./src/content/ms-form/ms-form-embed.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./ms-form.component */ "./src/content/ms-form/ms-form.component.tsx"), exports);


/***/ }),

/***/ "./src/content/ms-form/ms-form-embed.component.tsx":
/*!*********************************************************!*\
  !*** ./src/content/ms-form/ms-form-embed.component.tsx ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MSFormEmbed = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const page_1 = __webpack_require__(/*! ../page */ "./src/content/page/index.ts");
const MSFormEmbed = ({ uri, width, height, themeColour, lang = 'en-US', sso }) => {
    const formUri = `${uri}${!~uri.indexOf('&embed=')
        ? '&embed=true'
        : ''}${sso && !~uri.indexOf('&lang=')
        ? `&lang=${lang}`
        : ''}${sso && themeColour && !~uri.indexOf('&themecolor')
        ? `&themecolor=${themeColour}`
        : ''}${sso && !~uri.indexOf('&oembedsso=')
        ? '&oembedsso=true'
        : ''}`;
    return (react_1.default.createElement(page_1.PageViewEmbed, { uri: formUri, width: width, height: height }));
};
exports.MSFormEmbed = MSFormEmbed;


/***/ }),

/***/ "./src/content/ms-form/ms-form.component.tsx":
/*!***************************************************!*\
  !*** ./src/content/ms-form/ms-form.component.tsx ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MSForm = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const ms_form_embed_component_1 = __webpack_require__(/*! ./ms-form-embed.component */ "./src/content/ms-form/ms-form-embed.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles({
    wrapper: {
        display: 'flex',
        height: '100%',
    }
});
const MSForm = ({ config, config: { consumes, props } }) => {
    var _a, _b;
    let { themeColour, uri, sso } = props !== null && props !== void 0 ? props : {};
    const form = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "form"));
    const { definition: { palette } } = smarthub_common_1.useTheme();
    const styles = useStyles();
    const message = smarthub_common_1.useLocalize(smarthub_common_1.LocalizeKeys.msFormError);
    themeColour = themeColour
        ? (_a = palette[themeColour]) !== null && _a !== void 0 ? _a : themeColour : null;
    uri = ((_b = form === null || form === void 0 ? void 0 : form.uri) === null || _b === void 0 ? void 0 : _b.length) ? form.uri
        : props === null || props === void 0 ? void 0 : props.uri;
    const error = !(uri === null || uri === void 0 ? void 0 : uri.length) ? {
        message
    }
        : undefined;
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.wrapper, error: error }, (uri === null || uri === void 0 ? void 0 : uri.length) && react_1.default.createElement(ms_form_embed_component_1.MSFormEmbed, { uri: uri, width: '100%', height: '100%', themeColour: themeColour, sso: sso })));
};
exports.MSForm = MSForm;


/***/ }),

/***/ "./src/content/ms-power-app/index.ts":
/*!*******************************************!*\
  !*** ./src/content/ms-power-app/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./ms-power-app-embed.component */ "./src/content/ms-power-app/ms-power-app-embed.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./ms-power-app.component */ "./src/content/ms-power-app/ms-power-app.component.tsx"), exports);


/***/ }),

/***/ "./src/content/ms-power-app/ms-power-app-embed.component.tsx":
/*!*******************************************************************!*\
  !*** ./src/content/ms-power-app/ms-power-app-embed.component.tsx ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MSPowerAppEmbed = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const page_1 = __webpack_require__(/*! ../page */ "./src/content/page/index.ts");
const MSPowerAppEmbed = ({ appId, width, height, key }) => {
    const appUri = `https://apps.powerapps.com/play/${appId}?source=iframe`;
    return (react_1.default.createElement(page_1.PageViewEmbed, { key: key, uri: appUri, width: width, height: height }));
};
exports.MSPowerAppEmbed = MSPowerAppEmbed;


/***/ }),

/***/ "./src/content/ms-power-app/ms-power-app.component.tsx":
/*!*************************************************************!*\
  !*** ./src/content/ms-power-app/ms-power-app.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MSPowerApp = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const ms_power_app_embed_component_1 = __webpack_require__(/*! ./ms-power-app-embed.component */ "./src/content/ms-power-app/ms-power-app-embed.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles({
    wrapper: {
        display: 'flex',
        height: '100%',
    }
});
const MSPowerApp = ({ config, config: { consumes, props } }) => {
    var _a, _b;
    const app = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "app"));
    const theme = smarthub_common_1.useTheme();
    const refreshKey = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "refresh-key"))) !== null && _a !== void 0 ? _a : "0";
    const styles = useStyles();
    const appId = ((_b = app === null || app === void 0 ? void 0 : app.uri) === null || _b === void 0 ? void 0 : _b.length) ? app.uri
        : ((props === null || props === void 0 ? void 0 : props.themed) && (props === null || props === void 0 ? void 0 : props.themed[theme.name]) && (props === null || props === void 0 ? void 0 : props.themed[theme.name].length)
            ? props.themed[theme.name]
            : props === null || props === void 0 ? void 0 : props.appId);
    const message = smarthub_common_1.useLocalize(smarthub_common_1.LocalizeKeys.msPowerAppError);
    const error = !(appId === null || appId === void 0 ? void 0 : appId.length)
        ? {
            message
        }
        : undefined;
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.wrapper, error: error }, (appId === null || appId === void 0 ? void 0 : appId.length) && react_1.default.createElement(ms_power_app_embed_component_1.MSPowerAppEmbed, { appId: appId, key: refreshKey, width: '100%', height: '100%' })));
};
exports.MSPowerApp = MSPowerApp;


/***/ }),

/***/ "./src/content/ms-stream/index.ts":
/*!****************************************!*\
  !*** ./src/content/ms-stream/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./ms-stream-embed.component */ "./src/content/ms-stream/ms-stream-embed.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./ms-stream.component */ "./src/content/ms-stream/ms-stream.component.tsx"), exports);


/***/ }),

/***/ "./src/content/ms-stream/ms-stream-embed.component.tsx":
/*!*************************************************************!*\
  !*** ./src/content/ms-stream/ms-stream-embed.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StreamEmbed = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const page_1 = __webpack_require__(/*! ../page */ "./src/content/page/index.ts");
const StreamEmbed = ({ uri, width = '100%', height = '100%', sort, autoplay, responsive, startAt }) => {
    var _a;
    const typedURI = new URL(uri);
    const pathNameInitialString = (_a = typedURI === null || typedURI === void 0 ? void 0 : typedURI.pathname) === null || _a === void 0 ? void 0 : _a.split('/')[1];
    const updatedURI = `${typedURI === null || typedURI === void 0 ? void 0 : typedURI.origin}${pathNameInitialString != 'embed' ? '/embed' : ''}${typedURI === null || typedURI === void 0 ? void 0 : typedURI.pathname}`;
    const streamUri = `${updatedURI}?autoplay=${autoplay ? 'true' : 'false'}${sort ? `&sort=${sort}` : ''}&responsive=${responsive ? 'true' : 'false'}&startAt=${startAt > 0 ? startAt : 0}`;
    return (react_1.default.createElement(page_1.PageViewEmbed, { uri: streamUri, width: width, height: height }));
};
exports.StreamEmbed = StreamEmbed;


/***/ }),

/***/ "./src/content/ms-stream/ms-stream.component.tsx":
/*!*******************************************************!*\
  !*** ./src/content/ms-stream/ms-stream.component.tsx ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Stream = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const ms_stream_embed_component_1 = __webpack_require__(/*! ./ms-stream-embed.component */ "./src/content/ms-stream/ms-stream-embed.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles({
    wrapper: {
        display: 'flex',
        height: '100%',
    }
});
const Stream = ({ config, config: { props: { uri, sort, autoplay, responsive, startAt } } }) => {
    const styles = useStyles();
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.wrapper },
        react_1.default.createElement(ms_stream_embed_component_1.StreamEmbed, { uri: uri, width: '100%', height: '100%', sort: sort, autoplay: autoplay, responsive: responsive, startAt: startAt })));
};
exports.Stream = Stream;


/***/ }),

/***/ "./src/content/notification/index.ts":
/*!*******************************************!*\
  !*** ./src/content/notification/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./notification.component */ "./src/content/notification/notification.component.tsx"), exports);


/***/ }),

/***/ "./src/content/notification/notification.component.tsx":
/*!*************************************************************!*\
  !*** ./src/content/notification/notification.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Notification = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const fluentStyles = (({ config: count = 1, responsive: { size } = { size: 12 }, theme: { palette, fonts, spacing, sizes } }) => ({
    card: {
        root: Object.assign({ position: "absolute", boxShadow: `-${spacing.normal} -${spacing.normal} ${spacing.normal} ${palette.filmMinus1}`, right: 0, bottom: 0, zIndex: 1000, backgroundColor: palette.notifyMinus1, width: smarthub_common_1.responsiveColumnWidths[size] }, react_2.AnimationStyles.slideUpIn20)
    },
    actions: {
        root: {
            padding: 0
        },
        primarySet: {
            //TODO - Remove after Fluent UI Fix
            ["& .ms-OverflowSet-item"]: {
                width: `${100 / count}%`
            }
        }
    },
    action: {
        item: {
            width: `${100 / count}%`
        }
    },
    infoButton: {
        root: {
            width: "100%",
            backgroundColor: palette.notifyPlus1,
            color: palette.notifyPlus1On,
        },
        rootHovered: {
            backgroundColor: palette.notify,
            color: palette.notifyOn,
        },
        rootPressed: {
            backgroundColor: palette.notifyPlus2,
            color: palette.notifyPlus2On,
        },
        rootFocused: {
            backgroundColor: palette.notifyPlus2,
            color: palette.notifyPlus2On
        },
        icon: {
            color: palette.notifyPlus1On,
        },
        iconHovered: {
            color: palette.notifyOn,
        },
        iconPressed: {
            color: palette.notifyPlus2On,
        },
        textContainer: {
            flexGrow: 0
        }
    },
    acceptButton: {
        root: {
            width: "100%",
            backgroundColor: palette.notifyPlus2,
            color: palette.notifyPlus2On,
        },
        rootHovered: {
            backgroundColor: palette.notifyPlus1,
            color: palette.notifyPlus1On
        },
        rootPressed: {
            backgroundColor: palette.notify,
            color: palette.notifyOn,
        },
        rootFocused: {
            backgroundColor: palette.notify,
            color: palette.notifyOn,
        },
        icon: {
            color: palette.notifyPlus2On
        },
        iconHovered: {
            color: palette.notifyPlus1On
        },
        iconPressed: {
            color: palette.notifyOn,
        },
        textContainer: {
            flexGrow: 0
        }
    },
    dismissButton: {
        root: {
            width: "100%",
            backgroundColor: palette.notify,
            color: palette.notifyOn
        },
        rootHovered: {
            backgroundColor: palette.notifyMinus2,
            color: palette.notifyMinus2On
        },
        rootPressed: {
            backgroundColor: palette.notifyPlus1,
            color: palette.notifyPlus1On,
        },
        rootFocused: {
            backgroundColor: palette.notifyPlus1,
            color: palette.notifyPlus1On,
        },
        icon: {
            color: palette.notifyOn,
        },
        iconHovered: {
            color: palette.notifyMinus2On
        },
        iconPressed: {
            color: palette.notifyPlus1On,
        },
        textContainer: {
            flexGrow: 0
        }
    },
    rejectButton: {
        root: {
            width: "100%",
            backgroundColor: palette.hazardPlus1,
            color: palette.hazardPlus1On
        },
        rootHovered: {
            backgroundColor: palette.hazard,
            color: palette.hazardOn,
        },
        rootPressed: {
            backgroundColor: palette.hazardPlus2,
            color: palette.hazardPlus2On,
        },
        rootFocused: {
            backgroundColor: palette.hazardPlus2,
            color: palette.hazardPlus2On,
        },
        icon: {
            color: palette.hazardPlus1On
        },
        iconHovered: {
            color: palette.hazardOn,
        },
        iconPressed: {
            color: palette.hazardPlus2On,
        },
        textContainer: {
            flexGrow: 0
        }
    },
    body: {
        root: {
            color: palette.notifyMinus1On,
            display: "-webkit-box",
            textOverflow: "ellipsis",
            overflow: "hidden",
            "-webkit-line-clamp": "4",
            "-webkit-box-orient": "vertical",
        }
    },
    mainSection: {
        root: {
            display: "flex",
            minHeight: sizes.xxLargePlus
        }
    },
    contentSection: {
        root: {
            padding: spacing.medium
        }
    },
    icon: {
        root: {
            color: palette.notifyMinus1On,
            fontSize: fonts.mega.fontSize,
            width: fonts.mega.fontSize,
            margin: `${spacing.small} 0 ${spacing.medium} ${spacing.medium}`
        }
    },
    title: {
        root: Object.assign(Object.assign({}, fonts.mediumPlus), { color: palette.notifyMinus1On, whiteSpace: "norwap", textOverflow: "ellipsis", overflow: "hidden" })
    }
}));
const useImageStyles = react_jss_1.createUseStyles(({ spacing }) => ({
    image: {
        margin: `${spacing.mediumPlus} 0 ${spacing.medium} ${spacing.medium}`,
        maxHeight: "100%",
        height: "fit-content"
    }
}));
const responsiveConfig = {
    sm: { size: 12 },
    md: { size: 8 },
    lg: { size: 6 },
    lgx: { size: 5 },
    xl: { size: 4 },
    xlx: { size: 3 }
};
const Notification = () => {
    var _a;
    const imageStyles = useImageStyles();
    const dismiss = smarthub_common_1.useDismissNotification();
    const notification = smarthub_common_1.useNextNotification();
    const handleAction = smarthub_common_1.useHandleCommand();
    const localize = smarthub_common_1.useLocalizeConfig();
    const styleProps = smarthub_common_1.useThemeStyleProps((_a = notification === null || notification === void 0 ? void 0 : notification.actions) === null || _a === void 0 ? void 0 : _a.length, responsiveConfig);
    const styles = smarthub_common_1.useFluentStyles(fluentStyles, styleProps);
    const onClick = react_1.useCallback((action) => {
        if (action)
            handleAction(action);
        dismiss(notification);
    }, [notification, dismiss]);
    return react_1.useMemo(() => {
        var _a;
        return (react_1.default.createElement(react_1.default.Fragment, null, notification && react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.Announced, { message: `${localize.notificationAnnounce}: ${notification.title}` }),
            react_1.default.createElement(react_2.Stack, { styles: styles.card },
                react_1.default.createElement(react_2.Stack.Item, { styles: styles.mainSection },
                    react_1.default.createElement(react_2.Stack, { horizontal: true },
                        react_1.default.createElement(react_2.Stack.Item, null, ((_a = notification.icon) === null || _a === void 0 ? void 0 : _a.length) > 0 && react_1.default.createElement(react_2.Icon, { styles: styles.icon, iconName: notification.icon })),
                        react_1.default.createElement(react_2.Stack.Item, null, (notification === null || notification === void 0 ? void 0 : notification.image) && react_1.default.createElement(utilities_1.ThemeImage, { alt: notification.image.text, className: imageStyles.image, image: notification.image, defaultPalette: 'Notify', defaultSize: 'medium' })),
                        react_1.default.createElement(react_2.Stack.Item, { styles: styles.contentSection },
                            react_1.default.createElement(react_2.Text, { block: true, styles: styles.title }, notification.title),
                            react_1.default.createElement(react_2.Text, { block: true, styles: styles.body }, notification.body)))),
                react_1.default.createElement(react_2.Stack.Item, null,
                    react_1.default.createElement(react_2.CommandBar, { styles: styles.actions, items: notification.actions.map(({ title, type, description, icon, action }, idx) => ({
                            key: `${title}-${idx}`,
                            text: title,
                            itemProps: {
                                styles: styles.action
                            },
                            buttonStyles: type == 'dismiss'
                                ? styles.dismissButton
                                : type == 'accept'
                                    ? styles.acceptButton
                                    : type == 'reject'
                                        ? styles.rejectButton
                                        : styles.infoButton,
                            secondaryText: description,
                            iconProps: {
                                iconName: icon
                            },
                            ariaLabel: title,
                            title,
                            onClick: () => onClick(action)
                        })), ariaLabel: localize.notificationActions }))))));
    }, [notification, styles, imageStyles]);
};
exports.Notification = Notification;


/***/ }),

/***/ "./src/content/page/add-comment.component.tsx":
/*!****************************************************!*\
  !*** ./src/content/page/add-comment.component.tsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AddComment = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const page_comment_form_component_1 = __webpack_require__(/*! ./page-comment-form.component */ "./src/content/page/page-comment-form.component.tsx");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const AddComment = ({ config }) => {
    const { query, consumes, provides, props: { maxLength, localisedText } = {} } = config;
    const setRefreshKey = smarthub_common_1.useSetSharedState(provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'refreshKey'));
    const page = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"));
    const handleOnSuccess = react_1.useCallback(() => setRefreshKey((new Date()).getTime()), []);
    return react_1.useMemo(() => {
        var _a, _b;
        return ((((_a = page === null || page === void 0 ? void 0 : page.comments) === null || _a === void 0 ? void 0 : _a.enabled) && !((_b = page === null || page === void 0 ? void 0 : page.comments) === null || _b === void 0 ? void 0 : _b.closed))
            ? react_1.default.createElement(core_1.ComponentChrome, { config: config },
                react_1.default.createElement(page_comment_form_component_1.PageCommentForm, { mode: "add", displayMode: 'inline', query: query, localizedText: localisedText, maxLength: maxLength, params: { page }, onSuccess: handleOnSuccess }))
            : null);
    }, [config, page]);
};
exports.AddComment = AddComment;


/***/ }),

/***/ "./src/content/page/index.ts":
/*!***********************************!*\
  !*** ./src/content/page/index.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./page-content.component */ "./src/content/page/page-content.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-view-embed.component */ "./src/content/page/page-view-embed.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-view.component */ "./src/content/page/page-view.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-header.component */ "./src/content/page/page-header.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-nav.component */ "./src/content/page/page-nav.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-metadata.component */ "./src/content/page/page-metadata.component/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-comments.component */ "./src/content/page/page-comments.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-comment-form.component */ "./src/content/page/page-comment-form.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./add-comment.component */ "./src/content/page/add-comment.component.tsx"), exports);


/***/ }),

/***/ "./src/content/page/page-comment-form.component.tsx":
/*!**********************************************************!*\
  !*** ./src/content/page/page-comment-form.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageCommentForm = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_hooks_1 = __webpack_require__(/*! @fluentui/react-hooks */ "@fluentui/react-hooks");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles(({ palette, spacing }) => ({
    errorStyle: {
        color: palette.hazard,
        marginTop: spacing.smallPlus
    }
}));
const fluentStyles = (({ theme: { palette } }) => ({
    root: {
        backgroundColor: palette.hazard,
        borderColor: palette.hazard
    },
    label: {
        color: palette.hazardOn
    }
}));
const PageCommentForm = ({ mode, localizedText, displayMode = 'popup', query, maxLength = 255, id = null, params, message = '', onSuccess }) => {
    const localize = smarthub_common_1.useLocalizeConfig();
    const fetch = smarthub_common_1.useFetch();
    const styleProps = smarthub_common_1.useThemeStyleProps();
    const commonStyles = useStyles();
    const styles = smarthub_common_1.useFluentStyles(fluentStyles, styleProps);
    const { queries } = query;
    const [modeIs, setModeIs] = react_1.useState(mode);
    const [hideDialog, { toggle: toggleHideDialog }] = react_hooks_1.useBoolean(false);
    const [textValue, setTextValue] = react_1.useState(decodeURIComponent(message));
    const [errorMsg, setErrorMsg] = react_1.useState('');
    const { saveButtonText, saveButtonLabel, cancelButtonText, cancelButtonLabel, deleteButtonText, deleteButtonLabel, clearButtonText, clearButtonLabel, textBoxTitle, textBoxLabel, confirmDelete, errorEmptyComment, errorCommentTooLong } = localize[localizedText || 'commentForm'];
    const onSubmit = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const queryRequest = queries.find(({ action }) => action == modeIs);
        const textLength = textValue.length;
        let errorMsgIs = '';
        if (textLength > maxLength) {
            errorMsgIs = smarthub_common_1.replaceExpression(errorCommentTooLong, { maxLength });
        }
        else if (textLength == 0) {
            errorMsgIs = errorEmptyComment;
        }
        setErrorMsg(errorMsgIs);
        if (errorMsgIs != '')
            return;
        try {
            const body = { 'message': textValue };
            const fetchBody = Object.assign(Object.assign(Object.assign({}, params), body), { id });
            const response = yield fetch(queryRequest, fetchBody);
            if ((response === null || response === void 0 ? void 0 : response.data) || (response === null || response === void 0 ? void 0 : response.status) === 204) {
                onSuccess(modeIs === 'add' ? 'added' : 'updated');
                if (modeIs === 'add')
                    setTextValue("");
                toggleHideDialog();
            }
            else {
                setErrorMsg('Error occurred');
            }
        }
        catch (error) {
            setErrorMsg(error);
        }
    }), [textValue, localize, id]);
    const onChange = react_1.useCallback((ev, newText) => {
        setTextValue(newText);
    }, []);
    const onClear = react_1.useCallback(() => {
        setTextValue("");
        setErrorMsg("");
    }, [toggleHideDialog]);
    const onCancelDialog = react_1.useCallback(() => {
        setTextValue("");
        setModeIs(null);
        onSuccess('');
        toggleHideDialog();
    }, [toggleHideDialog]);
    const onDeleteFromUpdate = react_1.useCallback(() => {
        setModeIs('delete');
    }, []);
    const onDelete = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const queryRequest = queries.find(({ action }) => action == 'delete');
        try {
            const body = { 'message': textValue };
            const fetchBody = Object.assign(Object.assign(Object.assign({}, params), body), { id });
            const response = yield fetch(queryRequest, fetchBody);
            if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                onSuccess('deleted');
                toggleHideDialog();
            }
            else {
                setErrorMsg('Error occurred');
            }
        }
        catch (error) {
            setErrorMsg(error);
        }
    }), [localize, id]);
    const displayButtons = react_1.useCallback((modeIs) => {
        if (modeIs === 'add') {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_2.TextField, { placeholder: textBoxLabel, title: textBoxTitle, multiline: true, rows: 3, value: textValue, onChange: onChange, errorMessage: errorMsg }),
                react_1.default.createElement(react_2.DialogFooter, null,
                    react_1.default.createElement(react_2.PrimaryButton, { ariaLabel: saveButtonLabel, title: saveButtonLabel, text: saveButtonText, ariaDescription: saveButtonLabel, onClick: onSubmit }),
                    displayMode == 'inline'
                        ? react_1.default.createElement(react_2.DefaultButton, { ariaLabel: clearButtonLabel, title: clearButtonLabel, text: clearButtonText, ariaDescription: clearButtonLabel, onClick: onClear })
                        : react_1.default.createElement(react_2.DefaultButton, { ariaLabel: cancelButtonLabel, title: cancelButtonLabel, text: cancelButtonText, ariaDescription: cancelButtonLabel, onClick: onCancelDialog }))));
        }
        else if (modeIs === 'update') {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_2.TextField, { placeholder: textBoxLabel, title: textBoxTitle, multiline: true, rows: 3, value: textValue, onChange: onChange, errorMessage: errorMsg }),
                react_1.default.createElement(react_2.DialogFooter, null,
                    react_1.default.createElement(react_2.PrimaryButton, { styles: styles, ariaLabel: deleteButtonLabel, title: deleteButtonLabel, text: deleteButtonText, ariaDescription: deleteButtonLabel, onClick: onDeleteFromUpdate }),
                    react_1.default.createElement(react_2.PrimaryButton, { ariaLabel: saveButtonLabel, title: saveButtonLabel, text: saveButtonText, ariaDescription: saveButtonLabel, onClick: onSubmit }),
                    react_1.default.createElement(react_2.DefaultButton, { ariaLabel: cancelButtonLabel, title: cancelButtonLabel, text: cancelButtonText, ariaDescription: cancelButtonLabel, onClick: onCancelDialog }))));
        }
        else if (modeIs === 'delete') {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_2.Text, { block: true, title: confirmDelete }, confirmDelete),
                react_1.default.createElement(react_2.Text, { className: commonStyles.errorStyle }, errorMsg),
                react_1.default.createElement(react_2.DialogFooter, null,
                    react_1.default.createElement(react_2.PrimaryButton, { ariaLabel: deleteButtonLabel, title: deleteButtonLabel, text: deleteButtonText, ariaDescription: deleteButtonLabel, onClick: onDelete }),
                    react_1.default.createElement(react_2.DefaultButton, { ariaLabel: cancelButtonLabel, title: cancelButtonLabel, text: cancelButtonText, ariaDescription: cancelButtonLabel, onClick: onCancelDialog }))));
        }
        return null;
    }, [modeIs, textValue, localize, errorMsg]);
    return react_1.useMemo(() => displayMode == 'inline'
        ? displayButtons(modeIs)
        : react_1.default.createElement(react_2.Dialog, { hidden: hideDialog, minWidth: 450, onDismiss: toggleHideDialog }, displayButtons(modeIs)), [hideDialog, textValue, toggleHideDialog, modeIs, id, errorMsg]);
};
exports.PageCommentForm = PageCommentForm;


/***/ }),

/***/ "./src/content/page/page-comments.component.tsx":
/*!******************************************************!*\
  !*** ./src/content/page/page-comments.component.tsx ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageComments = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const card_list_1 = __webpack_require__(/*! ../card-list */ "./src/content/card-list/index.ts");
const PageComments = ({ config, config: { consumes }, config: { children } }) => {
    const page = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"));
    const card = children.find(c => c.$id == 'card');
    return react_1.useMemo(() => {
        var _a, _b;
        return ((((_a = page === null || page === void 0 ? void 0 : page.comments) === null || _a === void 0 ? void 0 : _a.enabled) && !((_b = page === null || page === void 0 ? void 0 : page.comments) === null || _b === void 0 ? void 0 : _b.closed) && card)
            ? react_1.default.createElement(card_list_1.CardList, { config: config })
            : null);
    }, [config]);
};
exports.PageComments = PageComments;


/***/ }),

/***/ "./src/content/page/page-content.component.tsx":
/*!*****************************************************!*\
  !*** ./src/content/page/page-content.component.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageContent = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_hooks_1 = __webpack_require__(/*! @fluentui/react-hooks */ "@fluentui/react-hooks");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing, sizes }) => ({
    selected: {
        "&::before": {
            width: spacing.xSmall,
            height: "100%",
            backgroundColor: palette.primaryMinus1,
            content: '""',
            marginLeft: `-${spacing.medium}`,
            position: "absolute"
        }
    },
    page: Object.assign(Object.assign({}, fonts.normal), { padding: `${spacing.medium} ${spacing.xxLarge}`, minHeight: "100%", boxSizing: 'border-box', backgroundColor: palette.neutralEmpty, color: palette.neutralEmptyOn, '@global': {
            table: {
                maxWidth: "100%",
                borderSpacing: 0,
                borderCollapse: "collapse",
                border: `${spacing.tiny} solid ${palette.neutral}`
            },
            th: Object.assign(Object.assign({}, fonts.mediumPlus), { padding: spacing.smallPlus, verticalAlign: "bottom", border: `${spacing.tiny} solid ${palette.neutral}`, backgroundColor: palette.neutralMinus4, color: palette.neutralMinus4On }),
            td: {
                verticalAlign: "top",
                padding: spacing.smallPlus,
                border: `${spacing.tiny} solid ${palette.neutral}`
            },
            img: {
                maxWidth: "100%"
            },
            iframe: {
                maxWidth: "100%"
            },
            h1: Object.assign(Object.assign({}, fonts.xLarge), { color: palette.primary, margin: `0 0 ${spacing.smallPlus} 0`, lineHeight: sizes.normalPlus, position: "relative" }),
            h2: Object.assign(Object.assign({}, fonts.large), { color: palette.primary, margin: `0 0 ${spacing.smallPlus} 0`, lineHeight: sizes.normalPlus, position: "relative" }),
            h3: Object.assign(Object.assign({}, fonts.mediumPlus), { color: palette.primary, margin: `0 0 ${spacing.smallPlus} 0`, lineHeight: sizes.normalPlus, position: "relative" }),
            h4: Object.assign(Object.assign({}, fonts.medium), { margin: `0 0 ${spacing.smallPlus} 0`, position: "relative", lineHeight: sizes.normalPlus }),
            h5: Object.assign(Object.assign({}, fonts.medium), { margin: `0 0 ${spacing.smallPlus} 0`, position: "relative", lineHeight: sizes.normalPlus }),
            h6: Object.assign(Object.assign({}, fonts.medium), { margin: `0 0 ${spacing.smallPlus} 0`, position: "relative", lineHeight: sizes.normalPlus }),
            p: {
                marginBottom: spacing.medium,
            },
            a: {
                color: palette.primary,
                '&:hover': {
                    color: palette.primaryPlus2,
                },
                '&:visited': {
                    color: palette.primaryPlus2,
                },
                '&:active': {
                    color: palette.primaryPlus2,
                },
            },
        } })
}));
const PageContent = ({ config, config: { consumes, provides, props } }) => {
    const { formatProvider, maxNavHeading = "h3" } = props !== null && props !== void 0 ? props : {};
    const headingId = react_hooks_1.useId('heading');
    const container = react_1.useRef(null);
    const contentFormatter = smarthub_common_1.useContentFormat(formatProvider);
    const handleAction = smarthub_common_1.useHandleCommand();
    const styles = useStyles();
    const page = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"));
    const heading = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "heading"));
    const setHeadings = smarthub_common_1.useSetSharedState(provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == "headings"));
    const [content, setContent] = react_1.useState(null);
    react_1.useEffect(() => {
        const current = document.getElementsByClassName(styles.selected);
        if (current.length)
            current.item(0).classList.remove(styles.selected);
        const next = document.getElementById(heading);
        if (next) {
            next.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest"
            });
            next.classList.add(styles.selected);
        }
    }, [heading]);
    react_1.useEffect(() => {
        var _a;
        if (page === null || page === void 0 ? void 0 : page.content) {
            let contentIs = '';
            if (Array.isArray(page === null || page === void 0 ? void 0 : page.content)) {
                const namedContent = (props === null || props === void 0 ? void 0 : props.name) ? filterContentByName(page === null || page === void 0 ? void 0 : page.content, props === null || props === void 0 ? void 0 : props.name) : page === null || page === void 0 ? void 0 : page.content;
                contentIs = namedContent.map(content => content.text).join(' ');
            }
            else {
                contentIs = (_a = page === null || page === void 0 ? void 0 : page.content) === null || _a === void 0 ? void 0 : _a.text;
            }
            contentFormatter(contentIs, { headingId, maxNavHeading }).then(result => {
                setHeadings(result.headings);
                setContent(result.content);
            });
        }
    }, [page, headingId]);
    const filterContentByName = (content, name) => {
        let res = [];
        if (typeof name === 'string') { // To handle string prop name Eg: name: "content"
            res = content.filter((el) => (el === null || el === void 0 ? void 0 : el.name) == name);
        }
        else { // To handle Array name prop Eg: name:["servicesImpacted1","servicesImpacted2"], 
            res = content.filter(data => {
                return name.find(element => {
                    return element === (data === null || data === void 0 ? void 0 : data.name);
                });
            });
        }
        return res;
    };
    const handleLink = react_1.useCallback((e) => {
        var _a, _b;
        let target = e.target;
        if (e.type == 'keypress' && e.keyCode != react_2.KeyCodes.enter)
            return;
        while (target != container.current && target.tagName != 'A') {
            target = target.parentElement;
        }
        if (target.tagName != 'A')
            return;
        e.stopPropagation();
        e.preventDefault();
        const action = ((_b = (_a = target.dataset) === null || _a === void 0 ? void 0 : _a.action) === null || _b === void 0 ? void 0 : _b.length) ? JSON.parse(target.dataset.action)
            : {
                $schema: smarthub_common_1.RouteActionSchema,
                uri: target.href
            };
        handleAction(action);
    }, []);
    return react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { config: config, hasContent: (content === null || content === void 0 ? void 0 : content.length) > 0 }, content && react_1.default.createElement("div", { ref: container, className: styles.page, onClickCapture: handleLink, onKeyPressCapture: handleLink, dangerouslySetInnerHTML: { __html: content } }))), [content, styles]);
};
exports.PageContent = PageContent;


/***/ }),

/***/ "./src/content/page/page-header.component.tsx":
/*!****************************************************!*\
  !*** ./src/content/page/page-header.component.tsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageHeader = exports.useStyles = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_hooks_1 = __webpack_require__(/*! @fluentui/react-hooks */ "@fluentui/react-hooks");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const relativeTime_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/relativeTime */ "dayjs/plugin/relativeTime"));
dayjs_1.default.extend(relativeTime_1.default);
exports.useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing }) => ({
    lines: Object.assign(Object.assign({}, fonts.normal), { display: "flex", alignItems: "center", margin: spacing.medium, gap: spacing.xxLarge, flexWrap: "wrap", "& div": {
            display: "flex",
            width: "auto",
            alignItems: "center",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "el",
            "& i": {
                verticalAlign: "middle",
                marginRight: spacing.smallPlus
            },
            "& span": {
                verticalAlign: "middle",
            },
        } })
}));
const PageHeader = ({ config, data }) => {
    const { children = [], consumes } = config;
    const tooltipId = react_hooks_1.useId('tooltip');
    const panelStyles = smarthub_common_1.usePanelStyles();
    const styles = exports.useStyles();
    const render = smarthub_common_1.useRender();
    const localize = smarthub_common_1.useLocalizeConfig();
    const gridStyles = smarthub_common_1.useGridStyles();
    const page = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'page'));
    //TODO remove line.format below - AES should enable this transform.
    return react_1.useMemo(() => {
        var _a;
        const { menu, nav } = children.reduce((named, component) => {
            named[component.$id] = component;
            return named;
        }, {});
        return react_1.default.createElement("header", { className: panelStyles.header },
            react_1.default.createElement("div", { className: gridStyles.grid },
                react_1.default.createElement("div", { className: gridStyles.row },
                    react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.smmin12].join(" ") },
                        menu && render(menu, null, core_1.PanelSidebarButton)(),
                        page && react_1.default.createElement("div", null,
                            react_1.default.createElement("h1", { className: panelStyles.title, "aria-label": localize.pageTitleLabel }, page.title),
                            react_1.default.createElement("div", { className: styles.lines }, (_a = page.lines) === null || _a === void 0 ? void 0 : _a.map((line, idx) => (react_1.default.createElement(react_2.TooltipHost, { key: idx, content: `${line.label} ${line.text}`, id: `${tooltipId}-line-${idx}` },
                                react_1.default.createElement("div", { "aria-describedby": `${tooltipId}-line-${idx}` },
                                    react_1.default.createElement(react_2.Icon, { iconName: line.icon }),
                                    react_1.default.createElement("span", null, line.format == 'span'
                                        ? dayjs_1.default(line.text).fromNow()
                                        : line.text)))))))),
                    react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.smmin12].join(" ") }, nav && render(nav, data, core_1.TabNavigation)()))));
    }, [config, data, panelStyles, page]);
};
exports.PageHeader = PageHeader;


/***/ }),

/***/ "./src/content/page/page-metadata.component/index.ts":
/*!***********************************************************!*\
  !*** ./src/content/page/page-metadata.component/index.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageListing = exports.PageMetadata = exports.PageLinks = exports.PageDate = exports.PageUser = exports.PageMap = exports.PageLocation = exports.PageImage = exports.PageDetails = exports.PageCategory = void 0;
var page_category_component_1 = __webpack_require__(/*! ./page-category.component */ "./src/content/page/page-metadata.component/page-category.component.tsx");
Object.defineProperty(exports, "PageCategory", ({ enumerable: true, get: function () { return page_category_component_1.PageCategory; } }));
var page_details_component_1 = __webpack_require__(/*! ./page-details.component */ "./src/content/page/page-metadata.component/page-details.component.tsx");
Object.defineProperty(exports, "PageDetails", ({ enumerable: true, get: function () { return page_details_component_1.PageDetails; } }));
var page_image_component_1 = __webpack_require__(/*! ./page-image.component */ "./src/content/page/page-metadata.component/page-image.component.tsx");
Object.defineProperty(exports, "PageImage", ({ enumerable: true, get: function () { return page_image_component_1.PageImage; } }));
var page_location_component_1 = __webpack_require__(/*! ./page-location.component */ "./src/content/page/page-metadata.component/page-location.component.tsx");
Object.defineProperty(exports, "PageLocation", ({ enumerable: true, get: function () { return page_location_component_1.PageLocation; } }));
var page_map_component_1 = __webpack_require__(/*! ./page-map.component */ "./src/content/page/page-metadata.component/page-map.component.tsx");
Object.defineProperty(exports, "PageMap", ({ enumerable: true, get: function () { return page_map_component_1.PageMap; } }));
var page_user_component_1 = __webpack_require__(/*! ./page-user.component */ "./src/content/page/page-metadata.component/page-user.component.tsx");
Object.defineProperty(exports, "PageUser", ({ enumerable: true, get: function () { return page_user_component_1.PageUser; } }));
var page_date_component_1 = __webpack_require__(/*! ./page-date.component */ "./src/content/page/page-metadata.component/page-date.component.tsx");
Object.defineProperty(exports, "PageDate", ({ enumerable: true, get: function () { return page_date_component_1.PageDate; } }));
var page_links_component_1 = __webpack_require__(/*! ./page-links.component */ "./src/content/page/page-metadata.component/page-links.component.tsx");
Object.defineProperty(exports, "PageLinks", ({ enumerable: true, get: function () { return page_links_component_1.PageLinks; } }));
var page_metadata_component_1 = __webpack_require__(/*! ./page-metadata.component */ "./src/content/page/page-metadata.component/page-metadata.component.tsx");
Object.defineProperty(exports, "PageMetadata", ({ enumerable: true, get: function () { return page_metadata_component_1.PageMetadata; } }));
var page_listing_component_1 = __webpack_require__(/*! ./page-listing.component */ "./src/content/page/page-metadata.component/page-listing.component.tsx");
Object.defineProperty(exports, "PageListing", ({ enumerable: true, get: function () { return page_listing_component_1.PageListing; } }));


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-category.component.tsx":
/*!******************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-category.component.tsx ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageCategory = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const page_listing_component_1 = __webpack_require__(/*! ./page-listing.component */ "./src/content/page/page-metadata.component/page-listing.component.tsx");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const PageCategory = ({ config, config: { consumes, props: { types, headerAlign } = {} }, data }) => {
    var _a;
    const page = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"))) !== null && _a !== void 0 ? _a : data;
    return react_1.useMemo(() => react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement(page_listing_component_1.PageListing, { horizontal: true, groups: page === null || page === void 0 ? void 0 : page.categoryGroups, headerAlign: headerAlign, types: types }, (group, { id, label, text }) => react_1.default.createElement(utilities_1.Tag, { key: id, tagInfo: {
                label,
                text
            } }))), [page]);
};
exports.PageCategory = PageCategory;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-date.component.tsx":
/*!**************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-date.component.tsx ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageDate = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const page_styles_1 = __webpack_require__(/*! ./page.styles */ "./src/content/page/page-metadata.component/page.styles.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const PageDate = ({ config, config: { consumes }, data }) => {
    var _a;
    const localize = smarthub_common_1.useLocalizeConfig();
    const activityStyles = smarthub_common_1.useFluentStylesWithProps(page_styles_1.activityStyles);
    const styles = page_styles_1.useSectionStyles();
    const page = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"))) !== null && _a !== void 0 ? _a : data;
    return react_1.useMemo(() => {
        var _a;
        return react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.sectionContent }, (_a = page === null || page === void 0 ? void 0 : page.dates) === null || _a === void 0 ? void 0 : _a.map((d, i) => (react_1.default.createElement(react_2.ActivityItem, { key: `${d.text}${i}`, styles: activityStyles, activityDescription: [
                react_1.default.createElement("span", { key: 1 },
                    d.label,
                    " "),
                react_1.default.createElement("span", { key: 2 }, d.text)
            ], activityIcon: d.icon
                ? react_1.default.createElement(react_2.Icon, { iconName: d.icon })
                : null }))));
    }, [page, localize]);
};
exports.PageDate = PageDate;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-details.component.tsx":
/*!*****************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-details.component.tsx ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageDetails = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const page_listing_component_1 = __webpack_require__(/*! ./page-listing.component */ "./src/content/page/page-metadata.component/page-listing.component.tsx");
const page_styles_1 = __webpack_require__(/*! ./page.styles */ "./src/content/page/page-metadata.component/page.styles.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const fluentStyles = (({ theme: { spacing, sizes } }) => ({
    iconStyles: {
        root: {
            lineHeight: sizes.normal
        }
    },
    buttonStyles: {
        root: {
            marginLeft: spacing.smallPlus,
            minHeight: sizes.normal,
            height: "auto"
        }
    }
}));
const PageDetails = ({ config, config: { consumes, props: { types, headerAlign } = {} }, data }) => {
    var _a;
    const page = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"))) !== null && _a !== void 0 ? _a : data;
    const { iconStyles, buttonStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const styles = page_styles_1.useSectionStyles();
    const handleAction = smarthub_common_1.useHandleCommand();
    return react_1.useMemo(() => react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement(page_listing_component_1.PageListing, { groups: page === null || page === void 0 ? void 0 : page.detailGroups, headerAlign: headerAlign, types: types }, (group, { icon, label, text, action, otherText }, idx) => (action
            ? react_1.default.createElement("div", { className: [styles.row, styles.padLeft, idx == 0 ? styles.first : ''].join(' ') },
                react_1.default.createElement(react_2.PrimaryButton, { styles: buttonStyles, iconProps: icon ? { iconName: icon } : null, title: text, ariaLabel: text, text: text, onClick: () => handleAction(action) }))
            : react_1.default.createElement("div", { className: [styles.row, idx == 0 ? styles.first : ''].join(' ') },
                icon && react_1.default.createElement(react_2.Icon, { styles: iconStyles, iconName: icon }),
                react_1.default.createElement("div", { className: styles.content },
                    label && react_1.default.createElement(react_2.Label, null,
                        label,
                        ": "),
                    react_1.default.createElement("div", { className: styles.text },
                        react_1.default.createElement(react_2.Text, null, text), otherText === null || otherText === void 0 ? void 0 :
                        otherText.map((text, i) => {
                            return react_1.default.createElement(react_2.Text, { key: i, block: true }, text);
                        }))))))), [page, config]);
};
exports.PageDetails = PageDetails;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-image.component.tsx":
/*!***************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-image.component.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageImage = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const image_1 = __webpack_require__(/*! ../../image */ "./src/content/image/index.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const PageImage = ({ config, config: { consumes, props }, data }) => {
    var _a, _b, _c;
    const { imageType, height, width, fit, orientation } = props;
    const page = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"))) !== null && _a !== void 0 ? _a : data;
    const { uri, label, description } = (_c = (_b = page === null || page === void 0 ? void 0 : page.images) === null || _b === void 0 ? void 0 : _b.find(i => i.type == imageType)) !== null && _c !== void 0 ? _c : {};
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config }, (uri === null || uri === void 0 ? void 0 : uri.length) > 0 && react_1.default.createElement(image_1.ImageEmbed, { uri: uri, height: height, width: width, fit: fit, orientation: orientation, alt: label, description: description })));
};
exports.PageImage = PageImage;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-links.component.tsx":
/*!***************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-links.component.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageLinks = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const page_styles_1 = __webpack_require__(/*! ./page.styles */ "./src/content/page/page-metadata.component/page.styles.ts");
const page_listing_component_1 = __webpack_require__(/*! ./page-listing.component */ "./src/content/page/page-metadata.component/page-listing.component.tsx");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const PageLinks = ({ config, config: { consumes, props: { types, headerAlign } = {} }, data }) => {
    var _a;
    const styles = page_styles_1.useSectionStyles();
    const groupedLinkStyles = smarthub_common_1.useFluentStylesWithProps(page_styles_1.groupedLinkStyles);
    const page = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"))) !== null && _a !== void 0 ? _a : data;
    const handleAction = smarthub_common_1.useHandleCommand();
    const handleLink = react_1.useCallback((e) => {
        if ((e.type == 'keypress' && e.keyCode != react_2.KeyCodes.enter))
            return;
        e.stopPropagation();
        e.preventDefault();
        const action = {
            $id: "",
            $schema: smarthub_common_1.RouteActionSchema,
            uri: e.currentTarget.href
        };
        handleAction(action);
    }, []);
    return react_1.useMemo(() => react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement(page_listing_component_1.PageListing, { groups: page === null || page === void 0 ? void 0 : page.linkGroups, headerAlign: headerAlign, types: types }, ({ icon }, { uri, text }, idx) => react_1.default.createElement("div", { className: [styles.row, , idx == 0 ? styles.first : ''].join(' ') },
            (icon === null || icon === void 0 ? void 0 : icon.length) > 0 && react_1.default.createElement(react_2.Icon, { iconName: icon }),
            react_1.default.createElement(react_2.Link, { href: uri, key: idx, title: `${text}`, "aria-label": `${text}`, styles: groupedLinkStyles, onClick: handleLink, onKeyPress: handleLink, target: "_blank" }, text)))), [page]);
};
exports.PageLinks = PageLinks;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-listing.component.tsx":
/*!*****************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-listing.component.tsx ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageListing = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const fluentStyles = (({ theme: { spacing, sizes } }) => ({
    stackStyles: {
        root: {
            padding: `0 ${spacing.medium} ${spacing.medium} ${spacing.medium}`
        },
        inner: {
            gap: spacing.smallPlus,
        }
    },
    iconStyles: {
        root: {
            marginRight: spacing.smallPlus
        }
    },
    sepStyles: {
        content: {
            lineHeight: sizes.normal
        }
    }
}));
const PageListing = ({ types, headerAlign, groups, horizontal, className, children }) => {
    const { iconStyles, sepStyles, stackStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    return react_1.default.createElement(react_2.Stack, { horizontal: horizontal == true, wrap: true }, groups === null || groups === void 0 ? void 0 : groups.filter(g => {
        var _a;
        return ((_a = g === null || g === void 0 ? void 0 : g.list) === null || _a === void 0 ? void 0 : _a.length) > 0
            && (!(types === null || types === void 0 ? void 0 : types.length)
                || ~types.indexOf(g.type));
    }).map((g, i) => {
        var _a, _b;
        return react_1.default.createElement(react_2.StackItem, { key: i },
            ((_a = g.text) === null || _a === void 0 ? void 0 : _a.length) > 0 && react_1.default.createElement(react_2.Separator, { styles: sepStyles, alignContent: headerAlign !== null && headerAlign !== void 0 ? headerAlign : 'start' },
                ((_b = g.icon) === null || _b === void 0 ? void 0 : _b.length) > 0 && react_1.default.createElement(react_2.Icon, { styles: iconStyles, iconName: g.icon }),
                react_1.default.createElement("span", null, g.text)),
            react_1.default.createElement(react_2.Stack, { styles: stackStyles, horizontal: horizontal == true, wrap: true }, g.list.map((item, idx) => react_1.default.createElement(react_2.StackItem, { key: idx }, children(g, item, idx)))));
    }));
};
exports.PageListing = PageListing;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-location.component.tsx":
/*!******************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-location.component.tsx ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageLocation = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const page_styles_1 = __webpack_require__(/*! ./page.styles */ "./src/content/page/page-metadata.component/page.styles.ts");
const page_helper_1 = __webpack_require__(/*! ./page.helper */ "./src/content/page/page-metadata.component/page.helper.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const PageLocation = ({ config, config: { consumes }, data }) => {
    var _a;
    const localize = smarthub_common_1.useLocalizeConfig();
    const handleCommand = smarthub_common_1.useHandleCommand();
    const styles = page_styles_1.useSectionStyles();
    const activityStyles = smarthub_common_1.useFluentStylesWithProps(page_styles_1.activityStyles);
    const page = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"))) !== null && _a !== void 0 ? _a : data;
    return react_1.useMemo(() => {
        var _a;
        return react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.sectionContent }, (_a = page === null || page === void 0 ? void 0 : page.locations) === null || _a === void 0 ? void 0 : _a.map((p, i) => (react_1.default.createElement(react_2.ActivityItem, { key: `${p.text}${i}`, styles: activityStyles, activityDescription: [
                react_1.default.createElement("span", { key: 1 },
                    p.label,
                    " "),
                react_1.default.createElement(react_2.Link, { key: 2, onClick: () => handleCommand(p.action), styles: page_styles_1.linkStyles, title: p.text, "aria-label": p.text }, p.text),
            ], timeStamp: p.date, activityPersonas: [{
                    text: p.text,
                    imageInitials: page_helper_1.getInitials(p.text),
                    onClick: () => handleCommand(p.action)
                }] }))));
    }, [page, localize]);
};
exports.PageLocation = PageLocation;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-map.component.tsx":
/*!*************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-map.component.tsx ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageMap = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const map_1 = __webpack_require__(/*! ../../map */ "./src/content/map/index.ts");
const page_styles_1 = __webpack_require__(/*! ./page.styles */ "./src/content/page/page-metadata.component/page.styles.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const PageMap = ({ config, config: { consumes, props }, data }) => {
    var _a;
    const { height, width } = props;
    const styles = page_styles_1.useSectionStyles();
    const page = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"))) !== null && _a !== void 0 ? _a : data;
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.sectionContent }, (page === null || page === void 0 ? void 0 : page.geoLocation) && react_1.default.createElement(map_1.MapEmbed, { location: page.geoLocation, height: height, width: width })));
};
exports.PageMap = PageMap;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-metadata.component.tsx":
/*!******************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-metadata.component.tsx ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageMetadata = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const page_category_component_1 = __webpack_require__(/*! ./page-category.component */ "./src/content/page/page-metadata.component/page-category.component.tsx");
const page_details_component_1 = __webpack_require__(/*! ./page-details.component */ "./src/content/page/page-metadata.component/page-details.component.tsx");
const page_image_component_1 = __webpack_require__(/*! ./page-image.component */ "./src/content/page/page-metadata.component/page-image.component.tsx");
const page_location_component_1 = __webpack_require__(/*! ./page-location.component */ "./src/content/page/page-metadata.component/page-location.component.tsx");
const page_map_component_1 = __webpack_require__(/*! ./page-map.component */ "./src/content/page/page-metadata.component/page-map.component.tsx");
const page_user_component_1 = __webpack_require__(/*! ./page-user.component */ "./src/content/page/page-metadata.component/page-user.component.tsx");
const page_date_component_1 = __webpack_require__(/*! ./page-date.component */ "./src/content/page/page-metadata.component/page-date.component.tsx");
const page_links_component_1 = __webpack_require__(/*! ./page-links.component */ "./src/content/page/page-metadata.component/page-links.component.tsx");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const PageMetadata = ({ config, config: { consumes, children = [], props = {} }, }) => {
    const { horizontal, wrap } = props;
    const render = smarthub_common_1.useRender();
    const page = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"));
    return react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement(react_2.Stack, { horizontal: horizontal, wrap: wrap }, children.map((child) => {
            const fallback = child.$id == "category"
                ? page_category_component_1.PageCategory
                : child.$id == "details"
                    ? page_details_component_1.PageDetails
                    : child.$id == "image"
                        ? page_image_component_1.PageImage
                        : child.$id == "location"
                            ? page_location_component_1.PageLocation
                            : child.$id == "map"
                                ? page_map_component_1.PageMap
                                : child.$id == "user"
                                    ? page_user_component_1.PageUser
                                    : child.$id == "date"
                                        ? page_date_component_1.PageDate
                                        : child.$id == "links"
                                            ? page_links_component_1.PageLinks
                                            : null;
            return (react_1.default.createElement(react_2.StackItem, { key: child.$id, grow: true, shrink: true }, render(child, page, fallback)()));
        })))), [page]);
};
exports.PageMetadata = PageMetadata;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page-user.component.tsx":
/*!**************************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page-user.component.tsx ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageUser = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const page_styles_1 = __webpack_require__(/*! ./page.styles */ "./src/content/page/page-metadata.component/page.styles.ts");
const page_helper_1 = __webpack_require__(/*! ./page.helper */ "./src/content/page/page-metadata.component/page.helper.ts");
const core_1 = __webpack_require__(/*! ../../../core */ "./src/core/index.ts");
const PageUser = ({ config, config: { consumes }, data }) => {
    var _a;
    const activityStyles = smarthub_common_1.useFluentStylesWithProps(page_styles_1.activityStyles);
    const localize = smarthub_common_1.useLocalizeConfig();
    const handleCommand = smarthub_common_1.useHandleCommand();
    const styles = page_styles_1.useSectionStyles();
    const page = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"))) !== null && _a !== void 0 ? _a : data;
    return react_1.useMemo(() => {
        var _a;
        return react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.sectionContent }, (_a = page === null || page === void 0 ? void 0 : page.users) === null || _a === void 0 ? void 0 : _a.map((p, i) => (react_1.default.createElement(react_2.ActivityItem, { key: `${p.text}${i}`, styles: activityStyles, activityDescription: [
                react_1.default.createElement("span", { key: 1 },
                    p.label,
                    " "),
                react_1.default.createElement(react_2.Link, { key: 2, onClick: () => handleCommand(p.action), styles: page_styles_1.linkStyles, title: p.text, "aria-label": p.text }, p.text),
            ], timeStamp: p.date, activityPersonas: [{
                    imageUrl: p.image,
                    text: p.text,
                    imageInitials: page_helper_1.getInitials(p.text),
                    onClick: () => handleCommand(p.action)
                }] }))));
    }, [page, localize]);
};
exports.PageUser = PageUser;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page.helper.ts":
/*!*****************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page.helper.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getInitials = void 0;
const getInitials = (text) => {
    if (!(text === null || text === void 0 ? void 0 : text.length))
        return null;
    const letters = text.match(/([^A-Z]|^)([A-Z])/g);
    return `${letters[0]}${letters.length > 1 ? letters[letters.length - 1] : ''}`;
};
exports.getInitials = getInitials;


/***/ }),

/***/ "./src/content/page/page-metadata.component/page.styles.ts":
/*!*****************************************************************!*\
  !*** ./src/content/page/page-metadata.component/page.styles.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLinkStyles = exports.groupedLinkStyles = exports.useSectionStyles = exports.activityStyles = exports.linkStyles = void 0;
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
exports.linkStyles = {
    root: {
        fontWeight: 600
    }
};
exports.activityStyles = (({ theme: { palette, spacing, fonts } }) => ({
    root: {
        marginBottom: spacing.medium
    },
    activityContent: {
        alignSelf: "center"
    },
    activityText: Object.assign(Object.assign({}, fonts.normal), { display: "block", color: palette.neutralEmptyOn }),
    activityTypeIcon: {
        height: "100%",
        alignSelf: "center"
    },
    timeStamp: {
        color: palette.neutralEmptyOn
    }
}));
exports.useSectionStyles = react_jss_1.createUseStyles(({ spacing }) => ({
    section: {
        padding: `0 ${spacing.medium} ${spacing.medium} ${spacing.medium}`,
    },
    sectionContent: {
        padding: spacing.medium,
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap"
    },
    padLeft: {
        paddingLeft: spacing.mediumPlus,
    },
    first: {},
    row: {
        display: "flex",
        gap: spacing.small,
        paddingTop: spacing.normal,
        ["&$first"]: {
            paddingTop: 0,
        }
    },
    content: {
        display: "flex",
        flex: "1 1",
        justifyContent: "space-between",
        gap: spacing.small,
        flexWrap: "wrap"
    },
    text: {
        display: "flex",
        padding: `${spacing.small} 0`,
        flexDirection: "column"
    }
}));
const groupedLinkStyles = ({ theme: { spacing } }) => ({
    root: {
        marginBottom: spacing.small,
    }
});
exports.groupedLinkStyles = groupedLinkStyles;
exports.useLinkStyles = react_jss_1.createUseStyles(({ spacing }) => ({
    links: {
        display: "flex",
        flexDirection: "column"
    },
    group: {
        marginBottom: spacing.small,
        fontWeight: 600
    }
}));


/***/ }),

/***/ "./src/content/page/page-nav.component.tsx":
/*!*************************************************!*\
  !*** ./src/content/page/page-nav.component.tsx ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageNav = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const navStyles = {
    root: {
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        overflowY: 'auto',
    },
    linkText: {
        whiteSpace: "normal",
        lineHeight: "normal",
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": "2",
    },
    chevronButton: {
        margin: 0
    },
    groupContent: {
        marginBottom: 0
    }
};
const transformHeadings = (headings, localize, expanded) => {
    return headings
        ? headings
            .map(({ text, id, children }) => ({
            name: `${text}`,
            ariaLabel: `${localize.pageNavLinkLabel} ${text}`,
            title: `${localize.pageNavLinkLabel} ${text}`,
            url: '',
            key: id,
            target: '_blank',
            links: transformHeadings(children, localize, expanded),
            collapseAriaLabel: `${localize.collapseLabel} ${text}`,
            expandAriaLabel: `${localize.expandLabel} ${text}`,
            isExpanded: expanded
        }))
        : null;
};
const PageNav = ({ config, config: { description, consumes, provides, props: { expanded } = { expanded: false } } }) => {
    const localize = smarthub_common_1.useLocalizeConfig();
    const headings = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "headings"));
    const heading = smarthub_common_1.useReadSharedState(provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == "heading"));
    const setHeading = smarthub_common_1.useSetSharedState(provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == "heading"));
    const onClick = react_1.useCallback((e, item) => {
        setHeading(item.key);
    }, [setHeading]);
    const links = react_1.useMemo(() => {
        return headings
            ? transformHeadings(headings, localize, expanded)
            : null;
    }, [headings]);
    return react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { hasContent: (links === null || links === void 0 ? void 0 : links.length) > 0, config: config }, links && react_1.default.createElement(react_2.Nav, { selectedKey: heading, styles: navStyles, onLinkClick: onClick, ariaLabel: description, groups: [{ links }] }))), [links, heading]);
};
exports.PageNav = PageNav;


/***/ }),

/***/ "./src/content/page/page-view-embed.component.tsx":
/*!********************************************************!*\
  !*** ./src/content/page/page-view-embed.component.tsx ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageViewEmbed = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles({
    viewer: ({ width, height }) => ({
        position: "relative",
        flex: "1 1",
        width: (width === null || width === void 0 ? void 0 : width.length) ? width : "100%",
        height: (height === null || height === void 0 ? void 0 : height.length) ? height : "100%",
        background: "transparent",
    }),
    frame: {
        height: "100%",
        width: "100%",
        border: "0"
    }
});
const PageViewEmbed = ({ uri, width, key, height }) => {
    const useWebView = navigator.userAgent.toLowerCase().indexOf(' electron/') > 0;
    const styles = useStyles({ width, height });
    return (react_1.default.createElement("div", { className: styles.viewer },
        !useWebView &&
            react_1.default.createElement("iframe", { key: key, src: uri, allowFullScreen: true, className: styles.frame }),
        useWebView &&
            react_1.default.createElement("webview", { key: key, src: uri, allowFullScreen: true, className: styles.frame })));
};
exports.PageViewEmbed = PageViewEmbed;


/***/ }),

/***/ "./src/content/page/page-view.component.tsx":
/*!**************************************************!*\
  !*** ./src/content/page/page-view.component.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageView = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const page_view_embed_component_1 = __webpack_require__(/*! ./page-view-embed.component */ "./src/content/page/page-view-embed.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles({
    wrapper: {
        display: 'flex',
        height: '100%',
    }
});
const PageView = ({ config, config: { consumes, props } }) => {
    var _a;
    const page = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "page"));
    const styles = useStyles();
    let uri = ((_a = page === null || page === void 0 ? void 0 : page.uri) === null || _a === void 0 ? void 0 : _a.length) ? page.uri : props === null || props === void 0 ? void 0 : props.uri;
    const message = smarthub_common_1.useLocalize(smarthub_common_1.LocalizeKeys.pageError);
    const error = !(uri === null || uri === void 0 ? void 0 : uri.length)
        ? {
            message
        }
        : undefined;
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.wrapper, error: error }, (uri === null || uri === void 0 ? void 0 : uri.length) && react_1.default.createElement(page_view_embed_component_1.PageViewEmbed, { uri: uri })));
};
exports.PageView = PageView;


/***/ }),

/***/ "./src/content/preferences/banner-image-selector.component.tsx":
/*!*********************************************************************!*\
  !*** ./src/content/preferences/banner-image-selector.component.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BannerImageSelector = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const fluentStyles = (({ theme: { spacing } }) => ({
    selectButtonStyles: {
        root: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            maxWidth: "none",
            display: "flex",
            justifyContent: "center"
        },
        flexContainer: {
            alignItems: "center",
            minWidth: "auto"
        }
    },
    imageStyles: {
        root: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            overflow: "hidden",
            borderRadius: spacing.xSmall
        },
        image: {
            maxWidth: "100%",
            position: "absolute",
            top: "50%",
            transform: "translate(0%, -50%)"
        }
    }
}));
const useStyles = react_jss_1.createUseStyles(({ spacing }) => ({
    root: {
        padding: spacing.medium,
    },
    imageContainer: {
        position: "relative",
        width: "100%",
        paddingTop: "20%"
    },
    buttons: {
        width: "100%",
        display: "flex",
        gap: spacing.smallPlus,
        justifyContent: "flex-end",
        marginTop: spacing.medium
    }
}));
const UploadResultSchema = "https://ics.ai/smarthub/file/upload-result";
const BannerImageSelector = ({ config, config: { query, props: { maxSize } = { maxSize: 0 } } }) => {
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const { queries } = query;
    const [imageRef, setImageRef] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys.userBannerImage, true);
    const [imageUri, setImageUri] = react_1.useState(null);
    const styles = useStyles();
    const { imageStyles, selectButtonStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const [upload, download] = smarthub_common_1.useFile();
    const transform = smarthub_common_1.useTransform();
    const fileRef = react_1.useRef(null);
    const [error, setError] = react_1.useState(null);
    const selectFile = react_1.useCallback(({ currentTarget }, newValue) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        setError(null);
        const file = (currentTarget).files[0];
        const { name, size, type } = file;
        if (maxSize && size > maxSize) {
            setError(localizeConfig.imageSelectSizeError);
            return;
        }
        if (!type.match(/image.*/)) {
            setError(localizeConfig.imageSelectTypeError);
            return;
        }
        const uploadQuery = queries.find(({ id }) => id == 'upload');
        const { data } = yield upload(file, uploadQuery, { name, size, type });
        const result = transform(UploadResultSchema, data);
        setImageRef(result);
    }), []);
    const remove = react_1.useCallback(() => {
        setImageRef(null);
    }, []);
    react_1.useEffect(() => {
        if (imageRef)
            (() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                const query = queries.find(({ id }) => id == 'download');
                const { uri } = yield download(query, 'dataUri', imageRef);
                setImageUri(uri);
            }))();
        else
            setImageUri(null);
    }, [imageRef]);
    const chooseFile = react_1.useCallback(() => {
        fileRef.current.click();
    }, []);
    return react_1.default.createElement(core_1.ComponentChrome, { config: config, className: styles.root },
        react_1.default.createElement("input", { accept: "image/*", ref: fileRef, hidden: true, type: "file", onChange: selectFile }),
        imageUri && react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: styles.imageContainer },
                react_1.default.createElement(react_2.Image, { src: imageUri, styles: imageStyles, coverStyle: react_2.ImageCoverStyle.landscape })),
            react_1.default.createElement("div", { className: styles.buttons }, imageUri &&
                react_1.default.createElement(react_2.DefaultButton, { ariaLabel: localizeConfig.imageRemoveLabel, title: localizeConfig.imageRemoveText, text: localizeConfig.imageRemoveText, label: localizeConfig.imageRemoveLabel, onClick: remove }))),
        !imageUri && react_1.default.createElement("div", { className: styles.imageContainer },
            react_1.default.createElement(react_2.CompoundButton, { styles: selectButtonStyles, iconProps: { iconName: 'PictureCenter' }, ariaLabel: localizeConfig.imageSelectText, title: localizeConfig.imageSelectText, label: localizeConfig.imageSelectLabel, text: localizeConfig.imageSelectText, secondaryText: localizeConfig.imageSelectSecondaryText, onClick: chooseFile })),
        error && react_1.default.createElement("span", null, error));
};
exports.BannerImageSelector = BannerImageSelector;


/***/ }),

/***/ "./src/content/preferences/index.ts":
/*!******************************************!*\
  !*** ./src/content/preferences/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./banner-image-selector.component */ "./src/content/preferences/banner-image-selector.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./theme-list.component */ "./src/content/preferences/theme-list.component.tsx"), exports);


/***/ }),

/***/ "./src/content/preferences/theme-list.component.tsx":
/*!**********************************************************!*\
  !*** ./src/content/preferences/theme-list.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ThemeList = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const theme_option_component_1 = __webpack_require__(/*! ./theme-option.component */ "./src/content/preferences/theme-option.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const buildLinks = (themes) => {
    return themes.map(({ $id, name, description, definition }) => ({
        name: name,
        key: $id,
        description: description,
        url: "",
        definition
    }));
};
const buildGroups = (themes, localize) => {
    const types = ['light', 'mid', 'dark', 'contrast', 'tone'];
    return types.reduce((groups, t) => {
        const typeThemes = themes.filter(({ definition: { type } }) => type == t);
        if (typeThemes.length)
            groups.push({
                name: localize[`${t}ThemeTypeTitle`],
                expandAriaLabel: `${localize.expandOptions}`,
                collapseAriaLabel: `${localize.collapseOptions}`,
                links: buildLinks(typeThemes)
            });
        return groups;
    }, []);
};
const ThemeList = ({ config, data }) => {
    const themes = smarthub_common_1.useThemes();
    const theme = smarthub_common_1.useTheme();
    const localize = smarthub_common_1.useLocalizeConfig();
    const options = react_1.useMemo(() => {
        return buildGroups(themes, localize);
    }, [themes, localize]);
    return react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement(react_2.Nav, { key: theme.$id, selectedKey: theme.name, groups: options, ariaLabel: localize.themeListLabel, linkAs: theme_option_component_1.ThemeOption }))), [options, localize]);
};
exports.ThemeList = ThemeList;


/***/ }),

/***/ "./src/content/preferences/theme-option.component.tsx":
/*!************************************************************!*\
  !*** ./src/content/preferences/theme-option.component.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ThemeOption = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const paletteNames = {
    primary: ["primaryEmpty", "primaryMinus4", "primaryMinus3", "primaryMinus2", "primaryMinus1", "primary", "primaryPlus1", "primaryPlus2", "primaryFull"],
    neutral: ["neutralEmpty", "neutralMinus4", "neutralMinus3", "neutralMinus2", "neutralMinus1", "neutral", "neutralPlus1", "neutralPlus3", "neutralFull"]
};
const useThemeStyles = react_jss_1.createUseStyles(({ fonts, spacing, sizes }) => ({
    theme: {
        borderRadius: spacing.small,
        display: "flex",
        overflow: "hidden",
        flexDirection: "column",
        margin: spacing.smallPlus,
        boxShadow: "rgb(0 0 0 / 13%) 0px 1.6px 3.6px 0px, rgb(0 0 0 / 11%) 0px 0.3px 0.9px 0px"
    },
    palette: {
        height: spacing.medium,
        display: "flex",
        marginTop: spacing.tiny,
        gap: spacing.tiny,
        ['@global div']: {
            flex: "1 1"
        }
    },
    title: Object.assign(Object.assign({}, fonts.mediumPlus), { borderTopLeftRadius: spacing.small, borderTopRightRadius: spacing.small, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", padding: `0 ${spacing.medium}`, lineHeight: sizes.mediumPlus }),
    content: {
        flex: "1 1",
        padding: spacing.medium,
        display: "flex",
        flexDirection: "column",
        gap: spacing.medium
    }
}));
const ThemeOption = ({ link: { name, key, description, definition: { palette } } }) => {
    const styles = useThemeStyles();
    const localize = smarthub_common_1.useLocalizeConfig();
    const setTheme = smarthub_common_1.useSetTheme();
    const setThemePref = smarthub_common_1.useSetPreference(smarthub_common_1.preferenceKeys.userTheme);
    const select = react_1.useCallback((e) => {
        setThemePref(key);
        setTheme(key);
    }, [setTheme, setThemePref]);
    return react_1.default.createElement("div", { className: styles.theme },
        react_1.default.createElement("div", { className: styles.title, style: {
                color: palette.primaryOn,
                backgroundColor: palette.primary
            } }, name),
        react_1.default.createElement("div", { style: {
                color: palette.neutralEmptyOn,
                backgroundColor: palette.neutralEmpty
            } },
            react_1.default.createElement("div", { className: styles.palette }, paletteNames.primary.map(c => react_1.default.createElement("div", { key: c, style: {
                    backgroundColor: palette[c]
                } }))),
            react_1.default.createElement("div", { className: styles.palette }, paletteNames.neutral.map(c => react_1.default.createElement("div", { key: c, style: {
                    color: palette[`${c}On`],
                    backgroundColor: palette[c]
                } }))),
            react_1.default.createElement("div", { className: styles.content },
                react_1.default.createElement("div", { style: {
                        color: palette.primary
                    } }, description),
                react_1.default.createElement(react_2.DefaultButton, { styles: {
                        root: {
                            border: 0,
                            backgroundColor: palette.primaryMinus2,
                            color: palette.primaryMinus2On,
                        }
                    }, "aria-label": localize.themeButtonLabel, title: localize.themeButtonLabel, text: localize.themeButtonText, onClick: select }))));
};
exports.ThemeOption = ThemeOption;


/***/ }),

/***/ "./src/content/profile/hierarchy-list.component.tsx":
/*!**********************************************************!*\
  !*** ./src/content/profile/hierarchy-list.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HierarchyPersonaList = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const hierarchy_persona_component_1 = __webpack_require__(/*! ./hierarchy-persona.component */ "./src/content/profile/hierarchy-persona.component.tsx");
const useHierachyStyles = react_jss_1.createUseStyles(({ palette, spacing, sizes }) => ({
    collapsed: {
        "& $personas": {
            flexDirection: "row",
        },
        "& $connector": {
            display: "none",
        },
        "& $listConnector": {
            display: "none",
        }
    },
    list: {
        paddingTop: spacing.xSmall,
        position: "relative",
        display: "flex",
        flexDirection: "column",
        "&$collapsed": {
            flexDirection: "row",
            alignItems: "center"
        },
    },
    container: {
        position: "relative",
        paddingTop: spacing.large
    },
    personas: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        gap: spacing.large,
    },
    persona: {
        display: "flex"
    },
    connector: {},
    button: {
        marginTop: spacing.large,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        gap: spacing.small,
        "&::before": {
            content: '""',
            height: spacing.xSmall,
            flex: "1 1",
            background: palette.neutral
        },
        "&::after": {
            content: '""',
            height: spacing.xSmall,
            flex: "1 1",
            background: palette.neutral
        },
        "$collapsed &": {
            "&::before": {
                content: "unset"
            },
            "&::after": {
                content: "unset"
            },
            justifyContent: "start",
            width: "auto",
        },
    },
    listConnector: {
        top: 0,
        width: spacing.xSmall,
        bottom: 0,
        position: "absolute",
        backgroundColor: palette.neutral,
        marginLeft: `calc((${sizes.mediumEm} - ${spacing.xSmall})/2)`
    },
    profileList: {
        "& $listConnector": {
            bottom: `calc(((${sizes.xLarge} + ${spacing.xSmall}) / 2) - ${spacing.xSmall})`
        },
        "& $connector": {
            width: sizes.smallPlus,
            marginTop: `calc((${sizes.xLarge} + ${spacing.xSmall}) / 2)`,
            height: spacing.xSmall,
            backgroundColor: palette.neutral,
            marginLeft: sizes.smallPlus
        }
    },
    managerList: {
        "& $container": {
            paddingTop: 0
        }
    },
    reportList: {
        paddingLeft: sizes.xLarge,
        "& $listConnector": {
            bottom: sizes.smallPlus
        },
        "& $connector": {
            width: sizes.smallPlus,
            height: spacing.xSmall,
            marginTop: spacing.large,
            border: 0,
            backgroundColor: palette.neutral,
            marginLeft: sizes.smallPlus
        }
    },
}));
const fluentStyles = (({ theme: { palette, sizes, spacing, fonts }, config: collapsed }) => ({
    button: {
        root: {
            borderRadius: sizes.medium,
            backgroundColor: palette.primary,
            width: sizes.medium,
            height: sizes.medium,
            marginLeft: collapsed ? spacing.large : 0
        },
        rootHovered: {
            backgroundColor: palette.primaryPlus2,
        },
        iconHovered: {
            color: palette.primaryPlus2On,
        },
        icon: {
            transition: "transform 0.1s linear 0s",
            color: palette.primaryOn,
            transform: collapsed ? "rotate(-180deg)" : undefined
        }
    },
    largeCoin: {
        coin: {
            border: `${spacing.xSmall} solid ${palette.neutral}`,
            backgroundColor: palette.neutralEmpty,
            borderRadius: sizes.xxLarge,
            minWidth: sizes.xxLarge,
            padding: spacing.xSmall,
            height: sizes.xxLarge,
            overflow: "hidden",
            boxSizing: "border-box",
            cursor: 'pointer',
        }
    },
    smallCoin: {
        coin: {
            border: `${spacing.xSmall} solid ${palette.neutral}`,
            backgroundColor: palette.neutralEmpty,
            borderRadius: sizes.mediumPlus,
            minWidth: sizes.mediumEm,
            padding: spacing.xSmall,
            height: sizes.mediumEm,
            overflow: "hidden",
            boxSizing: "border-box",
            cursor: 'pointer',
        }
    },
    persona: {
        secondaryText: {
            color: palette.neutralMinus5On
        },
        primaryText: {
            color: palette.neutralEmptyOn,
        },
        details: {
            display: collapsed ? "none" : undefined
        }
    },
    link: {
        root: Object.assign({}, fonts.normal)
    }
}));
const HierarchyPersonaList = ({ people, type, collapsable, initialCollapse }) => {
    const handeCommand = smarthub_common_1.useHandleCommand();
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const styles = useHierachyStyles();
    const [collapsed, setCollapse] = react_1.useState(initialCollapse);
    const hierarchyStyles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, collapsed);
    const [list, setList] = react_1.useState([]);
    react_1.useEffect(() => {
        if (people && collapsed)
            setList(people.slice(1, 4));
        else
            setList(people !== null && people !== void 0 ? people : []);
    }, [collapsed, people]);
    return react_1.default.createElement("div", { className: [styles.list, styles[`${type}List`], collapsed ? styles.collapsed : ''].join(' ') },
        react_1.default.createElement("div", { className: styles.container },
            react_1.default.createElement("div", { className: styles.listConnector }),
            react_1.default.createElement("div", { className: styles.personas }, list.map(p => react_1.default.createElement(hierarchy_persona_component_1.HierarchyPersona, { key: p.$id, fluentStyles: hierarchyStyles, person: p, type: type, handeCommand: handeCommand, localizeConfig: localizeConfig, styles: styles })))),
        list.length > 0 && collapsable && react_1.default.createElement("div", { className: styles.button },
            react_1.default.createElement(react_2.IconButton, { styles: hierarchyStyles.button, onClick: () => setCollapse(!collapsed), iconProps: { iconName: 'ChevronUp' } })));
};
exports.HierarchyPersonaList = HierarchyPersonaList;


/***/ }),

/***/ "./src/content/profile/hierarchy-persona.component.tsx":
/*!*************************************************************!*\
  !*** ./src/content/profile/hierarchy-persona.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HierarchyPersona = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const getCustomPrimaryTextRenderer = (action, linkStyles) => {
    return (props) => {
        return (react_1.default.createElement(utilities_1.ActionLink, { styles: linkStyles, "aria-label": props["aria-label"], title: props.title, action: action }, props.text));
    };
};
const HierarchyPersona = ({ person, type, styles, fluentStyles, handeCommand, localizeConfig }) => {
    const personaProps = {
        styles: fluentStyles.persona,
        size: type == 'profile' ? react_2.PersonaSize.size56 : react_2.PersonaSize.size40,
        coinProps: {
            styles: type == 'profile' ? fluentStyles.largeCoin : fluentStyles.smallCoin,
            onClick: () => handeCommand(person.action),
        },
        text: person.name,
        secondaryText: person.jobTitle,
        tertiaryText: person.department,
        imageUrl: person.image,
        imageAlt: person.name,
        title: `${localizeConfig.personaLinkTitle} ${person.name}`,
        "aria-label": `${localizeConfig.personaLinkAria} ${person.name}`,
        onRenderPrimaryText: getCustomPrimaryTextRenderer(person.action, fluentStyles.link)
    };
    return react_1.default.createElement("div", { className: styles.persona },
        react_1.default.createElement("div", { className: styles.connector }),
        react_1.default.createElement(react_2.Persona, Object.assign({}, personaProps)));
};
exports.HierarchyPersona = HierarchyPersona;


/***/ }),

/***/ "./src/content/profile/hierarchy.component.tsx":
/*!*****************************************************!*\
  !*** ./src/content/profile/hierarchy.component.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Hierarchy = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const hierarchy_list_component_1 = __webpack_require__(/*! ./hierarchy-list.component */ "./src/content/profile/hierarchy-list.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles(({ spacing }) => ({
    inner: {
        padding: `${spacing.smallPlus} ${spacing.medium}`,
        boxSizing: "border-box",
        maxWidth: "100%"
    }
}));
const Hierarchy = ({ config }) => {
    var _a;
    const { query, consumes } = config;
    const transform = smarthub_common_1.useTransform();
    const fetch = smarthub_common_1.useFetch();
    const styles = useStyles();
    const [data, setData] = react_1.useState({ managers: [], reports: [] });
    const currentProfile = smarthub_common_1.useProfile();
    const profile = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "profile"))) !== null && _a !== void 0 ? _a : currentProfile;
    react_1.useEffect(() => {
        const fetchData = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            try {
                const { data } = yield fetch(query, { profile });
                const managers = (_a = transform(smarthub_common_1.IPersonSchema, data.managers)) !== null && _a !== void 0 ? _a : [];
                const reports = (_b = transform(smarthub_common_1.IPersonSchema, data.reports)) !== null && _b !== void 0 ? _b : [];
                setData({
                    managers: managers,
                    reports: reports,
                });
            }
            catch (ex) {
                smarthub_common_1.Logger.error("Failed to fetch hierachy data", false, { ex });
            }
        });
        fetchData();
    }, [profile, fetch]);
    const managerData = react_1.useMemo(() => {
        return [...data.managers].reverse();
    }, [data.managers]);
    return react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement("div", { className: styles.inner },
            react_1.default.createElement(hierarchy_list_component_1.HierarchyPersonaList, { people: managerData, type: "manager" }),
            react_1.default.createElement(hierarchy_list_component_1.HierarchyPersonaList, { people: [profile], type: "profile" }),
            react_1.default.createElement(hierarchy_list_component_1.HierarchyPersonaList, { people: data.reports, type: "report", collapsable: true, initialCollapse: true })))), [profile, data]);
};
exports.Hierarchy = Hierarchy;


/***/ }),

/***/ "./src/content/profile/index.ts":
/*!**************************************!*\
  !*** ./src/content/profile/index.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileSummary = exports.ProfileSkills = exports.ProfileSchools = exports.ProfileProjects = exports.ProfileInterests = exports.ProfileContactInfo = exports.ProfileAboutInfo = exports.ProfileContact = exports.ProfileHeader = exports.MyHeader = exports.Hierarchy = exports.HierarchyPersona = exports.HierarchyPersonaList = void 0;
var hierarchy_list_component_1 = __webpack_require__(/*! ./hierarchy-list.component */ "./src/content/profile/hierarchy-list.component.tsx");
Object.defineProperty(exports, "HierarchyPersonaList", ({ enumerable: true, get: function () { return hierarchy_list_component_1.HierarchyPersonaList; } }));
var hierarchy_persona_component_1 = __webpack_require__(/*! ./hierarchy-persona.component */ "./src/content/profile/hierarchy-persona.component.tsx");
Object.defineProperty(exports, "HierarchyPersona", ({ enumerable: true, get: function () { return hierarchy_persona_component_1.HierarchyPersona; } }));
var hierarchy_component_1 = __webpack_require__(/*! ./hierarchy.component */ "./src/content/profile/hierarchy.component.tsx");
Object.defineProperty(exports, "Hierarchy", ({ enumerable: true, get: function () { return hierarchy_component_1.Hierarchy; } }));
var my_header_component_1 = __webpack_require__(/*! ./my-header.component */ "./src/content/profile/my-header.component.tsx");
Object.defineProperty(exports, "MyHeader", ({ enumerable: true, get: function () { return my_header_component_1.MyHeader; } }));
var profile_header_component_1 = __webpack_require__(/*! ./profile-header.component */ "./src/content/profile/profile-header.component.tsx");
Object.defineProperty(exports, "ProfileHeader", ({ enumerable: true, get: function () { return profile_header_component_1.ProfileHeader; } }));
var profile_contact_component_1 = __webpack_require__(/*! ./profile-contact.component */ "./src/content/profile/profile-contact.component.tsx");
Object.defineProperty(exports, "ProfileContact", ({ enumerable: true, get: function () { return profile_contact_component_1.ProfileContact; } }));
var profile_about_info_component_1 = __webpack_require__(/*! ./profile-about-info.component */ "./src/content/profile/profile-about-info.component.tsx");
Object.defineProperty(exports, "ProfileAboutInfo", ({ enumerable: true, get: function () { return profile_about_info_component_1.ProfileAboutInfo; } }));
var profile_contact_info_component_1 = __webpack_require__(/*! ./profile-contact-info.component */ "./src/content/profile/profile-contact-info.component.tsx");
Object.defineProperty(exports, "ProfileContactInfo", ({ enumerable: true, get: function () { return profile_contact_info_component_1.ProfileContactInfo; } }));
var profile_interests_component_1 = __webpack_require__(/*! ./profile-interests.component */ "./src/content/profile/profile-interests.component.tsx");
Object.defineProperty(exports, "ProfileInterests", ({ enumerable: true, get: function () { return profile_interests_component_1.ProfileInterests; } }));
var profile_projects_component_1 = __webpack_require__(/*! ./profile-projects.component */ "./src/content/profile/profile-projects.component.tsx");
Object.defineProperty(exports, "ProfileProjects", ({ enumerable: true, get: function () { return profile_projects_component_1.ProfileProjects; } }));
var profile_schools_component_1 = __webpack_require__(/*! ./profile-schools.component */ "./src/content/profile/profile-schools.component.tsx");
Object.defineProperty(exports, "ProfileSchools", ({ enumerable: true, get: function () { return profile_schools_component_1.ProfileSchools; } }));
var profile_skills_component_1 = __webpack_require__(/*! ./profile-skills.component */ "./src/content/profile/profile-skills.component.tsx");
Object.defineProperty(exports, "ProfileSkills", ({ enumerable: true, get: function () { return profile_skills_component_1.ProfileSkills; } }));
var profile_summary_component_1 = __webpack_require__(/*! ./profile-summary.component */ "./src/content/profile/profile-summary.component.tsx");
Object.defineProperty(exports, "ProfileSummary", ({ enumerable: true, get: function () { return profile_summary_component_1.ProfileSummary; } }));


/***/ }),

/***/ "./src/content/profile/my-header.component.tsx":
/*!*****************************************************!*\
  !*** ./src/content/profile/my-header.component.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MyHeader = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles(({ palette }) => ({
    background: (hasImage) => ({
        position: "relative",
        backgroundColor: hasImage
            ? palette.neutalFilmMinus2
            : undefined,
    }),
    components: {
        position: "relative",
        justifyContent: "flex-end",
        flexDirection: "row",
        display: "flex",
        width: "100%",
        ["& > *"]: {
            flex: "0 0"
        }
    }
}));
const fluentStyles = (({ theme: { palette, spacing, fonts }, config: hasImage }) => ({
    image: {
        root: {
            position: 'absolute',
            width: '100%',
            height: '100%'
        }
    },
    coin: {
        coin: {
            marginLeft: spacing.smallPlus,
        }
    },
    persona: {
        tertiaryText: {
            display: "none"
        },
        details: {
            width: "auto",
            padding: `${spacing.large} ${spacing.medium} ${spacing.large} ${spacing.medium}`,
            boxSizing: "border-box",
        },
        primaryText: {
            h1: Object.assign(Object.assign({}, fonts.xLarge), { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: '400', margin: 0 })
        },
        root: {
            height: `calc(100% - ${spacing.medium})`,
            margin: `${spacing.smallPlus} 0 ${spacing.smallPlus} ${spacing.smallPlus}`,
            borderRadius: spacing.small,
            backgroundColor: hasImage
                ? palette.neutalFilmMinus2
                : undefined,
        }
    },
}));
const cache = {
    imageUri: null,
    ref: null
};
const MyHeader = ({ config, data, config: { query, children = [], props: { nav } = {} } }) => {
    const gridStyles = smarthub_common_1.useGridStyles();
    const profile = smarthub_common_1.useProfile();
    const render = smarthub_common_1.useRender();
    const download = smarthub_common_1.useGetFile();
    const [imageUri, setImageUri] = react_1.useState(cache.imageUri);
    const hasImage = cache.imageUri != null;
    const [bannerImageRef] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys.userBannerImage, true);
    react_1.useEffect(() => {
        if (cache.imageUri && cache.ref == bannerImageRef)
            return;
        (() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const { uri } = yield download(query, 'dataUri', bannerImageRef);
            cache.imageUri = uri;
            cache.ref = bannerImageRef;
            setImageUri(uri);
        }))();
    }, [bannerImageRef]);
    const panelStyles = smarthub_common_1.usePanelStyles();
    const profileStyles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, hasImage);
    const styles = useStyles(hasImage);
    const props = react_1.useMemo(() => {
        return profile ? {
            size: react_2.PersonaSize.size72,
            text: profile.name,
            imageUrl: profile.image,
            secondaryText: profile.jobTitle && profile.department ? `${profile.jobTitle} - ${profile.department}` : profile.jobTitle ? profile.jobTitle : profile.department,
            styles: profileStyles.persona,
            coinProps: {
                styles: profileStyles.coin
            }
        }
            : null;
    }, [profile, profileStyles]);
    const getCustomPrimaryTextRenderer = () => {
        return (props) => {
            return (react_1.default.createElement("h1", null, props.text));
        };
    };
    return react_1.useMemo(() => {
        return react_1.default.createElement("div", { className: [panelStyles.header, gridStyles.grid, gridStyles.overflow].join(' ') },
            (imageUri === null || imageUri === void 0 ? void 0 : imageUri.length) > 0 && react_1.default.createElement(react_2.Image, { src: imageUri, styles: profileStyles.image, coverStyle: react_2.ImageCoverStyle.landscape, imageFit: react_2.ImageFit.cover }),
            react_1.default.createElement("div", { className: [gridStyles.row].join(" ") },
                react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.sm12, gridStyles.lgx4, gridStyles.xl3, gridStyles.xlx2, gridStyles.smclip].join(" ") },
                    react_1.default.createElement(react_2.Persona, Object.assign({}, props, { onRenderPrimaryText: getCustomPrimaryTextRenderer() }))),
                react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.sm12, gridStyles.lgx8, gridStyles.xl9, gridStyles.xlx10, gridStyles.smclip].join(" ") },
                    react_1.default.createElement("div", { className: styles.components }, children.map(c => render(c)())))),
            react_1.default.createElement("div", { className: [gridStyles.row, gridStyles.smnowrap].join(" ") },
                react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.sm12, gridStyles.lgx8, gridStyles.xl9, gridStyles.xlx10, styles.background].join(" ") }, render(nav, data, core_1.TabNavigation)())));
    }, [data, panelStyles, config, props, imageUri, styles, profileStyles]);
};
exports.MyHeader = MyHeader;


/***/ }),

/***/ "./src/content/profile/profile-about-info.component.tsx":
/*!**************************************************************!*\
  !*** ./src/content/profile/profile-about-info.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileAboutInfo = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const profile_styles_1 = __webpack_require__(/*! ./profile.styles */ "./src/content/profile/profile.styles.ts");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const ProfileAboutInfo = ({ config, config: { consumes, title, chrome, props }, data }) => {
    var _a, _b;
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const currentProfile = smarthub_common_1.useProfile();
    const styles = profile_styles_1.useSectionStyles();
    const contentFormatter = smarthub_common_1.useContentFormat(props.providerName);
    const profile = (_b = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "profile"))) !== null && _a !== void 0 ? _a : data === null || data === void 0 ? void 0 : data.profile) !== null && _b !== void 0 ? _b : currentProfile;
    const [content, setContent] = react_1.useState(null);
    react_1.useEffect(() => {
        var _a;
        if ((_a = profile === null || profile === void 0 ? void 0 : profile.aboutMe) === null || _a === void 0 ? void 0 : _a.length) {
            contentFormatter(`<div>${profile.aboutMe}</div>`, { headingId: '' }).then(result => {
                setContent(result.content);
            });
        }
    }, [profile, config]);
    return react_1.useMemo(() => {
        var _a, _b;
        return react_1.default.createElement(react_1.default.Fragment, null, (((_a = profile.birthday) === null || _a === void 0 ? void 0 : _a.year) > "1" || content) &&
            react_1.default.createElement(core_1.ComponentChrome, { config: config },
                ((title === null || title === void 0 ? void 0 : title.length) > 0 && !(chrome === null || chrome === void 0 ? void 0 : chrome.header)) && react_1.default.createElement(react_2.Separator, { alignContent: "start" }, title),
                react_1.default.createElement("div", { title: `${localizeConfig.profilePersonalInfo} ${profile.name}`, className: styles.section },
                    content && react_1.default.createElement("div", { className: [styles.row, styles.first].join(' ') },
                        react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: content } })),
                    ((_b = profile.birthday) === null || _b === void 0 ? void 0 : _b.year) > "1" && react_1.default.createElement("div", { className: styles.row },
                        react_1.default.createElement(react_2.Text, null, localizeConfig.profileBirthday),
                        react_1.default.createElement(react_2.Text, null,
                            profile.birthday.month,
                            " ",
                            profile.birthday.year)))));
    }, [content]);
};
exports.ProfileAboutInfo = ProfileAboutInfo;


/***/ }),

/***/ "./src/content/profile/profile-contact-info.component.tsx":
/*!****************************************************************!*\
  !*** ./src/content/profile/profile-contact-info.component.tsx ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileContactInfo = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const profile_styles_1 = __webpack_require__(/*! ./profile.styles */ "./src/content/profile/profile.styles.ts");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const ProfileContactInfo = ({ config, config: { consumes, title, chrome }, data }) => {
    var _a, _b;
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const currentProfile = smarthub_common_1.useProfile();
    const styles = profile_styles_1.useSectionStyles();
    const profile = (_b = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "profile"))) !== null && _a !== void 0 ? _a : data === null || data === void 0 ? void 0 : data.profile) !== null && _b !== void 0 ? _b : currentProfile;
    return react_1.useMemo(() => {
        var _a;
        return react_1.default.createElement(react_1.default.Fragment, null, ((_a = profile.contactActions) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
            react_1.default.createElement(core_1.ComponentChrome, { config: config },
                ((title === null || title === void 0 ? void 0 : title.length) > 0 && !(chrome === null || chrome === void 0 ? void 0 : chrome.header)) && react_1.default.createElement(react_2.Separator, { alignContent: "start" }, title),
                react_1.default.createElement("ul", { title: `${localizeConfig.profileContactInfo} ${profile.name}`, className: styles.section }, profile.contactActions.map((a, idx) => react_1.default.createElement("li", { key: idx, className: [styles.row, idx == 0 ? styles.first : ''].join(' ') },
                    react_1.default.createElement(react_2.Icon, { iconName: a.icon }),
                    react_1.default.createElement(react_2.Text, null, a.secondaryText))))));
    }, [profile, config]);
};
exports.ProfileContactInfo = ProfileContactInfo;


/***/ }),

/***/ "./src/content/profile/profile-contact.component.tsx":
/*!***********************************************************!*\
  !*** ./src/content/profile/profile-contact.component.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileContact = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const fluentStyles = (({ theme: { palette, fonts, spacing } }) => ({
    activity: {
        root: {
            margin: spacing.medium,
            flex: "1 1"
        },
        activityText: Object.assign(Object.assign({}, fonts.small), { lineHeight: "180%", display: "block", color: palette.neutralMinus5On }),
        activityTypeIcon: {
            color: palette.neutralMinus5On
        },
        timeStamp: Object.assign(Object.assign({}, fonts.normal), { wordBreak: "break-word", color: palette.neutralMinus5On })
    },
    copy: {
        root: {
            height: "100%",
            backgroundColor: palette.neutralMinus5
        }
    },
    stack: {
        root: {
            borderRadius: spacing.small,
            overflow: "hidden",
            width: "100%",
            backgroundColor: palette.neutralMinus5
        }
    }
}));
const mailIcon = { iconName: 'Mail' };
const phoneIcon = { iconName: 'Phone' };
const groupIcon = { iconName: 'Group' };
const locationIcon = { iconName: 'CityNext' };
const ProfileContact = ({ config, config: { consumes, responsive }, }) => {
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const currentProfile = smarthub_common_1.useProfile();
    const localize = smarthub_common_1.useLocalizeConfig();
    const stateRef = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'profile');
    const state = smarthub_common_1.useReadSharedState(stateRef);
    const profile = (state === null || state === void 0 ? void 0 : state.$schema) == smarthub_common_1.IPersonSchema
        ? state
        : stateRef
            ? null
            : currentProfile;
    const renderCard = react_1.useCallback(({ data }) => {
        return react_1.default.createElement(react_2.Stack, { horizontal: true, styles: styles.stack },
            react_1.default.createElement(react_2.StackItem, { grow: true },
                react_1.default.createElement(react_2.ActivityItem, { styles: styles.activity, activityDescription: [
                        react_1.default.createElement("span", { key: 1 }, data.type),
                    ], timeStamp: data.data == null ? localize.na : data.data, activityIcon: react_1.default.createElement(react_2.Icon, Object.assign({}, data.icon)) })),
            react_1.default.createElement(react_2.StackItem, null,
                react_1.default.createElement(react_2.IconButton, { onClick: () => navigator.clipboard.writeText(data.data), styles: styles.copy, alt: localize.copyIcn, ariaLabel: localize.btnCopy },
                    react_1.default.createElement(react_2.Icon, { iconName: "Copy" }))));
    }, [styles]);
    return react_1.useMemo(() => {
        var _a;
        const items = profile
            ? [
                { $id: `${profile.$id}-email`, type: 'Email', data: profile.mail, icon: mailIcon },
                { $id: `${profile.$id}-job`, type: 'Job Title', data: profile.jobTitle, icon: groupIcon },
                { $id: `${profile.$id}-mobile`, type: 'Mobile Phone', data: profile.mobilePhone, icon: phoneIcon },
                { $id: `${profile.$id}-dept`, type: 'Department', data: profile.department, icon: groupIcon },
                { $id: `${profile.$id}-city`, type: 'City', data: profile.city, icon: locationIcon },
                { $id: `${profile.$id}-phone`, type: 'Business Phone', data: (_a = profile.businessPhones) === null || _a === void 0 ? void 0 : _a[0], icon: phoneIcon },
                { $id: `${profile.$id}-location`, type: 'Office Location', data: profile.officeLocation, icon: locationIcon }
            ].filter(i => { var _a; return (_a = i.data) === null || _a === void 0 ? void 0 : _a.length; })
            : [];
        return (react_1.default.createElement(core_1.ComponentChrome, { config: config },
            react_1.default.createElement(core_1.CardListBase, { items: items, renderCard: renderCard, responsive: responsive })));
    }, [config, profile]);
};
exports.ProfileContact = ProfileContact;


/***/ }),

/***/ "./src/content/profile/profile-header.component.tsx":
/*!**********************************************************!*\
  !*** ./src/content/profile/profile-header.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileHeader = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const fluentStyles = (({ theme: { palette, fonts, spacing, sizes } }) => ({
    personaStyles: {
        primaryText: {
            h1: Object.assign(Object.assign({ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 400 }, fonts.superLarge), { color: palette.primaryPlus1, margin: 0 })
        },
    },
    imageStyles: {
        root: {
            margin: `0 ${sizes.smallPlus} ${sizes.smallPlus} ${sizes.smallPlus}`
        }
    },
    textCoinStyles: {
        coin: {
            display: "none"
        }
    },
    commandBarStyles: {
        root: {
            padding: 0
        }
    }
}));
const ProfileHeader = ({ config, data }) => {
    const { consumes, props: { nav } = {} } = config;
    const panelStyles = smarthub_common_1.usePanelStyles();
    const { personaStyles, commandBarStyles, imageStyles, textCoinStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const gridStyles = smarthub_common_1.useGridStyles();
    const currentProfile = smarthub_common_1.useProfile();
    const render = smarthub_common_1.useRender();
    const stateRef = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'profile');
    const state = smarthub_common_1.useReadSharedState(stateRef);
    const handleAction = smarthub_common_1.useHandleCommand();
    const profile = (state === null || state === void 0 ? void 0 : state.$schema) == smarthub_common_1.IPersonSchema
        ? state
        : stateRef
            ? null
            : currentProfile;
    const getCustomPrimaryTextRenderer = () => {
        return (props) => {
            return (react_1.default.createElement("h1", null, props.text));
        };
    };
    return react_1.useMemo(() => {
        var _a, _b;
        const name = !((_a = profile === null || profile === void 0 ? void 0 : profile.name) === null || _a === void 0 ? void 0 : _a.length)
            ? "Error: Profile not found"
            : profile.name;
        return profile
            ? react_1.default.createElement("div", { className: [panelStyles.header, gridStyles.grid, gridStyles.overflow, gridStyles.row, gridStyles.smnowrap].join(" ") },
                react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.smclip].join(" ") },
                    react_1.default.createElement(react_2.Persona, { size: react_2.PersonaSize.size100, text: name, imageUrl: profile.image, styles: imageStyles, hidePersonaDetails: true })),
                react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.smstretch, gridStyles.smclip].join(" ") },
                    react_1.default.createElement("div", { className: [gridStyles.row, gridStyles.smnowrap, gridStyles.padT].join(" ") },
                        react_1.default.createElement("div", { className: [gridStyles.col].join(" ") },
                            react_1.default.createElement(react_2.Persona, { styles: personaStyles, text: name, coinProps: {
                                    styles: textCoinStyles
                                }, secondaryText: profile.jobTitle && profile.department
                                    ? `${profile.jobTitle} - ${profile.department}`
                                    : profile.jobTitle ? profile.jobTitle : null, onRenderPrimaryText: getCustomPrimaryTextRenderer() })),
                        react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.smstretch, gridStyles.smclip].join(" ") },
                            react_1.default.createElement(react_2.CommandBar, { styles: commandBarStyles, items: (_b = profile.contactActions) === null || _b === void 0 ? void 0 : _b.map((a, i) => ({
                                    key: `${i}`,
                                    text: a.text,
                                    title: `${a.label} ${profile.name}`,
                                    iconProps: { iconName: a.icon },
                                    onClick: () => { handleAction(a.action); }
                                })) }))),
                    react_1.default.createElement("div", { className: [gridStyles.row, gridStyles.smstretch].join(" ") },
                        react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.smfill].join(" ") }, render(nav, data, core_1.TabNavigation)()))))
            : react_1.default.createElement(react_1.default.Fragment, null);
    }, [config, data, profile, panelStyles, gridStyles, personaStyles, imageStyles]);
};
exports.ProfileHeader = ProfileHeader;


/***/ }),

/***/ "./src/content/profile/profile-interests.component.tsx":
/*!*************************************************************!*\
  !*** ./src/content/profile/profile-interests.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileInterests = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const profile_tags_component_1 = __webpack_require__(/*! ./profile-tags.component */ "./src/content/profile/profile-tags.component.tsx");
const ProfileInterests = ({ config, config: { consumes, title, chrome }, data }) => {
    var _a, _b;
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const currentProfile = smarthub_common_1.useProfile();
    const profile = (_b = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "profile"))) !== null && _a !== void 0 ? _a : data === null || data === void 0 ? void 0 : data.profile) !== null && _b !== void 0 ? _b : currentProfile;
    return react_1.useMemo(() => {
        return react_1.default.createElement(profile_tags_component_1.ProfileTags, { config: config, items: profile.interests, title: !(chrome === null || chrome === void 0 ? void 0 : chrome.header) ? title : null, label: `${localizeConfig.profileInterests} ${profile.name}`, itemLabel: localizeConfig.profileInterest });
    }, [profile, config]);
};
exports.ProfileInterests = ProfileInterests;


/***/ }),

/***/ "./src/content/profile/profile-projects.component.tsx":
/*!************************************************************!*\
  !*** ./src/content/profile/profile-projects.component.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileProjects = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const profile_tags_component_1 = __webpack_require__(/*! ./profile-tags.component */ "./src/content/profile/profile-tags.component.tsx");
const ProfileProjects = ({ config, config: { consumes, title, chrome }, data }) => {
    var _a, _b;
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const currentProfile = smarthub_common_1.useProfile();
    const profile = (_b = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "profile"))) !== null && _a !== void 0 ? _a : data === null || data === void 0 ? void 0 : data.profile) !== null && _b !== void 0 ? _b : currentProfile;
    return react_1.useMemo(() => {
        return react_1.default.createElement(profile_tags_component_1.ProfileTags, { config: config, items: profile.pastProjects, title: !(chrome === null || chrome === void 0 ? void 0 : chrome.header) ? title : null, label: `${localizeConfig.profileProjects} ${profile.name}`, itemLabel: localizeConfig.profileProject });
    }, [profile, config]);
};
exports.ProfileProjects = ProfileProjects;


/***/ }),

/***/ "./src/content/profile/profile-schools.component.tsx":
/*!***********************************************************!*\
  !*** ./src/content/profile/profile-schools.component.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileSchools = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const profile_tags_component_1 = __webpack_require__(/*! ./profile-tags.component */ "./src/content/profile/profile-tags.component.tsx");
const ProfileSchools = ({ config, config: { consumes, title, chrome }, data }) => {
    var _a, _b;
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const currentProfile = smarthub_common_1.useProfile();
    const profile = (_b = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "profile"))) !== null && _a !== void 0 ? _a : data === null || data === void 0 ? void 0 : data.profile) !== null && _b !== void 0 ? _b : currentProfile;
    return react_1.useMemo(() => {
        return react_1.default.createElement(profile_tags_component_1.ProfileTags, { config: config, items: profile.schools, title: !(chrome === null || chrome === void 0 ? void 0 : chrome.header) ? title : null, label: `${localizeConfig.profileSchools} ${profile.name}`, itemLabel: localizeConfig.profileSchool });
    }, [profile, config]);
};
exports.ProfileSchools = ProfileSchools;


/***/ }),

/***/ "./src/content/profile/profile-skills.component.tsx":
/*!**********************************************************!*\
  !*** ./src/content/profile/profile-skills.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileSkills = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const profile_tags_component_1 = __webpack_require__(/*! ./profile-tags.component */ "./src/content/profile/profile-tags.component.tsx");
const ProfileSkills = ({ config, config: { consumes, title, chrome }, data }) => {
    var _a, _b;
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const currentProfile = smarthub_common_1.useProfile();
    const profile = (_b = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "profile"))) !== null && _a !== void 0 ? _a : data === null || data === void 0 ? void 0 : data.profile) !== null && _b !== void 0 ? _b : currentProfile;
    return react_1.useMemo(() => {
        return react_1.default.createElement(profile_tags_component_1.ProfileTags, { config: config, items: profile.skills, title: !(chrome === null || chrome === void 0 ? void 0 : chrome.header) ? title : null, label: `${localizeConfig.profileSkills} ${profile.name}`, itemLabel: localizeConfig.profileSkill });
    }, [profile, config]);
};
exports.ProfileSkills = ProfileSkills;


/***/ }),

/***/ "./src/content/profile/profile-summary.component.tsx":
/*!***********************************************************!*\
  !*** ./src/content/profile/profile-summary.component.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileSummary = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const profile_contact_info_component_1 = __webpack_require__(/*! ./profile-contact-info.component */ "./src/content/profile/profile-contact-info.component.tsx");
const profile_about_info_component_1 = __webpack_require__(/*! ./profile-about-info.component */ "./src/content/profile/profile-about-info.component.tsx");
const profile_skills_component_1 = __webpack_require__(/*! ./profile-skills.component */ "./src/content/profile/profile-skills.component.tsx");
const profile_projects_component_1 = __webpack_require__(/*! ./profile-projects.component */ "./src/content/profile/profile-projects.component.tsx");
const profile_interests_component_1 = __webpack_require__(/*! ./profile-interests.component */ "./src/content/profile/profile-interests.component.tsx");
const profile_schools_component_1 = __webpack_require__(/*! ./profile-schools.component */ "./src/content/profile/profile-schools.component.tsx");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const fluentStyles = ({ theme: { palette, spacing, sizes }, }) => ({
    coin: {
        coin: {
            border: `${spacing.small} solid ${palette.neutralMinus5}`,
            borderRadius: "100%",
            position: "absolute",
            marginTop: `calc(-${sizes.mediumPlus} - ${spacing.small})`,
        },
        image: {
            marginRight: 0,
        },
    },
    stack: {
        root: {
            marginTop: sizes.mediumPlus,
            backgroundColor: palette.neutralEmpty,
        },
    },
    stackItem: {
        root: {
            overflow: "overlay",
        },
    },
    persona: {
        root: {
            flexDirection: "column",
            height: "auto",
        },
        details: {
            marginTop: `calc(${sizes.medium} * 2)`,
            marginBottom: spacing.smallPlus,
            textAlign: "center",
            padding: 0,
        },
    },
});
const ProfileSummary = ({ config, config: { consumes, children, props }, }) => {
    var _a;
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const currentProfile = smarthub_common_1.useProfile();
    const render = smarthub_common_1.useRender();
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const profile = (_a = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "profile"))) !== null && _a !== void 0 ? _a : currentProfile;
    return react_1.useMemo(() => {
        return (react_1.default.createElement(core_1.ComponentChrome, { config: config },
            react_1.default.createElement(react_2.Stack, { styles: (props === null || props === void 0 ? void 0 : props.showPersona) ? styles.stack : null, title: localizeConfig.profileTitle },
                (props === null || props === void 0 ? void 0 : props.showPersona) && (react_1.default.createElement(react_2.Stack.Item, null,
                    react_1.default.createElement(react_2.Persona, Object.assign({}, {
                        coinProps: {
                            styles: styles.coin,
                        },
                        styles: styles.persona,
                        size: react_2.PersonaSize.size120,
                        text: profile.name,
                        secondaryText: profile.jobTitle,
                        tertiaryText: profile.department,
                        imageUrl: profile.image,
                        imageAlt: profile.name,
                    })))),
                react_1.default.createElement(react_2.Stack.Item, { styles: styles.stackItem }, children.map((child) => {
                    const fallback = child.$id == "contact"
                        ? profile_contact_info_component_1.ProfileContactInfo
                        : child.$id == "about"
                            ? profile_about_info_component_1.ProfileAboutInfo
                            : child.$id == "skills"
                                ? profile_skills_component_1.ProfileSkills
                                : child.$id == "projects"
                                    ? profile_projects_component_1.ProfileProjects
                                    : child.$id == "interests"
                                        ? profile_interests_component_1.ProfileInterests
                                        : child.$id == "schools"
                                            ? profile_schools_component_1.ProfileSchools
                                            : null;
                    return (react_1.default.createElement(react_2.StackItem, { key: child.$id, grow: true, shrink: true }, render(child, profile, fallback)()));
                })))));
    }, [profile, config]);
};
exports.ProfileSummary = ProfileSummary;


/***/ }),

/***/ "./src/content/profile/profile-tags.component.tsx":
/*!********************************************************!*\
  !*** ./src/content/profile/profile-tags.component.tsx ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileTags = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const fluentStyles = (({ theme: { spacing } }) => ({
    stackStyles: {
        root: {
            padding: `0 ${spacing.medium} ${spacing.medium} ${spacing.medium}`
        },
        inner: {
            gap: spacing.smallPlus,
        }
    }
}));
const ProfileTags = ({ items, title, label, itemLabel, config }) => {
    const { stackStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    return react_1.useMemo(() => {
        return react_1.default.createElement(react_1.default.Fragment, null, (items === null || items === void 0 ? void 0 : items.length) > 0 && react_1.default.createElement(core_1.ComponentChrome, { config: config, title: label },
            (title === null || title === void 0 ? void 0 : title.length) > 0 && react_1.default.createElement(react_2.Separator, { alignContent: "start" }, title),
            react_1.default.createElement(react_2.Stack, { horizontal: true, wrap: true, styles: stackStyles }, items.map((text, idx) => react_1.default.createElement(react_2.StackItem, { key: idx },
                react_1.default.createElement(utilities_1.Tag, { tagInfo: {
                        text,
                        label: `${itemLabel} ${text}`
                    } }))))));
    }, [items, title]);
};
exports.ProfileTags = ProfileTags;


/***/ }),

/***/ "./src/content/profile/profile.styles.ts":
/*!***********************************************!*\
  !*** ./src/content/profile/profile.styles.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSectionStyles = void 0;
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
exports.useSectionStyles = react_jss_1.createUseStyles(({ palette, type, spacing }) => ({
    section: {
        padding: spacing.medium,
        display: "flex",
        flexDirection: "column"
    },
    first: {},
    row: {
        display: "flex",
        gap: spacing.smallPlus,
        borderTop: `${spacing.tiny} solid ${type == "dark" ? palette.neutralMinus5 : palette.neutralMinus3}`,
        paddingTop: spacing.normal,
        marginTop: spacing.normal,
        ["&$first"]: {
            borderTop: 0,
            paddingTop: 0,
            marginTop: 0,
        }
    }
}));


/***/ }),

/***/ "./src/content/splash-screen/index.ts":
/*!********************************************!*\
  !*** ./src/content/splash-screen/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./splash-screen.component */ "./src/content/splash-screen/splash-screen.component.tsx"), exports);


/***/ }),

/***/ "./src/content/splash-screen/splash-screen.component.tsx":
/*!***************************************************************!*\
  !*** ./src/content/splash-screen/splash-screen.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SplashScreen = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles((theme) => {
    const { palette, fonts, spacing, sizes } = theme;
    return {
        background: ({ responsive: { fill }, }) => (Object.assign({ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: fill ? palette.primary : palette.neutralEmpty }, react_2.AnimationStyles.fadeIn500)),
        wrapper: ({ responsive: { fill, size }, }) => ({
            width: smarthub_common_1.responsiveColumnWidths[size],
            display: "flex",
            flexDirection: "column",
            backgroundColor: palette.primary,
            color: palette.primaryOn,
            boxShadow: fill ? "none" : `0 0 ${spacing.normal} ${palette.filmMinus1}`,
            minHeight: sizes.normal,
        }),
        headerText: Object.assign({}, fonts.mega),
        header: {
            // ...fonts.mega,
            fontWeight: "100",
            padding: `${spacing.medium} ${spacing.xxLarge}`,
        },
        detail: {
            flex: "1 1 100%",
            padding: spacing.xxLarge,
            display: "flex",
            flexDirection: "row",
        },
        logo: {
            paddingTop: spacing.smallPlus,
        },
        image: {
            maxWidth: "100%",
            maxHeight: "100%",
        },
        detailList: {
            display: "flex",
            flex: "1 1",
            paddingLeft: spacing.xxLarge,
            flexDirection: "column",
        },
        descriptionText: Object.assign({}, fonts.superLarge),
        description: {
            paddingBottom: spacing.large,
            fontWeight: "100",
        },
        info: Object.assign({}, fonts.small),
        label: Object.assign({}, fonts.smallPlus),
    };
});
const responsiveProps = {
    sm: {
        size: 12,
        fill: true,
    },
    md: {
        size: 10,
    },
    lg: {
        size: 8,
        fill: false,
    },
    xlx: {
        size: 6,
    },
    xxl: {
        size: 4,
    },
};
const SplashScreen = () => {
    var _a, _b;
    const source = smarthub_common_1.useSourceInfo();
    const localize = smarthub_common_1.useLocalizeConfig();
    const styleProps = smarthub_common_1.useStyleProps(null, responsiveProps);
    const styles = useStyles(styleProps);
    return (react_1.default.createElement("div", { className: styles.background },
        react_1.default.createElement("div", { className: styles.wrapper },
            react_1.default.createElement("div", { className: [styles.header, styles.headerText].join(" ") }, source.title),
            react_1.default.createElement("div", { className: styles.detail },
                react_1.default.createElement("div", { className: styles.logo },
                    react_1.default.createElement(utilities_1.ThemeImage, { alt: localize.logoImage, className: styles.image, image: smarthub_common_1.ImageKeys.appLogoOnPrimaryL })),
                react_1.default.createElement("div", { className: styles.detailList },
                    react_1.default.createElement("div", { className: [styles.description, styles.descriptionText].join(" ") }, source.description),
                    react_1.default.createElement("div", { className: styles.info },
                        react_1.default.createElement("span", { className: styles.label },
                            localize.aboutVersionPrefix,
                            ":",
                            " "),
                        react_1.default.createElement("span", null, source.version)),
                    react_1.default.createElement("div", { className: styles.info },
                        react_1.default.createElement("span", { className: styles.label },
                            localize.aboutPublishedPrefix,
                            ":",
                            " "),
                        react_1.default.createElement("span", null, source.publisher)),
                    ((_b = (_a = source.environment) === null || _a === void 0 ? void 0 : _a.label) === null || _b === void 0 ? void 0 : _b.length) > 0 && (react_1.default.createElement("div", { className: styles.info },
                        react_1.default.createElement("span", { className: styles.label },
                            localize.aboutEnvironmentPrefix,
                            ":",
                            " "),
                        react_1.default.createElement("span", null, source.environment.label))))))));
};
exports.SplashScreen = SplashScreen;


/***/ }),

/***/ "./src/content/summarizer/index.ts":
/*!*****************************************!*\
  !*** ./src/content/summarizer/index.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./summariser.component */ "./src/content/summarizer/summariser.component.tsx"), exports);


/***/ }),

/***/ "./src/content/summarizer/summariser.component.tsx":
/*!*********************************************************!*\
  !*** ./src/content/summarizer/summariser.component.tsx ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Summariser = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const useStyles = react_jss_1.createUseStyles(({ palette, spacing, sizes, fonts }) => ({
    summariserWrapper: {
        width: "100%",
        textAlign: "center"
    },
    summariserIcon: {
        padding: spacing.xxLargePlus,
        borderRadius: "100%",
        margin: `${spacing.large} ${spacing.large} ${spacing.large} 0`,
        backgroundColor: palette.neutralMinus3,
        fontSize: fonts.superLarge.fontSize
    },
    count: {
        fontSize: fonts.xSmall.fontSize,
        position: "absolute",
        borderRadius: "100%",
        backgroundColor: palette.hazard,
        bottom: `-${spacing.xSmall}`,
        right: `-${spacing.xSmall}`,
        lineHeight: sizes.small,
        height: sizes.small,
        width: sizes.small,
        fontWeight: 600,
        color: palette.hazardOn
    },
}));
const Summariser = ({ config }) => {
    var _a, _b, _c, _d;
    const baseStyles = useStyles();
    const handleAction = smarthub_common_1.useHandleCommand();
    const { $id, query, consumes, props: { icon } } = config;
    const fetch = smarthub_common_1.useFetch();
    const transform = smarthub_common_1.useTransform();
    const [filters, setFilters] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setFilters(consumes), [consumes]);
    const [item, setData] = react_1.useState(null);
    const fetchData = (filters) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const requiresParam = consumes === null || consumes === void 0 ? void 0 : consumes.some(({ required, name }) => required && (filters === null || filters === void 0 ? void 0 : filters[name]) == null);
            if (requiresParam)
                return;
            const { data } = yield fetch(query, filters);
            const outlook = transform(models_1.IOutlookSummariser, data);
            setData({ outlook });
        }
        catch (ex) {
            smarthub_common_1.Logger.error("Failed to fetch summarizer info", false, { ex });
        }
    });
    react_1.useEffect(() => {
        fetchData(filters);
    }, [filters, fetch, config]);
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config, hasContent: item != null },
        react_1.default.createElement(react_2.IconButton, { title: (_a = item === null || item === void 0 ? void 0 : item.outlook) === null || _a === void 0 ? void 0 : _a.title, ariaLabel: (_b = item === null || item === void 0 ? void 0 : item.outlook) === null || _b === void 0 ? void 0 : _b.title, className: baseStyles.summariserIcon, onClick: () => { var _a; handleAction((_a = item === null || item === void 0 ? void 0 : item.outlook) === null || _a === void 0 ? void 0 : _a.action); } },
            ((_c = item === null || item === void 0 ? void 0 : item.outlook) === null || _c === void 0 ? void 0 : _c.count) > 0 && react_1.default.createElement("div", { className: baseStyles.count }, (_d = item === null || item === void 0 ? void 0 : item.outlook) === null || _d === void 0 ? void 0 : _d.count),
            react_1.default.createElement(react_2.Icon, { iconName: icon }))));
};
exports.Summariser = Summariser;


/***/ }),

/***/ "./src/content/timeline/index.ts":
/*!***************************************!*\
  !*** ./src/content/timeline/index.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./timeline.component */ "./src/content/timeline/timeline.component.tsx"), exports);


/***/ }),

/***/ "./src/content/timeline/timeline-item.component.tsx":
/*!**********************************************************!*\
  !*** ./src/content/timeline/timeline-item.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TimelineItem = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const timeline_styles_1 = __webpack_require__(/*! ./timeline-styles */ "./src/content/timeline/timeline-styles.ts");
const models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const TimelineItem = ({ data }) => {
    const styles = timeline_styles_1.useTimelineStyles();
    const transform = smarthub_common_1.useTransform();
    const [item, setItem] = react_1.useState(data);
    react_1.useEffect(() => {
        if ((data === null || data === void 0 ? void 0 : data.startText) || (data === null || data === void 0 ? void 0 : data.endText)) {
            setItem({ heading: (data === null || data === void 0 ? void 0 : data.startText) || (data === null || data === void 0 ? void 0 : data.endText) });
        }
        else {
            const result = transform(models_1.ITimelineSchema, data);
            setItem(result);
        }
    }, [data]);
    return react_1.useMemo(() => (react_1.default.createElement("div", { className: styles.timelineItem }, item && react_1.default.createElement("div", { className: styles.timelineItemContent },
        react_1.default.createElement("div", { className: "bold" }, item === null || item === void 0 ? void 0 : item.created),
        (item === null || item === void 0 ? void 0 : item.heading) ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "heading" }, item === null || item === void 0 ? void 0 : item.heading),
            react_1.default.createElement("div", { className: "outerCircle" },
                react_1.default.createElement("div", { className: "innerCircle" })))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "message" }, item === null || item === void 0 ? void 0 : item.message),
            react_1.default.createElement("div", { className: "circle" })))))), [item]);
};
exports.TimelineItem = TimelineItem;


/***/ }),

/***/ "./src/content/timeline/timeline-styles.ts":
/*!*************************************************!*\
  !*** ./src/content/timeline/timeline-styles.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTimelineStyles = void 0;
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
exports.useTimelineStyles = react_jss_1.createUseStyles(({ palette, fonts }) => ({
    timelineContainer: Object.assign(Object.assign({ display: "flex", flexDirection: "column", position: "relative", margin: "40px 0", fontWeight: "bold" }, fonts.normal), { ["&::after"]: {
            backgroundColor: palette.primaryPlus1,
            content: '""',
            position: "absolute",
            left: "31px",
            width: "4px",
            height: "100%"
        } }),
    timelineItem: {
        display: "flex",
        justifyContent: "flex-start",
        paddingLeft: "60px",
        position: "relative",
        marginBottom: "15px",
    },
    timelineItemContent: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        position: "relative",
        width: "400px",
        maxWidth: "70%",
        textAlign: "left",
        ["& .heading"]: {
            fontWeight: "bold",
            marginBottom: "15px",
        },
        ["& .message"]: {
            fontSize: "16px",
            lineHeight: "24px",
            margin: "0",
            maxWidth: "250px",
        },
        ["& .bold"]: {
            fontWeight: "bold",
            margin: "0px",
        },
        ["& .circle"]: {
            backgroundColor: palette.neutralEmpty,
            border: `3px solid ${palette.primaryPlus1}`,
            borderRadius: "50%",
            position: "absolute",
            top: "0px",
            left: "-40px",
            width: "20px",
            height: "20px",
            zIndex: "100"
        },
        ["& .outerCircle"]: {
            background: palette.primaryPlus1,
            borderRadius: "50%",
            height: "26px",
            width: "26px",
            position: "absolute",
            top: "0px",
            left: "-40px",
            zIndex: "100"
        },
        ["& .innerCircle"]: {
            position: "relative",
            background: palette.primaryPlus1,
            borderRadius: "50%",
            height: "15px",
            width: "15px",
            top: "15%",
            left: "15%",
            zIndex: "100",
            border: `2px solid ${palette.neutralEmpty}`
        }
    },
}));


/***/ }),

/***/ "./src/content/timeline/timeline.component.tsx":
/*!*****************************************************!*\
  !*** ./src/content/timeline/timeline.component.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Timeline = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const timeline_item_component_1 = __webpack_require__(/*! ./timeline-item.component */ "./src/content/timeline/timeline-item.component.tsx");
const timeline_styles_1 = __webpack_require__(/*! ./timeline-styles */ "./src/content/timeline/timeline-styles.ts");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const Timeline = ({ config }) => {
    const { $id, query, consumes, props: { timelineStartText, timelineEndText } } = config;
    const fetch = smarthub_common_1.useFetch();
    const [dataSet, setDataSet] = react_1.useState({ items: null });
    const [filters, setFilters] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setFilters(consumes), [consumes]);
    const fetchData = (filters, { items } = {}) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const requiresParam = consumes === null || consumes === void 0 ? void 0 : consumes.some(({ required, name }) => required && (filters === null || filters === void 0 ? void 0 : filters[name]) == null);
            if (requiresParam)
                return;
            const { data } = yield fetch(query, filters);
            setDataSet({
                items: [
                    ...(items !== null && items !== void 0 ? items : []),
                    ...(timelineStartText ? [{ startText: timelineStartText }] : []),
                    ...(data !== null && data !== void 0 ? data : []),
                    ...(timelineEndText ? [{ endText: timelineEndText }] : []),
                ]
            });
        }
        catch (ex) {
            setDataSet({ error: ex, items: null });
        }
    });
    react_1.useEffect(() => {
        fetchData(filters);
    }, [filters, fetch, config]);
    const hasItems = react_1.useMemo(() => {
        const { items } = dataSet;
        let count = 0;
        items === null || items === void 0 ? void 0 : items.forEach(e => {
            if (!(e['startText'] || e['endText'])) {
                count++;
            }
        });
        return count != 0;
    }, [dataSet]);
    const styles = timeline_styles_1.useTimelineStyles();
    const { items } = dataSet;
    return react_1.useMemo(() => (react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement("div", { className: styles.timelineContainer }, hasItems && (items === null || items === void 0 ? void 0 : items.map((data, index) => (react_1.default.createElement(timeline_item_component_1.TimelineItem, { data: data, key: index }))))))), [dataSet]);
};
exports.Timeline = Timeline;


/***/ }),

/***/ "./src/content/up-next/index.ts":
/*!**************************************!*\
  !*** ./src/content/up-next/index.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./up-next-activity.component */ "./src/content/up-next/up-next-activity.component.tsx"), exports);


/***/ }),

/***/ "./src/content/up-next/up-next-activity.component.tsx":
/*!************************************************************!*\
  !*** ./src/content/up-next/up-next-activity.component.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.UpNextActivity = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const models_1 = __webpack_require__(/*! ../../models */ "./src/models/index.ts");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const utc_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/utc */ "dayjs/plugin/utc"));
const duration_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/duration */ "dayjs/plugin/duration"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
dayjs_1.default.extend(duration_1.default);
dayjs_1.default.extend(utc_1.default);
//TODO Use event interface and transform
//TODO fix sizing basd on new header layout
const useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing, sizes }) => ({
    card: Object.assign(Object.assign({}, fonts.normal), { width: '300px', height: sizes.mega, display: 'flex', boxSizing: 'border-box', flexDirection: 'column', justifyContent: 'space-between', borderLeft: `${spacing.smallPlus} solid ${palette.primary}`, padding: spacing.smallPlus, margin: spacing.smallPlus, backgroundColor: palette.neutalFilmMinus1, borderRadius: spacing.small, boxShadow: "rgb(0 0 0 / 13%) 0px 1.6px 3.6px 0px, rgb(0 0 0 / 11%) 0px 0.3px 0.9px 0px" }),
    meetingInfo: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    meetTime: {
        paddingRight: spacing.smallPlus
    },
    meetingTitle: Object.assign(Object.assign({}, fonts.normalPlus), { display: "flex" })
}));
const fluentStyles = ({ theme: { spacing } }) => ({
    calendarIcon: {
        root: {
            position: "relative",
            top: spacing.small,
            marginRight: spacing.smallPlus,
        }
    },
});
const defaultDateTimeFormat = "YYYY-MM-DDTHH:mm:ss.SSS[Z]";
const UpNextActivity = ({ config }) => {
    const { query, consumes, $id } = config;
    const activityStyles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const styles = useStyles();
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const fetch = smarthub_common_1.useFetch();
    const transform = smarthub_common_1.useTransform();
    const [dataSet, setDataSet] = react_1.useState({ items: null });
    const [data, setData] = react_1.useState(null);
    const [filters, setFilters] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setFilters(consumes), [consumes]);
    const fetchData = (filters, { continuation: next } = {}) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const requiresParam = consumes === null || consumes === void 0 ? void 0 : consumes.some(({ required, name }) => required && (filters === null || filters === void 0 ? void 0 : filters[name]) == null);
            if (requiresParam)
                return;
            const { data, continuation } = yield fetch(query, filters, next);
            setDataSet({
                items: transform(models_1.ICalendarSchema, data),
                continuation
            });
        }
        catch (ex) {
            setDataSet({ error: ex, items: null });
        }
    });
    react_1.useEffect(() => {
        fetchData(filters);
    }, [filters, fetch, config]);
    react_1.useEffect(() => {
        var _a, _b;
        setData(((_a = dataSet === null || dataSet === void 0 ? void 0 : dataSet.items) === null || _a === void 0 ? void 0 : _a.meetings) ? (_b = dataSet.items) === null || _b === void 0 ? void 0 : _b.meetings.filter(m => !m.isAllDay)[0] : null);
    }, [dataSet]);
    const processNextTime = react_1.useCallback(() => {
        const timeDiff = smarthub_common_1.timeDifference(dayjs_1.default().utc().format(defaultDateTimeFormat), dayjs_1.default(data === null || data === void 0 ? void 0 : data.start.dateTime).format(defaultDateTimeFormat));
        return (Math.sign(parseInt(timeDiff)) == 1) ? `${localizeConfig.nextUpIn} ${timeDiff}` : `${localizeConfig.inProgress}`;
    }, [data, localizeConfig]);
    return react_1.useMemo(() => data
        ? react_1.default.createElement(core_1.ComponentChrome, { config: config, hasContent: data },
            react_1.default.createElement("div", { className: styles.card },
                react_1.default.createElement("div", null, processNextTime()),
                react_1.default.createElement("div", { className: styles.meetingTitle },
                    react_1.default.createElement(utilities_1.TextOverflow, { lines: 1, text: data === null || data === void 0 ? void 0 : data.subject },
                        (data === null || data === void 0 ? void 0 : data.type) != "occurrence" ? react_1.default.createElement(react_2.Icon, { styles: activityStyles.calendarIcon, iconName: "Calendar" })
                            : react_1.default.createElement(react_2.Icon, { styles: activityStyles.calendarIcon, iconName: "RecurringEvent" }),
                        react_1.default.createElement("span", { className: styles.meetTime }, smarthub_common_1.formatDateTime([data === null || data === void 0 ? void 0 : data.start.dateTime, 'HH:mm'])),
                        react_1.default.createElement(react_2.Link, { href: data === null || data === void 0 ? void 0 : data.webLink, target: "_blank" }, data === null || data === void 0 ? void 0 : data.subject))),
                react_1.default.createElement("div", { className: styles.meetingInfo }, (data === null || data === void 0 ? void 0 : data.isOnlineMeeting) ? react_1.default.createElement(react_2.DefaultButton, { ariaDescription: localizeConfig.joinMeeting, title: localizeConfig.joinMeeting, text: localizeConfig.join, onClick: () => window.open(data === null || data === void 0 ? void 0 : data.onlineMeeting.joinUrl, '_blank') }) :
                    react_1.default.createElement(react_2.DefaultButton, { ariaDescription: localizeConfig.viewMore, title: localizeConfig.viewMore, text: localizeConfig.viewMore, onClick: () => window.open(data === null || data === void 0 ? void 0 : data.webLink, '_blank') }))))
        : react_1.default.createElement(react_1.default.Fragment, null), [data, localizeConfig, activityStyles]);
};
exports.UpNextActivity = UpNextActivity;


/***/ }),

/***/ "./src/content/view/index.ts":
/*!***********************************!*\
  !*** ./src/content/view/index.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./view-navigator.component */ "./src/content/view/view-navigator.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./views.component */ "./src/content/view/views.component.tsx"), exports);


/***/ }),

/***/ "./src/content/view/view-navigator.component.tsx":
/*!*******************************************************!*\
  !*** ./src/content/view/view-navigator.component.tsx ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ViewNavigator = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const navStyles = {
    root: {
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        overflowY: 'auto',
    },
};
const transformViews = (views) => {
    return views === null || views === void 0 ? void 0 : views.map(({ name, param, description, text, children, expand }, index) => ({
        name: text,
        key: `${((name === null || name === void 0 ? void 0 : name.length) ? name : index)}${((param === null || param === void 0 ? void 0 : param.length) ? `/${param}` : '')}`,
        url: null,
        isExpanded: expand,
        ariaLabel: description,
        title: description,
        links: children ? transformViews(children) : null,
        view: name,
        param: param
    }));
};
const ViewNavigator = ({ config, config: { props: { views = [] } } }) => {
    const { provides, title } = config;
    const viewProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'view');
    const paramProvider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'view-param');
    const view = smarthub_common_1.useReadSharedState(viewProvider);
    const setView = smarthub_common_1.useSetSharedState(viewProvider);
    const param = smarthub_common_1.useReadSharedState(paramProvider);
    const setParam = smarthub_common_1.useSetSharedState(paramProvider);
    const onClick = (ev, { view, param }) => {
        if (view === null || view === void 0 ? void 0 : view.length) {
            setView(view);
            setParam(param);
        }
    };
    const links = react_1.useMemo(() => {
        return transformViews(views);
    }, [views]);
    react_1.useEffect(() => {
        if (!(view === null || view === void 0 ? void 0 : view.length)) {
            const { name, param } = views[0];
            setView(name);
            setParam(param);
        }
    }, []);
    return react_1.useMemo(() => react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement(react_2.Nav, { selectedKey: `${view}${((param === null || param === void 0 ? void 0 : param.length) ? `/${param}` : '')}`, ariaLabel: title, styles: navStyles, onLinkClick: onClick, groups: [{
                    links: links
                }] })), [view, links, param]);
};
exports.ViewNavigator = ViewNavigator;


/***/ }),

/***/ "./src/content/view/views.component.tsx":
/*!**********************************************!*\
  !*** ./src/content/view/views.component.tsx ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Views = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const Views = ({ config: { consumes, children = [] } }) => {
    const render = smarthub_common_1.useRender();
    const view = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'view'));
    return react_1.useMemo(() => {
        var _a;
        const child = (_a = ((view === null || view === void 0 ? void 0 : view.length) ? children.find(({ $id }) => $id == view)
            : null)) !== null && _a !== void 0 ? _a : children[0];
        return render(child)();
    }, [view]);
};
exports.Views = Views;


/***/ }),

/***/ "./src/core/actions/action-bar/action-bar.component.tsx":
/*!**************************************************************!*\
  !*** ./src/core/actions/action-bar/action-bar.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ActionBar = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const __1 = __webpack_require__(/*! ../.. */ "./src/core/index.ts");
const action_bar_styles_1 = __webpack_require__(/*! ./action-bar.styles */ "./src/core/actions/action-bar/action-bar.styles.ts");
const use_transform_actions_hook_1 = __webpack_require__(/*! ./use-transform-actions.hook */ "./src/core/actions/action-bar/use-transform-actions.hook.ts");
const ActionBar = ({ config }) => {
    const { description, title, props: { actions, showTitle } = {}, children } = config;
    const transformActions = use_transform_actions_hook_1.useTransformActions();
    const { commandStyles, rootStyles, textStyles } = action_bar_styles_1.useStyles();
    const fluentStyles = smarthub_common_1.useFluentStylesWithProps(action_bar_styles_1.commandBarStyles);
    const props = react_1.useMemo(() => transformActions(actions, children), [actions, children]);
    return react_1.useMemo(() => (react_1.default.createElement(__1.ComponentChrome, { config: config },
        react_1.default.createElement("div", { className: rootStyles },
            showTitle && react_1.default.createElement("div", { className: textStyles }, title),
            react_1.default.createElement(react_2.CommandBar, Object.assign({ styles: fluentStyles, className: commandStyles, title: description, ariaLabel: description }, props))))), [textStyles, rootStyles, commandStyles, actions, config, title]);
};
exports.ActionBar = ActionBar;


/***/ }),

/***/ "./src/core/actions/action-bar/action-bar.styles.ts":
/*!**********************************************************!*\
  !*** ./src/core/actions/action-bar/action-bar.styles.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useStyles = exports.commandBarStyles = void 0;
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const commandBarStyles = (props) => {
    const { theme } = props;
    const { spacing } = theme;
    return {
        root: {
            padding: `0 ${spacing.xSmall}`,
            alignItems: 'center',
            gap: spacing.xSmall
        },
        primarySet: {
            alignItems: 'center',
            gap: spacing.xSmall
        },
        secondarySet: {
            alignItems: 'center',
            gap: spacing.xSmall
        },
    };
};
exports.commandBarStyles = commandBarStyles;
exports.useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing }) => ({
    rootStyles: {
        display: "flex",
        width: "100%",
        backgroundColor: palette.neutralEmpty,
    },
    textStyles: Object.assign(Object.assign({}, fonts.mediumPlus), { paddingLeft: spacing.medium, color: palette.neutralEmptyOn, alignSelf: "center" }),
    commandStyles: {
        flex: "1 1"
    }
}));


/***/ }),

/***/ "./src/core/actions/action-bar/index.ts":
/*!**********************************************!*\
  !*** ./src/core/actions/action-bar/index.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./action-bar.component */ "./src/core/actions/action-bar/action-bar.component.tsx"), exports);


/***/ }),

/***/ "./src/core/actions/action-bar/use-transform-actions.hook.ts":
/*!*******************************************************************!*\
  !*** ./src/core/actions/action-bar/use-transform-actions.hook.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTransformActions = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const middleware_1 = __webpack_require__(/*! ../../../middleware */ "./src/middleware/index.ts");
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const transformComponent = (action, components, template) => {
    const { component } = action;
    if (typeof component === 'string')
        return components.find(({ $id }) => $id == component);
    else if (component)
        return component;
    const { permission, name, coachmark } = action, props = tslib_1.__rest(action, ["permission", "name", "coachmark"]);
    const coachmarks = coachmark
        ? [Object.assign(Object.assign({}, coachmark), { target: "component.chrome" })]
        : undefined;
    const actionComponent = {
        $id: `component.app-action-${name}`,
        template,
        $schema: smarthub_common_1.IComponentSchema,
        props,
        coachmarks
    };
    return permission
        ? {
            $id: `component.app-secured-${name}`,
            permission,
            template: middleware_1.componentMiddleWareIds.components.secured,
            $schema: smarthub_common_1.IComponentSchema,
            children: [actionComponent]
        }
        : actionComponent;
};
const transformAction = (action, components, render) => {
    const component = transformComponent(action, components, middleware_1.componentMiddleWareIds.components.actionButton);
    if (!component)
        return null;
    const { $id: key } = component;
    const onRender = (props) => render(component, props)();
    return {
        key,
        onRender
    };
};
const transformGroups = (actions, components, render) => actions.reduce((groups, action) => {
    const item = transformAction(action, components, render);
    if (item)
        groups[action.position].push(item);
    return groups;
}, {
    farAfter: [],
    farBefore: [],
    moreAfter: [],
    moreBefore: [],
    nearAfter: [],
    nearBefore: []
});
const useTransformActions = () => {
    const render = smarthub_common_1.useRender();
    return react_1.useCallback((actions, components) => {
        const { farAfter, farBefore, moreAfter, moreBefore, nearAfter, nearBefore } = transformGroups(actions, components, render);
        return {
            farItems: [...farBefore, ...farAfter],
            overflowItems: [...moreBefore, ...moreAfter],
            items: [...nearBefore, ...nearAfter]
        };
    }, []);
};
exports.useTransformActions = useTransformActions;


/***/ }),

/***/ "./src/core/actions/action-button/action-button.component.tsx":
/*!********************************************************************!*\
  !*** ./src/core/actions/action-button/action-button.component.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ActionButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const action_button_styles_1 = __webpack_require__(/*! ./action-button.styles */ "./src/core/actions/action-button/action-button.styles.ts");
const base_action_button_1 = __webpack_require__(/*! ../base-action-button */ "./src/core/actions/base-action-button/index.ts");
const ActionButton = ({ config: { $id, consumes, props: appAction, coachmarks }, data: { renderedInOverflow } }) => {
    const getThemeImageURI = smarthub_common_1.useGetThemeImageURI();
    const { imageStyles } = smarthub_common_1.useFluentStylesWithProps(action_button_styles_1.fluentStyles);
    const handleCommand = smarthub_common_1.useHandleCommand();
    const [state, setState] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setState(consumes), [consumes]);
    return react_1.useMemo(() => {
        const requiresParam = consumes === null || consumes === void 0 ? void 0 : consumes.some(({ required, name }) => required && (state === null || state === void 0 ? void 0 : state[name]) == null);
        if (requiresParam)
            return null;
        const coachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(({ target }) => target == 'component-chrome');
        const { action, description, shortTitle, title, icon } = state
            ? smarthub_common_1.transformData(appAction, state)
            : appAction;
        const extendedProps = {
            key: $id,
            title,
            ariaLabel: description,
            text: shortTitle,
            name: shortTitle,
            iconProps: {
                iconName: typeof icon == 'string' ? icon : undefined,
                imageProps: typeof icon == 'object'
                    ? {
                        styles: imageStyles,
                        src: getThemeImageURI(icon.image),
                        alt: typeof icon.image == 'object'
                            ? icon.image.text
                            : title
                    }
                    : undefined
            },
            onClick: () => {
                handleCommand(action);
            }
        };
        return react_1.default.createElement(base_action_button_1.BaseActionButton, { props: extendedProps, coachmark: coachmark, renderedInOverflow: renderedInOverflow });
    }, [state, appAction, coachmarks, renderedInOverflow]);
};
exports.ActionButton = ActionButton;


/***/ }),

/***/ "./src/core/actions/action-button/action-button.styles.ts":
/*!****************************************************************!*\
  !*** ./src/core/actions/action-button/action-button.styles.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fluentStyles = void 0;
const fluentStyles = ({ theme: { sizes } }) => ({
    imageStyles: {
        image: {
            height: sizes.xSmall
        },
    }
});
exports.fluentStyles = fluentStyles;


/***/ }),

/***/ "./src/core/actions/action-button/index.ts":
/*!*************************************************!*\
  !*** ./src/core/actions/action-button/index.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./action-button.component */ "./src/core/actions/action-button/action-button.component.tsx"), exports);


/***/ }),

/***/ "./src/core/actions/base-action-button/base-action-button.interface.ts":
/*!*****************************************************************************!*\
  !*** ./src/core/actions/base-action-button/base-action-button.interface.ts ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/core/actions/base-action-button/base-action-button.styles.ts":
/*!**************************************************************************!*\
  !*** ./src/core/actions/base-action-button/base-action-button.styles.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.baseSplitButtonStyles = exports.baseButtonStyles = void 0;
const baseButtonStyles = ({ theme: { sizes } }) => ({
    buttonStyles: {
        root: {
            height: sizes.mediumPlus
        }
    },
    imageStyles: {
        image: {
            height: sizes.xSmall
        },
    },
    contextMenuStyles: {
        root: {
            width: "100%",
            height: sizes.mediumPlus
        },
        textContainer: {
            textAlign: "left"
        }
    }
});
exports.baseButtonStyles = baseButtonStyles;
const baseSplitButtonStyles = ({ theme: { palette, fonts, sizes, spacing } }) => ({
    contextMenuStyles: {
        root: {
            width: "100%",
            height: sizes.mediumPlus
        },
        textContainer: {
            textAlign: "left"
        }
    },
    imageStyles: {
        image: {
            height: sizes.xSmall
        },
    },
    buttonStyles: {
        splitButtonContainer: {
            marginLeft: spacing.xSmall
        },
        root: {
            padding: 0,
            border: 0,
            minHeight: sizes.medium,
            height: "100%"
        },
        rootHovered: {
            border: 0,
        },
        menuIcon: {
            margin: `0 ${spacing.normal}`
        },
        splitButtonMenuButton: {
            border: 0,
            borderRadius: 0,
        },
        splitButtonMenuIcon: {
            margin: `${spacing.small} ${spacing.small} 0 ${spacing.small}`,
        },
        splitButtonDivider: {
            display: "none",
        },
        textContainer: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        flexContainer: {
            padding: `0 ${spacing.smallPlus}`,
            boxSizing: "border-box",
            alignItems: "center"
        },
        label: {
            lineHeight: "normal",
            marginBottom: "0",
            fontWeight: "400"
        },
        description: {
            lineHeight: fonts.large.fontSize,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        }
    }
});
exports.baseSplitButtonStyles = baseSplitButtonStyles;


/***/ }),

/***/ "./src/core/actions/base-action-button/base-action-button.tsx":
/*!********************************************************************!*\
  !*** ./src/core/actions/base-action-button/base-action-button.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BaseActionButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const base_action_button_styles_1 = __webpack_require__(/*! ./base-action-button.styles */ "./src/core/actions/base-action-button/base-action-button.styles.ts");
const utilities_1 = __webpack_require__(/*! ../../../utilities */ "./src/utilities/index.ts");
const BaseActionButton = ({ props, coachmark, buttonStyles, renderedInOverflow }) => {
    const { contextMenuStyles, buttonStyles: normalStyles } = smarthub_common_1.useFluentStylesWithProps(buttonStyles || base_action_button_styles_1.baseButtonStyles, props);
    const styles = renderedInOverflow
        ? contextMenuStyles
        : normalStyles;
    return react_1.useMemo(() => {
        if (!props)
            return null;
        const Component = props.menuProps
            ? react_2.CompoundButton
            : react_2.CommandBarButton;
        const { key, title } = props, buttonProps = tslib_1.__rest(props, ["key", "title"]);
        const content = react_1.default.createElement(react_2.TooltipHost, { id: key, content: title },
            react_1.default.createElement(Component, Object.assign({}, buttonProps, { styles: styles })));
        return coachmark
            ? react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, coachmark),
                react_1.default.createElement("div", null, content))
            : content;
    }, [props, coachmark, styles]);
};
exports.BaseActionButton = BaseActionButton;


/***/ }),

/***/ "./src/core/actions/base-action-button/index.ts":
/*!******************************************************!*\
  !*** ./src/core/actions/base-action-button/index.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./base-action-button */ "./src/core/actions/base-action-button/base-action-button.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./base-action-button.interface */ "./src/core/actions/base-action-button/base-action-button.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./base-action-button.styles */ "./src/core/actions/base-action-button/base-action-button.styles.ts"), exports);


/***/ }),

/***/ "./src/core/actions/index.ts":
/*!***********************************!*\
  !*** ./src/core/actions/index.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./action-bar */ "./src/core/actions/action-bar/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./action-button */ "./src/core/actions/action-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./split-button */ "./src/core/actions/split-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./base-action-button */ "./src/core/actions/base-action-button/index.ts"), exports);


/***/ }),

/***/ "./src/core/actions/split-button/index.ts":
/*!************************************************!*\
  !*** ./src/core/actions/split-button/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./split-button.component */ "./src/core/actions/split-button/split-button.component.tsx"), exports);


/***/ }),

/***/ "./src/core/actions/split-button/split-button.component.tsx":
/*!******************************************************************!*\
  !*** ./src/core/actions/split-button/split-button.component.tsx ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SplitButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const split_button_styles_1 = __webpack_require__(/*! ./split-button.styles */ "./src/core/actions/split-button/split-button.styles.ts");
const base_action_button_1 = __webpack_require__(/*! ../base-action-button */ "./src/core/actions/base-action-button/index.ts");
const SplitButton = ({ props, coachmark, buttonStyles, renderedInOverflow }) => {
    const styles = buttonStyles || split_button_styles_1.fluentStyles;
    return react_1.default.createElement(base_action_button_1.BaseActionButton, { props: props, coachmark: coachmark, buttonStyles: styles, renderedInOverflow: renderedInOverflow });
};
exports.SplitButton = SplitButton;


/***/ }),

/***/ "./src/core/actions/split-button/split-button.styles.ts":
/*!**************************************************************!*\
  !*** ./src/core/actions/split-button/split-button.styles.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fluentStyles = void 0;
const base_action_button_1 = __webpack_require__(/*! ../base-action-button */ "./src/core/actions/base-action-button/index.ts");
const fluentStyles = (props) => {
    var _a;
    const { theme, config } = props;
    const { spacing, fonts } = theme;
    const { buttonStyles, contextMenuStyles, imageStyles } = base_action_button_1.baseSplitButtonStyles(props);
    return {
        contextMenuStyles,
        imageStyles,
        buttonStyles: Object.assign(Object.assign({}, buttonStyles), { icon: {
                margin: `0 ${spacing.normal} 0 ${spacing.xSmall}`,
                fontSize: ((_a = config.iconProps) === null || _a === void 0 ? void 0 : _a.iconName) == 'ChromeClose'
                    ? fonts.small.fontSize
                    : fonts.superLarge.fontSize
            } })
    };
};
exports.fluentStyles = fluentStyles;


/***/ }),

/***/ "./src/core/card-list-base/card-list-base.component.tsx":
/*!**************************************************************!*\
  !*** ./src/core/card-list-base/card-list-base.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CardListBase = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_visibility_sensor_1 = tslib_1.__importDefault(__webpack_require__(/*! react-visibility-sensor */ "react-visibility-sensor"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles(({ spacing }) => {
    return {
        list: ({ responsive: { spread, horizontal = true, wrap = true, } = {
            horizontal: true,
            wrap: true,
        } }) => ({
            gap: spacing.medium,
            flexWrap: wrap ? 'wrap' : 'nowrap',
            justifyContent: spread == "even" ? "space-between" : "start",
            flexDirection: horizontal ? "row" : "column",
            display: "flex",
            padding: "0",
            margin: "0",
        }),
        card: ({ responsive: { columns = 1, rows = 0 } = {
            columns: 1,
            rows: 0
        } }) => ({
            height: "auto",
            maxHeight: "100%",
            display: "flex",
            padding: "0",
            margin: "0",
            width: columns > 0 ? `calc((100% - (${spacing.medium} * ${columns - 1})) / ${columns})` : "auto",
            maxWidth: columns > 0 ? `calc((100% - (${spacing.medium} * ${columns - 1})) / ${columns})` : "100%",
            flex: rows != undefined
                ? rows > 0
                    ? `1 0 calc((100% - (${spacing.medium} * ${rows - 1})) / ${rows})`
                    : "1 1 100%"
                : columns != undefined
                    ? "none"
                    : undefined,
        }),
        loadMoreStackItem: ({ responsive: { wrap = true, horizontal = true, } = {
            wrap: true,
            horizontal: true,
        } }) => ({
            display: "flex",
            justifyContent: "center",
            flexDirection: horizontal && !wrap ? "column" : "row",
            height: horizontal && !wrap ? "100%" : "auto",
            width: !horizontal || wrap ? "100%" : "auto",
            marginTop: spacing.xxLarge,
            padding: spacing.xxLarge,
        }),
    };
});
const fluentStyles = (({ responsive: { wrap = true, horizontal = true, } = {
    wrap: true,
    horizontal: true,
    columns: 1,
    rows: 0
}, }) => {
    return {
        loadMore: {
            root: {
                width: horizontal && !wrap ? "100%" : "25%",
            }
        }
    };
});
const CardListBase = ({ items, onLoadMore, responsive, paging, renderCard, noResults = {}, coachmarks, chrome }) => {
    const loading = react_1.useRef(true);
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const styleProps = smarthub_common_1.useThemeStyleProps(chrome, responsive);
    const fStyles = smarthub_common_1.useFluentStyles(fluentStyles, styleProps);
    const styles = useStyles(styleProps);
    const onVisibilityChange = react_1.useCallback((isVisible) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        if (isVisible && !loading.current) {
            loading.current = true;
            yield onLoadMore();
            loading.current = false;
        }
    }), [onLoadMore]);
    return react_1.useMemo(() => {
        loading.current = items == null;
        return react_1.default.createElement("ul", { className: styles.list }, items === null || items === void 0 ? void 0 :
            items.map((item, index) => react_1.default.createElement("li", { key: item.$id, className: styles.card }, renderCard({ data: item, index }))),
            paging && react_1.default.createElement("li", { className: styles.loadMoreStackItem },
                react_1.default.createElement(utilities_1.DelayItem, { delay: 1000 },
                    react_1.default.createElement(react_visibility_sensor_1.default, { onChange: onVisibilityChange },
                        react_1.default.createElement(react_2.PrimaryButton, { disabled: loading.current, styles: fStyles.loadMore, ariaLabel: localizeConfig.loadMore, title: localizeConfig.loadMore, text: localizeConfig.loadMore, ariaDescription: localizeConfig.loadMoreDesc, onClick: onLoadMore })))));
    }, [items, styles.card, styles.loadMoreStackItem, styles.list, onVisibilityChange]);
};
exports.CardListBase = CardListBase;


/***/ }),

/***/ "./src/core/card-list-base/index.ts":
/*!******************************************!*\
  !*** ./src/core/card-list-base/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./card-list-base.component */ "./src/core/card-list-base/card-list-base.component.tsx"), exports);


/***/ }),

/***/ "./src/core/command-bar/command-bar.component.tsx":
/*!********************************************************!*\
  !*** ./src/core/command-bar/command-bar.component.tsx ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CommandBar = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const component_chrome_1 = __webpack_require__(/*! ../component-chrome */ "./src/core/component-chrome/index.ts");
const bot_1 = __webpack_require__(/*! ../../bot */ "./src/bot/index.ts");
const useStyles = react_jss_1.createUseStyles(({ sizes, palette, spacing }) => ({
    bar: {
        backgroundColor: palette.neutralMinus5,
        width: "100%",
        display: "flex",
        flexDirection: "row",
        height: "auto",
        boxSizing: "border-box",
        justifyContent: "space-between",
    },
    section: {
        flex: "1 1",
        display: "flex",
        alignItems: "center",
        height: sizes.large,
        boxSizing: "border-box",
        margin: `${spacing.medium} 0 ${spacing.medium} ${spacing.medium}`,
        justifyContent: "center"
    }
}));
const CommandBar = ({ config, config: { children, coachmarks } }) => {
    const localize = smarthub_common_1.useLocalizeConfig();
    const resetPanel = smarthub_common_1.useResetPanelId('main');
    const resetPage = smarthub_common_1.useResetPanelId('page');
    const chatPanelState = smarthub_common_1.usePanelView('chat');
    const chromeCoachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(coachmark => coachmark.target === 'chat-controls');
    const styles = useStyles();
    const buttonStyles = smarthub_common_1.useButtonStyles();
    const back = react_1.useCallback(() => {
        history.back();
    }, []);
    const forward = react_1.useCallback(() => {
        history.forward();
    }, []);
    const home = react_1.useCallback(() => {
        resetPage();
        resetPanel();
    }, []);
    return (react_1.default.createElement(component_chrome_1.ComponentChrome, { config: config, className: styles.bar },
        react_1.default.createElement("div", { className: styles.section },
            react_1.default.createElement(react_2.IconButton, { title: localize.iconBack, className: buttonStyles.medium, onClick: back },
                react_1.default.createElement(react_2.Icon, { iconName: "Back" })),
            react_1.default.createElement(react_2.IconButton, { title: localize.iconForward, className: buttonStyles.medium, onClick: forward },
                react_1.default.createElement(react_2.Icon, { iconName: "Forward" })),
            react_1.default.createElement(react_2.IconButton, { title: localize.iconHome, className: buttonStyles.medium, onClick: home },
                react_1.default.createElement(react_2.Icon, { iconName: "HomeSolid" }))),
        react_1.default.createElement(bot_1.ChatControlsInternal, { coachmark: chromeCoachmark, hideOnVisible: true }),
        !chatPanelState.visible && react_1.default.createElement("div", { className: styles.section })));
};
exports.CommandBar = CommandBar;


/***/ }),

/***/ "./src/core/command-bar/index.ts":
/*!***************************************!*\
  !*** ./src/core/command-bar/index.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./command-bar.component */ "./src/core/command-bar/command-bar.component.tsx"), exports);


/***/ }),

/***/ "./src/core/component-chrome/component-chrome.component.tsx":
/*!******************************************************************!*\
  !*** ./src/core/component-chrome/component-chrome.component.tsx ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ComponentChrome = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const component_header_1 = __webpack_require__(/*! ../component-header */ "./src/core/component-header/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useComponentStyles = react_jss_1.createUseStyles(({ spacing, palette }) => ({
    component: ({ responsive: { height, padding } = {}, }) => ({
        width: "100%",
        boxSizing: "border-box",
        borderRadius: spacing.small,
        display: "flex",
        flexDirection: "column",
        height: height == "full" ? "100%" : "auto",
        padding: !padding
            ? undefined
            : padding == "normal"
                ? `${spacing.medium} 0 0 ${spacing.medium}`
                : padding == "normal-left"
                    ? `0 0 0 ${spacing.medium}`
                    : padding == "normal-top"
                        ? `${spacing.medium} 0 0 0`
                        : padding == "large"
                            ? `${spacing.xxLarge} 0 0 ${spacing.xxLarge}`
                            : `${spacing.superLarge} 0 0 ${spacing.superLarge}`,
    }),
    inner: {
        display: "flex",
        height: "100%",
        width: "100%",
        flexDirection: "column",
    },
    hiddenHeader: {
        position: "absolute",
        width: "1px",
        height: "1px",
        padding: 0,
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        border: 0,
    },
    body: ({ config: { background }, responsive: { scroll, height, padding } = {}, }) => (Object.assign(Object.assign({ flex: "1 1", position: "relative", boxSizing: "border-box", borderRadius: spacing.xSmall, height: height == "full" ? "100%" : "auto" }, (scroll == "horizontal"
        ? {
            overflowY: "hidden",
            overflowX: "overlay",
            paddingBottom: spacing.medium,
        }
        : scroll == "vertical"
            ? {
                overflowY: "overlay",
                overflowX: "hidden",
                height: "0",
                paddingRight: padding && background != "fill" ? spacing.smallPlus : 0,
                marginRight: padding && background != "fill" ? `-${spacing.smallPlus}` : 0,
                flex: "auto",
            }
            : null)), (background == "fill"
        ? {
            paddingLeft: 0,
            backgroundColor: palette.neutralEmpty,
        }
        : background == "trans"
            ? {
                paddingLeft: 0,
                backgroundColor: palette.filmVar,
                backdropFilter: `blur(${spacing.medium})`,
            }
            : null))),
}));
const ComponentChrome = (_a) => {
    var { config, config: { $id, chrome: configChrome = {} }, headerContent, footerContent, hasContent = true, error, enableCoachmark, className, "aria-label": ariaLabel, title, children } = _a, props = tslib_1.__rest(_a, ["config", "config", "headerContent", "footerContent", "hasContent", "error", "enableCoachmark", "className", "aria-label", "title", "children"]);
    const chrome = Object.assign(Object.assign({}, configChrome), props);
    const { noContent, focus = true, focusable, header, footer, responsive, minimizeKey, } = chrome;
    const localize = smarthub_common_1.useLocalizeConfig();
    const render = smarthub_common_1.useRender();
    const styleProps = smarthub_common_1.useStyleProps(chrome, responsive);
    const styles = useComponentStyles(styleProps);
    const focusStyles = smarthub_common_1.useFocusStyles();
    const prefKey = (minimizeKey === null || minimizeKey === void 0 ? void 0 : minimizeKey.length) ? minimizeKey : $id;
    const [minimised] = smarthub_common_1.usePreference(`${smarthub_common_1.preferenceKeys.componentMinPrefix}${prefKey}`, true, false);
    const shouldEnterInnerZone = (ev) => ev.key == "Enter";
    const showContent = !minimised &&
        (hasContent || (noContent === null || noContent === void 0 ? void 0 : noContent.show) === null || (noContent === null || noContent === void 0 ? void 0 : noContent.show) === undefined);
    const renderHeader = react_1.useMemo(() => {
        var _a;
        if (headerContent) {
            return react_1.default.createElement("header", null, headerContent);
        }
        else if (header) {
            return react_1.default.createElement("header", null, render(header, config, component_header_1.ComponentHeader)());
        }
        else if ((_a = config.title) === null || _a === void 0 ? void 0 : _a.length) {
            return (react_1.default.createElement("header", { className: styles.hiddenHeader },
                react_1.default.createElement("h2", null, config.title)));
        }
        return null;
    }, [headerContent, header, config, styles]);
    const renderFooter = react_1.useMemo(() => {
        if (footerContent) {
            return react_1.default.createElement("footer", null, footerContent);
        }
        else if (footer) {
            return react_1.default.createElement("footer", null, render(footer, config)());
        }
        return null;
    }, [footerContent, footer, config]);
    const chromeContent = react_1.useMemo(() => {
        const showNoResults = !minimised && (noContent === null || noContent === void 0 ? void 0 : noContent.show);
        const hasChromeElements = renderHeader || renderFooter;
        const props = {
            "data-is-scrollable": true,
            className: [styles.body, className || ""].join(" "),
        };
        const content = showContent ? (children) : showNoResults ? (react_1.default.createElement(utilities_1.NoResults, Object.assign({}, noContent))) : null;
        const body = content ? (hasChromeElements ? (react_1.default.createElement("section", Object.assign({}, props), content)) : (content)) : null;
        if (focus !== false) {
            return (react_1.default.createElement(react_2.FocusZone, Object.assign({ as: !hasChromeElements ? "section" : "div", direction: focus === true
                    ? react_2.FocusZoneDirection.domOrder
                    : react_2.FocusZoneDirection[focus], shouldEnterInnerZone: !focusable ? shouldEnterInnerZone : undefined }, (!hasChromeElements ? props : { className: styles.inner })),
                renderHeader,
                body,
                renderFooter));
        }
        else {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                renderHeader,
                body,
                renderFooter));
        }
    }, [
        hasContent,
        styles,
        noContent,
        children,
        renderHeader,
        renderFooter,
        minimised,
        className,
    ]);
    const renderChrome = react_1.useMemo(() => {
        const { coachmarks, description: configDescription, title: configTitle, } = config;
        const hasChromeElements = renderHeader || renderFooter;
        const chromeCoachmark = enableCoachmark !== false
            ? coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find((coachmark) => coachmark.target === "component-chrome") : null;
        const labelPrefix = (ariaLabel === null || ariaLabel === void 0 ? void 0 : ariaLabel.length) ? ariaLabel : configDescription;
        const directionText = focus == "horizontal"
            ? localize.focusZoneHorizontalLabel
            : focus == "vertical"
                ? localize.focusZoneVerticalLabel
                : localize.focusZoneBothLabel;
        const label = `${labelPrefix} ${!focusable ? directionText : ""}`;
        const titleText = (title === null || title === void 0 ? void 0 : title.length) ? title : configTitle;
        const bodyClass = showContent && !hasChromeElements && !focus
            ? [styles.body, className || ""].join(" ")
            : "";
        const combinedClass = [
            styles.component,
            className,
            bodyClass,
            focusable ? focusStyles : "",
        ].join(" ");
        const content = (react_1.default.createElement("article", Object.assign({ "aria-label": label, title: titleText, className: combinedClass, "data-is-focusable": focusable, tabIndex: focusable ? 0 : undefined }, props), chromeContent));
        return chromeCoachmark ? (react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, chromeCoachmark), content)) : (content);
    }, [config, styles, chromeContent, ariaLabel, title, className, props]);
    return react_1.useMemo(() => error ? (react_1.default.createElement(utilities_1.ErrorBox, { error: error })) : hasContent || (noContent === null || noContent === void 0 ? void 0 : noContent.show) !== false ? (renderChrome) : (react_1.default.createElement(react_1.default.Fragment, null)), [renderChrome, noContent, hasContent, error]);
};
exports.ComponentChrome = ComponentChrome;


/***/ }),

/***/ "./src/core/component-chrome/index.ts":
/*!********************************************!*\
  !*** ./src/core/component-chrome/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./component-chrome.component */ "./src/core/component-chrome/component-chrome.component.tsx"), exports);


/***/ }),

/***/ "./src/core/component-header/component-header.component.tsx":
/*!******************************************************************!*\
  !*** ./src/core/component-header/component-header.component.tsx ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ComponentHeader = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_1 = __webpack_require__(/*! react */ "react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_3 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const fluentStyles = (({ config: { minimised }, theme: { sizes } }) => ({
    button: {
        root: {
            height: sizes.mediumPlus,
            width: sizes.mediumPlus
        }
    },
    icon: {
        root: {
            transition: "transform 0.1s linear 0s",
            transform: minimised ? "rotate(-90deg)" : undefined
        }
    }
}));
const useHeaderStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing, sizes, type }) => ({
    root: ({ config: { style, align, background } }) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: !align || align == 'left'
            ? 'flex-start'
            : align == 'right'
                ? 'flex-end'
                : 'center',
        marginBottom: style == 'detail'
            ? spacing.smallPlus
            : 0,
        backgroundColor: background == 'fill' ? palette.neutralEmpty : undefined,
        color: palette.neutralEmptyOn,
        borderRadius: style == 'mini' ? 0 : spacing.xSmall,
        borderBottom: style != 'keyline' && background == 'fill' ? `${spacing.tiny} solid ${type == "dark" ? palette.neutralMinus5 : palette.neutralMinus3}` : undefined,
        flex: "0 0",
        ['&::after']: style == 'keyline' && (!align || align == 'left' || align == 'center')
            ? {
                backgroundColor: background == "fill"
                    ? type == "dark" ? palette.neutralMinus5 : palette.neutralMinus3
                    : palette.neutral,
                height: spacing.tiny,
                content: '""',
                display: "block",
                flex: "1 1"
            }
            : undefined,
        ['&::before']: style == 'keyline' && (align == 'right' || align == 'center')
            ? {
                backgroundColor: background == "fill"
                    ? type == "dark" ? palette.neutralMinus5 : palette.neutralMinus3
                    : palette.neutral,
                height: spacing.tiny,
                content: '""',
                display: "block",
                flex: "1 1"
            }
            : undefined
    }),
    icon: {
        fontSize: sizes.mediumEm,
        color: palette.primary,
        float: "left",
        marginRight: spacing.tiny,
    },
    title: ({ config: { style } }) => (Object.assign(Object.assign({}, (style == 'detail'
        ? fonts.mediumPlus
        : fonts.medium)), { overFlow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", margin: 0, padding: style == 'mini'
            ? `0 ${spacing.smallPlus} 0 0`
            : style == 'keyline'
                ? `${spacing.smallPlus} ${spacing.medium}`
                : style == 'detail'
                    ? 0
                    : spacing.medium, display: "inline-block", verticalAlign: "top" })),
    description: {
        margin: 0,
        padding: 0
    },
}));
const defaultHeaderLevel = 'h2';
const configReplacements = (config, params) => {
    const { title = '', description = '', consumes } = config;
    if (consumes === null || consumes === void 0 ? void 0 : consumes.length) {
        return params
            ? smarthub_common_1.deepReplaceParams({ title, description }, params)
            : {
                title: '',
                description: ''
            };
    }
    return {
        title,
        description
    };
};
const ComponentHeader = ({ config, data: componentConfig }) => {
    const { $id, consumes, props: { style, align, headerLevel, icon } = {}, responsive } = config;
    const { $id: parentId, chrome: { minimizeKey, background } = { background: null, minimizeKey: null } } = componentConfig || { chrome: {} };
    const HeaderTag = headerLevel || defaultHeaderLevel;
    const prefKey = (minimizeKey === null || minimizeKey === void 0 ? void 0 : minimizeKey.length) ? minimizeKey
        : parentId;
    const [minimised, minimise] = smarthub_common_1.usePreference(`${smarthub_common_1.preferenceKeys.componentMinPrefix}${prefKey}`, true, false);
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const handleClick = react_1.useCallback(() => {
        minimise(minimised ? null : true);
    }, [minimise, minimised]);
    const styleConfig = react_1.useMemo(() => ({
        style,
        align,
        minimised,
        background
    }), [minimised, style, align, background]);
    const styleProps = smarthub_common_1.useThemeStyleProps(styleConfig, responsive);
    const buttonStyles = smarthub_common_1.useFluentStyles(fluentStyles, styleProps);
    const styles = useHeaderStyles(styleProps);
    const [replacements, setReplacements] = smarthub_common_1.useSharedStates($id);
    react_1.useEffect(() => setReplacements(consumes), [consumes]);
    const { title, description } = react_1.useMemo(() => configReplacements(config, replacements), [replacements, config]);
    return react_1.useMemo(() => (react_3.default.createElement("div", { className: styles.root },
        style == 'mini' && react_3.default.createElement(react_2.IconButton, { styles: buttonStyles.button, ariaLabel: minimised
                ? `${localizeConfig.expandComponent} ${title}`
                : `${localizeConfig.minimiseComponent} ${title}`, title: minimised
                ? `${localizeConfig.expandComponent} ${title}`
                : `${localizeConfig.minimiseComponent} ${title}`, iconProps: {
                styles: buttonStyles.icon,
                iconName: "ChevronDownMed"
            }, onClick: handleClick }),
        style == 'detail' && react_3.default.createElement(react_2.Icon, { iconName: icon, className: styles.icon }),
        react_3.default.createElement("div", null,
            react_3.default.createElement(HeaderTag, { className: styles.title }, title),
            style == 'detail' && react_3.default.createElement("p", { className: styles.description }, description)))), [styles, title, description, handleClick]);
};
exports.ComponentHeader = ComponentHeader;


/***/ }),

/***/ "./src/core/component-header/index.ts":
/*!********************************************!*\
  !*** ./src/core/component-header/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./component-header.component */ "./src/core/component-header/component-header.component.tsx"), exports);


/***/ }),

/***/ "./src/core/index.ts":
/*!***************************!*\
  !*** ./src/core/index.ts ***!
  \***************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./card-list-base */ "./src/core/card-list-base/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./command-bar */ "./src/core/command-bar/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./component-chrome */ "./src/core/component-chrome/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./component-header */ "./src/core/component-header/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-entity-header */ "./src/core/panel-entity-header/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-entity-menu */ "./src/core/panel-entity-menu/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-entity-search */ "./src/core/panel-entity-search/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-header */ "./src/core/panel-header/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-sidebar */ "./src/core/panel-sidebar/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-sidebar-button */ "./src/core/panel-sidebar-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./tab-navigation */ "./src/core/tab-navigation/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./secured */ "./src/core/secured/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./actions */ "./src/core/actions/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./list-actions */ "./src/core/list-actions/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./view-menu */ "./src/core/view-menu/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-menu */ "./src/core/page-menu/index.ts"), exports);


/***/ }),

/***/ "./src/core/list-actions/az-button/az-button.component.tsx":
/*!*****************************************************************!*\
  !*** ./src/core/list-actions/az-button/az-button.component.tsx ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AZButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const az_button_styles_1 = __webpack_require__(/*! ./az-button.styles */ "./src/core/list-actions/az-button/az-button.styles.ts");
const actions_1 = __webpack_require__(/*! ../../actions */ "./src/core/actions/index.ts");
const AZButton = ({ config: { $id, provides, coachmarks }, data: { renderedInOverflow } }) => {
    const provider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'az');
    const [state, setState] = smarthub_common_1.useSharedState(provider);
    const localize = smarthub_common_1.useLocalizeConfig();
    const styles = smarthub_common_1.useFluentStylesWithProps(az_button_styles_1.menuStyles);
    const items = react_1.useMemo(() => {
        const { azFilterValueDesc, azFilterValueTitle } = localize;
        const menuItems = [];
        for (let i = "A".charCodeAt(0); i <= "Z".charCodeAt(0); i++) {
            let char = String.fromCharCode(i);
            menuItems.push({
                key: char,
                text: char,
                ariaDescription: `${azFilterValueDesc} ${char}`,
                ariaLabel: `${azFilterValueTitle} ${char}`,
                title: `${azFilterValueTitle} ${char}`,
                onClick: () => setState(char)
            });
        }
        return menuItems;
    }, []);
    return react_1.useMemo(() => {
        const coachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(({ target }) => target == 'component-chrome');
        const { azFilterDesc, azFilterSecondaryText, azFilterText, azFilterTitle } = localize;
        const props = {
            key: $id,
            text: `${azFilterText}`,
            name: `${azFilterText}`,
            title: `${azFilterTitle} ${state}`,
            split: state != null,
            checked: state != null,
            menuProps: {
                items,
                styles: styles
            },
            iconProps: state
                ? { iconName: 'ChromeClose' }
                : null,
            secondaryText: state
                ? `${azFilterSecondaryText} ${state}`
                : null,
            ariaDescription: `${azFilterDesc} ${state}`,
            ariaLabel: `${azFilterTitle} ${state}`,
            onClick: () => state != null
                ? setState()
                : null
        };
        return react_1.default.createElement(actions_1.SplitButton, { props: props, coachmark: coachmark, renderedInOverflow: renderedInOverflow });
    }, [localize, state, coachmarks, renderedInOverflow]);
};
exports.AZButton = AZButton;


/***/ }),

/***/ "./src/core/list-actions/az-button/az-button.styles.ts":
/*!*************************************************************!*\
  !*** ./src/core/list-actions/az-button/az-button.styles.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.menuStyles = void 0;
const menuStyles = (props) => {
    const { sizes } = props.theme;
    return {
        list: {
            maxWidth: `calc(5 * ${sizes.mediumPlus})`
        },
        subComponentStyles: {
            menuItem: {
                root: {
                    padding: 0,
                    textAlign: "center"
                },
                item: {
                    width: sizes.mediumPlus,
                    display: "inline-block",
                }
            },
            callout: {}
        }
    };
};
exports.menuStyles = menuStyles;


/***/ }),

/***/ "./src/core/list-actions/az-button/index.ts":
/*!**************************************************!*\
  !*** ./src/core/list-actions/az-button/index.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./az-button.component */ "./src/core/list-actions/az-button/az-button.component.tsx"), exports);


/***/ }),

/***/ "./src/core/list-actions/clear-selection-button/clear-selection-button.component.tsx":
/*!*******************************************************************************************!*\
  !*** ./src/core/list-actions/clear-selection-button/clear-selection-button.component.tsx ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ClearSelectionButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const actions_1 = __webpack_require__(/*! ../../actions */ "./src/core/actions/index.ts");
const ClearSelectionButton = ({ config: { $id, consumes, props: appAction, coachmarks }, data: { renderedInOverflow } }) => {
    const { clearAllDesc, clearAllTitle, clearAllText } = smarthub_common_1.useLocalizeConfig();
    const [state, setState] = smarthub_common_1.useSharedStates($id);
    const setStates = smarthub_common_1.useSetSharedStates();
    react_1.useEffect(() => setState(consumes), [consumes]);
    const onClick = react_1.useCallback(() => {
        if (!(consumes === null || consumes === void 0 ? void 0 : consumes.length))
            return;
        const values = consumes.map(c => (Object.assign(Object.assign({}, c), { value: null })));
        setStates(values);
    }, [consumes]);
    return react_1.useMemo(() => {
        const keys = state
            ? Object.keys(state)
            : [];
        if (!keys.some(k => state[k] != null))
            return null;
        const coachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(({ target }) => target == 'component-chrome');
        const extendedProps = {
            key: $id,
            text: clearAllText,
            primary: true,
            iconProps: { iconName: 'ChromeClose' },
            ariaDescription: clearAllDesc,
            ariaLabel: clearAllTitle,
            title: clearAllTitle,
            name: clearAllText,
            onClick
        };
        return react_1.default.createElement(actions_1.BaseActionButton, { props: extendedProps, coachmark: coachmark, renderedInOverflow: renderedInOverflow });
    }, [state, appAction, coachmarks, onClick, renderedInOverflow]);
};
exports.ClearSelectionButton = ClearSelectionButton;


/***/ }),

/***/ "./src/core/list-actions/clear-selection-button/index.ts":
/*!***************************************************************!*\
  !*** ./src/core/list-actions/clear-selection-button/index.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./clear-selection-button.component */ "./src/core/list-actions/clear-selection-button/clear-selection-button.component.tsx"), exports);


/***/ }),

/***/ "./src/core/list-actions/date-picker/calendar-menu.component.tsx":
/*!***********************************************************************!*\
  !*** ./src/core/list-actions/date-picker/calendar-menu.component.tsx ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CalendarMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const utc_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/utc */ "dayjs/plugin/utc"));
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const date_picker_styles_1 = __webpack_require__(/*! ./date-picker.styles */ "./src/core/list-actions/date-picker/date-picker.styles.ts");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
dayjs_1.default.extend(utc_1.default);
const stopPropagation = (e) => e.stopPropagation();
const CalendarMenu = ({ value, onChange, isDayPickerVisible }) => {
    const onSelectDate = react_1.useCallback((date) => {
        const ISODate = dayjs_1.default(date).utc().toISOString();
        onChange(ISODate);
    }, []);
    const date = react_1.useMemo(() => {
        const date = dayjs_1.default(value);
        return date.isValid()
            ? date.toDate()
            : undefined;
    }, [value]);
    const styles = smarthub_common_1.useFluentStylesWithProps(date_picker_styles_1.datePickerStyles);
    return react_1.default.createElement("div", { onClick: stopPropagation },
        react_1.default.createElement(react_2.Calendar, { calendarMonthProps: styles, onSelectDate: onSelectDate, strings: react_2.defaultCalendarStrings, highlightSelectedMonth: true, isDayPickerVisible: isDayPickerVisible, showGoToToday: false, value: date, showCloseButton: true }));
};
exports.CalendarMenu = CalendarMenu;


/***/ }),

/***/ "./src/core/list-actions/date-picker/date-picker.component.tsx":
/*!*********************************************************************!*\
  !*** ./src/core/list-actions/date-picker/date-picker.component.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DatePicker = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const actions_1 = __webpack_require__(/*! ../../actions */ "./src/core/actions/index.ts");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const calendar_menu_component_1 = __webpack_require__(/*! ./calendar-menu.component */ "./src/core/list-actions/date-picker/calendar-menu.component.tsx");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const DatePicker = ({ config: { $id, provides, coachmarks, title, description, props: { dayView, format = '' } = {} }, data: { renderedInOverflow } }) => {
    const provider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'date');
    const buttonRef = react_1.useRef();
    const { commonDateFormat } = smarthub_common_1.useLocalizeConfig();
    const [state, setState] = smarthub_common_1.useSharedState(provider);
    const onSelectDate = react_1.useCallback((date) => {
        var _a;
        setState(date);
        (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.dismissMenu();
    }, []);
    return (react_1.useMemo(() => {
        const coachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(({ target }) => target == 'component-chrome');
        const secondaryText = state
            ? dayjs_1.default(state).format(format || commonDateFormat)
            : null;
        const props = {
            componentRef: buttonRef,
            key: $id,
            text: title,
            title: description,
            split: state != null,
            checked: state != null,
            iconProps: {
                iconName: state
                    ? 'ChromeClose'
                    : 'Calendar'
            },
            menuProps: {
                onRenderMenuList: () => react_1.default.createElement(calendar_menu_component_1.CalendarMenu, { isDayPickerVisible: dayView, value: state, onChange: onSelectDate }),
                items: [{ key: $id }]
            },
            onClick: () => state != null
                ? setState()
                : null,
            secondaryText,
        };
        return react_1.default.createElement(actions_1.SplitButton, { props: props, coachmark: coachmark, renderedInOverflow: renderedInOverflow });
    }, [state, coachmarks, renderedInOverflow]));
};
exports.DatePicker = DatePicker;


/***/ }),

/***/ "./src/core/list-actions/date-picker/date-picker.styles.ts":
/*!*****************************************************************!*\
  !*** ./src/core/list-actions/date-picker/date-picker.styles.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.datePickerStyles = void 0;
const datePickerStyles = (props) => {
    const { neutralEmptyOn } = props.theme.palette;
    return {
        styles: {
            currentItemButton: {
                color: neutralEmptyOn
            }
        }
    };
};
exports.datePickerStyles = datePickerStyles;


/***/ }),

/***/ "./src/core/list-actions/date-picker/index.ts":
/*!****************************************************!*\
  !*** ./src/core/list-actions/date-picker/index.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./date-picker.component */ "./src/core/list-actions/date-picker/date-picker.component.tsx"), exports);


/***/ }),

/***/ "./src/core/list-actions/index.ts":
/*!****************************************!*\
  !*** ./src/core/list-actions/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./az-button */ "./src/core/list-actions/az-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./sort-button */ "./src/core/list-actions/sort-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./refiner-button */ "./src/core/list-actions/refiner-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./clear-selection-button */ "./src/core/list-actions/clear-selection-button/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./date-picker */ "./src/core/list-actions/date-picker/index.ts"), exports);


/***/ }),

/***/ "./src/core/list-actions/refiner-button/index.ts":
/*!*******************************************************!*\
  !*** ./src/core/list-actions/refiner-button/index.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./refiner-button.component */ "./src/core/list-actions/refiner-button/refiner-button.component.tsx"), exports);


/***/ }),

/***/ "./src/core/list-actions/refiner-button/refiner-button.component.tsx":
/*!***************************************************************************!*\
  !*** ./src/core/list-actions/refiner-button/refiner-button.component.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RefinerButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const actions_1 = __webpack_require__(/*! ../../actions */ "./src/core/actions/index.ts");
const RefinerButton = ({ config: { $id, provides, consumes, coachmarks }, data: { renderedInOverflow } }) => {
    const refiners = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "refiners"));
    const provider = provides === null || provides === void 0 ? void 0 : provides[0];
    const [state, setState] = smarthub_common_1.useSharedState(provider);
    const localize = smarthub_common_1.useLocalizeConfig();
    return react_1.useMemo(() => {
        var _a;
        const refiner = Array.isArray(refiners)
            ? refiners === null || refiners === void 0 ? void 0 : refiners.find(({ name }) => name == (provider === null || provider === void 0 ? void 0 : provider.name)) : refiners;
        if (!((_a = refiner === null || refiner === void 0 ? void 0 : refiner.values) === null || _a === void 0 ? void 0 : _a.length))
            return null;
        const coachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(({ target }) => target == 'component-chrome');
        const { text, values } = refiner;
        const selected = state
            ? values.find(({ token }) => token == state)
            : null;
        const { value, text: valueText } = selected || {};
        const { refineByTitle, refineByDesc, refineByValueDesc, refineByValueTitle } = localize;
        const items = values.map(({ token, text }) => ({
            key: token,
            text: text,
            ariaDescription: `${refineByValueDesc} ${text} ${text}`,
            ariaLabel: `${refineByValueTitle} ${text} ${text}`,
            title: `${refineByValueTitle} ${text} ${text}`,
            onClick: () => setState(token)
        }));
        const props = {
            key: $id,
            text,
            secondaryText: valueText,
            split: value != null,
            checked: value != null,
            iconProps: value
                ? { iconName: 'ChromeClose' }
                : null,
            ariaDescription: `${refineByDesc} ${text} ${valueText}`,
            ariaLabel: `${refineByTitle} ${text} ${valueText}`,
            menuProps: {
                items
            },
            onClick: () => value != null
                ? setState()
                : null
        };
        return react_1.default.createElement(actions_1.SplitButton, { props: props, coachmark: coachmark, renderedInOverflow: renderedInOverflow });
    }, [localize, state, refiners, provides, coachmarks, renderedInOverflow]);
};
exports.RefinerButton = RefinerButton;


/***/ }),

/***/ "./src/core/list-actions/sort-button/index.ts":
/*!****************************************************!*\
  !*** ./src/core/list-actions/sort-button/index.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./sort-button.component */ "./src/core/list-actions/sort-button/sort-button.component.tsx"), exports);


/***/ }),

/***/ "./src/core/list-actions/sort-button/sort-button.component.tsx":
/*!*********************************************************************!*\
  !*** ./src/core/list-actions/sort-button/sort-button.component.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SortButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const actions_1 = __webpack_require__(/*! ../../actions */ "./src/core/actions/index.ts");
const SortButton = ({ config: { $id, provides, consumes, coachmarks }, data: { renderedInOverflow } }) => {
    const options = smarthub_common_1.useReadSharedState(consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == "sort-options"));
    const provider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'sort');
    const [state, setState] = smarthub_common_1.useSharedState(provider);
    const localize = smarthub_common_1.useLocalizeConfig();
    return react_1.useMemo(() => {
        var _a;
        if (!(options === null || options === void 0 ? void 0 : options.length))
            return null;
        const coachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(({ target }) => target == 'component-chrome');
        const { sortByText, sortByDesc, sortByTitle, sortByValueDesc, sortByValueTitle } = localize;
        const items = options.map(({ text, name, direction }) => ({
            key: `${name}-${direction}`,
            text: text,
            iconProps: {
                iconName: !direction || direction == 'ascending' || direction == 'asc'
                    ? 'ascending'
                    : 'descending'
            },
            ariaDescription: `${sortByValueDesc} ${text}`,
            ariaLabel: `${sortByValueTitle} ${text}`,
            title: `${sortByValueTitle} ${text}`,
            onClick: () => setState({ name, direction })
        }));
        const sort = (_a = (state
            ? options.find(({ name, direction }) => name == state.name &&
                direction == state.direction)
            : options.find(({ preferred }) => preferred))) !== null && _a !== void 0 ? _a : options[0];
        const asc = !sort.direction || sort.direction == 'ascending' || sort.direction == 'asc';
        const props = {
            key: $id,
            text: `${sortByText}`,
            name: `${sortByText}`,
            title: `${sortByTitle} ${sort.text}`,
            split: false,
            iconProps: {
                iconName: asc ? 'ascending' : 'descending'
            },
            secondaryText: sort.text,
            ariaDescription: `${sortByDesc} ${sort.text}`,
            ariaLabel: `${sortByTitle} ${sort.text}`,
            menuProps: {
                items
            },
            onClick: () => state != null
                ? setState()
                : null
        };
        return react_1.default.createElement(actions_1.SplitButton, { props: props, coachmark: coachmark, renderedInOverflow: renderedInOverflow });
    }, [localize, state, coachmarks, options, renderedInOverflow]);
};
exports.SortButton = SortButton;


/***/ }),

/***/ "./src/core/page-menu/bookmark-command-button.component.tsx":
/*!******************************************************************!*\
  !*** ./src/core/page-menu/bookmark-command-button.component.tsx ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BookmarkCommandButton = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const use_render_action_helper_1 = __webpack_require__(/*! ./use-render-action.helper */ "./src/core/page-menu/use-render-action.helper.tsx");
const getValue = (value, locale) => {
    return typeof value == "object" ? value[locale] : value;
};
const BookmarkCommandButton = (props) => {
    const getThemeImageURI = smarthub_common_1.useGetThemeImageURI();
    const entity = smarthub_common_1.usePanelEntity();
    const locale = smarthub_common_1.useLocale();
    const [bookmarked, bookmark] = smarthub_common_1.useBookmark(entity === null || entity === void 0 ? void 0 : entity.bookmark);
    const getProps = ({ title, shortTitle, description, icon, coachmark }, buttonProps) => (Object.assign(Object.assign({}, buttonProps), { title: getValue(title, locale), ariaLabel: getValue(description, locale), text: getValue(shortTitle, locale), iconProps: {
            iconName: typeof icon == "string" ? icon : undefined,
            imageProps: typeof icon == "object"
                ? {
                    src: getThemeImageURI(icon.image),
                    alt: typeof icon.image == "object"
                        ? icon.image.text
                        : getValue(title, locale),
                }
                : undefined,
        }, onClick: () => {
            bookmark();
        } }));
    return use_render_action_helper_1.useRenderAction(props, getProps, bookmarked);
};
exports.BookmarkCommandButton = BookmarkCommandButton;


/***/ }),

/***/ "./src/core/page-menu/content-view-command-button.component.tsx":
/*!**********************************************************************!*\
  !*** ./src/core/page-menu/content-view-command-button.component.tsx ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ContentViewCommandButton = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const use_render_action_helper_1 = __webpack_require__(/*! ./use-render-action.helper */ "./src/core/page-menu/use-render-action.helper.tsx");
const getValue = (value, locale) => {
    return typeof value == "object" ? value[locale] : value;
};
const ContentViewCommandButton = (props) => {
    const getThemeImageURI = smarthub_common_1.useGetThemeImageURI();
    const { content } = smarthub_common_1.usePanelView() || {};
    const locale = smarthub_common_1.useLocale();
    const setContentView = smarthub_common_1.useSetPreference(smarthub_common_1.preferenceKeys.pageContentView);
    const toggle = react_1.useCallback(() => {
        setContentView(content == "expanded" ? "normal" : "expanded");
    }, [content]);
    const getProps = ({ title, shortTitle, description, icon, coachmark }, buttonProps) => (Object.assign(Object.assign({}, buttonProps), { title: getValue(title, locale), ariaLabel: getValue(description, locale), text: getValue(shortTitle, locale), iconProps: {
            iconName: typeof icon == "string" ? icon : undefined,
            imageProps: typeof icon == "object"
                ? {
                    src: getThemeImageURI(icon.image),
                    alt: typeof icon.image == "object"
                        ? icon.image.text
                        : getValue(title, locale),
                }
                : undefined,
        }, onClick: toggle }));
    return use_render_action_helper_1.useRenderAction(props, getProps, content == "expanded");
};
exports.ContentViewCommandButton = ContentViewCommandButton;


/***/ }),

/***/ "./src/core/page-menu/index.ts":
/*!*************************************!*\
  !*** ./src/core/page-menu/index.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./page-menu.component */ "./src/core/page-menu/page-menu.component.tsx"), exports);


/***/ }),

/***/ "./src/core/page-menu/menu-command-button.component.tsx":
/*!**************************************************************!*\
  !*** ./src/core/page-menu/menu-command-button.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MenuCommandButton = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const use_render_action_helper_1 = __webpack_require__(/*! ./use-render-action.helper */ "./src/core/page-menu/use-render-action.helper.tsx");
const getValue = (value, locale) => {
    return typeof value == "object" ? value[locale] : value;
};
const MenuCommandButton = (props) => {
    const getThemeImageURI = smarthub_common_1.useGetThemeImageURI();
    const handleCommand = smarthub_common_1.useHandleCommand();
    const locale = smarthub_common_1.useLocale();
    const entity = smarthub_common_1.usePanelEntity();
    const getProps = ({ title, shortTitle, description, icon, coachmark, action }, buttonProps) => {
        if (!entity)
            return buttonProps;
        const command = entity ? smarthub_common_1.deepReplaceParams(action, { entity }) : null;
        return Object.assign(Object.assign({}, buttonProps), { title: getValue(title, locale), ariaLabel: getValue(description, locale), text: getValue(shortTitle, locale), iconProps: {
                iconName: typeof icon == "string" ? icon : undefined,
                imageProps: typeof icon == "object"
                    ? {
                        src: getThemeImageURI(icon.image),
                        alt: typeof icon.image == "object"
                            ? icon.image.text
                            : getValue(title, locale),
                    }
                    : undefined,
            }, onClick: () => {
                handleCommand(command);
            } });
    };
    return use_render_action_helper_1.useRenderAction(props, getProps);
};
exports.MenuCommandButton = MenuCommandButton;


/***/ }),

/***/ "./src/core/page-menu/page-menu-command-button.component.tsx":
/*!*******************************************************************!*\
  !*** ./src/core/page-menu/page-menu-command-button.component.tsx ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageMenuCommandButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const bookmark_command_button_component_1 = __webpack_require__(/*! ./bookmark-command-button.component */ "./src/core/page-menu/bookmark-command-button.component.tsx");
const content_view_command_button_component_1 = __webpack_require__(/*! ./content-view-command-button.component */ "./src/core/page-menu/content-view-command-button.component.tsx");
const menu_command_button_component_1 = __webpack_require__(/*! ./menu-command-button.component */ "./src/core/page-menu/menu-command-button.component.tsx");
const PageMenuCommandButton = (props) => {
    const isContextMenu = props.hasOwnProperty('item');
    const { data: { name } = { name: null }, defaultRender } = isContextMenu
        ? props.item
        : props;
    const Type = !name
        ? defaultRender
        : name == 'bookmark'
            ? bookmark_command_button_component_1.BookmarkCommandButton
            : name == 'content-resize'
                ? content_view_command_button_component_1.ContentViewCommandButton
                : menu_command_button_component_1.MenuCommandButton;
    return react_1.default.createElement(Type, Object.assign({}, props));
};
exports.PageMenuCommandButton = PageMenuCommandButton;


/***/ }),

/***/ "./src/core/page-menu/page-menu.component.tsx":
/*!****************************************************!*\
  !*** ./src/core/page-menu/page-menu.component.tsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const view_menu_1 = __webpack_require__(/*! ../view-menu */ "./src/core/view-menu/index.ts");
const use_menu_action_buttons_hook_1 = __webpack_require__(/*! ./use-menu-action-buttons.hook */ "./src/core/page-menu/use-menu-action-buttons.hook.tsx");
const page_menu_command_button_component_1 = __webpack_require__(/*! ./page-menu-command-button.component */ "./src/core/page-menu/page-menu-command-button.component.tsx");
const component_chrome_1 = __webpack_require__(/*! ../component-chrome */ "./src/core/component-chrome/index.ts");
const onRender = (props, dismiss) => react_1.default.createElement(page_menu_command_button_component_1.PageMenuCommandButton, Object.assign({}, props));
const PageMenu = ({ config }) => {
    var _a, _b, _c;
    const viewConfig = smarthub_common_1.useViewConfig();
    const setPagePosition = smarthub_common_1.useSetPreference(smarthub_common_1.preferenceKeys.pageDockPosition);
    const setPageSize = smarthub_common_1.useSetPreference(smarthub_common_1.preferenceKeys.pageDockSize);
    const { pageMenuTitle, pageMenuLabel, pageMenuCloseDesc, pageMenuCloseTitle, pageMenuCloseText } = smarthub_common_1.useLocalizeConfig();
    const entity = smarthub_common_1.usePanelEntity();
    const setPanel = smarthub_common_1.useSetPanelId();
    const view = smarthub_common_1.usePanelView();
    const { panel } = smarthub_common_1.usePanelViewContext() || {};
    const dockConfig = smarthub_common_1.useResponsiveProps((_b = (_a = panel === null || panel === void 0 ? void 0 : panel.dock) === null || _a === void 0 ? void 0 : _a.options) !== null && _b !== void 0 ? _b : (_c = viewConfig.page) === null || _c === void 0 ? void 0 : _c.dockSizes);
    const buttons = use_menu_action_buttons_hook_1.useMenuActionButtons(panel, entity, onRender);
    const close = react_1.useCallback(() => {
        setPanel();
    }, []);
    const changePageSize = react_1.useCallback((dock) => {
        setPageSize(dock);
    }, []);
    return react_1.useMemo(() => (react_1.default.createElement(component_chrome_1.ComponentChrome, { config: config },
        react_1.default.createElement(view_menu_1.ViewMenu, { title: pageMenuTitle, label: pageMenuLabel, changeDockSize: changePageSize, changeDockPosition: setPagePosition, focusName: "pageMenu", dockSize: view.size, dockPosition: view.position, dockConfig: dockConfig, dockPositionConfig: viewConfig.page.dockPositions, buttons: buttons, closeProps: {
                onClick: close,
                text: pageMenuCloseText,
                title: pageMenuCloseTitle,
                description: pageMenuCloseDesc
            } }))), [close, changePageSize, view, dockConfig, buttons]);
};
exports.PageMenu = PageMenu;


/***/ }),

/***/ "./src/core/page-menu/use-menu-action-buttons.hook.tsx":
/*!*************************************************************!*\
  !*** ./src/core/page-menu/use-menu-action-buttons.hook.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useMenuActionButtons = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const useMenuActionButtons = (panel, entity, onRender) => {
    const getPermission = smarthub_common_1.useHasPermission();
    const [actions, setActions] = react_1.useState(null);
    react_1.useEffect(() => {
        var _a;
        if (!panel || !entity)
            return null;
        let all = [
            ...(((_a = panel === null || panel === void 0 ? void 0 : panel.dock) === null || _a === void 0 ? void 0 : _a.actions) || []),
            ...((entity === null || entity === void 0 ? void 0 : entity.actions) || [])
        ];
        const promises = all
            .filter(({ permission }) => permission)
            .map((action) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const allowed = yield getPermission(action.permission);
            return {
                action,
                allowed
            };
        }));
        if (promises.length)
            Promise.all(promises).then((results) => setActions(all
                .filter(action => {
                const result = results.find(r => r.action == action);
                return result
                    ? result.allowed
                    : true;
            })));
        else
            setActions(all);
    }, [entity, panel]);
    const buildActions = react_1.useCallback((position) => actions
        .filter(({ position: p }) => Array.isArray(position)
        ? ~position.indexOf(p)
        : p == position)
        .map(data => ({
        key: data.name,
        data,
        onRender
    })), [actions]);
    return react_1.useMemo(() => {
        return actions ? {
            overflowItems: buildActions([smarthub_common_1.AppActionPosition.moreBefore, smarthub_common_1.AppActionPosition.moreAfter]),
            beforeItems: buildActions(smarthub_common_1.AppActionPosition.nearBefore),
            afterItems: [
                ...buildActions([smarthub_common_1.AppActionPosition.nearAfter, undefined]),
            ],
            farItems: [
                ...buildActions([smarthub_common_1.AppActionPosition.farBefore, smarthub_common_1.AppActionPosition.farAfter]),
            ]
        } : null;
    }, [actions, buildActions]);
};
exports.useMenuActionButtons = useMenuActionButtons;


/***/ }),

/***/ "./src/core/page-menu/use-render-action.helper.tsx":
/*!*********************************************************!*\
  !*** ./src/core/page-menu/use-render-action.helper.tsx ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useRenderAction = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
//TODO use sizes in next version
const fluentStyles = ({ theme: { sizes } }) => ({
    buttonStyles: {
        root: {
            height: sizes.mediumPlus,
        },
    },
    contextMenuStyles: {
        root: {
            width: "100%",
            height: sizes.mediumPlus,
        },
        textContainer: {
            textAlign: "left",
        },
    },
});
const useRenderAction = (props, getProps, useAlt) => {
    const { buttonStyles, contextMenuStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    return react_1.useMemo(() => {
        const buttonProps = Object.assign(Object.assign({}, props), { styles: props.renderedInOverflow ? contextMenuStyles : buttonStyles });
        const { data, data: { alt }, } = buttonProps;
        const action = useAlt && alt
            ? Object.assign(Object.assign({}, data), alt) : data;
        const { coachmark } = action;
        const _a = getProps
            ? getProps(action, buttonProps)
            : buttonProps, { title } = _a, extendedProps = tslib_1.__rest(_a, ["title"]);
        const { key } = extendedProps;
        const content = (react_1.default.createElement(react_2.TooltipHost, { id: key, content: title },
            react_1.default.createElement(react_2.CommandBarButton, Object.assign({}, extendedProps))));
        return coachmark ? (react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, coachmark),
            react_1.default.createElement("div", null, content))) : (content);
    }, [props, useAlt, buttonStyles, contextMenuStyles]);
};
exports.useRenderAction = useRenderAction;


/***/ }),

/***/ "./src/core/panel-entity-header/index.ts":
/*!***********************************************!*\
  !*** ./src/core/panel-entity-header/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-entity-header.component */ "./src/core/panel-entity-header/panel-entity-header.component.tsx"), exports);


/***/ }),

/***/ "./src/core/panel-entity-header/panel-entity-header.component.tsx":
/*!************************************************************************!*\
  !*** ./src/core/panel-entity-header/panel-entity-header.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelEntityHeader = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_2 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const tab_navigation_1 = __webpack_require__(/*! ../tab-navigation */ "./src/core/tab-navigation/index.ts");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const panel_sidebar_button_1 = __webpack_require__(/*! ../panel-sidebar-button */ "./src/core/panel-sidebar-button/index.ts");
const fluentStyles = (({ theme: { spacing } }) => ({
    personaStyles: {
        root: {
            margin: `${spacing.medium} 0 ${spacing.medium} ${spacing.medium}`
        },
        details: {
            display: "none"
        }
    },
    coinStyles: {
        initials: {
            borderRadius: spacing.small
        }
    }
}));
const PanelEntityHeader = ({ config, data }) => {
    const { children = [], props: { logo } = {} } = config;
    const render = smarthub_common_1.useRender();
    const panelStyles = smarthub_common_1.usePanelStyles();
    const gridStyles = smarthub_common_1.useGridStyles();
    const { personaStyles, coinStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const entity = smarthub_common_1.usePanelEntity();
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    return react_2.useMemo(() => {
        const { menu, nav } = children.reduce((named, component) => {
            named[component.$id] = component;
            return named;
        }, {});
        return react_2.default.createElement(react_2.default.Fragment, null, entity && react_2.default.createElement("div", { className: [panelStyles.header, gridStyles.grid, gridStyles.overflow, gridStyles.row].join(' ') },
            react_2.default.createElement("div", { className: gridStyles.col },
                react_2.default.createElement("div", { className: [gridStyles.row, gridStyles.smnowrap].join(" ") },
                    menu && render(menu, null, panel_sidebar_button_1.PanelSidebarButton)(),
                    logo && react_2.default.createElement("div", { className: panelStyles.logo },
                        react_2.default.createElement(utilities_1.ThemeImage, { alt: (logo === null || logo === void 0 ? void 0 : logo.title) || localizeConfig.logoImage, image: logo.image, defaultPalette: smarthub_common_1.PaletteKeys.neutralEmpty, defaultSize: 'medium' })),
                    react_2.default.createElement(react_1.Persona, { styles: personaStyles, coinProps: { styles: coinStyles }, text: entity.title, size: react_1.PersonaSize.size48, hidePersonaDetails: true }))),
            react_2.default.createElement("div", { className: [gridStyles.col, gridStyles.smstretch, gridStyles.smclip, gridStyles.smvanish, gridStyles.mdshow].join(" ") },
                react_2.default.createElement("div", { className: [gridStyles.col, gridStyles.smstretch, gridStyles.smclip, gridStyles.mdvanish].join(" ") },
                    react_2.default.createElement("h1", { className: [panelStyles.title, panelStyles.small].join(" ") }, entity.title)),
                react_2.default.createElement("div", { className: [gridStyles.col, gridStyles.sm12, gridStyles.mdstretch, gridStyles.smclip, gridStyles.mdvanish].join(" ") }, render(nav, data, tab_navigation_1.TabNavigation)()))));
    }, [entity, config, data, panelStyles, personaStyles, coinStyles, localizeConfig]);
};
exports.PanelEntityHeader = PanelEntityHeader;


/***/ }),

/***/ "./src/core/panel-entity-menu/index.ts":
/*!*********************************************!*\
  !*** ./src/core/panel-entity-menu/index.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-entity-menu.component */ "./src/core/panel-entity-menu/panel-entity-menu.component.tsx"), exports);


/***/ }),

/***/ "./src/core/panel-entity-menu/panel-entity-menu.component.tsx":
/*!********************************************************************!*\
  !*** ./src/core/panel-entity-menu/panel-entity-menu.component.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelEntityMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_3 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const reduce_panel_entities_helper_1 = __webpack_require__(/*! ./reduce-panel-entities.helper */ "./src/core/panel-entity-menu/reduce-panel-entities.helper.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const component_chrome_1 = __webpack_require__(/*! ../component-chrome */ "./src/core/component-chrome/index.ts");
const useStyles = react_jss_1.createUseStyles({
    link: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    }
});
const fluentStyles = (({ theme: { spacing } }) => ({
    personaStyles: {
        root: {
            flex: '1 1'
        }
    },
    coinStyles: {
        initials: {
            borderRadius: spacing.small
        }
    },
    navStyles: {
        root: {
            width: '100%',
            height: '100%',
            boxSizing: 'border-box',
            overflowY: 'auto',
        },
        link: {
            padding: `0 ${spacing.medium}`
        }
    }
}));
const defaultPinned = [];
const PanelEntityMenu = ({ config, config: { consumes, query, title, props } }) => {
    const { groups = [], prefKey } = props !== null && props !== void 0 ? props : {};
    const fetch = smarthub_common_1.useFetch();
    const transform = smarthub_common_1.useTransform();
    const searchProvider = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'search');
    const search = smarthub_common_1.useReadSharedState(searchProvider);
    const entity = smarthub_common_1.usePanelEntity();
    const setEnitityId = smarthub_common_1.useSetPanelEntityId();
    const [pinned, setPinned] = smarthub_common_1.usePreference(`${smarthub_common_1.preferenceKeys.entityPinPrefix}${prefKey}`, true, defaultPinned);
    const profile = smarthub_common_1.useProfile();
    const styles = useStyles();
    const { personaStyles, coinStyles, navStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const [navGroups, setNavGroups] = react_1.useState([]);
    const [entities, setEntities] = react_1.useState([]);
    const onClick = react_1.useCallback((ev, item) => {
        setEnitityId(item.key);
    }, [setEnitityId]);
    const setPin = react_1.useCallback((entity, pin) => {
        const current = pinned.filter(p => p.$id != entity.$id);
        if (pin)
            current.push(entity);
        setPinned(current);
    }, [setPinned, pinned]);
    react_1.useEffect(() => {
        const fetchData = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const { data } = yield fetch(query, searchProvider
                ? { [searchProvider.name]: search }
                : null);
            const items = transform(smarthub_common_1.IPanelEntitySchema, data);
            setEntities(items);
        });
        fetchData();
    }, [search]);
    react_1.useEffect(() => {
        const entityGroups = (entities === null || entities === void 0 ? void 0 : entities.length) ? reduce_panel_entities_helper_1.reducePanelEntities({
            grouped: query.hasOwnProperty('queries'),
            entities,
            pinned,
            profile,
            groups,
            selected: entity
        })
            : [];
        setNavGroups(entityGroups);
    }, [entities, pinned, query, entity]);
    const renderLink = (props, defaultRender) => {
        const { linkData: { entity, type, isPinned } } = props;
        return react_1.default.createElement("div", { className: styles.link },
            react_1.default.createElement(react_2.Persona, { styles: personaStyles, coinProps: { styles: coinStyles }, text: props.name, size: react_2.PersonaSize.size32 }),
            type == 'profile'
                ? react_1.default.createElement(react_2.Icon, { iconName: 'FavoriteStar' })
                : react_1.default.createElement(react_2.Icon, { iconName: isPinned
                        ? 'SingleBookmarkSolid'
                        : 'AddBookmark', onClick: (e) => {
                        e.stopPropagation();
                        setPin(entity, !isPinned);
                    } }));
    };
    return (react_1.default.createElement(component_chrome_1.ComponentChrome, { config: config },
        react_1.default.createElement(react_3.Nav, { selectedKey: entity === null || entity === void 0 ? void 0 : entity.$id, onRenderLink: renderLink, styles: navStyles, onLinkClick: onClick, ariaLabel: title, groups: navGroups })));
};
exports.PanelEntityMenu = PanelEntityMenu;


/***/ }),

/***/ "./src/core/panel-entity-menu/reduce-panel-entities.helper.ts":
/*!********************************************************************!*\
  !*** ./src/core/panel-entity-menu/reduce-panel-entities.helper.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.reducePanelEntities = void 0;
const transformlinks = (groupEntities, group, props) => {
    const { groupData: { type } } = group;
    return groupEntities.reduce((list, entity) => {
        var _a;
        const { pinned } = props;
        const isPinned = pinned.some(en => en.$id == entity.$id);
        if (!isPinned || type == 'pinned') {
            if (((_a = props.selected) === null || _a === void 0 ? void 0 : _a.$id) == entity.$id)
                group.collapseByDefault = false;
            const link = {
                name: entity.title,
                url: '',
                target: '_blank',
                key: entity.$id,
                ariaLabel: entity.description,
                title: entity.description,
                links: entity.children
                    ? transformlinks(entity.children, group, props)
                    : null,
                linkData: {
                    entity,
                    isPinned,
                    type
                }
            };
            list.push(link);
        }
        return list;
    }, []);
};
const reducePanelEntities = (props) => {
    const { groups, entities, grouped, pinned, profile } = props;
    return groups.reduce((navGroups, group) => {
        var _a;
        const { groupData: { type, property, query } } = group;
        const groupEntities = type == 'pinned'
            ? pinned
            : type == "profile"
                ? profile[property]
                : grouped
                    ? (_a = entities.find(e => e.$id == query)) === null || _a === void 0 ? void 0 : _a.items : entities;
        if (groupEntities) {
            const newGroup = Object.assign(Object.assign({}, group), {});
            newGroup.links = transformlinks(groupEntities, newGroup, props);
            navGroups.push(newGroup);
        }
        return navGroups;
    }, []);
};
exports.reducePanelEntities = reducePanelEntities;


/***/ }),

/***/ "./src/core/panel-entity-search/index.ts":
/*!***********************************************!*\
  !*** ./src/core/panel-entity-search/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-entity-search.component */ "./src/core/panel-entity-search/panel-entity-search.component.tsx"), exports);


/***/ }),

/***/ "./src/core/panel-entity-search/panel-entity-search.component.tsx":
/*!************************************************************************!*\
  !*** ./src/core/panel-entity-search/panel-entity-search.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelEntitySearch = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const component_chrome_1 = __webpack_require__(/*! ../component-chrome */ "./src/core/component-chrome/index.ts");
const fluentStyles = (({ theme: { palette, type, spacing } }) => ({
    root: {
        marginTop: 0,
        borderBottom: `${spacing.xSmall} solid ${type == "dark" ? palette.neutralMinus5 : palette.neutralMinus3}`,
    }
}));
const PanelEntitySearch = ({ config, config: { provides, title, description, props } }) => {
    const provider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'search');
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const [search, setSearch] = smarthub_common_1.useSharedState(provider);
    return react_1.useMemo(() => (react_1.default.createElement(component_chrome_1.ComponentChrome, { config: config },
        react_1.default.createElement(react_2.SearchBox, { styles: styles, placeholder: props === null || props === void 0 ? void 0 : props.placeholder, ariaLabel: description, title: title, underlined: true, value: search || '', onSearch: setSearch }))), [search, setSearch, styles]);
};
exports.PanelEntitySearch = PanelEntitySearch;


/***/ }),

/***/ "./src/core/panel-header/index.ts":
/*!****************************************!*\
  !*** ./src/core/panel-header/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-header.component */ "./src/core/panel-header/panel-header.component.tsx"), exports);


/***/ }),

/***/ "./src/core/panel-header/panel-header.component.tsx":
/*!**********************************************************!*\
  !*** ./src/core/panel-header/panel-header.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelHeader = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const tab_navigation_1 = __webpack_require__(/*! ../tab-navigation */ "./src/core/tab-navigation/index.ts");
const panel_sidebar_button_1 = __webpack_require__(/*! ../panel-sidebar-button */ "./src/core/panel-sidebar-button/index.ts");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const PanelHeader = ({ config }) => {
    const { children = [], props: { logo } = {} } = config;
    const { panel, panel: { title, description } } = smarthub_common_1.usePanelViewContext() || {};
    const panelStyles = smarthub_common_1.usePanelStyles();
    const render = smarthub_common_1.useRender();
    const gridStyles = smarthub_common_1.useGridStyles();
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    return react_1.useMemo(() => {
        const { menu, nav } = children.reduce((named, component) => {
            named[component.$id] = component;
            return named;
        }, {});
        return panel
            ? react_1.default.createElement("div", { className: [panelStyles.header, gridStyles.grid, gridStyles.overflow, gridStyles.row, gridStyles.lgxnowrap].join(' ') },
                react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.sm12, gridStyles.lgx0].join(" ") },
                    react_1.default.createElement("div", { className: [gridStyles.row, gridStyles.smnowrap].join(" ") },
                        logo && react_1.default.createElement("div", { className: panelStyles.logo },
                            react_1.default.createElement(utilities_1.ThemeImage, { alt: (logo === null || logo === void 0 ? void 0 : logo.title) || localizeConfig.logoImage, image: logo.image, defaultPalette: smarthub_common_1.PaletteKeys.neutralEmpty, defaultSize: 'medium' })),
                        menu && render(menu, null, panel_sidebar_button_1.PanelSidebarButton)(),
                        react_1.default.createElement("div", { className: gridStyles.col },
                            react_1.default.createElement("h1", { className: panelStyles.title, "aria-label": "Panel title" }, title),
                            react_1.default.createElement("div", { className: panelStyles.description, "aria-label": "Panel description" }, description)))),
                react_1.default.createElement("div", { className: [gridStyles.col, gridStyles.sm12, gridStyles.lgxstretch, gridStyles.smclip].join(" ") }, render(nav, null, tab_navigation_1.TabNavigation)()))
            : react_1.default.createElement(react_1.default.Fragment, null);
    }, [config, panel, panelStyles, localizeConfig]);
};
exports.PanelHeader = PanelHeader;


/***/ }),

/***/ "./src/core/panel-sidebar-button/index.ts":
/*!************************************************!*\
  !*** ./src/core/panel-sidebar-button/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-sidebar-button.component */ "./src/core/panel-sidebar-button/panel-sidebar-button.component.tsx"), exports);


/***/ }),

/***/ "./src/core/panel-sidebar-button/panel-sidebar-button.component.tsx":
/*!**************************************************************************!*\
  !*** ./src/core/panel-sidebar-button/panel-sidebar-button.component.tsx ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelSidebarButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_2 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const component_chrome_1 = __webpack_require__(/*! ../component-chrome */ "./src/core/component-chrome/index.ts");
const fluentStyles = (({ theme: { sizes, fonts } }) => ({
    iconStyles: {
        root: {
            width: sizes.large,
            height: sizes.large,
        },
        icon: {
            fontSize: fonts.xxLarge.fontSize
        }
    }
}));
const PanelSidebarButton = ({ config }) => {
    const { props: { initial, alwaysOpen, icon, prefKey = smarthub_common_1.preferenceKeys.sideBar } = {} } = config;
    const [view, setView] = smarthub_common_1.usePreference(prefKey, false, initial !== null && initial !== void 0 ? initial : 'open');
    const { iconStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const open = react_2.useCallback(() => {
        setView('open');
    }, [setView]);
    return react_2.useMemo(() => (react_2.default.createElement(component_chrome_1.ComponentChrome, { config: config, hasContent: !alwaysOpen && view == 'closed' },
        react_2.default.createElement(react_1.IconButton, { styles: iconStyles, ariaLabel: config.title, title: config.title, iconProps: {
                iconName: icon !== null && icon !== void 0 ? icon : "CollapseMenu"
            }, ariaDescription: config.description, onClick: open }))), [view, config]);
};
exports.PanelSidebarButton = PanelSidebarButton;


/***/ }),

/***/ "./src/core/panel-sidebar/index.ts":
/*!*****************************************!*\
  !*** ./src/core/panel-sidebar/index.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-sidebar.component */ "./src/core/panel-sidebar/panel-sidebar.component.tsx"), exports);


/***/ }),

/***/ "./src/core/panel-sidebar/panel-sidebar.component.tsx":
/*!************************************************************!*\
  !*** ./src/core/panel-sidebar/panel-sidebar.component.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelSidebar = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_2 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const panel_entity_menu_1 = __webpack_require__(/*! ../panel-entity-menu */ "./src/core/panel-entity-menu/index.ts");
const panel_entity_search_1 = __webpack_require__(/*! ../panel-entity-search */ "./src/core/panel-entity-search/index.ts");
const component_chrome_1 = __webpack_require__(/*! ../component-chrome */ "./src/core/component-chrome/index.ts");
const useStyles = react_jss_1.createUseStyles(({ palette, spacing }) => ({
    wrapper: () => ({
        position: 'relative',
        display: "flex",
        flexDirection: "column",
        boxShadow: `0 0 ${spacing.normal} ${palette.filmMinus1}`,
        zIndex: 1,
        backgroundColor: palette.neutralEmpty,
        height: '100%',
        width: '100%'
    }),
    main: {
        flex: "1 1 auto",
        height: "100%",
    }
}));
const fluentStyles = (({ theme: { spacing, sizes } }) => ({
    navStyles: {
        root: {
            height: sizes.medium,
            padding: 0,
            marginBottom: spacing.xSmall
        }
    }
}));
const PanelSidebar = ({ config }) => {
    const { responsive, children = [], props: { initial, alwaysOpen, prefKey = smarthub_common_1.preferenceKeys.sideBar } = {} } = config;
    const [view, setView] = smarthub_common_1.usePreference(prefKey, false, initial !== null && initial !== void 0 ? initial : 'open');
    const styleProps = smarthub_common_1.useStyleProps(null, responsive);
    const styles = useStyles(styleProps);
    const { navStyles } = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const render = smarthub_common_1.useRender();
    const close = react_2.useCallback(() => {
        setView('closed');
    }, [setView]);
    return react_2.useMemo(() => {
        const { header, top, main, footer } = children.reduce((named, component) => {
            named[component.$id] = component;
            return named;
        }, {});
        const buttons = !alwaysOpen
            ? [{
                    key: "close",
                    iconProps: { iconName: 'ChromeClose' },
                    ariaLabel: localizeConfig.sideBarClose,
                    title: localizeConfig.sideBarClose,
                    ariaDescription: localizeConfig.sideBarCloseDesc,
                    onClick: close,
                }]
            : [];
        return react_2.default.createElement(react_2.default.Fragment, null, view == 'open' && react_2.default.createElement(component_chrome_1.ComponentChrome, { config: config, title: config.title, "aria-label": config.title, role: "menu" },
            react_2.default.createElement("div", { className: styles.wrapper },
                react_2.default.createElement(react_1.CommandBar, { styles: navStyles, title: localizeConfig.sideBarCommandBar, "aria-label": localizeConfig.sideBarCommandBar, items: [], farItems: buttons }),
                header && render(header, null, panel_entity_search_1.PanelEntitySearch)(),
                top && render(top)(),
                main && react_2.default.createElement("div", { className: styles.main }, render(main, null, panel_entity_menu_1.PanelEntityMenu)()),
                footer && render(footer)())));
    }, [styles, config, view]);
};
exports.PanelSidebar = PanelSidebar;


/***/ }),

/***/ "./src/core/secured/index.ts":
/*!***********************************!*\
  !*** ./src/core/secured/index.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./secured.component */ "./src/core/secured/secured.component.tsx"), exports);


/***/ }),

/***/ "./src/core/secured/secured.component.tsx":
/*!************************************************!*\
  !*** ./src/core/secured/secured.component.tsx ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Secured = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const Secured = ({ config: { $id, children, permission, consumes } }) => {
    const checkPermission = smarthub_common_1.useHasPermission();
    const render = smarthub_common_1.useRender();
    const [state, setState] = smarthub_common_1.useSharedStates($id);
    const [hasPermission, setHasPermission] = react_1.useState(false);
    react_1.useEffect(() => setState(consumes), [consumes]);
    smarthub_common_1.useAsyncEffect(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const result = yield checkPermission(permission, state);
        setHasPermission(result);
    }), [state, permission]);
    return react_1.useMemo(() => hasPermission
        ? react_1.default.createElement(react_1.default.Fragment, null, children.map(c => render(c)()))
        : null, [hasPermission, children]);
};
exports.Secured = Secured;


/***/ }),

/***/ "./src/core/tab-navigation/index.ts":
/*!******************************************!*\
  !*** ./src/core/tab-navigation/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./tab-navigation.component */ "./src/core/tab-navigation/tab-navigation.component.tsx"), exports);


/***/ }),

/***/ "./src/core/tab-navigation/tab-menu.component.tsx":
/*!********************************************************!*\
  !*** ./src/core/tab-navigation/tab-menu.component.tsx ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TabMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_3 = __webpack_require__(/*! react */ "react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const useStyles = react_jss_1.createUseStyles(({ spacing, sizes }) => ({
    coachmark: {
        lineHeight: "normal",
        whiteSpace: "normal",
        textAlign: "left",
    },
    action: {
        display: "flex",
    },
    nav: {
        marginTop: "auto",
        marginBottom: `-${spacing.xSmall}`,
    },
    pivotItem: {
        marginLeft: spacing.normal,
    },
    pivotItemIcon: {
        width: "auto",
        height: sizes.xSmall,
    },
}));
const fluentStyles = ({ theme: { palette, spacing, sizes }, config: { actionCount, minimise }, }) => ({
    root: {
        display: "flex",
        marginLeft: spacing.smallPlus,
    },
    text: {
        marginLeft: spacing.normal,
        display: minimise ? "none" : undefined,
    },
    linkInMenu: {
        ["& .ms-Pivot-text"]: {
            display: "inline-block",
        },
    },
    linkIsSelected: {
        minWidth: minimise ? sizes.mediumPlus : "auto",
        transition: "background-color 200ms ease-in",
        color: palette.primary,
        ["&::before"]: {
            transition: "left 300ms cubic-bezier(0.1, 0.25, 0.75, 0.9) 0s, right 300ms cubic-bezier(0.1, 0.25, 0.75, 0.9) 0s",
        },
    },
    overflowMenuButton: {
        marginLeft: "auto",
    },
    link: {
        minWidth: minimise ? sizes.mediumPlus : "auto",
        transition: "background-color 200ms ease-in",
        ["&::before"]: {
            transition: "background-color 75ms ease-in, left 350ms cubic-bezier(0.1, 0.25, 0.75, 0.9) 0s, right 350ms cubic-bezier(0.1, 0.25, 0.75, 0.9) 0s",
        },
        ["&:hover::before"]: {
            backgroundColor: palette.neutral,
            left: "0",
            right: "0",
        },
        [`&:nth-last-child(${actionCount + 1})`]: {
            marginLeft: actionCount > 0 ? "auto" : undefined,
        },
    },
});
const actionKeyPrefix = "action-";
const getValue = (value, locale) => {
    return typeof value == "object" ? value[locale] : value;
};
const renderItemContent = (action, minimise, styles) => {
    const locale = smarthub_common_1.useLocale();
    const { title, icon, coachmark, shortTitle } = action;
    const content = (react_1.default.createElement("span", { className: styles.action },
        typeof icon == "string" ? (react_1.default.createElement(react_2.Icon, { iconName: icon })) : (react_1.default.createElement(utilities_1.ThemeImage, { className: styles.pivotItemIcon, alt: getValue(title, locale), image: icon === null || icon === void 0 ? void 0 : icon.image, defaultPalette: smarthub_common_1.PaletteKeys.neutralEmpty, defaultSize: "medium" })),
        !minimise && (react_1.default.createElement("div", { className: styles.pivotItem }, getValue(shortTitle, locale)))));
    return coachmark ? (react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, coachmark, { className: styles.coachmark, doNotLayer: false }), content)) : (content);
};
const TabMenu = ({ actions, tabs, tab }) => {
    const localize = smarthub_common_1.useLocalizeConfig();
    const setTabId = smarthub_common_1.useSetTabId();
    const styles = useStyles();
    const breakpoint = smarthub_common_1.useBreakpoint();
    const handleCommand = smarthub_common_1.useHandleCommand();
    const minimise = breakpoint.current.size < smarthub_common_1.Breakpoints.lg;
    const registerLastFocus = smarthub_common_1.useRegisterLastAction();
    const pivotRef = react_1.useRef();
    const pivotStyles = smarthub_common_1.useFluentStylesWithProps(fluentStyles, {
        actionCount: actions.length,
        minimise,
    });
    const registerFocusCallback = react_3.useCallback(() => {
        registerLastFocus("main", () => {
            pivotRef.current.focus();
        });
    }, []);
    const handleClick = react_3.useCallback(({ props: { itemKey } }) => {
        if (~itemKey.indexOf(actionKeyPrefix)) {
            const idx = itemKey.substr(actionKeyPrefix.length);
            const appAction = actions[idx];
            if (appAction) {
                registerFocusCallback();
                handleCommand(appAction.action);
            }
        }
        else
            setTabId(itemKey);
    }, [tabs, actions]);
    return react_3.useMemo(() => {
        const props = {
            overflowBehavior: "menu",
            "aria-label": localize.layoutNavTitle,
            className: styles.nav,
            styles: pivotStyles,
            headersOnly: true,
            selectedKey: tab === null || tab === void 0 ? void 0 : tab.$id,
            linkFormat: "links",
            linkSize: minimise ? "large" : "normal",
            onLinkClick: handleClick,
        };
        const items = [
            ...((tabs === null || tabs === void 0 ? void 0 : tabs.length) > 1
                ? tabs.map((layout) => {
                    var _a, _b;
                    return (react_1.default.createElement(react_2.PivotItem, { itemKey: layout.$id, key: layout.$id, headerText: layout.title, headerButtonProps: {
                            title: `${layout.description}`,
                        }, itemIcon: ((_a = layout.icon) === null || _a === void 0 ? void 0 : _a.display) != "minimised" || minimise
                            ? (_b = layout.icon) === null || _b === void 0 ? void 0 : _b.name : null, ariaLabel: layout.description }));
                })
                : []),
            ...actions.map((action, index) => (react_1.default.createElement(react_2.PivotItem, { itemKey: `${actionKeyPrefix}${index}`, key: `${actionKeyPrefix}${index}`, headerButtonProps: {
                    title: `${action.title} ${action.description}`,
                }, onRenderItemLink: () => renderItemContent(action, minimise, styles) }))),
        ];
        return react_1.default.createElement(react_2.Pivot, Object.assign({}, props), items);
    }, [tabs, tab, handleClick, minimise, actions]);
};
exports.TabMenu = TabMenu;


/***/ }),

/***/ "./src/core/tab-navigation/tab-navigation.component.tsx":
/*!**************************************************************!*\
  !*** ./src/core/tab-navigation/tab-navigation.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TabNavigation = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const tab_menu_component_1 = __webpack_require__(/*! ./tab-menu.component */ "./src/core/tab-navigation/tab-menu.component.tsx");
const utilities_1 = __webpack_require__(/*! ../../utilities */ "./src/utilities/index.ts");
const component_chrome_1 = __webpack_require__(/*! ../component-chrome */ "./src/core/component-chrome/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles({
    root: {
        marginTop: "auto",
    }
});
const TabNavigation = ({ config }) => {
    const styles = useStyles();
    const { actions, tabs, tab } = smarthub_common_1.usePanelViewContext() || { actions: [], tabs: [], tab: null };
    const { coachmarks } = config;
    const coachmark = coachmarks === null || coachmarks === void 0 ? void 0 : coachmarks.find(coachmark => coachmark.target === 'component-chrome');
    return react_1.default.createElement(component_chrome_1.ComponentChrome, { hasContent: (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 1 || actions.length > 0, config: config, className: styles.root }, (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 1 || actions.length
        ? coachmark
            ? react_1.default.createElement(utilities_1.CoachMarkWrapper, Object.assign({}, coachmark),
                react_1.default.createElement(tab_menu_component_1.TabMenu, { actions: actions, tabs: tabs, tab: tab }))
            : react_1.default.createElement(tab_menu_component_1.TabMenu, { actions: actions, tabs: tabs, tab: tab })
        : null);
};
exports.TabNavigation = TabNavigation;


/***/ }),

/***/ "./src/core/view-menu/button.styles.tsx":
/*!**********************************************!*\
  !*** ./src/core/view-menu/button.styles.tsx ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.buttonStyles = void 0;
const buttonStyles = ({ theme: { spacing, sizes } }) => ({
    splitButtonContainer: {
        margin: `${spacing.xSmall} ${spacing.smallPlus} ${spacing.xSmall} 0`
    },
    root: {
        padding: "0",
        border: "0",
        minHeight: sizes.normal,
    },
    rootHovered: {
        border: "0",
    },
    menuIcon: {
        margin: `0 ${spacing.normal}`
    },
    splitButtonMenuButton: {
        border: "0",
        borderRadius: "0",
    },
    splitButtonMenuIcon: {
        margin: `${spacing.small} ${spacing.smallPlus} 0 ${spacing.smallPlus}`,
    },
    splitButtonDivider: {
        display: "none",
    },
    textContainer: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    flexContainer: {
        padding: `0 0.${spacing.smallPlus}`,
        boxSizing: "border-box",
        alignItems: "center"
    },
    label: {
        lineHeight: "normal",
        marginBottom: "0",
        fontWeight: "600"
    }
});
exports.buttonStyles = buttonStyles;


/***/ }),

/***/ "./src/core/view-menu/index.ts":
/*!*************************************!*\
  !*** ./src/core/view-menu/index.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./view-menu.component */ "./src/core/view-menu/view-menu.component.tsx"), exports);


/***/ }),

/***/ "./src/core/view-menu/view-menu.component.tsx":
/*!****************************************************!*\
  !*** ./src/core/view-menu/view-menu.component.tsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ViewMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const button_styles_1 = __webpack_require__(/*! ./button.styles */ "./src/core/view-menu/button.styles.tsx");
const styles = {
    root: {
        padding: 0,
    },
};
const icons = {
    full: "SingleColumn",
    narrow: "ColumnLeftTwoThirds",
    split: "DoubleColumn",
    wide: "ColumnRightTwoThirds",
    left: "DockLeft",
    right: "DockRight",
};
const ViewMenu = ({ title, label, focusName, buttons, closeProps, dockSize, changeDockSize, dockConfig, dockPosition, changeDockPosition, dockPositionConfig, }) => {
    const panelType = smarthub_common_1.usePanelType();
    const locale = smarthub_common_1.useLocale();
    const { panel: { languages, showLanguageSwitcher }, } = smarthub_common_1.usePanelViewContext();
    const setLocale = smarthub_common_1.useSetLocale();
    const commandBar = react_1.useRef();
    const splitButtonStyles = smarthub_common_1.useFluentStylesWithProps(button_styles_1.buttonStyles);
    const { focusZoneHorizontalLabel, dockSizeOptions: dockSizeOptionsText, dockPositionOptions: dockPositionOptionsText, dockSize: dockSizeText, dockSizeAriaLabel, dockSizeTitle, dockLang, dockLangAriaLabel, dockLangTitle, dockPosition: dockPositionText, dockPositionAriaLabel, dockPositionTitle, } = smarthub_common_1.useLocalizeConfig();
    const registerFocus = smarthub_common_1.useRegisterFocus();
    const focusLastAction = smarthub_common_1.useFocusLastAction();
    const farItems = react_1.useMemo(() => {
        var _a;
        return [
            ...((_a = buttons === null || buttons === void 0 ? void 0 : buttons.farItems) !== null && _a !== void 0 ? _a : []),
            {
                key: "close",
                text: closeProps.text,
                name: closeProps.text,
                iconOnly: true,
                iconProps: {
                    iconName: "ChromeClose",
                    styles: {
                        root: {
                            display: "block !important",
                        },
                    },
                },
                ariaDescription: closeProps.description,
                ariaLabel: closeProps.title,
                title: closeProps.title,
                onClick: () => {
                    closeProps.onClick();
                    focusLastAction(panelType);
                },
            },
        ];
    }, [closeProps]);
    const dockSizeOptions = react_1.useMemo(() => Object.keys(dockConfig)
        .filter((d) => d != "asside" && d != "preferred")
        .reduce((buttons, key) => {
        const dockSizeVal = dockConfig[key];
        if (key == "full" || dockSizeVal < 12)
            buttons.push({
                key,
                text: dockSizeOptionsText[key].text,
                name: dockSizeOptionsText[key].text,
                iconOnly: true,
                disabled: dockSize == key,
                iconProps: { iconName: icons[key] },
                ariaDescription: dockSizeOptionsText[key].title,
                ariaLabel: dockSizeOptionsText[key].ariaLabel,
                onClick: () => changeDockSize(key),
            });
        return buttons;
    }, []), [changeDockSize, dockSize, dockConfig, dockSizeOptionsText]);
    const dockPositionOptions = react_1.useMemo(() => dockPositionConfig.options.map((pos) => ({
        key: pos,
        text: dockPositionOptionsText[pos].text,
        name: dockPositionOptionsText[pos].text,
        iconOnly: true,
        disabled: dockPosition == pos,
        iconProps: { iconName: icons[pos] },
        ariaDescription: dockPositionOptionsText[pos].title,
        ariaLabel: dockPositionOptionsText[pos].ariaLabel,
        onClick: () => changeDockPosition(pos),
    })), [
        changeDockPosition,
        dockPosition,
        dockPositionOptionsText,
        dockPositionConfig,
    ]);
    const langs = languages === null || languages === void 0 ? void 0 : languages.map((language) => {
        return {
            key: `lang-${language.language}`,
            text: language.label[locale],
            name: language.label[locale],
            iconOnly: true,
            ariaDescription: language.label[locale],
            ariaLabel: language.label[locale],
            onClick: () => setLocale(smarthub_common_1.LocalizeLanguages[language.language]),
        };
    });
    const langOptions = react_1.useMemo(() => (langs === null || langs === void 0 ? void 0 : langs.length) > 1
        ? [
            {
                key: "lang-options",
                name: dockLang,
                text: dockLang,
                split: false,
                iconProps: {
                    iconName: "LocaleLanguage",
                    root: {
                        display: "block !important",
                    },
                },
                ariaLabel: dockLangAriaLabel,
                title: dockLangTitle,
                subMenuProps: {
                    items: langs,
                },
            },
        ]
        : [], [langs]);
    const sizeOptions = react_1.useMemo(() => dockSizeOptions.length > 1
        ? [
            {
                key: "size-options",
                name: dockSizeText,
                text: dockSizeText,
                styles: splitButtonStyles,
                split: false,
                iconProps: {
                    iconName: icons[dockSize],
                    root: {
                        display: "block !important",
                    },
                },
                ariaLabel: dockSizeAriaLabel,
                title: dockSizeTitle,
                subMenuProps: {
                    items: dockSizeOptions,
                },
            },
        ]
        : [], [dockSizeOptions]);
    const positionOptions = react_1.useMemo(() => dockPositionOptions.length > 1
        ? [
            {
                key: "position-options",
                text: dockPositionText,
                name: dockPositionText,
                styles: splitButtonStyles,
                split: false,
                iconProps: {
                    iconName: icons[dockPosition],
                    root: {
                        display: "block !important",
                    },
                },
                ariaLabel: dockPositionAriaLabel,
                title: dockPositionTitle,
                subMenuProps: {
                    items: dockPositionOptions,
                },
            },
        ]
        : [], [dockPositionOptions]);
    const items = react_1.useMemo(() => {
        var _a, _b;
        return [
            ...((_a = buttons === null || buttons === void 0 ? void 0 : buttons.beforeItems) !== null && _a !== void 0 ? _a : []),
            ...positionOptions,
            ...sizeOptions,
            ...(showLanguageSwitcher ? langOptions : []),
            ...((_b = buttons === null || buttons === void 0 ? void 0 : buttons.afterItems) !== null && _b !== void 0 ? _b : []),
        ];
    }, [positionOptions, sizeOptions, langOptions, buttons, showLanguageSwitcher]);
    react_1.useEffect(() => {
        registerFocus(focusName, () => {
            commandBar.current.focus();
        });
    }, []);
    return react_1.useMemo(() => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.CommandBar, { componentRef: commandBar, styles: styles, items: items, farItems: farItems, overflowItems: buttons === null || buttons === void 0 ? void 0 : buttons.overflowItems, ariaLabel: `${label} ${focusZoneHorizontalLabel}` }))), [items, farItems, styles, sizeOptions, positionOptions]);
};
exports.ViewMenu = ViewMenu;


/***/ }),

/***/ "./src/designers/component-designer/component-designer.component.tsx":
/*!***************************************************************************!*\
  !*** ./src/designers/component-designer/component-designer.component.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ComponentDesigner = exports.Component = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! react */ "react");
const react_3 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const Component = ({ config, data }) => {
    const render = smarthub_common_1.useRender();
    try {
        return render(config, data)();
    }
    catch (ex) {
        console.log("Failed to render", ex);
        return react_1.default.createElement("div", null, "Failed to render, check the log");
    }
};
exports.Component = Component;
const ComponentDesigner = ({ config, config: { consumes } }) => {
    const dataConsumer = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'data');
    const configConsumer = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'config');
    const componentConfig = smarthub_common_1.useReadSharedState(configConsumer);
    const dataConfig = smarthub_common_1.useReadSharedState(dataConsumer);
    const [items, setItems] = react_2.useState();
    const [output, setOutput] = react_2.useState();
    const render = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const data = (dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.length) ? JSON.parse(dataConfig)
                : null;
            const config = JSON.parse(componentConfig);
            const props = Array.isArray(config)
                ? config.map((config, idx) => ({
                    config,
                    data: Array.isArray(data) && data.length > idx
                        ? data[idx]
                        : null
                }))
                : [{
                        config,
                        data
                    }];
            setOutput(null);
            setItems(props);
        }
        catch (ex) {
            setOutput(JSON.stringify({ message: ex.message }, null, 4));
        }
    }), [dataConfig, componentConfig]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_3.PrimaryButton, { onClick: render, text: 'render' }),
        (output === null || output === void 0 ? void 0 : output.length) && react_1.default.createElement("div", null, output),
        (items === null || items === void 0 ? void 0 : items.length) > 0 && items.map(props => react_1.default.createElement(exports.Component, Object.assign({ key: props.config.$id }, props)))));
};
exports.ComponentDesigner = ComponentDesigner;


/***/ }),

/***/ "./src/designers/component-designer/index.ts":
/*!***************************************************!*\
  !*** ./src/designers/component-designer/index.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./component-designer.component */ "./src/designers/component-designer/component-designer.component.tsx"), exports);


/***/ }),

/***/ "./src/designers/designer-input/designer-input.component.tsx":
/*!*******************************************************************!*\
  !*** ./src/designers/designer-input/designer-input.component.tsx ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DesignerInput = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const use_debounce_1 = __webpack_require__(/*! use-debounce */ "use-debounce");
const DesignerInput = ({ config, config: { provides, props, $id } }) => {
    const provider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'value');
    const setProvider = smarthub_common_1.useSetSharedState(provider);
    const debounce = use_debounce_1.useDebouncedCallback((value) => {
        setProvider(value);
        smarthub_common_1.Cache.set(`${$id}-value`, value, { storage: 'local' });
    }, 500);
    const handleChange = react_1.useCallback((event, newValue) => {
        setValue(newValue);
        debounce(newValue);
    }, []);
    const [value, setValue] = react_1.useState();
    react_1.useEffect(() => {
        const value = smarthub_common_1.Cache.get(`${$id}-value`, { storage: 'local' }) || JSON.stringify(props, null, 2);
        setValue(value);
    }, [props]);
    react_1.useEffect(() => setProvider(value));
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement(react_2.TextField, { multiline: true, resizable: true, onChange: handleChange, value: value })));
};
exports.DesignerInput = DesignerInput;


/***/ }),

/***/ "./src/designers/designer-input/index.ts":
/*!***********************************************!*\
  !*** ./src/designers/designer-input/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./designer-input.component */ "./src/designers/designer-input/designer-input.component.tsx"), exports);


/***/ }),

/***/ "./src/designers/index.ts":
/*!********************************!*\
  !*** ./src/designers/index.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./designer-input */ "./src/designers/designer-input/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./query-designer */ "./src/designers/query-designer/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./transform-designer */ "./src/designers/transform-designer/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./component-designer */ "./src/designers/component-designer/index.ts"), exports);


/***/ }),

/***/ "./src/designers/query-designer/index.ts":
/*!***********************************************!*\
  !*** ./src/designers/query-designer/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./query-designer.component */ "./src/designers/query-designer/query-designer.component.tsx"), exports);


/***/ }),

/***/ "./src/designers/query-designer/query-designer.component.tsx":
/*!*******************************************************************!*\
  !*** ./src/designers/query-designer/query-designer.component.tsx ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryDesigner = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! react */ "react");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const react_3 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const QueryDesigner = ({ config, config: { provides, consumes } }) => {
    const fetch = smarthub_common_1.useFetch();
    const paramsConsumer = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'params');
    const queryConsumer = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'query');
    const provider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'queryResult');
    const params = smarthub_common_1.useReadSharedState(paramsConsumer);
    const query = smarthub_common_1.useReadSharedState(queryConsumer);
    const setData = smarthub_common_1.useSetSharedState(provider);
    const [output, setOutput] = react_2.useState();
    const [next, setNext] = react_2.useState();
    const fetchData = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const result = yield fetch(JSON.parse(query), JSON.parse(params), next);
            setNext(result.continuation);
            setData(JSON.stringify(result.data, null, 4));
            setOutput(JSON.stringify(result, null, 4));
        }
        catch (ex) {
            setOutput(JSON.stringify({ message: ex.message }, null, 4));
        }
    }), [query, params, next]);
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement(react_3.PrimaryButton, { onClick: fetchData, text: 'Query' }),
        react_1.default.createElement(react_3.TextField, { multiline: true, resizable: true, value: output })));
};
exports.QueryDesigner = QueryDesigner;


/***/ }),

/***/ "./src/designers/transform-designer/index.ts":
/*!***************************************************!*\
  !*** ./src/designers/transform-designer/index.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./transform-designer.component */ "./src/designers/transform-designer/transform-designer.component.tsx"), exports);


/***/ }),

/***/ "./src/designers/transform-designer/transform-designer.component.tsx":
/*!***************************************************************************!*\
  !*** ./src/designers/transform-designer/transform-designer.component.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TransformDesigner = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! react */ "react");
const core_1 = __webpack_require__(/*! ../../core */ "./src/core/index.ts");
const react_3 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const TransformDesigner = ({ config, config: { consumes, provides } }) => {
    const templateConsumer = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'template');
    const dataConsumer = consumes === null || consumes === void 0 ? void 0 : consumes.find(({ name }) => name == 'data');
    const provider = provides === null || provides === void 0 ? void 0 : provides.find(({ name }) => name == 'transformedData');
    const template = smarthub_common_1.useReadSharedState(templateConsumer);
    const data = smarthub_common_1.useReadSharedState(dataConsumer);
    const setData = smarthub_common_1.useSetSharedState(provider);
    const knownUrisRef = smarthub_common_1.useHookRef(smarthub_common_1.useKnownUris);
    const profileRef = smarthub_common_1.useHookRef(smarthub_common_1.useProfile);
    const stringsRef = smarthub_common_1.useHookRef(smarthub_common_1.useLocalizeConfig);
    const [output, setOutput] = react_2.useState();
    const transform = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const parsedTemplate = JSON.parse(template);
            const templates = Array.isArray(parsedTemplate)
                ? parsedTemplate
                : [parsedTemplate];
            const result = templates.reduce((data, template) => smarthub_common_1.transformData(template, {
                data,
                profile: profileRef.current,
                knownUris: knownUrisRef.current,
                strings: stringsRef.current
            }), JSON.parse(data));
            setData(JSON.stringify(result, null, 4));
            setOutput(JSON.stringify(result, null, 4));
        }
        catch (ex) {
            setOutput(JSON.stringify({ message: ex.message }, null, 4));
        }
    }), [template, data]);
    return (react_1.default.createElement(core_1.ComponentChrome, { config: config },
        react_1.default.createElement(react_3.PrimaryButton, { onClick: transform, text: 'Transform' }),
        react_1.default.createElement(react_3.TextField, { multiline: true, resizable: true, value: output })));
};
exports.TransformDesigner = TransformDesigner;


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./bot */ "./src/bot/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./core */ "./src/core/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./content */ "./src/content/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./models */ "./src/models/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./middleware */ "./src/middleware/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./utilities */ "./src/utilities/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./designers */ "./src/designers/index.ts"), exports);


/***/ }),

/***/ "./src/middleware/component-middleware-ids.const.tsx":
/*!***********************************************************!*\
  !*** ./src/middleware/component-middleware-ids.const.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.componentMiddleWareIds = void 0;
exports.componentMiddleWareIds = {
    components: {
        bannerImageSelector: "component.banner-image-selector",
        panelHeader: "component.panel-header",
        chatControls: "component.chat-controls",
        chatHeader: "component.chat-header",
        chatFooter: "component.chat-footer",
        chatSplash: "component.chat-splash",
        chatLauncher: "component.chat-launcher",
        chatPages: "component.chat-pages",
        chatMenu: "component.chat-menu",
        pageMenu: "component.page-menu",
        chatTranscript: "component.chat-transcript",
        commandBar: "component.command-bar",
        entityHeader: "component.entity-header",
        profileHeader: "component.profile-header",
        myHeader: "component.my-header",
        carousel: "component.carousel",
        dataTable: "component.data-table",
        cardList: "component.card-list",
        galaxyGraph: "component.galaxy-graph",
        parallelTimeline: "component.parallel-timeline",
        thumbCard: "component.thumb-card",
        listCommandBar: "component.list-command-bar",
        launchButton: "component.launch-button",
        about: "component.about",
        htmlScreen: "component.htmlScreen",
        preferences: "component.preferences",
        stream: "component.stream",
        streamVideo: "component.stream-video",
        msForm: "component.ms-form",
        msPowerApp: "component.ms-power-app",
        tile: "component.tile",
        linkTile: "component.link-tile",
        slide: "component.slide",
        personCard: "component.person-card",
        categoryMenu: "component.category-menu",
        adaptiveCard: "component.adaptive-card",
        componentFlow: "component.component-flow",
        notification: "component.notification",
        page: "component.page",
        panelSidebar: "component.panel-sidebar",
        panelSidebarButton: "component.panel-sidebar-button",
        panelEntityMenu: "component.panel-entity-menu",
        panelEntitySearch: "component.panel-entity-search",
        pageContent: "component.page-content",
        pageHeader: "component.page-header",
        pageNav: "component.page-nav",
        pageMetadata: "component.page-metadata",
        pageImage: "component.page-image",
        pageDetails: "component.page-details",
        pageComments: "component.page-comments",
        commentCard: "component.comment-card",
        addCommentCard: "component.add-comment",
        timeline: "component.timeline",
        image: "component.image",
        map: "component.map",
        pageUser: "component.page-user",
        pageCategory: "component.page-category",
        pageLocation: "component.page-location",
        pageMap: "component.page-map",
        pageDate: "component.page-date",
        pageLinks: "component.page-links",
        profileHierachy: "component.profile-hierarchy",
        profileSummary: "component.profile-summary",
        profileContact: "component.profile-contact",
        profileContactInfo: "component.profile-contact-info",
        profileAboutInfo: "component.profile-about-info",
        profileSkills: "component.profile-skills",
        profileProjects: "component.profile-projects",
        profileInterests: "component.profile-interests",
        profileSchools: "component.profile-schools",
        bookmarkList: "component.bookmark-list",
        calendarActivity: "component.calendar-activity",
        calendarEventCard: "component.calendar-event-card",
        upNextActivity: "component.up-next-activity",
        views: "component.views",
        viewNavigator: "component.view-navigator",
        splashScreen: "component.splash-screen",
        summariser: "component.summariser",
        queryDesigner: "component.query-designer",
        componentDesigner: "component.component-designer",
        transformDesigner: "component.transform-designer",
        designerInput: "component.designer-input",
        DatePicker: "component.date-picker",
        secured: "component.secured",
        actionBar: "component.action-bar",
        actionButton: "component.action-button",
        sortButton: "component.sort-button",
        azButton: "component.az-button",
        clearSelButton: "component.clear-sel-button",
        refinerButton: "component.refiner-button",
        datePicker: "component.date-picker",
    },
};


/***/ }),

/***/ "./src/middleware/core-activity-middleware.fn.ts":
/*!*******************************************************!*\
  !*** ./src/middleware/core-activity-middleware.fn.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.coreActivityMiddleware = void 0;
const bot_1 = __webpack_require__(/*! ../bot */ "./src/bot/index.ts");
const oAuthCardContentType = 'application/vnd.microsoft.card.oauth';
const coreActivityMiddleware = (props) => () => next => (activityInfo) => {
    const { activity, activity: { attachments } } = activityInfo;
    const { attachmentLayout } = activity;
    const firstAttchment = attachments === null || attachments === void 0 ? void 0 : attachments[0];
    const handler = attachmentLayout == "carousel"
        ? bot_1.handleCarousel(props, activityInfo)
        : (firstAttchment === null || firstAttchment === void 0 ? void 0 : firstAttchment.contentType) === oAuthCardContentType
            ? bot_1.handleOAuth(props, activityInfo)
            : null;
    return handler !== null
        ? handler
        : next(activityInfo);
};
exports.coreActivityMiddleware = coreActivityMiddleware;


/***/ }),

/***/ "./src/middleware/core-attachment-middleware.fn.tsx":
/*!**********************************************************!*\
  !*** ./src/middleware/core-attachment-middleware.fn.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.coreAttachmentMiddleware = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const content_1 = __webpack_require__(/*! ../content */ "./src/content/index.ts");
const models_1 = __webpack_require__(/*! ../models */ "./src/models/index.ts");
const coreAttachmentMiddleware = (props) => () => next => (card) => {
    const data = card.attachment;
    if (data.$schema === models_1.SearchResultCardSchema)
        //TODO Refactor this- do we need transform, kinda makes sense? Is this POC stuff?
        return react_1.default.createElement(content_1.ThumbCard, { config: {
                $id: "component.chat-result-card",
                $schema: smarthub_common_1.IComponentSchema,
                template: null,
                responsive: {
                    sm: { horizontal: true }
                }
            }, data: { data } });
    return next(card);
};
exports.coreAttachmentMiddleware = coreAttachmentMiddleware;


/***/ }),

/***/ "./src/middleware/core-component-middleware.fn.tsx":
/*!*********************************************************!*\
  !*** ./src/middleware/core-component-middleware.fn.tsx ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.coreComponentMiddleware = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const content_1 = __webpack_require__(/*! ../content */ "./src/content/index.ts");
const core_1 = __webpack_require__(/*! ../core */ "./src/core/index.ts");
const bot_1 = __webpack_require__(/*! ../bot */ "./src/bot/index.ts");
const component_middleware_ids_const_1 = __webpack_require__(/*! ./component-middleware-ids.const */ "./src/middleware/component-middleware-ids.const.tsx");
const designers_1 = __webpack_require__(/*! ../designers */ "./src/designers/index.ts");
let { components } = component_middleware_ids_const_1.componentMiddleWareIds;
//TODO priorities and group?
const coreComponentMiddleware = () => (next) => ({ component, options }) => {
    const { template } = component;
    const id = (template === null || template === void 0 ? void 0 : template.length) ? template : components.cardList;
    switch (id) {
        case components.secured:
            return () => react_1.default.createElement(core_1.Secured, { config: component, data: options });
        case components.chatControls:
            return () => react_1.default.createElement(bot_1.ChatControls, { config: component, data: options });
        case components.chatFooter:
            return () => react_1.default.createElement(bot_1.ChatFooter, { config: component, data: options });
        case components.chatLauncher:
            return () => react_1.default.createElement(bot_1.ChatLauncher, { config: component, data: options });
        case components.chatPages:
            return () => react_1.default.createElement(bot_1.ChatPages, { config: component, data: options });
        case components.chatSplash:
            return () => react_1.default.createElement(bot_1.ChatSplash, { config: component, data: options });
        case components.chatHeader:
            return () => react_1.default.createElement(bot_1.ChatHeader, { config: component, data: options });
        case components.chatMenu:
            return () => react_1.default.createElement(bot_1.ChatMenu, { config: component, data: options });
        case components.chatTranscript:
            return () => react_1.default.createElement(bot_1.ChatTranscript, { config: component, data: options });
        case components.pageMenu:
            return () => react_1.default.createElement(core_1.PageMenu, { config: component, data: options });
        case components.commandBar:
            return () => react_1.default.createElement(core_1.CommandBar, { config: component, data: options });
        case components.listCommandBar:
            return () => react_1.default.createElement(content_1.ListCommandBar, { config: component, data: options });
        case components.actionBar:
            return () => react_1.default.createElement(core_1.ActionBar, { config: component, data: options });
        case components.sortButton:
            return () => react_1.default.createElement(core_1.SortButton, { config: component, data: options });
        case components.clearSelButton:
            return () => react_1.default.createElement(core_1.ClearSelectionButton, { config: component, data: options });
        case components.refinerButton:
            return () => react_1.default.createElement(core_1.RefinerButton, { config: component, data: options });
        case components.azButton:
            return () => react_1.default.createElement(core_1.AZButton, { config: component, data: options });
        case components.actionButton:
            return () => (react_1.default.createElement(core_1.ActionButton, { config: component, data: options }));
        case components.panelHeader:
            return () => react_1.default.createElement(core_1.PanelHeader, { config: component, data: options });
        case components.panelEntityMenu:
            return () => react_1.default.createElement(core_1.PanelEntityMenu, { config: component, data: options });
        case components.panelEntitySearch:
            return () => react_1.default.createElement(core_1.PanelEntitySearch, { config: component, data: options });
        case components.panelSidebar:
            return () => react_1.default.createElement(core_1.PanelSidebar, { config: component, data: options });
        case components.panelSidebarButton:
            return () => react_1.default.createElement(core_1.PanelSidebarButton, { config: component, data: options });
        case components.entityHeader:
            return () => react_1.default.createElement(core_1.PanelEntityHeader, { config: component, data: options });
        case components.profileHeader:
            return () => react_1.default.createElement(content_1.ProfileHeader, { config: component, data: options });
        case components.myHeader:
            return () => react_1.default.createElement(content_1.MyHeader, { config: component, data: options });
        case components.dataTable:
            return () => react_1.default.createElement(content_1.DataTable, { config: component, data: options });
        case components.cardList:
            return () => react_1.default.createElement(content_1.CardList, { config: component, data: options });
        case components.carousel:
            return () => react_1.default.createElement(content_1.Carousel, { config: component, data: options });
        case components.thumbCard:
            return () => react_1.default.createElement(content_1.ThumbCard, { config: component, data: options });
        case components.slide:
            return () => react_1.default.createElement(content_1.Slide, { config: component, data: options });
        case components.tile:
            return () => react_1.default.createElement(content_1.Tile, { config: component, data: options });
        case components.linkTile:
            return () => react_1.default.createElement(content_1.LinkTile, { config: component, data: options });
        case components.msForm:
            return () => react_1.default.createElement(content_1.MSForm, { config: component, data: options });
        case components.about:
            return () => react_1.default.createElement(content_1.About, { config: component, data: options });
        case components.htmlScreen:
            return () => react_1.default.createElement(content_1.HTMLScreen, { config: component, data: options });
        case components.preferences:
            return () => react_1.default.createElement(content_1.ThemeList, { config: component, data: options });
        case components.stream:
            return () => react_1.default.createElement(content_1.Stream, { config: component, data: options });
        case components.categoryMenu:
            return () => (react_1.default.createElement(content_1.CategoryMenu, { config: component, data: options }));
        case components.personCard:
            return () => (react_1.default.createElement(content_1.PersonCard, { config: component, data: options }));
        case components.adaptiveCard:
            return () => (react_1.default.createElement(content_1.AdaptiveCard, { config: component, data: options }));
        case components.page:
            return () => react_1.default.createElement(content_1.PageView, { config: component, data: options });
        case components.msPowerApp:
            return () => react_1.default.createElement(content_1.MSPowerApp, { config: component, data: options });
        case components.componentFlow:
            return () => react_1.default.createElement(content_1.ComponentFlow, { config: component, data: options });
        case components.pageContent:
            return () => react_1.default.createElement(content_1.PageContent, { config: component, data: options });
        case components.pageHeader:
            return () => react_1.default.createElement(content_1.PageHeader, { config: component, data: options });
        case components.pageNav:
            return () => react_1.default.createElement(content_1.PageNav, { config: component, data: options });
        case components.pageMetadata:
            return () => react_1.default.createElement(content_1.PageMetadata, { config: component, data: options });
        case components.pageImage:
            return () => react_1.default.createElement(content_1.PageImage, { config: component, data: options });
        case components.pageMap:
            return () => react_1.default.createElement(content_1.PageMap, { config: component, data: options });
        case components.pageUser:
            return () => react_1.default.createElement(content_1.PageUser, { config: component, data: options });
        case components.pageLocation:
            return () => react_1.default.createElement(content_1.PageLocation, { config: component, data: options });
        case components.pageCategory:
            return () => react_1.default.createElement(content_1.PageCategory, { config: component, data: options });
        case components.pageDetails:
            return () => react_1.default.createElement(content_1.PageDetails, { config: component, data: options });
        case components.pageDate:
            return () => react_1.default.createElement(content_1.PageDate, { config: component, data: options });
        case components.pageLinks:
            return () => react_1.default.createElement(content_1.PageLinks, { config: component, data: options });
        case components.pageComments:
            return () => react_1.default.createElement(content_1.PageComments, { config: component, data: options });
        case components.commentCard:
            return () => react_1.default.createElement(content_1.CommentCard, { config: component, data: options });
        case components.addCommentCard:
            return () => react_1.default.createElement(content_1.AddComment, { config: component, data: options });
        case components.timeline:
            return () => react_1.default.createElement(content_1.Timeline, { config: component, data: options });
        case components.image:
            return () => react_1.default.createElement(content_1.Image, { config: component, data: options });
        case components.map:
            return () => react_1.default.createElement(content_1.Map, { config: component, data: options });
        case components.profileHierachy:
            return () => react_1.default.createElement(content_1.Hierarchy, { config: component, data: options });
        case components.profileSummary:
            return () => (react_1.default.createElement(content_1.ProfileSummary, { config: component, data: options }));
        case components.profileContactInfo:
            return () => (react_1.default.createElement(content_1.ProfileContactInfo, { config: component, data: options }));
        case components.profileContact:
            return () => (react_1.default.createElement(content_1.ProfileContact, { config: component, data: options }));
        case components.profileAboutInfo:
            return () => (react_1.default.createElement(content_1.ProfileAboutInfo, { config: component, data: options }));
        case components.profileSkills:
            return () => (react_1.default.createElement(content_1.ProfileSkills, { config: component, data: options }));
        case components.profileProjects:
            return () => (react_1.default.createElement(content_1.ProfileProjects, { config: component, data: options }));
        case components.profileInterests:
            return () => (react_1.default.createElement(content_1.ProfileInterests, { config: component, data: options }));
        case components.profileSchools:
            return () => (react_1.default.createElement(content_1.ProfileSchools, { config: component, data: options }));
        case components.bannerImageSelector:
            return () => (react_1.default.createElement(content_1.BannerImageSelector, { config: component, data: options }));
        case components.bookmarkList:
            return () => (react_1.default.createElement(content_1.BookmarkList, { config: component, data: options }));
        case components.calendarActivity:
            return () => (react_1.default.createElement(content_1.CalendarActivity, { config: component, data: options }));
        case components.calendarEventCard:
            return () => react_1.default.createElement(content_1.EventCard, { config: component, data: options });
        case components.upNextActivity:
            return () => (react_1.default.createElement(content_1.UpNextActivity, { config: component, data: options }));
        case components.summariser:
            return () => (react_1.default.createElement(content_1.Summariser, { config: component, data: options }));
        case components.views:
            return () => react_1.default.createElement(content_1.Views, { config: component, data: options });
        case components.viewNavigator:
            return () => (react_1.default.createElement(content_1.ViewNavigator, { config: component, data: options }));
        case components.notification:
            return () => (react_1.default.createElement(content_1.Notification, { config: component, data: options }));
        case components.splashScreen:
            return () => (react_1.default.createElement(content_1.SplashScreen, { config: component, data: options }));
        case components.launchButton:
            return () => (react_1.default.createElement(content_1.LaunchButton, { config: component, data: options }));
        case components.queryDesigner:
            return () => (react_1.default.createElement(designers_1.QueryDesigner, { config: component, data: options }));
        case components.componentDesigner:
            return () => (react_1.default.createElement(designers_1.ComponentDesigner, { config: component, data: options }));
        case components.transformDesigner:
            return () => (react_1.default.createElement(designers_1.TransformDesigner, { config: component, data: options }));
        case components.designerInput:
            return () => (react_1.default.createElement(designers_1.DesignerInput, { config: component, data: options }));
        case components.datePicker:
            return () => (react_1.default.createElement(core_1.DatePicker, { config: component, data: options }));
        default:
            return next({ component, options });
    }
};
exports.coreComponentMiddleware = coreComponentMiddleware;


/***/ }),

/***/ "./src/middleware/index.ts":
/*!*********************************!*\
  !*** ./src/middleware/index.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./core-component-middleware.fn */ "./src/middleware/core-component-middleware.fn.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./component-middleware-ids.const */ "./src/middleware/component-middleware-ids.const.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./core-activity-middleware.fn */ "./src/middleware/core-activity-middleware.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./core-attachment-middleware.fn */ "./src/middleware/core-attachment-middleware.fn.tsx"), exports);


/***/ }),

/***/ "./src/models/card-list-item-props.interface.ts":
/*!******************************************************!*\
  !*** ./src/models/card-list-item-props.interface.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/index.ts":
/*!*****************************!*\
  !*** ./src/models/index.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ICommentSchema = exports.IOutlookSummariser = exports.ICalendarSchema = exports.IToDoSchema = exports.IOutlookSchema = exports.ILinkTileSchema = exports.IAdaptiveCardSchema = exports.ISlideSchema = exports.ITileSchema = exports.IThumbCardSchema = exports.SearchResultCardSchema = exports.ExtendedAdaptiveCardSchema = exports.ITimelineSchema = exports.IPersonCardSchema = exports.IDataTableRowSchema = exports.ICategoryLinkSchema = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./thumb-card.interface */ "./src/models/thumb-card.interface.ts"), exports);
var schemas_const_1 = __webpack_require__(/*! ./schemas.const */ "./src/models/schemas.const.ts");
Object.defineProperty(exports, "ICategoryLinkSchema", ({ enumerable: true, get: function () { return schemas_const_1.ICategoryLinkSchema; } }));
Object.defineProperty(exports, "IDataTableRowSchema", ({ enumerable: true, get: function () { return schemas_const_1.IDataTableRowSchema; } }));
Object.defineProperty(exports, "IPersonCardSchema", ({ enumerable: true, get: function () { return schemas_const_1.IPersonCardSchema; } }));
Object.defineProperty(exports, "ITimelineSchema", ({ enumerable: true, get: function () { return schemas_const_1.ITimelineSchema; } }));
Object.defineProperty(exports, "ExtendedAdaptiveCardSchema", ({ enumerable: true, get: function () { return schemas_const_1.ExtendedAdaptiveCardSchema; } }));
Object.defineProperty(exports, "SearchResultCardSchema", ({ enumerable: true, get: function () { return schemas_const_1.SearchResultCardSchema; } }));
Object.defineProperty(exports, "IThumbCardSchema", ({ enumerable: true, get: function () { return schemas_const_1.IThumbCardSchema; } }));
Object.defineProperty(exports, "ITileSchema", ({ enumerable: true, get: function () { return schemas_const_1.ITileSchema; } }));
Object.defineProperty(exports, "ISlideSchema", ({ enumerable: true, get: function () { return schemas_const_1.ISlideSchema; } }));
Object.defineProperty(exports, "IAdaptiveCardSchema", ({ enumerable: true, get: function () { return schemas_const_1.IAdaptiveCardSchema; } }));
Object.defineProperty(exports, "ILinkTileSchema", ({ enumerable: true, get: function () { return schemas_const_1.ILinkTileSchema; } }));
Object.defineProperty(exports, "IOutlookSchema", ({ enumerable: true, get: function () { return schemas_const_1.IOutlookSchema; } }));
Object.defineProperty(exports, "IToDoSchema", ({ enumerable: true, get: function () { return schemas_const_1.IToDoSchema; } }));
Object.defineProperty(exports, "ICalendarSchema", ({ enumerable: true, get: function () { return schemas_const_1.ICalendarSchema; } }));
Object.defineProperty(exports, "IOutlookSummariser", ({ enumerable: true, get: function () { return schemas_const_1.IOutlookSummariser; } }));
Object.defineProperty(exports, "ICommentSchema", ({ enumerable: true, get: function () { return schemas_const_1.ICommentSchema; } }));
tslib_1.__exportStar(__webpack_require__(/*! ./card-list-item-props.interface */ "./src/models/card-list-item-props.interface.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./tag.interface */ "./src/models/tag.interface.ts"), exports);


/***/ }),

/***/ "./src/models/schemas.const.ts":
/*!*************************************!*\
  !*** ./src/models/schemas.const.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ICommentSchema = exports.IOutlookSummariser = exports.ICalendarSchema = exports.ICategoryLinkSchema = exports.ISlideSchema = exports.IDataTableRowSchema = exports.SearchResultCardSchema = exports.ExtendedAdaptiveCardSchema = exports.IPersonCardSchema = exports.ITimelineSchema = exports.IThumbCardSchema = exports.IToDoSchema = exports.IOutlookSchema = exports.ILinkTileSchema = exports.ITileSchema = exports.IAdaptiveCardSchema = void 0;
exports.IAdaptiveCardSchema = "http://adaptivecards.io/schemas/adaptive-card.json";
exports.ITileSchema = "https://ics.ai/smarthub/tile";
exports.ILinkTileSchema = "https://ics.ai/smarthub/link-tile";
exports.IOutlookSchema = "https://ics.ai/smarthub/outlook";
exports.IToDoSchema = "https://ics.ai/smarthub/todo";
exports.IThumbCardSchema = "https://ics.ai/smarthub/thumb-card";
exports.ITimelineSchema = "https://ics.ai/smarthub/timeline";
exports.IPersonCardSchema = "https://ics.ai/smarthub/component/person";
exports.ExtendedAdaptiveCardSchema = "https://ics.ai/smarthub/chat-card";
exports.SearchResultCardSchema = "https://ics.ai/smarthub/chat-search-result-card";
exports.IDataTableRowSchema = "https://ics.ai/intranet/table-row";
exports.ISlideSchema = "https://ics.ai/smarthub/slide";
exports.ICategoryLinkSchema = "https://ics.ai/smarthub/category/link";
exports.ICalendarSchema = "https://ics.ai/smarthub/event-card";
exports.IOutlookSummariser = "https://ics.ai/smarthub/summariser";
exports.ICommentSchema = "https://ics.ai/smarthub/comment";


/***/ }),

/***/ "./src/models/tag.interface.ts":
/*!*************************************!*\
  !*** ./src/models/tag.interface.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/models/thumb-card.interface.ts":
/*!********************************************!*\
  !*** ./src/models/thumb-card.interface.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/utilities/action-link/action-link.component.tsx":
/*!*************************************************************!*\
  !*** ./src/utilities/action-link/action-link.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ActionLink = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const action_to_uri_helper_1 = __webpack_require__(/*! ./action-to-uri.helper */ "./src/utilities/action-link/action-to-uri.helper.ts");
const useStyles = react_jss_1.createUseStyles(({ palette }) => ({
    text: (colour) => {
        return {
            color: (colour === null || colour === void 0 ? void 0 : colour.length) ? palette[colour] : undefined,
        };
    },
    header: {
        padding: "0",
        margin: "0",
        display: "inline",
    },
}));
const defaultLevel = "h3";
const getValue = (value, locale) => {
    return typeof value == "object" ? value[locale] : value;
};
const ActionLink = (_a) => {
    var { headerLevel, action, colour, className } = _a, rest = tslib_1.__rest(_a, ["headerLevel", "action", "colour", "className"]);
    const openAction = smarthub_common_1.useHandleCommand();
    const registerLastFocus = smarthub_common_1.useRegisterLastAction();
    const locale = smarthub_common_1.useLocale();
    const styles = useStyles(colour);
    const linkRef = react_1.useRef();
    const currentType = smarthub_common_1.usePanelType();
    const registerFocusCallback = react_1.useCallback(() => {
        registerLastFocus(currentType, () => {
            linkRef.current.focus();
        });
    }, []);
    const onClick = react_1.useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        openAction(action);
        registerFocusCallback();
    }, [action, locale]);
    const url = action_to_uri_helper_1.actionToUri(action);
    const { uri } = action;
    const { target = "_blank" } = action;
    const link = (react_1.default.createElement(react_2.Link, Object.assign({ componentRef: linkRef, className: [styles.text, className].join(" ") }, rest, { href: target != "_blank" ? getValue(uri, locale) : url, onClick: onClick })));
    if (headerLevel === false)
        return link;
    const HeaderTag = typeof headerLevel === "string" && headerLevel.length
        ? headerLevel
        : defaultLevel;
    return react_1.default.createElement(HeaderTag, { className: styles.header }, link);
};
exports.ActionLink = ActionLink;


/***/ }),

/***/ "./src/utilities/action-link/action-to-uri.helper.ts":
/*!***********************************************************!*\
  !*** ./src/utilities/action-link/action-to-uri.helper.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.actionToUri = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const query_string_1 = tslib_1.__importDefault(__webpack_require__(/*! query-string */ "query-string"));
const flatten = (obj, flat, keyPath) => {
    const keys = Object.keys(obj);
    flat = flat !== null && flat !== void 0 ? flat : {};
    keyPath = keyPath !== null && keyPath !== void 0 ? keyPath : '';
    keys
        .sort()
        .forEach(key => {
        const value = obj[key];
        const flatKey = `${keyPath}${keyPath.length ? '.' : ''}${key}`;
        if (value && typeof value == 'object')
            flatten(value, flat, flatKey);
        else if (value && (typeof value != 'string' || value.length > 0))
            flat[flatKey] = value;
    });
    return flat;
};
const schemaPrefix = `${smarthub_common_1.ActionSchema}/`;
const actionToUri = (action) => {
    const prefix = './#';
    if (!action || !Object.keys(action).length)
        return prefix;
    let { $schema } = action, rest = tslib_1.__rest(action, ["$schema"]);
    if (!$schema.length)
        $schema = smarthub_common_1.RouteActionSchema;
    else if ($schema.startsWith(schemaPrefix))
        $schema = $schema.substring(schemaPrefix.length);
    const $action = Object.assign(Object.assign({}, rest), { $schema });
    const flat = flatten({ $action });
    const serialised = query_string_1.default.stringify(flat, { encode: true });
    return serialised.length
        ? `${prefix}?${serialised}`
        : prefix;
};
exports.actionToUri = actionToUri;


/***/ }),

/***/ "./src/utilities/action-link/index.ts":
/*!********************************************!*\
  !*** ./src/utilities/action-link/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./action-link.component */ "./src/utilities/action-link/action-link.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/bookmark/bookmark.component.tsx":
/*!*******************************************************!*\
  !*** ./src/utilities/bookmark/bookmark.component.tsx ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Bookmark = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
exports.Bookmark = react_1.forwardRef(({ title, bookmarkInfo, className }, ref) => {
    const [bookmark, toggle] = smarthub_common_1.useBookmark(bookmarkInfo);
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const handleBookmark = (e) => {
        e.stopPropagation();
        toggle();
    };
    return react_1.default.createElement("div", { className: className, ref: ref },
        react_1.default.createElement(react_2.IconButton, { ariaLabel: bookmark ? `${localizeConfig.unbookmark} ${title}` : `${localizeConfig.bookmark} ${title}`, onClick: (e) => handleBookmark(e) },
            react_1.default.createElement(react_2.Icon, { iconName: bookmark ? "SingleBookmarkSolid" : "SingleBookmark" })));
});


/***/ }),

/***/ "./src/utilities/bookmark/index.ts":
/*!*****************************************!*\
  !*** ./src/utilities/bookmark/index.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./bookmark.component */ "./src/utilities/bookmark/bookmark.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/coach-mark-wrapper/coach-mark-wrapper.component.tsx":
/*!***************************************************************************!*\
  !*** ./src/utilities/coach-mark-wrapper/coach-mark-wrapper.component.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CoachMarkWrapper = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_visibility_sensor_1 = tslib_1.__importDefault(__webpack_require__(/*! react-visibility-sensor */ "react-visibility-sensor"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const styles = {
    entityInnerHost: {
        minWidth: "300px"
    }
};
const CoachMarkWrapper = ({ name, position, children, cacheLevel, version, className, doNotLayer = true }) => {
    const ref = react_1.useRef(null);
    const [showCoachMark, setShowCoachMark] = react_1.useState(false);
    const localiseConfig = smarthub_common_1.useLocalizeConfig();
    const [coachMarks, setCoachMarks] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys.coachMarks, true, [], cacheLevel);
    const coachMark = coachMarks === null || coachMarks === void 0 ? void 0 : coachMarks.find(({ name: n, version: v }) => n == name && v == version);
    const hideCoachmark = react_1.useCallback(() => {
        setCoachMarks([
            ...coachMarks.filter(({ name: n }) => n != name),
            {
                name, version
            }
        ]);
    }, [coachMarks]);
    const directionalHint = typeof position == 'string' ? react_2.DirectionalHint[position] : position;
    const onVisibilityChange = react_1.useCallback((isVisible) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        setShowCoachMark(isVisible);
    }), []);
    const child = !coachMark
        ? react_1.Children.only(children)
        : null;
    const content = !coachMark
        ? react_1.cloneElement(child, Object.assign(Object.assign({}, child.props), { ref }))
        : null;
    return react_1.default.createElement(react_1.default.Fragment, null, !coachMark
        ? react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_visibility_sensor_1.default, { onChange: onVisibilityChange }, content),
            showCoachMark && react_1.default.createElement(react_2.Coachmark, { preventFocusOnMount: true, target: ref.current, positioningContainerProps: {
                    directionalHint,
                    doNotLayer: doNotLayer
                }, className: className, styles: styles, ariaAlertText: localiseConfig[`${name}CoachAlert`], ariaDescribedBy: `${name}-coach-desc`, ariaLabelledBy: `${name}-coach-label`, ariaDescribedByText: localiseConfig[`${name}CoachDesc`], ariaLabelledByText: localiseConfig[`${name}CoachLabel`] },
                react_1.default.createElement(react_2.TeachingBubbleContent, { headline: localiseConfig[`${name}CoachTitle`], hasCloseButton: true, isWide: true, closeButtonAriaLabel: localiseConfig.hideCoachMark, onDismiss: hideCoachmark, ariaDescribedBy: `${name}-bubble-desc`, ariaLabelledBy: `${name}-bubble-label` }, localiseConfig[`${name}CoachText`])))
        : children);
};
exports.CoachMarkWrapper = CoachMarkWrapper;


/***/ }),

/***/ "./src/utilities/coach-mark-wrapper/index.ts":
/*!***************************************************!*\
  !*** ./src/utilities/coach-mark-wrapper/index.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./coach-mark-wrapper.component */ "./src/utilities/coach-mark-wrapper/coach-mark-wrapper.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/delay-item/delay-item.component.tsx":
/*!***********************************************************!*\
  !*** ./src/utilities/delay-item/delay-item.component.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DelayItem = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const DelayItem = ({ index = 1, delay, children }) => {
    const [show, setShow] = react_1.useState(false);
    react_1.useEffect(() => {
        const id = setTimeout(() => setShow(true), index * delay);
        return () => clearTimeout(id);
    }, []);
    return show ? children : null;
};
exports.DelayItem = DelayItem;


/***/ }),

/***/ "./src/utilities/delay-item/index.ts":
/*!*******************************************!*\
  !*** ./src/utilities/delay-item/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./delay-item.component */ "./src/utilities/delay-item/delay-item.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/error-box/error-box.component.tsx":
/*!*********************************************************!*\
  !*** ./src/utilities/error-box/error-box.component.tsx ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ErrorBox = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const ErrorBox = ({ error: { message, description } }) => {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", null, "An error has occurred."),
        (message === null || message === void 0 ? void 0 : message.length) > 0 && react_1.default.createElement("div", null, message),
        (description === null || description === void 0 ? void 0 : description.length) > 0 && react_1.default.createElement("div", null, description)));
};
exports.ErrorBox = ErrorBox;


/***/ }),

/***/ "./src/utilities/error-box/index.ts":
/*!******************************************!*\
  !*** ./src/utilities/error-box/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./error-box.component */ "./src/utilities/error-box/error-box.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/index.ts":
/*!********************************!*\
  !*** ./src/utilities/index.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./action-link */ "./src/utilities/action-link/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./bookmark */ "./src/utilities/bookmark/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./delay-item */ "./src/utilities/delay-item/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./error-box */ "./src/utilities/error-box/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./info-box */ "./src/utilities/info-box/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./no-results */ "./src/utilities/no-results/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./tag */ "./src/utilities/tag/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./text-overflow */ "./src/utilities/text-overflow/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./theme-image */ "./src/utilities/theme-image/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./coach-mark-wrapper */ "./src/utilities/coach-mark-wrapper/index.ts"), exports);


/***/ }),

/***/ "./src/utilities/info-box/index.ts":
/*!*****************************************!*\
  !*** ./src/utilities/info-box/index.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./info-box.component */ "./src/utilities/info-box/info-box.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/info-box/info-box.component.tsx":
/*!*******************************************************!*\
  !*** ./src/utilities/info-box/info-box.component.tsx ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InfoBox = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const React = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const InfoBox = ({ message, details, children }) => {
    return (React.createElement("div", null,
        React.createElement("div", null, message),
        (details === null || details === void 0 ? void 0 : details.length) > 0 && React.createElement("div", null, details),
        React.createElement("div", null, children)));
};
exports.InfoBox = InfoBox;


/***/ }),

/***/ "./src/utilities/no-results/index.ts":
/*!*******************************************!*\
  !*** ./src/utilities/no-results/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./no-results.component */ "./src/utilities/no-results/no-results.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/no-results/no-results.component.tsx":
/*!***********************************************************!*\
  !*** ./src/utilities/no-results/no-results.component.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NoResults = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing, sizes }) => ({
    wrapper: {
        maxWidth: "100%",
        maxHeight: "100%",
        padding: spacing.medium,
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    title: Object.assign(Object.assign({}, fonts.superLarge), { color: palette.primary }),
    description: Object.assign(Object.assign({}, fonts.medium), { color: palette.neutralEmptyOn }),
    cloud: {
        maxWidth: `calc(${sizes.mega} * 3)`,
        fill: palette.primaryMinus3
    }
}));
const NoResults = (props) => {
    const localizeConfig = smarthub_common_1.useLocalizeConfig();
    const { show = true, title = localizeConfig.noResultsTitle, description = localizeConfig.noResultsDescription } = props !== null && props !== void 0 ? props : {};
    const styles = useStyles();
    return (show
        ? react_1.default.createElement("div", { className: styles.wrapper },
            react_1.default.createElement("svg", { viewBox: "0 0 480 300", className: styles.cloud },
                react_1.default.createElement("path", { d: "M 179.32617 10.005859 C 171.67594 10.081205 163.91978 10.850578 156.13672 12.345703 C 117.1555 19.833988 84.534191 46.058853 69.691406 81.84375 C 64.232056 95.005867 61.705546 107.27721 61.158203 123.29883 L 60.853516 132.24219 L 58.929688 132.95508 C 56.15698 133.98042 47.467491 139.0654 43.285156 142.11133 C 38.716236 145.4388 33.045525 150.67877 29.292969 155.04102 C 5.0127755 183.26613 3.4795846 225.86105 25.660156 255.92188 C 39.379166 274.51494 61.104609 286.90333 84.648438 289.55859 C 89.719626 290.13057 389.62664 290.15318 394.7793 289.58203 C 431.48207 285.5137 460.49794 260.0922 468.10547 225.33789 C 475.16564 193.08425 462.15154 160.2571 434.73242 141.15625 C 432.40681 139.53619 427.51862 136.76105 423.86914 134.98828 L 417.23438 131.76562 L 416.17773 127.60547 C 414.10301 119.43153 409.87951 109.7461 405.2168 102.46875 C 389.93552 78.618149 364.86859 63.315177 335.63086 59.988281 C 328.22685 59.145806 314.36344 59.701594 307.38086 61.123047 C 300.68837 62.485448 293.42478 64.854536 288.32031 67.337891 C 286.30167 68.319968 284.56237 69.123047 284.45703 69.123047 C 284.35165 69.123047 282.81474 66.85717 281.04102 64.087891 C 258.82295 29.399162 220.63748 9.5989923 179.32617 10.005859 z M 236.63672 98.6875 C 242.35652 98.6875 247.7677 99.290567 252.86914 100.49414 C 258.12518 101.54727 262.76388 103.50284 266.7832 106.36133 C 270.80253 109.06936 273.97022 112.83024 276.28906 117.64453 C 278.76249 122.45882 280 128.55195 280 135.92383 C 280 140.43722 279.53691 144.49866 278.60938 148.10938 C 277.68184 151.72009 276.29062 155.10429 274.43555 158.26367 C 272.73507 161.2726 270.64726 164.1318 268.17383 166.83984 C 265.7004 169.39743 262.99579 172.03024 260.05859 174.73828 C 255.5755 178.64989 252.01864 181.95993 249.39062 184.66797 C 246.76261 187.22556 244.67675 189.70809 243.13086 192.11523 C 241.58497 194.52238 240.50312 197.07907 239.88477 199.78711 C 239.26641 202.49515 238.8792 205.95546 238.72461 210.16797 L 226.89844 210.16797 C 222.41535 210.16797 220.17383 206.40709 220.17383 198.88477 C 220.17383 195.42449 220.56104 192.34085 221.33398 189.63281 C 222.10693 186.92477 223.26661 184.29197 224.8125 181.73438 C 226.51298 179.17678 228.59884 176.62009 231.07227 174.0625 C 233.70028 171.35446 236.71427 168.41914 240.11523 165.25977 C 243.20702 162.40128 245.75792 159.91875 247.76758 157.8125 C 249.93183 155.5558 251.63243 153.52606 252.86914 151.7207 C 254.10586 149.7649 254.95615 147.88349 255.41992 146.07812 C 256.03828 144.12232 256.34766 141.86619 256.34766 139.30859 C 256.34766 131.93671 254.2618 126.74526 250.08789 123.73633 C 246.06857 120.57695 239.72926 118.99805 231.07227 118.99805 C 225.35246 118.99805 220.09695 119.44888 215.30469 120.35156 C 210.51242 121.1038 207.03339 121.48047 204.86914 121.48047 C 202.85948 121.48047 201.54609 121.02963 200.92773 120.12695 C 200.30938 119.22427 200 117.94593 200 116.29102 L 200 105.23242 C 204.48309 103.57751 209.7386 102.07277 215.76758 100.71875 C 221.95115 99.364731 228.90726 98.6875 236.63672 98.6875 z M 231.53711 230.02734 C 236.94773 230.02734 240.8879 231.15541 243.36133 233.41211 C 245.83476 235.51836 247.07227 239.12896 247.07227 244.24414 C 247.07227 249.50977 245.83476 253.2726 243.36133 255.5293 C 240.8879 257.63555 236.94773 258.6875 231.53711 258.6875 C 225.9719 258.6875 221.95194 257.63555 219.47852 255.5293 C 217.15968 253.2726 216 249.50977 216 244.24414 C 216 239.12896 217.23751 235.51836 219.71094 233.41211 C 222.18437 231.15541 226.12648 230.02734 231.53711 230.02734 z " })),
            react_1.default.createElement("div", { className: styles.title }, title),
            react_1.default.createElement("div", { className: styles.description }, description))
        : null);
};
exports.NoResults = NoResults;


/***/ }),

/***/ "./src/utilities/tag/index.ts":
/*!************************************!*\
  !*** ./src/utilities/tag/index.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./tag.component */ "./src/utilities/tag/tag.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/tag/tag.component.tsx":
/*!*********************************************!*\
  !*** ./src/utilities/tag/tag.component.tsx ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Tag = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const text_overflow_component_1 = __webpack_require__(/*! ../text-overflow/text-overflow.component */ "./src/utilities/text-overflow/text-overflow.component.tsx");
const useStyles = react_jss_1.createUseStyles(({ palette, fonts, spacing }) => ({
    rootStyle: ({ width }) => ({
        width: width == 'fill'
            ? "100%"
            : "auto",
        display: width == 'fill'
            ? "block"
            : "inline-block",
    }),
    innerStyle: {
        display: "flex",
        gap: spacing.smallPlus,
        alignItems: "start",
        width: "100%",
        maxWidth: "100%",
    },
    textStyle: Object.assign(Object.assign({}, fonts.small), { color: palette.neutralMinus3On })
}));
const Tag = (props) => {
    const { tagInfo: { label, text, icon } = {}, width } = props;
    const { rootStyle, innerStyle, textStyle } = useStyles(props);
    return (react_1.default.createElement("div", { className: rootStyle },
        react_1.default.createElement("div", { className: innerStyle },
            icon && react_1.default.createElement(react_2.Icon, { "aria-hidden": true, iconName: icon, title: text }),
            react_1.default.createElement(text_overflow_component_1.TextOverflow, { lines: 2, label: label, className: textStyle, fixed: width == 'fill', text: text }))));
};
exports.Tag = Tag;


/***/ }),

/***/ "./src/utilities/text-overflow/index.ts":
/*!**********************************************!*\
  !*** ./src/utilities/text-overflow/index.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./text-overflow.component */ "./src/utilities/text-overflow/text-overflow.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/text-overflow/text-overflow.component.tsx":
/*!*****************************************************************!*\
  !*** ./src/utilities/text-overflow/text-overflow.component.tsx ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TextOverflow = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const useStyles = react_jss_1.createUseStyles(({ palette, fonts }) => ({
    text: ({ lines, colour, fixed, font }) => {
        const textFont = (font === null || font === void 0 ? void 0 : font.length) ? fonts[font]
            : fonts.normal;
        return Object.assign(Object.assign({}, textFont), { lineHeight: `calc(${textFont.fontSize} * 1.3)`, height: fixed
                ? `calc(${lines} * (${textFont.fontSize} * 1.3))`
                : 'auto', overflow: "hidden", color: (colour === null || colour === void 0 ? void 0 : colour.length) ? palette[colour]
                : undefined, whiteSpace: "normal", wordWrap: "normal", "-webkit-line-clamp": lines, display: "-webkit-box", "-webkit-box-orient": "vertical" });
    }
}));
const TextOverflow = (props) => {
    const { text, showTooltip, toolTipDir, className, children, label } = props;
    const styles = useStyles(props);
    const focusStyle = smarthub_common_1.useFocusStyles();
    return showTooltip
        ? react_1.default.createElement(react_2.TooltipHost, { overflowMode: react_2.TooltipOverflowMode.Self, hostClassName: [styles.text, focusStyle.focus, className ? className : ''].join(" "), content: text, directionalHint: toolTipDir !== null && toolTipDir !== void 0 ? toolTipDir : react_2.DirectionalHint.topCenter },
            react_1.default.createElement("div", { "data-is-focusable": true, "aria-label": label }, children ? children : text))
        : react_1.default.createElement("div", { className: [styles.text, focusStyle.focus, className ? className : ''].join(" "), "data-is-focusable": true, "aria-label": label }, children ? children : text);
};
exports.TextOverflow = TextOverflow;


/***/ }),

/***/ "./src/utilities/theme-image/index.ts":
/*!********************************************!*\
  !*** ./src/utilities/theme-image/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./theme-image.component */ "./src/utilities/theme-image/theme-image.component.tsx"), exports);


/***/ }),

/***/ "./src/utilities/theme-image/theme-image.component.tsx":
/*!*************************************************************!*\
  !*** ./src/utilities/theme-image/theme-image.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ThemeImage = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles({
    image: {
        maxHeight: "100%"
    }
});
const sizes = {
    small: "S",
    medium: "M",
    large: "L",
    default: "L"
};
const parseUri = ({ image, defaultSize, defaultPalette }, theme) => {
    if (typeof image == 'string')
        return theme.image[image];
    const { name, definition: { prefix, size, palette } = {}, uri } = image;
    let imageUri;
    if (prefix === null || prefix === void 0 ? void 0 : prefix.length)
        imageUri = theme.image[`${prefix}On${(palette === null || palette === void 0 ? void 0 : palette.length) ? palette : defaultPalette}${sizes[(size === null || size === void 0 ? void 0 : size.length) ? size : defaultSize]}`];
    if (!imageUri && (name === null || name === void 0 ? void 0 : name.length))
        imageUri = theme.image[name];
    if (!imageUri && (uri === null || uri === void 0 ? void 0 : uri.length))
        imageUri = uri;
    return imageUri;
};
const ThemeImage = (props) => {
    const { image, alt, className } = props;
    const { definition: theme } = smarthub_common_1.useTheme();
    const styles = useStyles();
    const uri = parseUri(props, theme);
    const altText = typeof image == "object"
        ? image.text
        : alt;
    return react_1.default.createElement("img", { alt: altText, title: altText, src: uri, className: [styles.image, className !== null && className !== void 0 ? className : ''].join(' ') });
};
exports.ThemeImage = ThemeImage;


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/index.js":
/*!****************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/index.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useBoolean": () => (/* reexport safe */ _useBoolean_useBoolean__WEBPACK_IMPORTED_MODULE_0__["default"]),
/* harmony export */   "useClickAnyWhere": () => (/* reexport safe */ _useClickAnyWhere_useClickAnyWhere__WEBPACK_IMPORTED_MODULE_1__["default"]),
/* harmony export */   "useCopyToClipboard": () => (/* reexport safe */ _useCopyToClipboard_useCopyToClipboard__WEBPACK_IMPORTED_MODULE_2__["default"]),
/* harmony export */   "useCountdown": () => (/* reexport safe */ _useCountdown_useCountdown__WEBPACK_IMPORTED_MODULE_3__["default"]),
/* harmony export */   "useCounter": () => (/* reexport safe */ _useCounter_useCounter__WEBPACK_IMPORTED_MODULE_4__["default"]),
/* harmony export */   "useDarkMode": () => (/* reexport safe */ _useDarkMode_useDarkMode__WEBPACK_IMPORTED_MODULE_5__["default"]),
/* harmony export */   "useDebounce": () => (/* reexport safe */ _useDebounce_useDebounce__WEBPACK_IMPORTED_MODULE_6__["default"]),
/* harmony export */   "useDocumentTitle": () => (/* reexport safe */ _useDocumentTitle_useDocumentTitle__WEBPACK_IMPORTED_MODULE_7__["default"]),
/* harmony export */   "useEffectOnce": () => (/* reexport safe */ _useEffectOnce_useEffectOnce__WEBPACK_IMPORTED_MODULE_8__["default"]),
/* harmony export */   "useElementSize": () => (/* reexport safe */ _useElementSize_useElementSize__WEBPACK_IMPORTED_MODULE_9__["default"]),
/* harmony export */   "useEventCallback": () => (/* reexport safe */ _useEventCallback_useEventCallback__WEBPACK_IMPORTED_MODULE_10__["default"]),
/* harmony export */   "useEventListener": () => (/* reexport safe */ _useEventListener_useEventListener__WEBPACK_IMPORTED_MODULE_11__["default"]),
/* harmony export */   "useFetch": () => (/* reexport safe */ _useFetch_useFetch__WEBPACK_IMPORTED_MODULE_12__["default"]),
/* harmony export */   "useHover": () => (/* reexport safe */ _useHover_useHover__WEBPACK_IMPORTED_MODULE_13__["default"]),
/* harmony export */   "useImageOnLoad": () => (/* reexport safe */ _useImageOnLoad_useImageOnLoad__WEBPACK_IMPORTED_MODULE_14__["default"]),
/* harmony export */   "useIntersectionObserver": () => (/* reexport safe */ _useIntersectionObserver_useIntersectionObserver__WEBPACK_IMPORTED_MODULE_15__["default"]),
/* harmony export */   "useInterval": () => (/* reexport safe */ _useInterval_useInterval__WEBPACK_IMPORTED_MODULE_16__["default"]),
/* harmony export */   "useIsClient": () => (/* reexport safe */ _useIsClient_useIsClient__WEBPACK_IMPORTED_MODULE_17__["default"]),
/* harmony export */   "useIsFirstRender": () => (/* reexport safe */ _useIsFirstRender_useIsFirstRender__WEBPACK_IMPORTED_MODULE_18__["default"]),
/* harmony export */   "useIsMounted": () => (/* reexport safe */ _useIsMounted_useIsMounted__WEBPACK_IMPORTED_MODULE_19__["default"]),
/* harmony export */   "useIsomorphicLayoutEffect": () => (/* reexport safe */ _useIsomorphicLayoutEffect_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_20__["default"]),
/* harmony export */   "useLocalStorage": () => (/* reexport safe */ _useLocalStorage_useLocalStorage__WEBPACK_IMPORTED_MODULE_21__["default"]),
/* harmony export */   "useLockedBody": () => (/* reexport safe */ _useLockedBody_useLockedBody__WEBPACK_IMPORTED_MODULE_22__["default"]),
/* harmony export */   "useMap": () => (/* reexport safe */ _useMap_useMap__WEBPACK_IMPORTED_MODULE_23__["default"]),
/* harmony export */   "useMediaQuery": () => (/* reexport safe */ _useMediaQuery_useMediaQuery__WEBPACK_IMPORTED_MODULE_24__["default"]),
/* harmony export */   "useOnClickOutside": () => (/* reexport safe */ _useOnClickOutside_useOnClickOutside__WEBPACK_IMPORTED_MODULE_25__["default"]),
/* harmony export */   "useReadLocalStorage": () => (/* reexport safe */ _useReadLocalStorage_useReadLocalStorage__WEBPACK_IMPORTED_MODULE_26__["default"]),
/* harmony export */   "useScreen": () => (/* reexport safe */ _useScreen_useScreen__WEBPACK_IMPORTED_MODULE_27__["default"]),
/* harmony export */   "useScript": () => (/* reexport safe */ _useScript_useScript__WEBPACK_IMPORTED_MODULE_28__["default"]),
/* harmony export */   "useSessionStorage": () => (/* reexport safe */ _useSessionStorage_useSessionStorage__WEBPACK_IMPORTED_MODULE_29__["default"]),
/* harmony export */   "useSsr": () => (/* reexport safe */ _useSsr_useSsr__WEBPACK_IMPORTED_MODULE_30__["default"]),
/* harmony export */   "useStep": () => (/* reexport safe */ _useStep_useStep__WEBPACK_IMPORTED_MODULE_31__["default"]),
/* harmony export */   "useTernaryDarkMode": () => (/* reexport safe */ _useTernaryDarkMode_useTernaryDarkMode__WEBPACK_IMPORTED_MODULE_32__["default"]),
/* harmony export */   "useTimeout": () => (/* reexport safe */ _useTimeout_useTimeout__WEBPACK_IMPORTED_MODULE_33__["default"]),
/* harmony export */   "useToggle": () => (/* reexport safe */ _useToggle_useToggle__WEBPACK_IMPORTED_MODULE_34__["default"]),
/* harmony export */   "useUpdateEffect": () => (/* reexport safe */ _useUpdateEffect_useUpdateEffect__WEBPACK_IMPORTED_MODULE_35__["default"]),
/* harmony export */   "useWindowSize": () => (/* reexport safe */ _useWindowSize_useWindowSize__WEBPACK_IMPORTED_MODULE_36__["default"])
/* harmony export */ });
/* harmony import */ var _useBoolean_useBoolean__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./useBoolean/useBoolean */ "./node_modules/usehooks-ts/dist/esm/useBoolean/useBoolean.js");
/* harmony import */ var _useClickAnyWhere_useClickAnyWhere__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./useClickAnyWhere/useClickAnyWhere */ "./node_modules/usehooks-ts/dist/esm/useClickAnyWhere/useClickAnyWhere.js");
/* harmony import */ var _useCopyToClipboard_useCopyToClipboard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./useCopyToClipboard/useCopyToClipboard */ "./node_modules/usehooks-ts/dist/esm/useCopyToClipboard/useCopyToClipboard.js");
/* harmony import */ var _useCountdown_useCountdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./useCountdown/useCountdown */ "./node_modules/usehooks-ts/dist/esm/useCountdown/useCountdown.js");
/* harmony import */ var _useCounter_useCounter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./useCounter/useCounter */ "./node_modules/usehooks-ts/dist/esm/useCounter/useCounter.js");
/* harmony import */ var _useDarkMode_useDarkMode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./useDarkMode/useDarkMode */ "./node_modules/usehooks-ts/dist/esm/useDarkMode/useDarkMode.js");
/* harmony import */ var _useDebounce_useDebounce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./useDebounce/useDebounce */ "./node_modules/usehooks-ts/dist/esm/useDebounce/useDebounce.js");
/* harmony import */ var _useDocumentTitle_useDocumentTitle__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./useDocumentTitle/useDocumentTitle */ "./node_modules/usehooks-ts/dist/esm/useDocumentTitle/useDocumentTitle.js");
/* harmony import */ var _useEffectOnce_useEffectOnce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./useEffectOnce/useEffectOnce */ "./node_modules/usehooks-ts/dist/esm/useEffectOnce/useEffectOnce.js");
/* harmony import */ var _useElementSize_useElementSize__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./useElementSize/useElementSize */ "./node_modules/usehooks-ts/dist/esm/useElementSize/useElementSize.js");
/* harmony import */ var _useEventCallback_useEventCallback__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./useEventCallback/useEventCallback */ "./node_modules/usehooks-ts/dist/esm/useEventCallback/useEventCallback.js");
/* harmony import */ var _useEventListener_useEventListener__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./useEventListener/useEventListener */ "./node_modules/usehooks-ts/dist/esm/useEventListener/useEventListener.js");
/* harmony import */ var _useFetch_useFetch__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./useFetch/useFetch */ "./node_modules/usehooks-ts/dist/esm/useFetch/useFetch.js");
/* harmony import */ var _useHover_useHover__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./useHover/useHover */ "./node_modules/usehooks-ts/dist/esm/useHover/useHover.js");
/* harmony import */ var _useImageOnLoad_useImageOnLoad__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./useImageOnLoad/useImageOnLoad */ "./node_modules/usehooks-ts/dist/esm/useImageOnLoad/useImageOnLoad.js");
/* harmony import */ var _useIntersectionObserver_useIntersectionObserver__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./useIntersectionObserver/useIntersectionObserver */ "./node_modules/usehooks-ts/dist/esm/useIntersectionObserver/useIntersectionObserver.js");
/* harmony import */ var _useInterval_useInterval__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./useInterval/useInterval */ "./node_modules/usehooks-ts/dist/esm/useInterval/useInterval.js");
/* harmony import */ var _useIsClient_useIsClient__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./useIsClient/useIsClient */ "./node_modules/usehooks-ts/dist/esm/useIsClient/useIsClient.js");
/* harmony import */ var _useIsFirstRender_useIsFirstRender__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./useIsFirstRender/useIsFirstRender */ "./node_modules/usehooks-ts/dist/esm/useIsFirstRender/useIsFirstRender.js");
/* harmony import */ var _useIsMounted_useIsMounted__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./useIsMounted/useIsMounted */ "./node_modules/usehooks-ts/dist/esm/useIsMounted/useIsMounted.js");
/* harmony import */ var _useIsomorphicLayoutEffect_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./useIsomorphicLayoutEffect/useIsomorphicLayoutEffect */ "./node_modules/usehooks-ts/dist/esm/useIsomorphicLayoutEffect/useIsomorphicLayoutEffect.js");
/* harmony import */ var _useLocalStorage_useLocalStorage__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./useLocalStorage/useLocalStorage */ "./node_modules/usehooks-ts/dist/esm/useLocalStorage/useLocalStorage.js");
/* harmony import */ var _useLockedBody_useLockedBody__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./useLockedBody/useLockedBody */ "./node_modules/usehooks-ts/dist/esm/useLockedBody/useLockedBody.js");
/* harmony import */ var _useMap_useMap__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./useMap/useMap */ "./node_modules/usehooks-ts/dist/esm/useMap/useMap.js");
/* harmony import */ var _useMediaQuery_useMediaQuery__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./useMediaQuery/useMediaQuery */ "./node_modules/usehooks-ts/dist/esm/useMediaQuery/useMediaQuery.js");
/* harmony import */ var _useOnClickOutside_useOnClickOutside__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./useOnClickOutside/useOnClickOutside */ "./node_modules/usehooks-ts/dist/esm/useOnClickOutside/useOnClickOutside.js");
/* harmony import */ var _useReadLocalStorage_useReadLocalStorage__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./useReadLocalStorage/useReadLocalStorage */ "./node_modules/usehooks-ts/dist/esm/useReadLocalStorage/useReadLocalStorage.js");
/* harmony import */ var _useScreen_useScreen__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./useScreen/useScreen */ "./node_modules/usehooks-ts/dist/esm/useScreen/useScreen.js");
/* harmony import */ var _useScript_useScript__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./useScript/useScript */ "./node_modules/usehooks-ts/dist/esm/useScript/useScript.js");
/* harmony import */ var _useSessionStorage_useSessionStorage__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./useSessionStorage/useSessionStorage */ "./node_modules/usehooks-ts/dist/esm/useSessionStorage/useSessionStorage.js");
/* harmony import */ var _useSsr_useSsr__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./useSsr/useSsr */ "./node_modules/usehooks-ts/dist/esm/useSsr/useSsr.js");
/* harmony import */ var _useStep_useStep__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./useStep/useStep */ "./node_modules/usehooks-ts/dist/esm/useStep/useStep.js");
/* harmony import */ var _useTernaryDarkMode_useTernaryDarkMode__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./useTernaryDarkMode/useTernaryDarkMode */ "./node_modules/usehooks-ts/dist/esm/useTernaryDarkMode/useTernaryDarkMode.js");
/* harmony import */ var _useTimeout_useTimeout__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./useTimeout/useTimeout */ "./node_modules/usehooks-ts/dist/esm/useTimeout/useTimeout.js");
/* harmony import */ var _useToggle_useToggle__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./useToggle/useToggle */ "./node_modules/usehooks-ts/dist/esm/useToggle/useToggle.js");
/* harmony import */ var _useUpdateEffect_useUpdateEffect__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./useUpdateEffect/useUpdateEffect */ "./node_modules/usehooks-ts/dist/esm/useUpdateEffect/useUpdateEffect.js");
/* harmony import */ var _useWindowSize_useWindowSize__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./useWindowSize/useWindowSize */ "./node_modules/usehooks-ts/dist/esm/useWindowSize/useWindowSize.js");












































































/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useBoolean/useBoolean.js":
/*!********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useBoolean/useBoolean.js ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useBoolean(defaultValue) {
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!!defaultValue);
    const setTrue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => setValue(true), []);
    const setFalse = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => setValue(false), []);
    const toggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => setValue(x => !x), []);
    return { value, setValue, setTrue, setFalse, toggle };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useBoolean);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useClickAnyWhere/useClickAnyWhere.js":
/*!********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useClickAnyWhere/useClickAnyWhere.js ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");

function useClickAnyWhere(handler) {
    (0,___WEBPACK_IMPORTED_MODULE_0__.useEventListener)('click', event => {
        handler(event);
    });
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useClickAnyWhere);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useCopyToClipboard/useCopyToClipboard.js":
/*!************************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useCopyToClipboard/useCopyToClipboard.js ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

function useCopyToClipboard() {
    const [copiedText, setCopiedText] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const copy = (text) => __awaiter(this, void 0, void 0, function* () {
        if (!(navigator === null || navigator === void 0 ? void 0 : navigator.clipboard)) {
            console.warn('Clipboard not supported');
            return false;
        }
        try {
            yield navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        }
        catch (error) {
            console.warn('Copy failed', error);
            setCopiedText(null);
            return false;
        }
    });
    return [copiedText, copy];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCopyToClipboard);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useCountdown/useCountdown.js":
/*!************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useCountdown/useCountdown.js ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useCountdown(countdownOption) {
    let isDeprecated = false;
    let countStart, intervalMs, isIncrement, countStop;
    if ('seconds' in countdownOption) {
        console.warn('[useCountdown:DEPRECATED] new interface is already available (see https://usehooks-ts.com/react-hook/use-countdown), the old version will retire on usehooks-ts@3.');
        isDeprecated = true;
        countStart = countdownOption.seconds;
        intervalMs = countdownOption.interval;
        isIncrement = countdownOption.isIncrement;
    }
    else {
        ;
        ({ countStart, intervalMs, isIncrement, countStop } = countdownOption);
    }
    intervalMs = intervalMs !== null && intervalMs !== void 0 ? intervalMs : 1000;
    isIncrement = isIncrement !== null && isIncrement !== void 0 ? isIncrement : false;
    countStop = countStop !== null && countStop !== void 0 ? countStop : 0;
    const { count, increment, decrement, reset: resetCounter, } = (0,___WEBPACK_IMPORTED_MODULE_1__.useCounter)(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown, } = (0,___WEBPACK_IMPORTED_MODULE_1__.useBoolean)(false);
    const resetCountdown = () => {
        stopCountdown();
        resetCounter();
    };
    const countdownCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) {
            increment();
        }
        else {
            decrement();
        }
    }, [count, countStop, decrement, increment, isIncrement, stopCountdown]);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useInterval)(countdownCallback, isCountdownRunning ? intervalMs : null);
    return isDeprecated
        ? [
            count,
            {
                start: startCountdown,
                stop: stopCountdown,
                reset: resetCountdown,
            },
        ]
        : [
            count,
            {
                startCountdown,
                stopCountdown,
                resetCountdown,
            },
        ];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCountdown);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useCounter/useCounter.js":
/*!********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useCounter/useCounter.js ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useCounter(initialValue) {
    const [count, setCount] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialValue || 0);
    const increment = () => setCount(x => x + 1);
    const decrement = () => setCount(x => x - 1);
    const reset = () => setCount(initialValue || 0);
    return {
        count,
        increment,
        decrement,
        reset,
        setCount,
    };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCounter);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useDarkMode/useDarkMode.js":
/*!**********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useDarkMode/useDarkMode.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");

const COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)';
function useDarkMode(defaultValue) {
    var _a;
    const isDarkOS = (0,___WEBPACK_IMPORTED_MODULE_0__.useMediaQuery)(COLOR_SCHEME_QUERY);
    const [isDarkMode, setDarkMode] = (0,___WEBPACK_IMPORTED_MODULE_0__.useLocalStorage)('usehooks-ts-dark-mode', (_a = defaultValue !== null && defaultValue !== void 0 ? defaultValue : isDarkOS) !== null && _a !== void 0 ? _a : false);
    (0,___WEBPACK_IMPORTED_MODULE_0__.useUpdateEffect)(() => {
        setDarkMode(isDarkOS);
    }, [isDarkOS]);
    return {
        isDarkMode,
        toggle: () => setDarkMode(prev => !prev),
        enable: () => setDarkMode(true),
        disable: () => setDarkMode(false),
    };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useDarkMode);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useDebounce/useDebounce.js":
/*!**********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useDebounce/useDebounce.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const timer = setTimeout(() => setDebouncedValue(value), delay || 500);
        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);
    return debouncedValue;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useDebounce);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useDocumentTitle/useDocumentTitle.js":
/*!********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useDocumentTitle/useDocumentTitle.js ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");

function useDocumentTitle(title) {
    (0,___WEBPACK_IMPORTED_MODULE_0__.useIsomorphicLayoutEffect)(() => {
        window.document.title = title;
    }, [title]);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useDocumentTitle);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useEffectOnce/useEffectOnce.js":
/*!**************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useEffectOnce/useEffectOnce.js ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useEffectOnce(effect) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(effect, []);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useEffectOnce);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useElementSize/useElementSize.js":
/*!****************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useElementSize/useElementSize.js ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useElementSize() {
    const [ref, setRef] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const [size, setSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: 0,
        height: 0,
    });
    const handleSize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        setSize({
            width: (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0,
            height: (ref === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0,
        });
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('resize', handleSize);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        handleSize();
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    return [setRef, size];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useElementSize);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useEventCallback/useEventCallback.js":
/*!********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useEventCallback/useEventCallback.js ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ useEventCallback)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useEventCallback(fn) {
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(() => {
        throw new Error('Cannot call an event handler while rendering.');
    });
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        ref.current = fn;
    }, [fn]);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((...args) => ref.current(...args), [ref]);
}


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useEventListener/useEventListener.js":
/*!********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useEventListener/useEventListener.js ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useEventListener(eventName, handler, element, options) {
    const savedHandler = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(handler);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        savedHandler.current = handler;
    }, [handler]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        var _a;
        const targetElement = (_a = element === null || element === void 0 ? void 0 : element.current) !== null && _a !== void 0 ? _a : window;
        if (!(targetElement && targetElement.addEventListener))
            return;
        const listener = event => savedHandler.current(event);
        targetElement.addEventListener(eventName, listener, options);
        return () => {
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [eventName, element, options]);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useEventListener);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useFetch/useFetch.js":
/*!****************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useFetch/useFetch.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

function useFetch(url, options) {
    const cache = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const cancelRequest = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const initialState = {
        error: undefined,
        data: undefined,
    };
    const fetchReducer = (state, action) => {
        switch (action.type) {
            case 'loading':
                return Object.assign({}, initialState);
            case 'fetched':
                return Object.assign(Object.assign({}, initialState), { data: action.payload });
            case 'error':
                return Object.assign(Object.assign({}, initialState), { error: action.payload });
            default:
                return state;
        }
    };
    const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(fetchReducer, initialState);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (!url)
            return;
        cancelRequest.current = false;
        const fetchData = () => __awaiter(this, void 0, void 0, function* () {
            dispatch({ type: 'loading' });
            if (cache.current[url]) {
                dispatch({ type: 'fetched', payload: cache.current[url] });
                return;
            }
            try {
                const response = yield fetch(url, options);
                if (!response.ok) {
                    throw new Error(response.statusText);
                }
                const data = (yield response.json());
                cache.current[url] = data;
                if (cancelRequest.current)
                    return;
                dispatch({ type: 'fetched', payload: data });
            }
            catch (error) {
                if (cancelRequest.current)
                    return;
                dispatch({ type: 'error', payload: error });
            }
        });
        void fetchData();
        return () => {
            cancelRequest.current = true;
        };
    }, [url]);
    return state;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useFetch);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useHover/useHover.js":
/*!****************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useHover/useHover.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useHover(elementRef) {
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const handleMouseEnter = () => setValue(true);
    const handleMouseLeave = () => setValue(false);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('mouseenter', handleMouseEnter, elementRef);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('mouseleave', handleMouseLeave, elementRef);
    return value;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useHover);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useImageOnLoad/useImageOnLoad.js":
/*!****************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useImageOnLoad/useImageOnLoad.js ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useImageOnLoad() {
    const [isLoaded, setIsLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const handleImageOnLoad = () => {
        setIsLoaded(true);
    };
    const css = {
        thumbnail: {
            visibility: isLoaded ? 'hidden' : 'visible',
            filter: 'blur(8px)',
            transition: 'visibility 0ms ease-out 500ms',
        },
        fullSize: {
            opacity: isLoaded ? 1 : 0,
            transition: 'opacity 500ms ease-in 0ms',
        },
    };
    return { handleImageOnLoad, css };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useImageOnLoad);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useIntersectionObserver/useIntersectionObserver.js":
/*!**********************************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useIntersectionObserver/useIntersectionObserver.js ***!
  \**********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useIntersectionObserver(elementRef, { threshold = 0, root = null, rootMargin = '0%', freezeOnceVisible = false, }) {
    const [entry, setEntry] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const frozen = (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && freezeOnceVisible;
    const updateEntry = ([entry]) => {
        setEntry(entry);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const node = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        const hasIOSupport = !!window.IntersectionObserver;
        if (!hasIOSupport || frozen || !node)
            return;
        const observerParams = { threshold, root, rootMargin };
        const observer = new IntersectionObserver(updateEntry, observerParams);
        observer.observe(node);
        return () => observer.disconnect();
    }, [elementRef === null || elementRef === void 0 ? void 0 : elementRef.current, JSON.stringify(threshold), root, rootMargin, frozen]);
    return entry;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useIntersectionObserver);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useInterval/useInterval.js":
/*!**********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useInterval/useInterval.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useInterval(callback, delay) {
    const savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        savedCallback.current = callback;
    }, [callback]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (!delay && delay !== 0) {
            return;
        }
        const id = setInterval(() => savedCallback.current(), delay);
        return () => clearInterval(id);
    }, [delay]);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useInterval);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useIsClient/useIsClient.js":
/*!**********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useIsClient/useIsClient.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useIsClient() {
    const [isClient, setClient] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        setClient(true);
    }, []);
    return isClient;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useIsClient);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useIsFirstRender/useIsFirstRender.js":
/*!********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useIsFirstRender/useIsFirstRender.js ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useIsFirstRender() {
    const isFirst = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useIsFirstRender);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useIsMounted/useIsMounted.js":
/*!************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useIsMounted/useIsMounted.js ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useIsMounted() {
    const isMounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => isMounted.current, []);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useIsMounted);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useIsomorphicLayoutEffect/useIsomorphicLayoutEffect.js":
/*!**************************************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useIsomorphicLayoutEffect/useIsomorphicLayoutEffect.js ***!
  \**************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useIsomorphicLayoutEffect);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useLocalStorage/useLocalStorage.js":
/*!******************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useLocalStorage/useLocalStorage.js ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useLocalStorage(key, initialValue) {
    const readValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? parseJSON(item) : initialValue;
        }
        catch (error) {
            console.warn(`Error reading localStorage key “${key}”:`, error);
            return initialValue;
        }
    }, [initialValue, key]);
    const [storedValue, setStoredValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(readValue);
    const setValue = (0,___WEBPACK_IMPORTED_MODULE_1__.useEventCallback)(value => {
        if (typeof window === 'undefined') {
            console.warn(`Tried setting localStorage key “${key}” even though environment is not a client`);
        }
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.localStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event('local-storage'));
        }
        catch (error) {
            console.warn(`Error setting localStorage key “${key}”:`, error);
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((event) => {
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) {
            return;
        }
        setStoredValue(readValue());
    }, [key, readValue]);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('storage', handleStorageChange);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('local-storage', handleStorageChange);
    return [storedValue, setValue];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useLocalStorage);
function parseJSON(value) {
    try {
        return value === 'undefined' ? undefined : JSON.parse(value !== null && value !== void 0 ? value : '');
    }
    catch (_a) {
        console.log('parsing error on', { value });
        return undefined;
    }
}


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useLockedBody/useLockedBody.js":
/*!**************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useLockedBody/useLockedBody.js ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useLockedBody(initialLocked = false, rootId = '___gatsby') {
    const [locked, setLocked] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialLocked);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        if (!locked) {
            return;
        }
        const originalOverflow = document.body.style.overflow;
        const originalPaddingRight = document.body.style.paddingRight;
        document.body.style.overflow = 'hidden';
        const root = document.getElementById(rootId);
        const scrollBarWidth = root ? root.offsetWidth - root.scrollWidth : 0;
        if (scrollBarWidth) {
            document.body.style.paddingRight = `${scrollBarWidth}px`;
        }
        return () => {
            document.body.style.overflow = originalOverflow;
            if (scrollBarWidth) {
                document.body.style.paddingRight = originalPaddingRight;
            }
        };
    }, [locked]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (locked !== initialLocked) {
            setLocked(initialLocked);
        }
    }, [initialLocked]);
    return [locked, setLocked];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useLockedBody);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useMap/useMap.js":
/*!************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useMap/useMap.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useMap(initialState = new Map()) {
    const [map, setMap] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(new Map(initialState));
    const actions = {
        set: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((key, value) => {
            setMap(prev => {
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(entries => {
            setMap(() => new Map(entries));
        }, []),
        remove: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(key => {
            setMap(prev => {
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
            setMap(() => new Map());
        }, []),
    };
    return [map, actions];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useMap);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useMediaQuery/useMediaQuery.js":
/*!**************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useMediaQuery/useMediaQuery.js ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useMediaQuery(query) {
    const getMatches = (query) => {
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches;
        }
        return false;
    };
    const [matches, setMatches] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getMatches(query));
    function handleChange() {
        setMatches(getMatches(query));
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) {
            matchMedia.addListener(handleChange);
        }
        else {
            matchMedia.addEventListener('change', handleChange);
        }
        return () => {
            if (matchMedia.removeListener) {
                matchMedia.removeListener(handleChange);
            }
            else {
                matchMedia.removeEventListener('change', handleChange);
            }
        };
    }, [query]);
    return matches;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useMediaQuery);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useOnClickOutside/useOnClickOutside.js":
/*!**********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useOnClickOutside/useOnClickOutside.js ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");

function useOnClickOutside(ref, handler, mouseEvent = 'mousedown') {
    (0,___WEBPACK_IMPORTED_MODULE_0__.useEventListener)(mouseEvent, event => {
        const el = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!el || el.contains(event.target)) {
            return;
        }
        handler(event);
    });
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useOnClickOutside);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useReadLocalStorage/useReadLocalStorage.js":
/*!**************************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useReadLocalStorage/useReadLocalStorage.js ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useReadLocalStorage(key) {
    const readValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (typeof window === 'undefined') {
            return null;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        }
        catch (error) {
            console.warn(`Error reading localStorage key “${key}”:`, error);
            return null;
        }
    }, [key]);
    const [storedValue, setStoredValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(readValue);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((event) => {
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) {
            return;
        }
        setStoredValue(readValue());
    }, [key, readValue]);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('storage', handleStorageChange);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('local-storage', handleStorageChange);
    return storedValue;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useReadLocalStorage);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useScreen/useScreen.js":
/*!******************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useScreen/useScreen.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useScreen() {
    const getScreen = () => {
        if (typeof window !== 'undefined' && window.screen) {
            return window.screen;
        }
        return undefined;
    };
    const [screen, setScreen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getScreen());
    function handleSize() {
        setScreen(getScreen());
    }
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('resize', handleSize);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        handleSize();
    }, []);
    return screen;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useScreen);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useScript/useScript.js":
/*!******************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useScript/useScript.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const cachedScriptStatuses = {};
function getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node === null || node === void 0 ? void 0 : node.getAttribute('data-status');
    return {
        node,
        status,
    };
}
function useScript(src, options) {
    const [status, setStatus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
        var _a;
        if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) {
            return 'idle';
        }
        if (typeof window === 'undefined') {
            return 'loading';
        }
        return (_a = cachedScriptStatuses[src]) !== null && _a !== void 0 ? _a : 'loading';
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        var _a, _b;
        if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) {
            return;
        }
        const cachedScriptStatus = cachedScriptStatuses[src];
        if (cachedScriptStatus === 'ready' || cachedScriptStatus === 'error') {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement('script');
            scriptNode.src = src;
            scriptNode.async = true;
            scriptNode.setAttribute('data-status', 'loading');
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event) => {
                const scriptStatus = event.type === 'load' ? 'ready' : 'error';
                scriptNode === null || scriptNode === void 0 ? void 0 : scriptNode.setAttribute('data-status', scriptStatus);
            };
            scriptNode.addEventListener('load', setAttributeFromEvent);
            scriptNode.addEventListener('error', setAttributeFromEvent);
        }
        else {
            setStatus((_b = (_a = script.status) !== null && _a !== void 0 ? _a : cachedScriptStatus) !== null && _b !== void 0 ? _b : 'loading');
        }
        const setStateFromEvent = (event) => {
            const newStatus = event.type === 'load' ? 'ready' : 'error';
            setStatus(newStatus);
            cachedScriptStatuses[src] = newStatus;
        };
        scriptNode.addEventListener('load', setStateFromEvent);
        scriptNode.addEventListener('error', setStateFromEvent);
        return () => {
            if (scriptNode) {
                scriptNode.removeEventListener('load', setStateFromEvent);
                scriptNode.removeEventListener('error', setStateFromEvent);
            }
            if (scriptNode && (options === null || options === void 0 ? void 0 : options.removeOnUnmount)) {
                scriptNode.remove();
            }
        };
    }, [src, options === null || options === void 0 ? void 0 : options.shouldPreventLoad, options === null || options === void 0 ? void 0 : options.removeOnUnmount]);
    return status;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useScript);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useSessionStorage/useSessionStorage.js":
/*!**********************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useSessionStorage/useSessionStorage.js ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useSessionStorage(key, initialValue) {
    const readValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.sessionStorage.getItem(key);
            return item ? parseJSON(item) : initialValue;
        }
        catch (error) {
            console.warn(`Error reading sessionStorage key “${key}”:`, error);
            return initialValue;
        }
    }, [initialValue, key]);
    const [storedValue, setStoredValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(readValue);
    const setValue = (0,___WEBPACK_IMPORTED_MODULE_1__.useEventCallback)(value => {
        if (typeof window == 'undefined') {
            console.warn(`Tried setting sessionStorage key “${key}” even though environment is not a client`);
        }
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.sessionStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event('session-storage'));
        }
        catch (error) {
            console.warn(`Error setting sessionStorage key “${key}”:`, error);
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((event) => {
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) {
            return;
        }
        setStoredValue(readValue());
    }, [key, readValue]);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('storage', handleStorageChange);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('session-storage', handleStorageChange);
    return [storedValue, setValue];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useSessionStorage);
function parseJSON(value) {
    try {
        return value === 'undefined' ? undefined : JSON.parse(value !== null && value !== void 0 ? value : '');
    }
    catch (_a) {
        console.log('parsing error on', { value });
        return undefined;
    }
}


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useSsr/useSsr.js":
/*!************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useSsr/useSsr.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function useSsr() {
    const isDOM = typeof window !== 'undefined' &&
        window.document &&
        window.document.documentElement;
    return {
        isBrowser: isDOM,
        isServer: !isDOM,
    };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useSsr);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useStep/useStep.js":
/*!**************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useStep/useStep.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useStep(maxStep) {
    const [currentStep, setCurrentStep] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(1);
    const canGoToNextStep = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => currentStep + 1 <= maxStep, [currentStep, maxStep]);
    const canGoToPrevStep = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => currentStep - 1 >= 1, [currentStep]);
    const setStep = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(step => {
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error('Step not valid');
    }, [maxStep, currentStep]);
    const goToNextStep = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (canGoToNextStep) {
            setCurrentStep(step => step + 1);
        }
    }, [canGoToNextStep]);
    const goToPrevStep = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (canGoToPrevStep) {
            setCurrentStep(step => step - 1);
        }
    }, [canGoToPrevStep]);
    const reset = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep,
            goToPrevStep,
            canGoToNextStep,
            canGoToPrevStep,
            setStep,
            reset,
        },
    ];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useStep);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useTernaryDarkMode/useTernaryDarkMode.js":
/*!************************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useTernaryDarkMode/useTernaryDarkMode.js ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


const COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)';
function useTernaryDarkMode() {
    const isDarkOS = (0,___WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)(COLOR_SCHEME_QUERY);
    const [ternaryDarkMode, setTernaryDarkMode] = (0,___WEBPACK_IMPORTED_MODULE_1__.useLocalStorage)('usehooks-ts-ternary-dark-mode', 'system');
    const [isDarkMode, setDarkMode] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isDarkOS);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useUpdateEffect)(() => {
        if (ternaryDarkMode === 'system') {
            setDarkMode(isDarkOS);
        }
    }, [isDarkOS]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        switch (ternaryDarkMode) {
            case 'light':
                setDarkMode(false);
                break;
            case 'system':
                setDarkMode(isDarkOS);
                break;
            case 'dark':
                setDarkMode(true);
                break;
        }
    }, [ternaryDarkMode, isDarkOS]);
    function toggleTernaryDarkMode() {
        const toggleDict = {
            light: 'system',
            system: 'dark',
            dark: 'light',
        };
        setTernaryDarkMode(prevMode => toggleDict[prevMode]);
    }
    return {
        isDarkMode,
        ternaryDarkMode,
        setTernaryDarkMode,
        toggleTernaryDarkMode,
    };
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useTernaryDarkMode);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useTimeout/useTimeout.js":
/*!********************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useTimeout/useTimeout.js ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useTimeout(callback, delay) {
    const savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        savedCallback.current = callback;
    }, [callback]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (!delay && delay !== 0) {
            return;
        }
        const id = setTimeout(() => savedCallback.current(), delay);
        return () => clearTimeout(id);
    }, [delay]);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useTimeout);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useToggle/useToggle.js":
/*!******************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useToggle/useToggle.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

function useToggle(defaultValue) {
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!!defaultValue);
    const toggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => setValue(x => !x), []);
    return [value, toggle, setValue];
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useToggle);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useUpdateEffect/useUpdateEffect.js":
/*!******************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useUpdateEffect/useUpdateEffect.js ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useUpdateEffect(effect, deps) {
    const isFirst = (0,___WEBPACK_IMPORTED_MODULE_1__.useIsFirstRender)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (!isFirst) {
            return effect();
        }
    }, deps);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useUpdateEffect);


/***/ }),

/***/ "./node_modules/usehooks-ts/dist/esm/useWindowSize/useWindowSize.js":
/*!**************************************************************************!*\
  !*** ./node_modules/usehooks-ts/dist/esm/useWindowSize/useWindowSize.js ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./node_modules/usehooks-ts/dist/esm/index.js");


function useWindowSize() {
    const [windowSize, setWindowSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: 0,
        height: 0,
    });
    const handleSize = () => {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    };
    (0,___WEBPACK_IMPORTED_MODULE_1__.useEventListener)('resize', handleSize);
    (0,___WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
        handleSize();
    }, []);
    return windowSize;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useWindowSize);


/***/ }),

/***/ "@fluentui/react":
/*!**********************************!*\
  !*** external "@fluentui/react" ***!
  \**********************************/
/***/ ((module) => {

"use strict";
module.exports = require("@fluentui/react");

/***/ }),

/***/ "@fluentui/react-file-type-icons":
/*!**************************************************!*\
  !*** external "@fluentui/react-file-type-icons" ***!
  \**************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@fluentui/react-file-type-icons");

/***/ }),

/***/ "@fluentui/react-hooks":
/*!****************************************!*\
  !*** external "@fluentui/react-hooks" ***!
  \****************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@fluentui/react-hooks");

/***/ }),

/***/ "adaptivecards":
/*!********************************!*\
  !*** external "adaptivecards" ***!
  \********************************/
/***/ ((module) => {

"use strict";
module.exports = require("adaptivecards");

/***/ }),

/***/ "botframework-webchat":
/*!***************************************!*\
  !*** external "botframework-webchat" ***!
  \***************************************/
/***/ ((module) => {

"use strict";
module.exports = require("botframework-webchat");

/***/ }),

/***/ "botframework-webchat-component":
/*!*************************************************!*\
  !*** external "botframework-webchat-component" ***!
  \*************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("botframework-webchat-component");

/***/ }),

/***/ "dayjs":
/*!************************!*\
  !*** external "dayjs" ***!
  \************************/
/***/ ((module) => {

"use strict";
module.exports = require("dayjs");

/***/ }),

/***/ "dayjs/plugin/advancedFormat":
/*!**********************************************!*\
  !*** external "dayjs/plugin/advancedFormat" ***!
  \**********************************************/
/***/ ((module) => {

"use strict";
module.exports = require("dayjs/plugin/advancedFormat");

/***/ }),

/***/ "dayjs/plugin/duration":
/*!****************************************!*\
  !*** external "dayjs/plugin/duration" ***!
  \****************************************/
/***/ ((module) => {

"use strict";
module.exports = require("dayjs/plugin/duration");

/***/ }),

/***/ "dayjs/plugin/relativeTime":
/*!********************************************!*\
  !*** external "dayjs/plugin/relativeTime" ***!
  \********************************************/
/***/ ((module) => {

"use strict";
module.exports = require("dayjs/plugin/relativeTime");

/***/ }),

/***/ "dayjs/plugin/utc":
/*!***********************************!*\
  !*** external "dayjs/plugin/utc" ***!
  \***********************************/
/***/ ((module) => {

"use strict";
module.exports = require("dayjs/plugin/utc");

/***/ }),

/***/ "query-string":
/*!*******************************!*\
  !*** external "query-string" ***!
  \*******************************/
/***/ ((module) => {

"use strict";
module.exports = require("query-string");

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ "react-jss":
/*!****************************!*\
  !*** external "react-jss" ***!
  \****************************/
/***/ ((module) => {

"use strict";
module.exports = require("react-jss");

/***/ }),

/***/ "react-visibility-sensor":
/*!******************************************!*\
  !*** external "react-visibility-sensor" ***!
  \******************************************/
/***/ ((module) => {

"use strict";
module.exports = require("react-visibility-sensor");

/***/ }),

/***/ "smarthub-common":
/*!**********************************!*\
  !*** external "smarthub-common" ***!
  \**********************************/
/***/ ((module) => {

"use strict";
module.exports = require("smarthub-common");

/***/ }),

/***/ "tslib":
/*!************************!*\
  !*** external "tslib" ***!
  \************************/
/***/ ((module) => {

"use strict";
module.exports = require("tslib");

/***/ }),

/***/ "use-debounce":
/*!*******************************!*\
  !*** external "use-debounce" ***!
  \*******************************/
/***/ ((module) => {

"use strict";
module.exports = require("use-debounce");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/index.ts");
/******/ 	var __webpack_export_target__ = exports;
/******/ 	for(var i in __webpack_exports__) __webpack_export_target__[i] = __webpack_exports__[i];
/******/ 	if(__webpack_exports__.__esModule) Object.defineProperty(__webpack_export_target__, "__esModule", { value: true });
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.js.map